// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/GreycliffCF-Heavy.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/GreycliffCF-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/GreycliffCF-DemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/GreycliffCF-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/GreycliffCF-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/GreycliffCF-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/GreycliffCF-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/info-card-2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/bg-signup.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/info-card-3.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  overflow: auto !important;
}

body {
  padding: 0 0 0px 0;
  background-color: #fafafa;
  letter-spacing: -0.3px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 1.6;
  font-weight: 400;
    font-family: 'Greycliff CF' !important;
}
@font-face {
  font-family: 'Greycliff CF';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Greycliff CF';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: 800;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Visby Round CF Demi';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Greycliff CF';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Greycliff CF';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: 'Greycliff CF';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
 
@font-face {
  font-family: 'Greycliff CF';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}
.ant-layout.ant-layout-has-sider {
  flex-direction: row;
  color: #2563eb0f !important;
  height: 100%;
}

h2.main-center-logo-2 {
  font-size: 20px;
  margin: 0;
}

.layout-dashboard {
  background: transparent;
  text-align: left;
  position: relative;
  overflow-x: hidden;
}

.ant-modal-body input::placeholder {
  /* Was #000000c7 (near-black) — read as bold entered text rather than a
     hint in every modal form (Add Customer, etc.). Matched to the lighter
     gray used elsewhere (e.g. the demo password field) for one consistent
     placeholder color across all modals. */
  color: #b8bfc7;
}

form.ant-form.ant-form-vertical.change-pw.main-new-commition-text span.ant-input-affix-wrapper.ant-input-affix-wrapper-has-feedback {
  border-radius: 10px;
  border: 2px solid #ddd;
}

.ant-input-number-affix-wrapper.ant-input-number-affix-wrapper-status-success.ant-input-number-affix-wrapper-has-feedback {
  width: 100%;
  border-radius: 10px;
}

.ant-modal-footer button.ant-btn.ant-btn-default,
.ant-modal-confirm-btns button.ant-btn.ant-btn-default {
  background: transparent !important;
  color: #3B6B94 !important;
  font-weight: 700 !important;
}

.ant-drawer-content-wrapper {
  border-radius: 0px 30px 30px 0px !important;
  overflow: hidden;
}

label.ant-form-item-required {
  font-size: 14px;
  font-weight: 600;
}

@media (min-width: 992px) {
  .layout-dashboard {
    overflow: auto;
  }
}

/* .layout-dashboard .ant-layout-sider.sider-primary {
  width: 280px ;
  max-width: 280px ;
  min-width: 280px;
  position: fixed;
  left: 0;
  z-index: 99;
  height: 100vh;
  overflow: auto;
  margin: 0;
  padding: 33px 20px;
  border-radius: 0px 67px 67px 0px;
  overflow-x: hidden !important;
} */
.layout-dashboard .ant-layout-sider.sider-primary .brand img {
  max-width: 150px; 
  width: 100%;
}
.notificationDropdownMain button {
  background-color: transparent !important;
  padding: 0px;
  width: 35px;
  height: 35px !important;
}

/* .layout-dashboard .ant-layout-sider.sider-primary hr {
  margin: 0px 0 18px;
  border: none;
  height: 1px;
  background-color: #f5f5f5;
} */
.layout-dashboard .ant-layout-sider.sider-primary .brand {
  text-align: center;
  font-weight: 600; 
}

.layout-dashboard .ant-layout-sider.sider-primary .brand span {
  vertical-align: middle;
  margin-left: 3px;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-layout-sider-children {
  width: auto;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-inline {
  border: none;
}

.layout-dashboard .ant-menu {
  background: transparent;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-inline .ant-menu-item,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-inline .ant-menu-submenu {
  margin: 0;
  overflow: visible;
}

.toggale-headr {
  display: flex;
  align-items: center;
}

.notification-header button.ant-btn.ant-btn-default {
  padding: 8px;
  width: 40px;
  height: 40px !important;
  background: #3B6B94 !important;
}

img.mian-new-header-logo {
  width: 100px;
}
.ant-btn.ant-btn-link.sidebar-toggler svg {
  width: 25px;
  height: 25px;
}

aside.ant-layout-sider.ant-layout-sider-light.sider-primary.ant-layout-sider-primary.visible-class {
  width: 0px !important;
  flex: 0px 1 !important;
  max-width: 0px !important;
  min-width: 0px !important;
  display: none;
}

button.ant-btn.ant-btn-link.sidebar-toggler:hover {
  background: none !important;
}

button.ant-btn.ant-btn-link.sidebar-toggler.ps-0.d-none.d-lg-block:hover {
  background: none !important;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu {
  padding: 0 !important;
  height: auto;
  line-height: normal;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-inline .ant-menu-item:after,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-inline .ant-menu-submenu:after {
  display: none;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item.ant-menu-item-selected,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item.ant-menu-item:active,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .ant-menu-submenu-selected,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item.ant-menu-submenu-title:active,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .ant-menu-submenu:active,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu.ant-menu-item-selected,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu.ant-menu-item:active,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu .ant-menu-submenu-selected,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu.ant-menu-submenu-title:active,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu .ant-menu-submenu:active {
  background-color: transparent;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item.ant-menu-item-selected .active,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .active,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu.ant-menu-item-selected .active,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu .active {
  font-weight: 700;
  color: #fff;
  background: #3B6B94;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .active::after {
  content: "";
  width: 5px;
  height: 100%;
  background-color: #3B6B94;
  position: absolute;
  right: 0;
  border-radius: 0px 10px 10px 0;
  left: 0;
}

.icon-box img {
  width: 20px;
  height: 20px;
}

.layout-dashboard .ant-layout-sider.sider-primary span.ant-menu-title-content {
  margin: 0px 15px;
  border-radius: 8px;
}

.for-card-title-mian .ant-card-head-title {
  font-size: 20px;
  font-weight: 600;
  padding: 10px 0px !important;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item a,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu a {
  padding: 6px 16px;
  color: #000;
  border-radius: 8px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  border-bottom: solid 0px #cccccc29;
}

.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-primary .ant-menu-item.ant-menu-item-selected .active .icon,
.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-primary .ant-menu-item .active .icon {
  background-color: transparent !important;
}

a {
  color: #2563eb;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item.ant-menu-item-selected .active .icon,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .active .icon,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu.ant-menu-item-selected .active .icon,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu .active .icon {
  background-color: transparent !important;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .icon,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu .icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  border-radius: 6px;
  justify-content: flex-start;
  align-items: center;
  margin-right: 1px;
  vertical-align: middle;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item.ant-menu-item-selected .active svg path,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .active svg path,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu.ant-menu-item-selected .active svg path,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu .active svg path {
  fill: #fff;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item svg path,
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu svg path {
  fill: #bfbfbf;
}

/* .layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu a:hover {
  color: #ffffff;
} */

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-inline .ant-menu-item.menu-item-header {
  padding: 10px 16px !important;
  color: #8c8c8c;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  display: block;
}

.menu-item-header:hover {
  color: inherit;
}

.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-zero-width {
  overflow-x: hidden;
  width: 210px;
  margin: 0;
  padding: 33px 0;
}

.layout-dashboard.has-sidebar .ant-layout-sider.sider-primary .aside-footer {
  display: block;
}

.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-primary .footer-box {
  background-color: #2563eb;
  color: #fff;
  box-shadow: none;
}

.layout-dashboard .ant-layout-sider.sider-primary .footer-box {
  background-color: #fff;
  color: #141414;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
  margin-bottom: 8px;
}

.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-primary .footer-box .icon {
  background-color: #fff;
}

.layout-dashboard .ant-layout-sider.sider-primary .footer-box .icon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  background-color: #2563eb;
}

.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-primary .footer-box h6 {
  color: #fff;
}

.layout-dashboard .ant-layout-sider.sider-primary .footer-box h6 {
  font-weight: 600;
  font-size: 16px;
  color: #141414;
  margin-bottom: 0;
}

.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-primary .footer-box p {
  color: #f5f5f5;
}

.layout-dashboard .ant-layout-sider.sider-primary .footer-box p {
  color: #8c8c8c;
  font-weight: 600;
}

.ant-menu-sub.ant-menu-inline {
  padding-left: 24px;
}

.ant-menu-sub.ant-menu-inline .ant-menu-item .active::after {
  background: transparent !important;
}

.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-primary .footer-box button {
  background-color: #fff;
  border-color: #f0f0f0;
  color: #141414;
}

.layout-dashboard .ant-layout-sider.sider-primary .footer-box button {
  margin: 0;
}

.ant-btn-sm,
.ant-radio-group-small .ant-radio-button-wrapper {
  height: 34px;
  font-size: 12px;
  padding: 0 15px;
}

.ant-btn-sm {
  border-radius: 4px;
}

.ant-btn-sm,
.ant-radio-group-small .ant-radio-button-wrapper {
  height: 34px;
  font-size: 12px;
  padding: 0 15px;
}

.ant-btn-sm {
  border-radius: 4px;
}

.ant-btn,
.ant-radio-group .ant-radio-button-wrapper {
  font-weight: 600;
}

.layout-dashboard .ant-layout-sider.sider-primary .aside-footer {
  padding-top: 100px;
  padding-bottom: 33px;
}

.ant-menu-inline.ant-menu-root .ant-menu-item,
.ant-menu-inline.ant-menu-root .ant-menu-submenu-title {
  display: block;
}

.ant-layout.ant-layout-has-sider>.ant-layout,
.ant-layout.ant-layout-has-sider>.ant-layout-content {
  overflow-x: hidden;
}

.layout-dashboard .ant-layout {
  background: transparent;
  position: relative;
  min-height: calc(100vh - 0px);
  width: 100%;
  flex-shrink: 0;
  padding-bottom: 35px;
}

.layout-dashboard .ant-layout-header {
  background: #ffffff;
  height: auto;
  padding: 16px;
  margin: 0px;
  line-height: inherit;
  border-radius: 0px;
  transition: 0.2s;
}

.layout-dashboard .ant-breadcrumb>span .ant-breadcrumb-link a {
  color: #8c8c8c;
}

.layout-dashboard .ant-breadcrumb>span:last-child .ant-breadcrumb-link {
  color: #141414;
}

.layout-dashboard .ant-page-header-heading {
  margin-top: 0;
}

.layout-dashboard .ant-page-header-heading .ant-page-header-heading-title {
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  margin-top: 4px;
}

.layout-dashboard .ant-layout-header .ant-row {
  align-items: center !important;
  flex-wrap: nowrap !important;
}
.layout-dashboard .ant-layout-header .SectionMain {
  flex-shrink: 0;
}

.layout-dashboard .header-control {
  display: flex;
  align-items: center;
  margin-top: 0;
  gap: 12px;
  justify-content: flex-end;
  flex-wrap: nowrap;
  overflow: hidden;
}

td.ant-table-cell label.ant-checkbox-wrapper {
  margin: 0 !important;
}

button.ant-btn.ant-btn-default.ant-dropdown-trigger.notification-box {
  border-radius: 50% !important;
  width: 40px;
  height: 40px;
  padding: 0;
}

span.active_notification.active_notification-999 {
  position: absolute;
  top: -6px;
  right: -6px;
  background: red;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 9px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

button.ant-btn.ant-btn-default.ant-dropdown-trigger.notification-box img {
  filter: brightness(100);
}

.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown {
  background: #fff;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
  border-radius: 12px;
  min-width: 276px;
  padding: 16px 8px;
}

.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown ul.ant-dropdown-menu-items {
  margin: 0px;
  padding: 0px;
}

.ant-dropdown.ant-dropdown-placement-bottomRight {
  min-width: inherit !important;
}

.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown .ant-list-item {
  padding: 5px 16px;
  margin-bottom: 8px;
}

.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown .ant-avatar {
  width: 36px;
  height: 36px;
  background-color: #fafafa;
  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown .ant-list-item-meta-title {
  line-height: normal;
}

.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdownt .ant-list-item-meta-description {
  color: #8c8c8c;
  font-size: 12px;
  line-height: 12px;
  font-weight: 600;
}

.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown .ant-list-item-meta-description svg {
  width: 14px;
  height: 14px;
  fill: #8c8c8c;
  vertical-align: middle;
  margin-right: 4px;
}

.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown .ant-list-item-meta-description svg path {
  fill: #8c8c8c;
}

.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown .ant-list-item-meta-description span {
  vertical-align: middle;
}

.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown .ant-avatar .ant-avatar-string {
  top: 6px;
}

.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown .ant-avatar .ant-avatar-string svg {
  width: 22px;
  height: 22px;
}

.h3,
.h4,
h3,
h4 {
  font-weight: 700;
  color: #141414;
}

.ant-list-item-meta-title>a {
  color: rgba(0, 0, 0, 0.65);
  transition: all 0.3s;
}

.ant-list-item-meta-title {
  margin-bottom: 4px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  line-height: 22px;
}

.layout-dashboard .header-control .ant-btn-link {
  height: auto;
  padding: 0 7px;
  margin: 0;
  box-shadow: none;
  color: #8c8c8c;
  line-height: normal;
  border: none !important;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-layout-sider-children {
  overflow: auto;
  overflow-x: hidden;
  width: auto;
}

.ant-btn svg {
  margin-right: 5px;
}

.layout-dashboard .header-control svg {
  width: 13px;
  height: 13px;
}

.layout-dashboard .header-control svg path {
  fill: #141414;
}

.layout-dashboard .header-control .btn-sign-in {
  height: auto;
  padding: 0 7px;
  margin: 0;
  box-shadow: none;
  color: #8c8c8c;
}

.layout-dashboard .header-control .btn-sign-in svg {
  margin-right: 4px;
}

.layout-dashboard .header-control svg {
  vertical-align: middle;
}

.layout-dashboard .header-control .header-search {
  width: 213px;
  margin: 0 7px 0 0;
  border-radius: 6px;
  height: 40px;
  border: 1px solid #d9d9d9;
}

.layout-dashboard .header-control .anticon.anticon-search svg {
  width: 16px;
  height: 16px;
}

.layout-dashboard .header-control .header-search svg path {
  fill: #8c8c8c;
}

.settings-drawer .drawer-content>hr {
  margin: 18px 0;
  border: none;
  height: 1px;
  background-color: #f5f5f5;
}

.ant-layout-sider-children hr {
  margin: 0px 0px 18px !important;
  border: none;
  height: 1px;
  background-color: #f5f5f5;
}

.settings-drawer .drawer-content>h6 {
  font-size: 20px;
  margin-bottom: 0;
}

.layout-dashboard .settings-drawer .drawer-content h6 {
  font-weight: 600;
  color: #141414;
}

.settings-drawer .drawer-content p {
  color: #8c8c8c;
}

p {
  font-size: 14px;
}

.settings-drawer .drawer-content .sidebar-color h6 {
  margin-bottom: 8px;
}

.h6,
h6 {
  font-size: 16px;
}

.drawer-sidebar .ant-drawer-body {
  padding: 0px;
}

.drawer-sidebar .ant-drawer-body aside.ant-layout-sider.ant-layout-sider-light.sider-primary.ant-layout-sider-primary {
  margin: 0px;
}

.layout-dashboard .header-control .header-search .ant-input-suffix .ant-input-search-icon.anticon-loading,
.layout-dashboard .header-control .sidebar-toggler {
  display: block;
}

.layout-dashboard .header-control .btn-sign-in span {
  font-weight: 600;
  vertical-align: middle;
  display: none;
}

/* Old css start */
.site-layout-background {
  background: transparent;
}

header.ant-layout-header.subheader {
  background: transparent;
}

.sidemenu {
  margin-top: 20px;
  margin-left: 20px;
}

.logo img {
  width: 32px;
  margin-right: 10px;
}

.logo {
  margin-bottom: 15px;
}

.logo span {
  font-size: 16px;
  font-weight: 600;
}

hr.horizontal.dark {
  background-image: linear-gradient(90deg,
      transparent,
      rgb(0 0 0 / 12%),
      transparent);
  border: 0px;
}

hr.horizontal {
  background-color: transparent;
}

hr:not([size]) {
  height: 1px;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav {
  background: transparent;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li {
  padding: 10px 16px !important;
  height: auto;
  line-height: normal;
  margin: 0px;
  border: 0px;
  font-size: 16px;
  color: #141414;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li.ant-menu-item-selected {
  box-shadow: 0px 20px 27px #0000000d;
  border-radius: 8px;
  background: #fff;
  border: 0px;
  font-weight: 600;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li.ant-menu-item-selected {
  box-shadow: 0px 20px 27px #0000000d;
  border-radius: 8px;
  background: #fff;
  border: 0px;
  font-weight: 600;
}

.ant-menu-inline.ant-menu-root .ant-menu-item>.ant-menu-title-content,
.ant-menu-inline.ant-menu-root .ant-menu-submenu-title>.ant-menu-title-content {
  flex: auto;
  min-width: 0;
  overflow: visible;
  text-overflow: ellipsis;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li::after {
  display: none;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li span.anticon {
  width: 32px;
  height: 32px;
  line-height: 32px;
  background: #fff;
  box-shadow: 0px 4px 6px #0000001f;
  border-radius: 6px;
  font-size: 16px;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li.ant-menu-item-selected span.anticon {
  background: #2563eb;
  color: #fff;
}

/* ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li:hover {
  box-shadow: 0px 20px 27px #0000000d;
  border-radius: 8px;
  background: #fff;
  border: 0px;
  font-weight: 600;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav
  li:hover
  span.anticon {
  background: #2563eb ;
  color: #fff;
} */

.divder {
  display: table;
  width: 100%;
  padding: 10px 15px;
  color: #8c8c8c;
  font-weight: 600;
  margin: 15px 0px;
}

.ant-card.ant-card-bordered.documentation-card {
  border: 0px;
  box-shadow: 0px 20px 27px #0000000d;
  border-radius: 8px;
  background: #fff;
}

.p-15 {
  padding: 15px;
}

.card-document {
  width: 32px;
  height: 32px;
  text-align: center;
  box-shadow: 0px 4px 6px #0000001f;
  border-radius: 6px;
  font-size: 19px;
  background: #2563eb;
  color: #fff;
  direction: ltr;
  margin-bottom: 15px;
}

.documentation-card h4 {
  margin: 0px;
}

.left-nav {
  /* height: 435px;
  overflow: hidden;
  overflow-y: auto;
  padding-right: 15px; */

  margin-top: 15px;
}

.ant-layout.ant-layout-has-sider {
  background: #f3f2f7 !important;
}

.pageheader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.rightside-top {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
}

.signin {
  white-space: nowrap;
  margin: 0px 20px;
}

.signin span.ant-avatar {
  margin-right: 9px;
}

.shadow-lg {
  box-shadow: 0 8px 26px -4px hsla(0, 0%, 8%, 0.15),
    0 8px 9px -5px hsla(0, 0%, 8%, 0.06) !important;
}

.ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border: 0px;
}

.header-top h4 {
  margin: 0px;
  font-size: 20px;
}

.header-top .subtitle {
  display: block;
  font-weight: normal;
  color: #8c8c8c;
  font-size: 14px;
}

.header-top {
  margin-top: -10px;
}

.ant-drawer.ant-drawer-right.ant-drawer-open.colorside button.ant-drawer-close {
  color: #000;
}

.header-top {
  border-bottom: 1px solid rgb(140 140 140 / 7%);
  padding-bottom: 15px;
}

.rightside-top span.ant-input-affix-wrapper {
  border-radius: 4px;
}

.rightside-top span.ant-input-affix-wrapper span.ant-input-prefix {
  color: #c0c0c0;
}

.setting button.ant-btn {
  padding: 0px;
  line-height: normal;
  background: transparent;
  border: 0px;
  box-shadow: none;
}

button.ant-btn.bell {
  padding: 0px;
  border: 0px;
  background: transparent;
  box-shadow: none;
  position: relative;
}

button.ant-btn.bell strong {
  position: absolute;
  top: -1px;
  right: -5px;
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #f5222d;
  border-radius: 100%;
  text-align: center;
  line-height: normal;
  font-weight: normal;
  color: #fff;
}

.ant-dropdown-menu.ant-dropdown-menu-split.list-notifaction {
  width: 336px;
}

.list-notifaction ul {
  padding: 5px 10px;
  margin: 0px;
}

.list-notifaction ul li {
  display: block;
  width: 100%;

  clear: both;
  font-weight: 400;
  color: #67748e;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.list-notifaction ul li a {
  display: block;
  padding: 10px;
  border-radius: 8px;
}

.list-notifaction ul li a:hover {
  color: #252f40;
  background-color: #e9ecef;
}

.list-notifaction ul span.ant-avatar.ant-avatar-image {
  width: 48px;
  height: 48px;
  border-radius: 0.75rem;
}

.list-notifaction ul li {
  padding: 0px;
}

.ant-dropdown-menu.ant-dropdown-menu-split.list-notifaction {
  border-radius: 0.75rem;
}

.list-notifaction .ant-list-item-meta-title {
  font-weight: bold;
  color: #141414;
}

.list-notifaction .ant-list-item-meta-title {
  font-weight: bold;
  color: #141414;
}

.list-notifaction .ant-avatar.ant-avatar-circle {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.list-notifaction ul li a span.ant-avatar-string {
  line-height: normal;
}

.bnb2 {
  color: #52c41a;
  font-weight: 700;
}

.ant-card.criclebox {
  box-shadow: 0px 20px 27px #0000000d;
  border-radius: 12px;
}

.number span {
  font-weight: 600;
  color: #8c8c8c;
  font-size: 16px;
}

.dashboard-card {
  display: flex;
  flex-wrap: wrap;
}

.dashboard-card .cust_col {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(100% / 7 - 0px);
  padding: 0 10px;
}

.dashboard-card .cust_col h3.ant-typography {
  font-size: 14px;
}

.dashboard-card .cust_col .ant-card.criclebox {
  height: 100%;
}

.dashboard-card .cust_col .ant-card.criclebox .ant-card-body {
  height: 100%;
}

.dashboard-card .cust_col .ant-card.criclebox .number .ant-row.ant-row-middle {
  margin: 0 !important;
}

.dashboard-card .cust_col .ant-card.criclebox .number .ant-row.ant-row-middle .ant-col {
  padding: 0 !important;
}

.number h3 {
  font-weight: 700 !important;
  margin-bottom: 0px !important;
  font-size: 30px !important;
}

.number h3 small {
  font-weight: 600;
  font-size: 14px;
}

/* ── Stat-card icon — absolute circle, top-right corner ── */
.number-dash-count {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}
.number-dash-count .number { width: 100%; }

.icon-box {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #E8F0F7;
  overflow: hidden;
  box-sizing: border-box;
  flex-shrink: 0;
}
.icon-box .anticon { font-size: 17px; line-height: 1; display: flex; align-items: center; justify-content: center; color: #3B6B94; pointer-events: none; }
.icon-box svg { width: 17px !important; height: 17px !important; display: block; flex-shrink: 0; }

/* Per-card colours */
.card-0 .icon-box { background: #E8F0F7; } .card-0 .icon-box .anticon { color: #3B6B94; }
.card-1 .icon-box { background: #E6F4FF; } .card-1 .icon-box .anticon { color: #1677FF; }
.card-2 .icon-box { background: #FFF7E6; } .card-2 .icon-box .anticon { color: #FA8C16; }
.card-3 .icon-box { background: #F6FFED; } .card-3 .icon-box .anticon { color: #52C41A; }
.card-4 .icon-box { background: #F9F0FF; } .card-4 .icon-box .anticon { color: #722ED1; }
.card-5 .icon-box { background: #FFF1F0; } .card-5 .icon-box .anticon { color: #F5222D; }

/* Card container — anchor for icon + hide overflow */
.ant-card.criclebox.count-card {
  box-shadow: 6px 6px 54px 0px #0000000D !important;
  border: 0px !important;
  overflow: hidden !important;
}
.ant-card.criclebox.count-card .ant-card-body {
  padding: 20px 30px !important;
  overflow: hidden !important;
  position: relative !important;
}

/* Breakdown text stays on one line */
.dashboard-count-breakdown {
  color: #6b7280;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.35;
  margin-top: 3px;
  white-space: nowrap;
  overflow: visible;
}

.icon-box-text_mainhh .ant-card-body {
  padding: 12px !important;
}

.icon-box-text_mainhh .number {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.listpage {
  padding-top: 15px;
}

.bar-chart {
  background: transparent linear-gradient(62deg, #00369e 0%, #005cfd 53%, #a18dff 100%) 0% 0% no-repeat padding-box;
  box-shadow: 0px 4px 6px #0000001f;

  border-radius: 8px;
}

.chart-vistior {
  margin-top: 30px;
}

.chart-vistior h5 {
  margin: 0px;
  font-weight: 700;
}

.ant-typography.lastweek {
  color: #8c8c8c;
  font-weight: 600;
}

.chart-visitor-count h4 {
  margin: 0px;
  font-weight: 700;
}

.chart-visitor-count span {
  color: rgba(0, 0, 0, 0.65);
  font-weight: 600;
}

.linechart h5 {
  font-weight: 700;
  margin: 0px;
}

.linechart {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sales ul {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

.sales ul li:first-child span.anticon {
  color: #b37feb;
}

.sales ul li:last-child span.anticon {
  color: #2563eb;
}

.sales ul li {
  color: #8c8c8c;
  margin-bottom: 3px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
}

.project-ant h4 {
  margin: 0px;
  font-size: 16px;
  font-weight: bold;
  color: #141414;
}

span.blue {
  margin-left: 5px;
  color: #2563eb;
  font-weight: 600;
}

.project-ant h5 {
  margin: 0px;
  color: #141414;
  font-weight: 700;
}

span.blue {
  margin-left: 5px;
  color: #2563eb;
  font-weight: 600;
}

.project-ant {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.antd-pro-pages-dashboard-analysis-style-salesExtra a {
  display: inline-block;
  padding: 7px 10px;
  color: #595959;
  border: 1px solid #d9d9d9;
  text-align: center;
  border-right: 1px solid transparent;
}

.antd-pro-pages-dashboard-analysis-style-salesExtra a:last-child {
  border-right: 1px solid #d9d9d9;
  border-radius: 0px 5px 5px 0px;
}

.antd-pro-pages-dashboard-analysis-style-salesExtra a:first-child {
  border-radius: 5px 0px 0px 5px;
}

.antd-pro-pages-dashboard-analysis-style-salesExtra a:hover {
  color: #2563eb;
  border: 1px solid #2563eb;
}

.antd-pro-pages-dashboard-analysis-style-salesExtra a.active {
  color: #2563eb;
  border: 1px solid #2563eb;
}

.ant-list-box th {
  text-align: left;
  border-bottom: 1px solid #0000000d;
  padding: 8px 0px;
  color: #8c8c8c;
  font-size: 12px;
  font-weight: 600;
}

.ant-list-box td {
  text-align: left;
  border-bottom: 1px solid #0000000d;
  padding: 16px 25px;
  white-space: nowrap;
  font-size: 12px;
  font-weight: 600;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 7px;
  box-shadow: 0 0 9px #cccccc85;
  background-color: #ffffff;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.d-flex {
  display: flex !important;
}

.justify-content-center {
  justify-content: center !important;
}

.flex-column {
  flex-direction: column !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.tootip-img {
  width: 24px;
  height: 24px;
  border-radius: 100%;
  border: 1px solid #fff;
  position: relative;
  z-index: 2;
  cursor: pointer;
}

.avatar-group .tootip-img+.tootip-img {
  margin-left: -10px;
}

.tootip-img:hover {
  z-index: 3;
  cursor: pointer;
}

.title-box h5 {
  margin: 0px;
}

.text-xs {
  color: #8c8c8c;
}

.percent-progress span.ant-progress-text {
  display: flex;
  margin-top: -27px;
  color: #8c8c8c;
  position: relative;
  margin-left: 0px;
}

/* .percent-progress .ant-progress-outer {
  margin-right: 0px;
  padding-right: 0px;
} */

.percent-progress .ant-progress-status-exception .ant-progress-text {
  color: #ff4d4f;
}

.ant-full-box {
  width: 100%;
  border: 1px dashed #d9d9d9;
  padding: 10px;
  height: auto;
  color: #141414;
  border-radius: 10px;
}

.uploadfile {
  margin-top: 15px;
}

.uploadfile .ant-upload.ant-upload-select {
  display: block;
}

.ant-timeline-item-tail {
  left: 7px;
}

.ant-list-box h5 {
  font-size: 14px;
}

.timeline-box h5 {
  margin-bottom: 0px;
  font-weight: 700;
}

.timelinelist h5 {
  font-size: 14px;
  font-weight: 600;
}

.timelinelist span {
  color: #8c8c8c;
  font-size: 12px;
}

.ant-muse span {
  color: #8c8c8c;
  font-weight: 600;
}

.ant-muse h5 {
  margin: 0px 0px 15px !important;
  font-size: 20px;
}

.bg-gradient-primary {
  background-image: linear-gradient(310deg, #2152ff, #21d4fd);
}

img {
  max-width: 100%;
}

.border10 {
  border-radius: 10px;
}

.py-4 {
  padding: 20px;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.icon-move-right .anticon-right {
  color: #40a9ff;
  margin-left: 2px;
}

.icon-move-right {
  color: #2563eb;

  display: block;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.gradent {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat center top;
  background-size: cover;
  padding: 15px;
  border-radius: 15px;
  color: #fff;
}

.gradent h5 {
  color: #fff;
}

.gradent .ant-typography {
  color: #fff;
  font-size: 20px;
}

.gradent .icon-move-right {
  color: #fff;
}

.gradent .icon-move-right .anticon-right {
  color: #fff;
}

.copyright {
  color: #8c8c8c;
  margin: 6px 0;
  text-align: center;
}

.copyright .anticon-heart {
  color: #f5222d;
  margin: 0px 5px;
}

.copyright a {
  margin: 0px 5px;
  color: #141414;
  font-weight: 700;
}

.footer-menu ul {
  margin: 0px;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.footer-menu ul li {
  list-style: none;
}

.footer-menu ul li a {
  padding: 0.5rem 1rem;
  display: block;
  color: #8c8c8c;
}

span.ismobile {
  display: none;
  margin-right: 15px;
  cursor: pointer;
}

@media (max-width: 992px) {
  .footer-menu ul {
    justify-content: center;
  }

  footer.ant-layout-footer {
    padding: 0px 15px;
    text-align: center;
  }

  .project-ant {
    display: block;
  }

  .ant-filtertabs {
    text-align: right;
  }

  .rightside-top span.ant-input-affix-wrapper {
    width: 200px;
  }

  .rightside-top {
    justify-content: flex-end;
  }

  header.ant-layout-header.subheader {
    padding: 0px 24px 0px 0px;
  }

  main.ant-layout-content.content-ant {
    padding-left: 0px !important;
  }

  span.ismobile {
    display: inline-block;
  }

  .bar-chart {
    width: 100% !important;
    max-width: 100%;
  }

  .full-width {
    max-width: 100% !important;
  }

  .bar-chart {
    width: 100% !important;
  }

  .icon-move-right {
    margin-bottom: 15px;
  }

  .pageheader {
    display: block;
  }

  .ant-cret img {
    width: 100%;
    height: 300px;
    object-fit: cover;
  }
}

.sidebar-color {
  padding: 1.5rem 0px;
}

.theme-color button {
  margin-right: 8px;
  border: 0px;
  width: 20px !important;
  height: 20px !important;
  padding: 0px;
  box-shadow: none;
  visibility: visible !important;
  line-height: 20px !important;
}

.theme-color button:focus {
  box-shadow: none;
  border-color: transparent;
}

.theme-color button span {
  opacity: 0;
}

.mb-2 {
  margin-bottom: 25px;
}

.sidebarnav-color button {
  width: 100%;
  margin-right: 10px;
  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 9%), 0 2px 3px -1px rgb(0 0 0 / 7%);
  height: 40px;
}

.sidebarnav-color h5 {
  margin: 0px;
}

.sidebarnav-color span.ant-typography {
  color: #8c8c8c;
}

.sidebarnav-color .trans {
  margin-top: 1rem;
  display: flex;
}

.sidebarnav-color button:last-child {
  margin-right: 0px;
}

.ant-docment button {
  width: 100%;
  margin-bottom: 10px;
  border-radius: 5px;
}

.viewstar {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
}

.viewstar a {
  display: inline-block;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 16px;
  border-radius: 0em 0.25em 0.25em 0em;
  border: 1px solid #ddddde;
  border-left: 0px;
  color: #141414;
}

.viewstar a:first-child {
  color: #24292e;
  background-color: #eff3f6;
  border-color: #cfd3d6;
  background-image: linear-gradient(180deg, #fafbfc, #eff3f6 90%);
  border-radius: 0.25em 0 0 0.25em;
  border-left: 1px solid #ddddde;
}

.social {
  text-align: center;
  margin-top: 25px;
}

.social button {
  margin: 0px 5px;
  display: inline-flex;
  align-items: center;
}

.ant-thank {
  text-align: center;
  margin-top: 25px;
}

.setting-drwer {
  background: #fff;
  border-radius: 50%;
  bottom: 42px;
  right: 30px;
  font-size: 1.25rem;
  z-index: 990;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 16%);
  width: 52px;
  height: 52px;
  text-align: center;
  line-height: 60px;
  position: fixed;
  cursor: pointer;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li:active {
  background: transparent;
}

.rightside-top .ant-input {
  height: 30px;
}

.aside-footer {
  padding-top: 100px;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li svg path {
  color: #bfbfbf;
}

.cardbody .ant-card-body {
  padding-left: 0px;
  padding-right: 0px;
}

.ant-card.criclebox .project-ant {
  padding-left: 0;
  padding-right: 0;
}

.ant-card.criclebox table th {
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 14px;
  padding-bottom: 14px;
  text-transform: capitalize;
}

/* The row-selection checkbox column (BrandManager.js's bulk-select,
   #bm-staff-table-card) inherits that same 24px left/right padding from
   the rule above — on an ~18px checkbox that reads as its own wide column
   instead of a small checkbox tucked next to the Staff avatar. Two earlier
   attempts at this (a plain ".ant-table-selection-column" class selector,
   then a ".bm-staff-table"-scoped class-chain selector) both LOST to other
   !important rules elsewhere in this file that happened to chain more
   classes together — class-selector specificity fights are fragile since
   any other rule can always out-chain another class selector. An #id
   selector is immune to that: by the CSS spec an id beats ANY number of
   chained classes, so this is guaranteed to win regardless of what else
   exists in this file, now or added later. \`#bm-staff-table-card\` is set
   only on this one Card (id="bm-staff-table-card" in BrandManager.js).
   Belt-and-braces: also sets the actual <col> width antd computes column
   sizing from (.ant-table-selection-col), not just cell padding — a narrow
   padding alone can still leave the column wider than its content if
   something else is driving col width. */
#bm-staff-table-card .ant-table-selection-col {
  width: 32px !important;
  min-width: 32px !important;
}
#bm-staff-table-card .ant-table-thead > tr > th:first-child,
#bm-staff-table-card .ant-table-tbody > tr > td:first-child {
  width: 32px !important;
  min-width: 32px !important;
  max-width: 32px !important;
  padding: 14px 8px !important;
  text-align: center !important;
}

/* Same fix, same reason, second table — User.js's Client table (bulk-select
   added per direct request: "put that checkbox on clients also like we
   have on brands"). Without this it inherits the exact same wide
   .ant-card.criclebox table th padding the comment above explains, so the
   checkbox column read just as oversized here as it did on Staff before
   that fix. \`#cm-clients-table-card\` is set only on this one Card
   (id="cm-clients-table-card" in User.js). */
#cm-clients-table-card .ant-table-selection-col {
  width: 32px !important;
  min-width: 32px !important;
}
#cm-clients-table-card .ant-table-thead > tr > th:first-child,
#cm-clients-table-card .ant-table-tbody > tr > td:first-child {
  width: 32px !important;
  min-width: 32px !important;
  max-width: 32px !important;
  padding: 14px 8px !important;
  text-align: center !important;
}

.ant-card.criclebox table th .ant-table-filter-trigger {
  color: #fff !important;
}

/* Tables with a light header (Customer Management in User.js, Brand
   Manager/Strategist in BrandManager.js — both tagged with the
   \`customer-table\` class) have the shared white filter-icon rule above
   make the funnel icon invisible. Scoped override back to AntD's normal
   grey, only for tables opted into this class. */
.ant-card.criclebox.customer-table table th .ant-table-filter-trigger {
  color: rgba(0, 0, 0, 0.45) !important;
}
.ant-card.criclebox.customer-table table th .ant-table-filter-trigger:hover {
  color: #1890ff !important;
}
.ant-card.criclebox.customer-table table th .ant-table-filter-trigger.active {
  color: #1890ff !important;
}

/* Same white-icon-on-white-header problem, same fix — Graphics/Blog Write
   Requests tables (CreateGraphicsRequest.js, GraphicsOversight.js,
   CreateBlogWriteRequest.js, BlogWriteOversight.js) also have a light
   header and are tagged "tablespace", not "customer-table", so the shared
   ".criclebox table th .ant-table-filter-trigger { color: #fff }" rule
   above was making their new filter funnel icons invisible — present and
   clickable, just rendered white-on-white. */
.ant-card.criclebox.tablespace table th .ant-table-filter-trigger {
  color: rgba(0, 0, 0, 0.45) !important;
}
.ant-card.criclebox.tablespace table th .ant-table-filter-trigger:hover {
  color: #1890ff !important;
}
.ant-card.criclebox.tablespace table th .ant-table-filter-trigger.active {
  color: #1890ff !important;
}

.percent-progress .ant-progress-bg {
  height: 3px !important;
}

.uploadfile {
  padding-left: 24px;
  padding-right: 24px;
}

.ant-card.tablespace .ant-card-body {
  padding: 15px;
}
.active-feed-listing li {
  list-style: none;
  display: flex;
  align-items: flex-start;
  gap: 15px;
  background: #f3f2f7;
  margin-bottom: 10px;
  border-radius: 10px;
  padding: 10px;
}
.active-feed-listing ul{
  padding: 0px !important;
}
.main-new-food-cart-header-nothidhi {
  font-size: 18px;
  font-weight: 600;
  color: #1e232c !important;
  line-height: 20px;
}

li.ant-list-item.remamber-main.Notification-read .ant-list-item-meta-avatar img {
  width: 60px;
  height: 60px;
}

.main-time-for998 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.main-time-for998 h6 {
  font-size: 14px;
  color: #686868;
  line-height: 20px;
  margin: 0;
  font-weight: 600;
}

.main-delete-out {
  width: 32px;
  height: 32px;
  background: #3B6B94;
  border-radius: 5px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  position: absolute;
  bottom: 0;
  right: 0;
}

.ant-list-item-meta-description {
  font-size: 15px;
  font-weight: 600;
  color: #686868;
  line-height: 18px;
}

li.ant-list-item.remamber-main {
  border-radius: 14px;
  padding: 12px;
  box-shadow: 8px 8px 32px 0px #0000000d;
  border: 1px solid #e8ecf4 !important;
  overflow: hidden;
  position: relative;
  margin-bottom: 10px;
}

.tablespace .ant-card-head-title {
  font-size: 20px;
  font-weight: 600;
}

.ant-radio-button-wrapper:first-child {
  border-radius: 4px 0 0 4px;
}

.ant-radio-button-wrapper:last-child {
  border-radius: 0 4px 4px 0;
}

ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li.ant-menu-item-selected path {
  color: #fff;
}

.ant-avatar-group .ant-avatar-square {
  border-radius: 4px;
}

.shape-avatar {
  margin-right: 20px;
}

.shape-avatar img {
  border-radius: 4px;
}

.avatar-info h5 {
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 3px;
}

.avatar-info p {
  font-size: 14px;
  font-weight: 400;
  color: #8c8c8c;
  margin: 0px;
}

.ant-table-tbody>tr>td h5 {
  font-size: 14px;
  font-weight: 600;
  color: #141414;
  margin-bottom: 0px;
}

.ant-table-tbody>tr>td p {
  font-size: 14px;
  color: #8c8c8c;
  margin: 0px;
}

.tag-primary {
  border-radius: 6px;
  padding: 2px 12px;
  font-size: 14px;
  height: auto;
  line-height: 24px;
  font-weight: 600;
}

.ant-employed {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  color: #8c8c8c;
}

.ant-employed a {
  color: #8c8c8c;
  text-decoration: none;
  font-weight: 600;
}

.tag-badge {
  border-radius: 6px;
  padding: 2px 12px;
  font-size: 14px;
  height: auto;
  line-height: 24px;
  font-weight: 600;
  background: #8c8c8c;
  color: #fff;
  outline: none;
}

.tag-badge:hover {
  background: #8c8c8c;
  color: #fff;
  border-color: #8c8c8c;
  opacity: 0.9;
}

.ant-avatar-group {
  align-items: center;
}

.mb-24 {
  margin-bottom: 24px;
}

.ant-table-thead>tr>th {
  color: #8c8c8c;
  font-weight: 700;
  background-color: transparent;
  font-size: 12px;
}

.ant-border-space th:before {
  display: none;
}

.ant-table-tbody>tr>td,
.ant-table-thead>tr>th {
  padding: 16px 25px !important;
}

.tablespace {
  overflow: hidden;
}

/* Customer Management table — tighter row padding than the site-wide
   default. That default (16px 25px) is generous for tables with 1-2 lines
   of dense content per cell; this table has many mostly-empty/short cells
   (single tags, "N/A"s) across a lot of columns, so the same padding reads
   as excess whitespace rather than breathing room. Scoped to .customer-table
   (not the shared rule above) so no other table's spacing is affected. */
.customer-table .ant-table-tbody>tr>td,
.customer-table .ant-table-thead>tr>th {
  padding: 10px 16px !important;
}

/* AntD renders a hidden "measure row" (ant-table-measure-row) to calculate
   column widths — normally zero-height/invisible, but the !important
   padding above (and the later, higher-specificity padding rule further
   down this file) apply to it too, giving it real height and exposing it
   as a blank white bar between the header and the first real row. */
.customer-table .ant-table-measure-row,
.customer-table .ant-table-measure-row > td,
.ant-card.criclebox.customer-table .ant-table-measure-row,
.ant-card.criclebox.customer-table .ant-table-tbody > tr.ant-table-measure-row > td {
  height: 0 !important;
  padding: 0 !important;
  border: none !important;
  line-height: 0 !important;
}

/* Center every column heading (title + sort arrows + filter icon all move
   together as one inline group — AntD lays these out as flex children of
   the header cell, so centering the cell centers the whole group). */
.customer-table .ant-table-thead>tr>th {
  text-align: center;
}
.customer-table .ant-table-thead>tr>th .ant-table-column-sorters {
  justify-content: center;
}

/* Associated Staff column — role-tagged BM/BS rows. Fixed-width badges so
   both rows' names start at the same x position regardless of "BM" vs "BS"
   rendering slightly differently, and brand palette (steel blue / turquoise)
   instead of generic antd tag colors so it reads as part of this app rather
   than a default component. */
.staff-role-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.staff-role-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.staff-role-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 20px;
  flex-shrink: 0;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.3px;
}
.staff-role-badge-bm {
  background: rgba(59, 107, 148, 0.12);
  color: #3b6b94;
}
.staff-role-badge-bs {
  background: rgba(24, 82, 80, 0.12);
  color: #185250;
}
.staff-role-name {
  font-size: 13px;
  color: #334155;
}

.ant-table.ant-table-middle .ant-table-title,
.ant-table.ant-table-middle .ant-table-footer,
.ant-table.ant-table-middle .ant-table-thead>tr>th,
.ant-table.ant-table-middle .ant-table-tbody>tr>td,
.ant-table.ant-table-middle tfoot>tr>th,
.ant-table.ant-table-middle tfoot>tr>td {
  padding: 16px 25px;
}

.avatar-sm {
  width: 25px;
}

.ant-progress-project {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ant-progress-project .ant-progress-outer {
  float: right;
}

.ant-progress-project .ant-progress-text {
  margin: 0px 0px 0px 0px;
  color: #8c8c8c;
  font-weight: 600;
}

.semibold {
  font-weight: 600;
  color: #8c8c8c;
}

.text-sm {
  font-size: 12px;
  color: #8c8c8c;
  font-weight: 600;
}

.ant-progress-project .ant-progress {
  margin-right: 15px;
}

.semibold {
  font-weight: 600;
  color: #8c8c8c;
}

.text-sm {
  font-size: 12px;
  color: #8c8c8c;
  font-weight: 600;
}

.ant-progress-project .ant-progress-bg {
  height: 3px !important;
}

.ant-table-tbody>tr>td,
.ant-table-thead>tr>th {
  white-space: nowrap;
}

.h-full {
  height: 100%;
}

@media (min-width: 1200px) {
  .ant-col.col-img img {
    height: 196px;
  }

  /* .bar-chart {
    max-width: 438px;
  } */
  /* .full-width {
    max-width: 658px;
  } */
}

@media (max-width: 1024px) {
  .bar-chart {
    max-width: 100%;
  }

  .full-width {
    max-width: 100%;
  }

  /* .ant-col.mobile-24 {
    margin-bottom: 24px;
  } */
}

/* 
body {
  overflow: visible !important;
  width: 100% !important;
} */

.card-info-2 .ant-card-body {
  height: 100%;
}

.col-content {
  flex-grow: 1;
  padding: 24px;
  margin-right: 0;
  border-radius: 8px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.card-content p {
  font-size: 16px;
}

.ant-layout-footer {
  padding: 0px 50px;
}

/* sign up start */
.layout-default.ant-layout.layout-sign-up header.ant-layout-header {
  background-color: transparent;
  color: #fff;
  margin: 0;
  padding: 0 20px;
  z-index: 1;
}

.layout-default .ant-layout-header {
  display: flex;
}

.header-col.header-nav {
  margin-left: auto;
  width: 100%;
  margin-right: auto;
}

.header-col.header-nav .ant-menu-overflow {
  justify-content: center;
}

.header-col.header-nav .ant-menu-horizontal {
  background: transparent;
  box-shadow: none;
  border: 0px;
}

.layout-default.ant-layout.layout-sign-up {
  padding: 11px;
}

.header-col.header-nav li:after {
  display: none;
}

.sign-up-header {
  height: 550px;
  margin-top: -62.8px;
  padding-top: 137.8px;
  border-radius: 12px;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
  background-size: cover;
  background-position: 50%;
  text-align: center;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat center top;
}

.header-col.header-brand {
  white-space: nowrap;
}

.header-col.header-brand h5 {
  margin: 0px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.header-col.header-nav {
  color: #fff;
  font-weight: 600;
}

.header-col.header-nav ul li {
  color: #fff !important;
}

.header-col.header-nav ul li img {
  margin-top: -2px;
  margin-right: 5px;
}

.header-col.header-btn button {
  height: 34px;
  padding: 0 16px;
  border-radius: 34px;
  line-height: 33px;
}

.sign-up-header .content {
  padding-top: 40px;
  max-width: 480px;
  margin: auto;
}

.sign-up-header * {
  color: #fff;
}

.sign-up-header .content h1 {
  font-size: 48px;
  color: #fff;
}

.text-lg {
  font-size: 16px;
}

.card-signup .sign-up-gateways .ant-btn {
  margin-right: 10px;
  margin-left: 10px;
  height: 60px;
  width: 70px;
  box-shadow: none;
  border-radius: 6px;
}

.card-signup {
  width: 100%;
  max-width: 500px;
  margin: auto;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
  border-radius: 12px;
  margin-top: -190px;
  margin-bottom: 20px;
}

.card-signup h5 {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #141414;
  margin: 0px;
}

.header-solid .ant-card-head {
  border-bottom: 0;
}

.card-signup .sign-up-gateways .ant-btn img {
  width: 20px;
}

.sign-up-gateways {
  text-align: center;
}

.m-25,
.mb-25,
.my-25 {
  margin-bottom: 25px;
}

.m-25,
.mt-25,
.my-25 {
  margin-top: 25px;
}

.text-center {
  text-align: center;
}

.font-semibold {
  font-weight: 600;
}

.text-muted {
  color: #8c8c8c;
}

.ant-input {
  height: 40px;
  border-radius: 8px !important;
  border: 1px solid #d9d9d9 !important;
  font-weight: 600;
  color: #8c8c8c;
  outline: none !important;
  box-shadow: none !important;
}

.font-bold {
  font-weight: 700;
}

.text-dark {
  color: #141414;
}

.ant-btn,
.ant-radio-group .ant-radio-button-wrapper {
  font-weight: 600;
  font-size: 12px;
  height: 40px;
  padding: 0 15px;
  line-height: 40px;
}

.ant-btn {
  box-shadow: 0 2px 4px rgb(0 0 0 / 7%);
  border-radius: 6px;
}

.layout-sign-up .ant-layout-footer {
  padding: 24px 50px;
}

.layout-default .ant-layout-footer {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  background: transparent;
  text-align: center;
}

.layout-default .ant-layout-footer .ant-menu-horizontal {
  border: none;
  line-height: 1.5;
  margin: 0 0 30px;
  background-color: transparent;
  font-size: 16px;
}

.layout-default .ant-layout-footer .ant-menu-horizontal {
  text-align: center;
  display: block;
}

.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-item,
.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-item-active,
.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-item-selected,
.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-item:hover,
.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-submenu,
.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-submenu-active,
.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-submenu-selected,
.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-submenu:hover {
  color: #8c8c8c;
  border: none;
}

.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-item-active,
.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-item-selected,
.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-item:hover,
.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-submenu-active,
.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-submenu-selected,
.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-submenu:hover {
  color: #262626;
}

.layout-default.ant-layout.layout-sign-up .ant-layout-footer ul li:after {
  display: none;
}

.layout-default.ant-layout.layout-sign-up footer.ant-layout-footer ul li a svg {
  width: 18px;
  height: 18px;
}

.layout-default .ant-layout-footer .menu-nav-social a svg {
  fill: #8c8c8c;
  vertical-align: middle;
}

.layout-default .ant-layout-footer .menu-nav-social a:hover svg {
  fill: #2563eb;
}

.layout-default .ant-layout-footer .copyright a {
  color: inherit;
  font-weight: normal;
}

/* signin start csss */
.layout-default.layout-signin header.ant-layout-header {
  display: flex;
  position: relative;
  background-color: #fff;
  color: #141414;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
  flex-direction: row;
  padding: 0 50px;
  height: 64px;
  line-height: 64px;
}

.fill-muted {
  fill: #8c8c8c;
}

.layout-default .ant-layout-header .header-brand h5 {
  white-space: nowrap;

  color: #141414;
  margin: 0;
}

.layout-default .ant-layout-header .header-nav a svg {
  margin-right: 5px;
}

.layout-default .ant-layout-header .header-nav a span,
.layout-default .ant-layout-header .header-nav a svg {
  vertical-align: middle;
}

.layout-default .ant-layout-header .header-nav a {
  color: #141414;
  padding: 6px 12px;
  font-weight: 400;
}

.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-item,
.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-item-active,
.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-item-selected,
.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-item:hover,
.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-submenu,
.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-submenu-active,
.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-submenu-selected,
.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-submenu:hover {
  color: #8c8c8c;
  font-weight: 600;
  border: none;
}

.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-item {
  padding: 0;
}

.sign-in {
  padding: 0 20px;
}

.layout-default .ant-layout-content {
  padding-top: 40px;
}

.font-regular {
  font-weight: 400;
}

.signin h1 {
  font-size: 48px;
  font-weight: 700;
  color: #141414;
}

.signin h5 {
  font-weight: 400;
  color: #8c8c8c;
  font-size: 20px;
  white-space: normal;
}

.ant-row.ant-form-item.username {
  display: block;
}

.ant-row.ant-form-item.username .ant-col.ant-form-item-label .ant-form-item-required:before {
  display: none;
}

.ant-row.ant-form-item.username .ant-col.ant-form-item-label {
  font-size: 13px;
  font-weight: 600;
  color: #141414;
}

.signin .ant-form-item-control-input button.ant-switch {
  margin-right: 5px;
}

.text-dark {
  color: #141414;
}

.sign-img img {
  width: 100%;
  max-width: 500px;
  margin: auto;
  display: block;
}

/* .signin {
  background-image: url(../images/Herro\\ Banner\\ neww.png) !important;
  background-color: #fff !important;
  height: 100%;
  width: 100%;
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;

  position: fixed;
  margin: 0;
} */
.layout-signin footer.ant-layout-footer svg {
  width: 18px;
  height: 18px;
}

.layout-signin footer.ant-layout-footer ul li:after {
  display: none;
}

.layout-default .ant-layout-footer .copyright {
  font-size: 16px;
  color: #8c8c8c;
}

.row-col .ant-row {
  margin-left: 0px;
  margin-right: 0px;
}

.layout-default.ant-layout.layout-sign-up .header-col.header-brand h5 {
  color: #fff;
}

.layout-default.ant-layout.layout-sign-up .header-col.header-nav a {
  color: #fff;
}

.layout-default.ant-layout.layout-sign-up .header-col.header-nav svg path.fill-muted {
  fill: #fff;
}

/* sign in end */

@media (min-width: 768px) {
  .sign-img img {
    margin: 0;
  }

  .card-signup {
    margin-bottom: 120px;
  }

  .card-signup .sign-up-gateways .ant-btn {
    width: 100px;
  }
}

/* end sign up */

.rightside-top .signin {
  display: inline-flex;
}

.rightside-top .signin svg {
  margin-right: 5px;
}

button.ant-btn.bell strong {
  position: absolute;
  top: -1px;
  right: -9px;
  display: inline-block;
  width: 18px;
  height: 18px;
  background: #f5222d;
  border-radius: 100%;
  text-align: center;
  line-height: normal;
  font-weight: normal;
  color: #fff;
}

/* old css end */

.layout-dashboard .ant-layout-footer {
  background: transparent;

  padding: 0;
}

.layout-dashboard .ant-layout-content {
  padding: 0;
  margin: 15px 15px 0;
}

.m-10,
.mr-10,
.mx-10 {
  margin-right: 10px !important;
}

.ant-table-tbody>tr>td h6 {
  font-size: 14px;
  font-weight: 600;
  color: #141414;
}

.layout-dashboard .header-control .header-search input.ant-input {
  height: auto;
}

small.redtext {
  color: red;
}

.full-width path {
  fill: transparent;
}

.bar-chart line.apexcharts-xaxis-tick {
  stroke: transparent;
}

section.ant-layout.layout-content .ant-layout-content.content-ant {
  padding: 0px !important;
}

.layout-dashboard .ant-card {
  border-radius: 12px;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
}

.card-credit {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-position: 50%;
  background-size: cover;
  border: none;
}

.card-credit * {
  color: #fff;
}

.card-credit .card-number {
  word-spacing: 10px;
  font-weight: 600;
  margin-bottom: 45px;
  font-size: 20px;
}

.ant-card-head-wrapper {
  min-height: 72px;
}

.card-credit .ant-card-body {
  padding-top: 15px;
}

.card-credit .card-footer {
  display: flex;
  align-items: flex-end;
}

.m-auto,
.ml-auto {
  margin-left: auto !important;
}

.m-30,
.mr-30,
.mx-30 {
  margin-right: 30px !important;
}

.card-credit .card-footer h6,
.card-credit .card-footer p {
  margin-bottom: 0;
}

.card-credit .col-logo img {
  max-width: 50px;
}

.card-credit .card-footer h6 {
  font-weight: 700;
}

.width-100 {
  width: 100%;
}

.p-20 {
  padding: "0px 20px 0px 0px";
}

.layout-default .ant-layout-content.p-0 {
  padding: 0px;
}

.pt {
  padding-top: 0px;
}

.widget-2 .icon {
  width: 64px;
  height: 64px;
  margin: auto;
  background-color: #2563eb;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}

.widget-2 .ant-statistic-title h6 {
  font-weight: 600;
}

.widget-2 .ant-statistic-title p {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 0;
}

.widget-2 .ant-statistic-content {
  font-family: open sans, Helvetica, Arial, sans-serif !important;
  font-weight: 600;
  font-size: 20px;
  padding: 12px 16px;
  border-top: 1px solid #f5f5f5;
  text-align: center;
}

.widget-2 .ant-statistic-title {
  text-align: center;
  padding: 16px;
}

.widget-2 .ant-card-body {
  padding: 0;
}

.widget-2 .icon img {
  width: 30px;
}

.ant-row-flex-middle {
  align-items: center;
}

.d-flex {
  display: flex;
  align-items: center;
}

.payment-method-card.ant-card {
  box-shadow: none;
  word-spacing: 10px;
}

.payment-method-card.ant-card img {
  width: 40px;
}

.payment-method-card.ant-card .ant-card-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.payment-method-card.ant-card .ant-btn {
  margin-right: -20px;
}

.ant-btn.ant-btn-link.ant-edit-link {
  font-weight: 600;
  font-size: 12px;
  height: 40px;
  padding: 0 15px;
  box-shadow: none;
}

.ant-btn.ant-btn-link.ant-edit-link img {
  width: 20px;
}

.payment-method-card.ant-card .ant-btn {
  margin-right: -20px;
}

.fill-gray-7 {
  fill: #8c8c8c !important;
}

.payment-method-card.ant-card h6 {
  font-weight: 600;
  margin-bottom: 0;
  color: #141414;
}

.m-0 {
  margin: 0px;
}

.ant-card.ant-card-bordered.payment-method-card .ant-card-body {
  padding-top: 16px;
}

.header-solid .ant-card-head {
  border-bottom: 0;
}

.invoice-list .ant-list-item,
.transactions-list .ant-list-item {
  padding: 11px 0;
  border-bottom: 0;
}

.ant-invoice-card .ant-card-body {
  padding-top: 0px;
}

.invoice-list .ant-list-item-meta-title,
.transactions-list .ant-list-item-meta-title {
  font-size: 14px;
  font-weight: 600;
  color: #141414;
}

.invoice-list .ant-list-item-meta-description,
.transactions-list .ant-list-item-meta-description {
  font-size: 12px;
  font-weight: 600;
  color: #8c8c8c;
}

.invoice-list .ant-list-item-action .ant-btn,
.transactions-list .ant-list-item-action .ant-btn {
  font-weight: 600;
  color: #141414;
  box-shadow: none;
}

.ant-btn>svg,
.ant-btn>svg+span {
  vertical-align: middle;
}

.invoice-list .amount,
.transactions-list .amount {
  font-size: 14px;
  font-weight: 600;
  color: #8c8c8c;
}

.card-billing-info.ant-card {
  box-shadow: none;
  background-color: #fafafa;
  border: 1px solid #f5f5f5;
}

.ant-descriptions .ant-descriptions-title {
  font-size: 14px;
  font-weight: 600;
  color: #141414;
  margin-bottom: 14px;
}

.fill-danger {
  fill: #ff4d4f;
}

.card-billing-info.ant-card .darkbtn {
  color: #8c8c8c;
}

.col-action {
  display: flex;
}

.card-billing-info .col-action button {
  height: 34px;
  font-size: 12px;
  padding: 0 15px;
  box-shadow: none;
}

.ant-descriptions .ant-descriptions-row>td,
.ant-descriptions .ant-descriptions-row>th {
  padding-bottom: 6px;
}

.ant-descriptions .ant-descriptions-item-label {
  font-size: 13px;
  font-weight: 600;
  color: #8c8c8c;
}

.ant-descriptions .ant-descriptions-item-content {
  font-size: 13px;
  font-weight: 600;
  color: #141414;
}

.ant-descriptions .ant-descriptions-title {
  font-size: 14px;
  font-weight: 600;
  color: #141414;
  margin-bottom: 14px;
}

.card-billing-info.ant-card .ant-descriptions-header {
  margin-bottom: 0px;
}

.card-header-date {
  margin-bottom: 0;
  font-weight: 700;
  color: #8c8c8c;
}

.card-header-date>* {
  vertical-align: middle;
}

.card-header-date svg {
  margin-right: 5px;
}

.transactions-list .amount {
  font-size: 16px;
  font-weight: 700;
}

.text-light-danger {
  background: #fde3cf;
  color: #f56a00;
}

.text-fill {
  color: #52c41a;
  background: #edf9e7;
}

.text-danger {
  color: #f5222d;
}

.text-success {
  color: #52c41a;
}

.transactions-list .ant-list-item-meta {
  align-items: center;
}

.text-warning {
  background: rgb(255, 252, 231);
  color: #fadb14;
}

.text-warning-b {
  font-size: 14px;
  font-weight: 600;
  color: #fadb14;
}

.ant-card.ant-list-yes .ant-list-header {
  border: 0px;
}

.ant-card.ant-list-yes .ant-list-header h6 {
  font-size: 12px;
  font-weight: 600;
  color: #8c8c8c;
  margin: 6px 0;
}

.ant-list.ant-list-split.transactions-list.ant-newest .ant-list-header {
  padding-top: 0px;
}

.profile-nav-bg {
  height: 300px;
  margin-top: -137.8px;
  border-radius: 12px;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
  background-size: cover;
  background-position: 50%;
}

section.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile span.ant-page-header-heading-title {
  color: #fff;
}

section.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile span.ant-breadcrumb-separator {
  color: #e9b248;
}

section.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile span.ant-breadcrumb-link {
  color: #e9b248;
}

section.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile .btn-sign-in {
  color: #fff;
}

.layout-profile .ant-layout-header {
  margin: 10px 20px;
}

.card-profile-head .ant-card-head {
  border-bottom: 0px;
  padding: 0px 16px;
}

.card-profile-head {
  margin: -53px 0 24px;
}

.card-profile-head .ant-card-head .ant-avatar {
  box-shadow: 0 5px 10px rgb(0 0 0 / 12%);
  border-radius: 8px;
  margin: 0;
}

.card-profile-head .ant-card-head .avatar-info {
  margin-left: 16px;
}

.ant-card-head-title p {
  font-weight: 600;
  color: #8c8c8c;
  margin-bottom: 0;
}

.card-profile-head .ant-card-head .avatar-info h4 {
  font-size: 24px;
}

.card-profile-head .ant-card-head .avatar-info h4 {
  font-size: 24px;
}

.card-profile-head .ant-radio-group .ant-radio-button-wrapper {
  height: auto;
  font-weight: 700;
}

.ant-radio-button-wrapper {
  color: #595959;
}

.layout-profile .ant-card-head {
  padding: 0 16px;
}

.settings-list {
  list-style: none;
  padding: 0;
}

.settings-list>li:first-child {
  padding-top: 0;
}

.settings-list>li {
  padding: 12px 0;
}

.settings-list>li h6 {
  font-size: 12px;
  color: #8c8c8c;
  margin: 0;
  font-weight: 700;
}

.settings-list>li span {
  margin-left: 16px;
  color: #141414;
}

.ant-btn-link {
  box-shadow: none;
}

.card-profile-information hr {
  opacity: 0.2;
}

.p-5,
.pr-5,
.px-5 {
  padding-right: 5px !important;
}

.p-5,
.pl-5,
.px-5 {
  padding-left: 5px !important;
}

.m-5,
.mr-5,
.mx-5 {
  margin-right: 5px !important;
}

.m-5,
.ml-5,
.mx-5 {
  margin-left: 5px !important;
}

.card-profile-information .ant-descriptions .ant-descriptions-row>td,
.card-profile-information .ant-descriptions .ant-descriptions-row>th {
  padding-bottom: 16px;
}

.conversations-list .ant-list-item-meta-description {
  font-size: 12px;
  font-weight: 600;
  color: #8c8c8c;
}

.conversations-list .ant-avatar {
  border-radius: 10.5px;
  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);
}

.conversations-list .ant-list-item {
  padding: 14px 0;
}

.ant-card-head-title p {
  font-weight: 600;
  color: #8c8c8c;
  margin-bottom: 0;
}

.ant-card-head-title h6 {
  margin-bottom: 0;
}

.card-project.ant-card {
  box-shadow: none;
  border: none;
}

.card-project.ant-card .ant-card-cover img {
  border-radius: 8px;
  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);
}

.card-project.ant-card .card-tag,
.card-project.ant-card p {
  font-weight: 600;
  color: #8c8c8c;
  margin-bottom: 5px;
}

.card-project.ant-card h5 {
  font-weight: 600;
  font-size: 20px;
}

.card-project.ant-card .card-tag,
.card-project.ant-card p {
  font-weight: 600;
  color: #8c8c8c;
  margin-bottom: 5px;
}

.card-project.ant-card p {
  margin-bottom: 0;
}

.card-project.ant-card .ant-card-body {
  padding: 16px 0 0;
}

.card-project.ant-card .card-footer {
  margin-top: 22px;
}

.avatar-chips .ant-avatar-image {
  border: 1px solid #fff;
}

.avatar-chips .ant-avatar-image:hover,
.avatar-chips .ant-space-item:hover {
  z-index: 1;
}

.projects-uploader {
  height: 100%;
  border-radius: 8px;
  border-color: #d9d9d9;
}

.projects-uploader .ant-upload {
  width: 100%;
  height: 100%;
  margin: 0;
  border-radius: 8px;
  padding: 8px;
}

.projects-uploader .ant-upload-list.ant-upload-list-picture-card {
  height: 100%;
}

.projects-uploader .ant-upload.ant-upload-select-picture-card {
  background-color: transparent;
}

.projects-uploader svg {
  width: 20px;
  height: 20px;
}

.text-right {
  text-align: right;
}

.layout-dashboard-rtl {
  background: transparent;
  text-align: right;
  direction: rtl;
  position: relative;
  overflow-x: hidden;
}

.layout-dashboard-rtl .ant-layout-sider.sider-primary .ant-menu-item .icon,
.layout-dashboard-rtl .ant-layout-sider.sider-primary .ant-menu-submenu .icon {
  margin-left: 11px;
  margin-right: 0;
}

.layout-dashboard-rtl .ant-timeline-item-tail {
  right: 6.5px;
  left: auto;
}

.layout-dashboard-rtl .ant-timeline-item-content {
  margin: 0 33px 0 0;
}

.ant-timeline-item-head {
  width: 15px;
  height: 15px;
  border-width: 3px;
}

.layout-dashboard-rtl .ant-radio-button-wrapper:first-child {
  border-right-width: 1px;
  border-radius: 0 4px 4px 0;
}

.layout-dashboard-rtl .ant-list-box td {
  text-align: right;
}

.layout-dashboard-rtl .ant-space-horizontal {
  direction: ltr;
}

.layout-dashboard-rtl .ant-btn>.anticon+span,
.ant-btn>span+.anticon {
  margin-right: 8px;
  margin-left: 0px;
}

.layout-dashboard-rtl .setting-drwer {
  left: 30px;
  right: auto;
}

.layout-dashboard-rtl ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light {
  text-align: right;
}

.layout-dashboard-rtl .avatar-group.mt-2 {
  direction: ltr;
}

.ant-list-box table tr:hover td {
  background: #fafafa;
}

.layout-dashboard-rtl .icon-box {
  margin-left: 0px;
  margin-right: auto;
}

.layout-dashboard-rtl .m-10,
.layout-dashboard-rtl .mr-10,
.layout-dashboard-rtl .mx-10 {
  margin-left: 10px !important;
}

.layout-dashboard-rtl .ant-progress-show-info .ant-progress-outer {
  margin-right: 0px;
  padding-right: 0px;
}

.layout-dashboard-rtl .ant-badge-count,
.layout-dashboard-rtl .ant-badge-dot,
.layout-dashboard-rtl .ant-badge .ant-scroll-number-custom-component {
  left: 0;
  right: auto;
  transform: translate(-50%, -50%);
}

.layout-dashboard-rtl .header-control .btn-sign-in svg {
  margin-left: 4px;
  margin-right: 0px;
}

.ant-drawer.drawer-sidebar.drawer-sidebar-rtl aside.ant-layout-sider.ant-layout-sider-light.sider-primary.ant-layout-sider-primary {
  left: auto;
  right: 0px;
  direction: rtl;
}

.layout-dashboard.layout-dashboard-rtl .header-control span.ant-badge {
  margin: 0px 7px;
}

.layout-dashboard.layout-dashboard-rtl span.ant-input-prefix {
  margin-right: 0px;
  margin-left: 4px;
}

.layout-dashboard-rtl .ant-drawer-left .ant-drawer-content-wrapper {
  left: 0;
  direction: rtl;
}

.settings-drawer.settings-drawer-rtl {
  left: 0;
  direction: rtl;
}

.settings-drawer.settings-drawer-rtl button.ant-drawer-close {
  left: 0px;
  right: auto;
  margin-right: 0px;
  margin-left: var(--scroll-bar);
  padding-left: calc(20px - var(--scroll-bar));
}

.layout-dashboard-rtl .ant-drawer-left .ant-drawer-content-wrapper {
  left: 0;
  direction: rtl;
}

.settings-drawer.settings-drawer-rtl {
  left: 0;
  direction: rtl;
}

.settings-drawer.settings-drawer-rtl button.ant-drawer-close {
  left: 0px;
  right: auto;
  margin-right: 0px;
  margin-left: var(--scroll-bar);
  padding-left: calc(20px - var(--scroll-bar));
}

.settings-drawer.settings-drawer-rtl .sidebarnav-color button {
  margin-right: 0px;
  margin-left: 10px;
}

.settings-drawer.settings-drawer-rtl .viewstar a:first-child {
  border-radius: 0em 0.25em 0.25em 0;
  border-right: 1px solid #ddddde;
}

.settings-drawer.settings-drawer-rtl .viewstar a {
  border-radius: 0.25em 0 0 0.25em;
  border: 1px solid #ddddde;
  border-right: 0px;
}

.social svg path {
  fill: #fff;
}

.settings-drawer.settings-drawer-rtl .social svg {
  margin-right: 0px;
  margin-left: 5px;
}

.social svg {
  width: 15px;
  height: 15px;
}

.layout-dashboard .ant-affix .ant-layout-header {
  background: #fff;
  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);
  margin: 10px 20px;
  z-index: 10;
}

aside.ant-layout-sider.ant-layout-sider-light.sider-primary.ant-layout-sider-primary.active-route a.active {
  background: transparent;
  box-shadow: none;
}

.uploadfile.pb-15 {
  padding-bottom: 16px;
}

.ant-row.ant-form-item.aligin-center .ant-form-item-control-input-content {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

.uploadfile.shadow-none .ant-upload.ant-upload-select.ant-upload-select-text .ant-btn.ant-full-box {
  box-shadow: none;
}

.ant-btn-dashed {
  color: rgba(0, 0, 0, 0.65);
}

button.ant-btn.ant-btn-dashed.ant-full-box svg {
  width: 16px;
  height: 16px;
}

.ant-btn-dashed.active,
.ant-btn-dashed:active {
  color: #096dd9;
  background-color: #fff;
  border-color: #096dd9;
}

section.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile .header-control span.ant-input-affix-wrapper.header-search .anticon-search svg path {
  fill: #8c8c8c;
}

.ant-card-head-wrapper {
  gap: 16px;
  align-items: center;
}

.ant-card-head-wrapper .ant-card-extra {
  gap: 16px;
  align-items: center;
  margin-left: auto;
  justify-content: end;
}

.ant-card-head-title {
  display: block !important;
  flex: 0 0 auto !important;
}

.ant-card-extra {
  display: flex;
  justify-content: space-between;
}

.ant-card-head-wrapper {
  flex-wrap: wrap;
}

.main-new-header-of-table10 {
  gap: 15px;
  flex-wrap: wrap;
}

.ant-input-wrapper.ant-input-group {
  max-width: 260px;
  height: 32px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  overflow: hidden;
}

.ant-input-wrapper.ant-input-group input.ant-input {
  border: none;
}

aside {
  margin: 0 !important;
  padding: 0 !important;
  background: #fff !important;
  /* border-radius: 0px 30px 30px 0px; */
}

/* width */
aside::-webkit-scrollbar {
  width: 1px;
}

/* Handle */
aside::-webkit-scrollbar-thumb {
  background: #fff;
}

.ant-tabs-nav-wrap {
  border-bottom: 1px solid #ddd;
}

.table-responsive .ant-table::-webkit-scrollbar {
  height: 6px;
  touch-action: auto;
  cursor: pointer;
}

.brand {
  padding: 20px;
}

.ant-breadcrumb+.ant-page-header-heading {
  margin-top: 0;
}

.ant-table-pagination.ant-pagination {
  margin: 8px 15px !important;
}

.ant-card-head {
  padding: 0 15px !important;
}

.ant-card-extra {
  padding: 10px 0 !important;
}

.tablespace .ant-card-head-title {
  padding: 10px 0 !important;
  width: 100%;
}

.ant-card-head-wrapper {
  min-height: unset;
}

th,
td {
  padding: 8px 15px !important;
}

td {
  width: 150px !important;
  max-width: 300px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 100% !important;
  background-color: #ffffff24;
  border-bottom: 1px solid #d9d9d9 !important;
}

/* The global \`td\` rule above (150px + min-width:100% !important) was meant
   for data-list tables, but with no scoping it leaks into every <td> on the
   page — including antd DatePicker's internal panels. Quarter/year/decade
   panels lay out their cells in a single row (Q1-Q4, or a decade of years)
   inside a fixed-width 280px container; forcing each cell to 150px blows
   that row out to 600px+, and the picker's own overflow:hidden then
   silently clips whatever falls past the visible edge — Q3/Q4 in the
   Renewal Rate period picker, for instance, with no visible sign anything
   is missing. Undo the leak specifically inside any antd picker panel,
   restoring antd's own default cell sizing there, without touching the
   global rule the real data tables depend on. */
.ant-picker-panel td,
.ant-picker-panel-container td {
  width: auto !important;
  max-width: none !important;
  min-width: 0 !important;
  background-color: transparent !important;
  border-bottom: none !important;
}

.ant-col.ant-form-item-label {
  width: 100%;
  display: block;
  text-align: left;
}

.ant-col.ant-form-item-control {
  flex: 0 0 100%;
}

.ant-space.ant-space-horizontal.ant-space-align-baseline {
  padding: 0 5px;
  position: relative;
  display: block;
}

.ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space.ant-space-horizontal.ant-space-align-baseline {
  flex: 0 0 20%;
  max-width: 20%;
  display: flex;
  align-items: center;
  gap: 0 !important;
}

.ant-space-item {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 -5px;
}

/* Card-toolbar \`<Space>\` rows (Search / filters / action buttons in a Card's
   \`extra\`) need each item to size to its own content and flow left-to-right,
   not stretch to 100% like the dynamic-form-field Space usage above was
   written for. Scoped override rather than touching the global rule, which
   other pages may depend on. */
.gfx-toolbar.ant-space-horizontal {
  display: flex;
  flex-wrap: wrap;
}
.gfx-toolbar.ant-space-horizontal .ant-space-item {
  display: inline-flex;
  width: auto;
  margin: 0;
}

/* Toolbars that must never wrap to a second row (e.g. Contract Management's
   modal toolbar): let the extra area use the card head's full width, and
   scroll horizontally as a last resort instead of stacking rows. */
.gfx-toolbar-card .ant-card-head-wrapper {
  flex-wrap: nowrap;
}
.gfx-toolbar-card .ant-card-extra {
  flex: 1 1 auto;
  min-width: 0;
  margin-left: auto;
}
.gfx-toolbar-nowrap.ant-space-horizontal {
  flex-wrap: nowrap;
  max-width: 100%;
  overflow-x: auto;
  padding-bottom: 2px;
}

/* Payment Records cards: the title is multi-line (contract dates, amount,
   terms), so undo Ant Design's default single-line ellipsis clipping that was
   cutting the left edge of the title text. */
.payment-record-card .ant-card-head-title {
  overflow: visible;
  white-space: normal;
  text-overflow: clip;
}

/* Contract Management table uses rowSpan to merge contract-level cells across a
   contract's payment rows. Ant's per-row hover highlight only tints the hovered
   row, so the un-merged payment cells (Amount / Paid Through) looked like stray
   white boxes against a tinted row. Kill the hover tint entirely so every cell
   stays a uniform white and the merged group reads as one block. */
.gfx-contract-table .ant-table-tbody > tr.ant-table-row:hover > td,
.gfx-contract-table .ant-table-tbody > tr.ant-table-row-hover > td,
.gfx-contract-table .ant-table-tbody > tr > td.ant-table-cell-row-hover,
.gfx-contract-table .ant-table-tbody > tr:hover > td.ant-table-cell {
  background: #ffffff !important;
  background-color: #ffffff !important;
}

.anticon[tabindex] {
  height: 45px;
  width: 50px;
  border-radius: 0px 25px 25px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  margin-top: 0;
  right: 6px;
  top: 23px;
  color: #fff;
  font-weight: bold;
  color: black;
}

.ant-form-item-label>label {
  height: unset;
}

.ant-row {
  width: 100%;
}

.ant-space-item .ant-space-item {
  display: block;
}

.ant-space-item .ant-space-item input {
  padding-right: 15px;
}

.ant-space.ant-space-horizontal.ant-space-align-baseline .ant-row.ant-form-item-row {
  display: block;
}

.ant-form-item-label>label {
  display: block;
  height: unset !important;
}

.ant-select.ant-select-in-form-item {
  height: 100%;
  min-height: 45px !important;
}

span.ant-upload-span {
  justify-content: space-between !important;
}

.ant-select.ant-select-in-form-item .ant-select-selector {
  height: 100% !important;
  border-radius: 8px !important;
  box-shadow: inset 0 0 20px 20px #f7f8f9 !important;
  outline: none;
  border: 1px solid #e8ecf4 !important;
  width: 100% !important;
}

.ant-form-item .ant-form-item-control-input-content .ant-select-selection-search {
  margin: 0px !important;
}

.nottfy-add span.ant-select-selection-placeholder {
  line-height: 42px !important;
}

.ant-form-item.form-add-option {
  margin-bottom: 0;
  width: 40px;
  height: 40px;
}

.ant-form-item.form-add-option button {
  margin-top: 6px;
  width: 40px;
  height: 40px;
  background: #2563eb;
  padding: 0;
  border: 0;
}

.ant-form-item.form-add-option button span.anticon.anticon-plus {
  justify-content: center;
  padding: 0;
  margin: 0;
  width: 100%;
}

.ant-form-item.form-add-option button span.anticon.anticon-plus svg {
  margin-right: 0;
  fill: #000 !important;
}

.signin-bg {
  height: 100%;
}

.signin-bg img {
  height: 100%;
  width: 100%;
}

button.ant-btn.ant-btn-text.ant-btn-sm.ant-btn-icon-only.ant-upload-list-item-card-actions-btn {
  background: none !important;
  border: none !important;
}

a.ant-upload-list-item-name {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 320px !important;
  width: 100% !important;
}

.ant-space.ant-space-horizontal.ant-space-align-baseline .ant-row {
  margin: 0 -5px;
}

.ant-space.ant-space-horizontal.ant-space-align-baseline .ant-col {
  padding: 0 5px;
}

.signin-box {
  width: 100%;
  inset: 0;
  margin: 0 auto;
  max-width: 600px;
  background: #E8F9FF;
  border: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  justify-content: center;
  height: 100vh;
}

.layout-signin-rowsss {
  height: 100vh;
}

section.ant-layout.layout-default.layout-signin {
  height: 100vh;
}

.signup-logo {
  text-align: center;
  padding: 15px 0px;
}

.signup-logo img {
  max-width: 130px;
}

.signup-logo h4 {
  font-size: 19px;
  margin: 0;
  margin-top: 10px;
  font-weight: 700;
  color: #3B6B94;
}

.signin-box .ant-row {
  margin: 0 !important;
}

.ant-menu-submenu-arrow:after,
.ant-menu-submenu-arrow:before {
  background-color: rgb(0 0 0 / 70%) !important;
}

button.ant-btn.ant-btn-link.sidebar-toggler.ps-0.d-none.d-lg-block {
  border: none !important;
}

.signup-form {
  padding: 40px;
}

.ant-input-group-wrapper {
  width: fit-content !important;
}

h6.profile-picture.profile-picture-new-picture img {
  width: 100px;
  border-radius: 10px;
  height: 100px;
}

main.ant-layout-content.signin {
  padding: 0px;
  margin: 0;
}

.signin-box h1 {
  font-size: 34px !important;
  font-weight: 700 !important;
  margin-bottom: 0 !important;
  text-align: left;
  text-transform: uppercase;
}

.signin-box h5 {
  font-size: 16px !important;
  font-weight: 500 !important;
  margin-top: 5px !important;
  margin-bottom: 35px !important;
  text-align: left;
}

.signin-box .ant-btn-primary {
  padding: 10px;
  height: 40px;
  border-radius: 10px;
  box-shadow: none !important;
  background: #3B6B94 !important;
  border: none !important;
}

.signin-box .ant-switch-checked {
  background-color: #3B6B94 !important;
}

.signin-box .ant-input,
.username span.ant-input-affix-wrapper.ant-input-password {
  height: 45px;
  border-radius: 8px !important;
  border: 1px solid #e8ecf4 !important;
  outline: none !important;
  box-shadow: inset 0 0 20px 20px #f7f8f9 !important;
  background-color: #3B6B94 !important;
  width: 100%;
  background-image: none !important;
  color: #686868 !important;
  background: #f7f8f9 !important;
}

input#password {
  box-shadow: inset 0 0 20px 20px #f7f8f9 !important;
  border: none !important;
}

.signin-box .ant-input::placeholder {
  color: #686868 !important;
}

input#password {
  height: 100%;
}

.sign-rightouter img {
  max-width: 800px;
  width: 100%;
}

/* .signin-bg {
  background-image: url(../images/bg-light.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 100vh;
  width: 100%;
  display: flex !important;
  justify-content: center;
  align-items: center;
  padding: 0 40px;
} */
.ant-card-body {
  padding: 15px;
}

footer.ant-layout-footer {
  background: #f4f3ef !important;
  position: fixed;
  bottom: 0;
  width: 100%;
}

span.icon img {
  max-width: 18px;
  width: 18px;
  max-height: 18px;
  filter: brightness(23.5);
}

.ant-select-single .ant-select-selector .ant-select-selection-item,
.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  padding: 0;
  line-height: 42px !important;
}

/* .layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-primary .ant-menu-item .active .icon img {
  filter: none;
} */

span.ant-input-group-wrapper.ant-input-search.ant-input-search-large.searchbar-layout {
  width: fit-content;
}

.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item:last-child a {
  border-bottom: 0;
}

.ant-btn-primary {
  background: #3B6B94 !important;
  border-color: #3B6B94 !important;
  padding: 10px 24px !important;
  height: 40px !important;
  border-radius: 8px !important;
  line-height: 1;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
}

.ant-btn-View {
  display: inline-flex !important;
  height: 40px !important;
  align-items: center;
  justify-content: center;
  border-radius: 8px !important;
  background: #3B6B94 !important;
  color: #fff !important;
  border-color: #3B6B94 !important;
}
.ant-btn-default {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
}

.main-all-buttonclassokjh {
  display: flex;
  align-items: center;
  gap: 10px;
}

.all-check-box-desing {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
  column-gap: 15px;
}

.all-check-box-desing .ant-checkbox-wrapper+.ant-checkbox-wrapper {
  margin: 0px !important;
}

.ant-btn-default:hover {
  background: #fff !important;
  border-color: #2563eb !important;
  color: #2563eb !important;
}

.ant-btn-primary:hover,
.ant-btn:hover {
  background: #3B6B94;
  color: white;
}

.ant-modal-body {
  padding: 20px !important;
}

/* Assistant/Sub-Client management modals (pages/accessModule/AssistantsTab.js) —
   opts out of the default above for a more breathable Add/Edit Assistant form. */
.assistant-form-modal .ant-modal-content {
  padding: 0 !important;
  border-radius: 16px !important;
  overflow: hidden;
}
.assistant-form-modal .ant-modal-header {
  padding: 20px 28px !important;
  margin-bottom: 0 !important;
  border-bottom: 1px solid var(--border, #E7E9F2) !important;
}
.assistant-form-modal .ant-modal-close {
  top: 14px !important;
  right: 16px !important;
}
.assistant-form-modal .ant-modal-body {
  padding: 24px 28px !important;
  max-height: 60vh;
  overflow-y: auto;
}
.assistant-form-modal .ant-form-item {
  margin-bottom: 20px;
}
.assistant-form-modal label {
  font-weight: 600 !important;
}
.assistant-form-modal .ant-modal-footer {
  padding: 16px 28px !important;
  margin-top: 0 !important;
  border-top: 1px solid var(--border, #E7E9F2) !important;
}
.assistant-form-modal .ant-modal-footer .ant-btn {
  height: 40px !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.ant-modal-footer {
  padding: 20px;
}

.ant-modal-body input,
span.ant-input-affix-wrapper.ant-input-password,
span.ant-input-affix-wrapper.ant-input-password.ant-input-affix-wrapper-has-feedback {
  height: 45px;
  border-radius: 10px;
  border: 1px solid #e8ecf4 !important;
  background: #f7f8f9 !important;
  box-shadow: inset 0 0 20px 20px #f7f8f9 !important;
}

input#password,
input#old_password,
input#new_password,
input#newPassword,
input#confirm_new_password,
input#new_password,
input#confirm_new_password {
  box-shadow: inset 0 0 20px 20px #f7f8f9 !important;
  border: none !important;
  height: 100%;
}

.wrapperClassName.rdw-editor-wrapper {
  border: 1px solid #ddd !important;
}

.editorClassName.rdw-editor-main {
  padding: 10px;
}

.public-DraftStyleDefault-block.public-DraftStyleDefault-ltr {
  margin: 0;
}

.main-new-updater-image-okik {
  display: flex;
  align-items: center;
  gap: 20px;
}

.main-new-graph-class-oki h2 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
}

.ant-picker-input input {
  background: #ffffff !important;
  background-color: #ffffff !important;
  border: none !important;
  box-shadow: unset !important;
}

.react-tel-input .selected-flag {
  border-radius: 8px 0 0 8px !important;
}

.ant-table-cell .ant-btn {
  height: 30px !important;
  overflow: hidden !important;
}

.ant-modal-body .ant-picker {
  height: 45px;
  width: 100% !important;
  border-radius: 8px;
}

.ant-modal-body .ant-input-affix-wrapper {
  padding: 0 10px;
  border-radius: 8px;
}

.ant-modal-header {
  padding: 10px 15px;
}

.ant-input-number.ant-input-number-in-form-item {
  width: 100% !important;
  border-radius: 8px;
}

.ant-modal-header {
  padding: 20px !important;
}

.ant-table-tbody>tr>td.ant-table-cell button.ant-btn.ant-btn-default {
  background: #3B6B94 !important;
  margin-right: 10px;
  color: #ffffff !important;
  border: none !important;
  display: flex !important;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 14px;
}
button.ant-btn.ant-btn-default.ant-btn-block.add-brand-button {
    border: 1px solid #3b6b94 !important;
    background: white !important;
    color: #3b6b94 !important;
}
.ant-table-tbody>tr>td.ant-table-cell button.ant-btn.tb-view {
  background: #2563eb !important;
  margin-right: 10px;
  color: #fff !important;
  border: none;
  display: flex !important;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 14px;
}

td.ant-table-cell .cta_wrap {
  display: flex;
  align-items: center;
}

.ant-pagination-item-active:hover a {
  color: #2563eb !important;
}

.ant-pagination-item:hover a {
  color: #3B6B94 !important;
  border-color: #3B6B94 !important;
}

.ant-modal-content .react-tel-input .form-control {
  height: 42px;
  width: 100%;
  border-radius: 8px;
}

.ant-pagination-item-active:hover a {
  color: #ffffff !important;
}

.react-tel-input .flag-dropdown {
  position: absolute;
  top: 0;
  bottom: 0;
  padding: 0;
  background-color: #f5f5f5;
  border: 1px solid #cacaca;
  border-radius: 8px 0 0 8px !important;
}

.ant-input-wrapper.ant-input-group button {
  background-color: #3B6B94 !important;
  border: none !important;
  color: #ffffff !important;
  border-radius: 0 8px 8px 0 !important;
  box-shadow: none !important;
}

.ant-input-search>.ant-input-group>.ant-input-group-addon:last-child {
  left: 0px !important;
}

.signup-form .ant-form-item:last-child {
  margin-bottom: 0;
}

.ant-modal-body form .ant-modal-body .ant-row .ant-col.ant-col-12:last-child .ant-form-item {
  margin-bottom: 0;
}

.ant-pagination-item-active a {
  color: #fff !important;
  background-color: #3B6B94 !important;
}

.ant-pagination-item-active {
  border-color: #3B6B94 !important;
}

.ant-pagination-item {
  border-radius: 8px !important;
  overflow: hidden;
}

.ant-pagination-prev button,
.ant-pagination-next button {
  border-radius: 8px !important;
}

.ant-pagination-prev button,
.ant-pagination-next button {
  border-radius: 8px !important;
  border-color: #3B6B94 !important;
  color: #3B6B94 !important;
}

.layout-dashboard .ant-layout-sider.sider-primary .brand a {
  color: #ffffff !important;
  font-size: 20px;
  font-weight: 700;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

::-webkit-scrollbar {
  width: 5px;
  background-color: #3B6B94;
}

::-webkit-scrollbar-thumb {
  background-color: #3B6B94 !important;
}

.ant-btn .anticon svg {
  margin-right: 0;
}

.view-inner-cls {
  display: flex;
  align-items: center;
  border-bottom: solid 1px #f1f1f1;
  padding: 10px 0px;
}

.view-inner-cls:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.view-inner-cls:first-child {
  padding-top: 0;
}

.view-main-list {
  border-right: solid 1px #d3d3d3;
  padding-right: 15px;
}

.view-inner-cls h5 {
  margin-bottom: 0;
  font-size: 15px;
  font-weight: 600;
  max-width: 600px;
  width: 100%;
}

.view-page-header h1 {
  font-size: 23px;
  font-weight: 700;
  margin-bottom: 20px;
}

.view-inner-cls h6 {
  margin-bottom: 0;
  font-size: 13px;
  margin-left: auto;
  text-align: end;
  line-height: 21px;
  font-weight: 600;
  flex: 0 0 auto;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
  width: 40%;
}

/* ═══════════════════════════════════════════════════════════════
   Customer View Details page — scoped to .customer-view-page so this
   doesn't touch .view-inner-cls/.label-quote-card, which other View
   pages across the app still use as-is.
   ═══════════════════════════════════════════════════════════════ */
.customer-view-page .cvp-card {
  border-radius: 14px;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);
}
.customer-view-page .cvp-header {
  display: flex;
  align-items: center;
  gap: 20px;
}
.customer-view-page .cvp-avatar {
  width: 72px;
  height: 72px;
  flex-shrink: 0;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eaf6f7 0%, #eef4fb 100%);
  color: #3b6b94;
  font-size: 28px;
  box-shadow: 0 0 0 1px #e6ecf4;
}
.customer-view-page .cvp-avatar .ant-image,
.customer-view-page .cvp-avatar .ant-image img {
  width: 72px;
  height: 72px;
  object-fit: cover;
}
.customer-view-page .cvp-name {
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 2px;
  color: #1e293b;
}
.customer-view-page .cvp-email {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 10px;
}
.customer-view-page .cvp-status-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.customer-view-page .cvp-status-row .ant-tag {
  border-radius: 999px;
  padding: 2px 12px;
  font-weight: 600;
  font-size: 12px;
  border: none;
  margin: 0;
}
.customer-view-page .cvp-divider {
  height: 1px;
  background: #eef1f5;
  margin: 24px 0 20px;
}
.customer-view-page .cvp-section-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 14px;
}
.customer-view-page .cvp-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  gap: 20px 32px;
}
.customer-view-page .cvp-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.customer-view-page .cvp-field-label {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 600;
}
.customer-view-page .cvp-field-value {
  font-size: 14px;
  color: #334155;
  font-weight: 600;
  word-break: break-word;
}
.customer-view-page .cvp-empty {
  color: #bbb;
  font-weight: 400;
}
@media (max-width: 576px) {
  .customer-view-page .cvp-grid {
    grid-template-columns: 1fr;
  }
  .customer-view-page .cvp-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

span.anticon.anticon-delete.delete-circal {
  background: #ff4700;
  border-radius: 7px !important;
  color: white;
  font-size: 19px;
  width: 35px;
  height: 35px;
}

.view-main-list.border-right-0 {
  border-right: 0;
  padding-right: 0;
}

.ant-card-head-title {
  padding: 10px 0 !important;
}

.profile-nav-inner {
  display: flex;
  gap: 10px;
}

.profile-nav-inner button.ant-btn:last-child {
  margin-bottom: 0;
}

.profile-nav-inner button.ant-btn {
  padding: 0 15px;
}
span.ant-input-group-wrapper.ant-input-search.searchInput input.ant-input {
    border: none !important;
}
.profile-nav {
  margin-top: 15px !important;
}

.card-profile-head .ant-card-head-wrapper {
  display: block;
  width: 100%;
}

.card-profile-head .ant-card-head-wrapper .ant-avatar-group {
  width: 100%;
}

.card-profile-head .ant-card-head-wrapper .ant-avatar-group .avatar-info {
  margin-left: auto;
  text-align: right;
}

.card-profile-head .ant-card-head {
  padding: 0 !important;
  padding-left: 15px !important;
}

.card-profile-head .ant-card-head-wrapper .ant-avatar-group .avatar-info h4 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 0;
}

.card-profile-head .ant-card-head-wrapper .ant-avatar-group .avatar-info p {
  font-size: 14px;
}

.card-profile-head .ant-card-head-wrapper .ant-avatar-group span.ant-avatar.ant-avatar-square.ant-avatar-image {
  border-radius: 50%;
}

.ant-upload-list-picture .ant-upload-list-item-thumbnail,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail {
  line-height: 40px !important;
  height: 40px !important;
  width: 40px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ant-upload-list-picture .ant-upload-list-item,
.ant-upload-list-picture-card .ant-upload-list-item {
  height: 45px !important;
  margin-top: 0 !important;
  position: relative !important;
  border-radius: 8px !important;
}

span.ant-upload-list-item-card-actions.picture {
  position: unset !important;
}

span.ant-upload-list-item-card-actions.picture .ant-upload-list-item-card-actions-btn span.anticon.anticon-delete {
  position: absolute !important;
  top: -13px !important;
  right: -9px !important;
  border-radius: 0px 8px 8px 0px;
  height: 45px;
}

span.ant-upload-list-item-card-actions.picture .ant-upload-list-item-card-actions-btn span.anticon.anticon-delete svg {
  fill: #000 !important;
  font-size: 18px !important;
}

.ant-upload button.ant-btn.ant-btn-default {
  width: 100% !important;
}

.ant-table-content span.ant-avatar.ant-avatar-square {
  height: 40px !important;
  width: 40px !important;
  line-height: 40px !important;
}

.table-responsive .ant-table {
  overflow: auto;
}

.change-pw span.anticon.anticon-eye-invisible.ant-input-password-icon {
  top: 0px;
  right: 0px;
}

/* .change-pw span.anticon.anticon-eye-invisible.ant-input-password-icon svg {
  filter: brightness(0) invert(1) !important;
} */
.forgot-pass {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.forgot-pass .ant-form-item.aligin-center {
  margin-bottom: 0;
}

.ant-switch-checked {
  background: #141414 !important;
}

span.anticon.anticon-eye-invisible.ant-input-password-icon {
  top: 0px !important;
  right: 0px !important;

  margin: 0 !important;
}

span.anticon.anticon-eye-invisible.ant-input-password-icon svg {
  fill: #000;
}

span.anticon.anticon-eye.ant-input-password-icon svg {
  fill: #000 !important;
}

span.anticon.anticon-eye.ant-input-password-icon {
  top: 0px;
  right: 0px;
  margin-right: 0;
}

.forgate-btn {
  background-color: transparent !important;
  color: #020202 !important;
  border: 0px;
  font-weight: 600;
  box-shadow: none !important;
}

.main-new-class-image-no img {
  width: 100%;
  height: 100%;
  max-width: 50px;
}

td.ant-table-cell .ant-select-selector {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px !important;
}

.ant-input-affix-wrapper {
  padding: 0 !important;
  border-radius: 8px;
}

.ant-modal-confirm-body span.anticon.anticon-exclamation- {
  display: block;
}

span.add-services-close-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.ant-modal-confirm-body-wrapper .ant-modal-confirm-body span.anticon.anticon-exclamation-circle {
  width: 100%;
  display: block;
  margin-right: 0px !important;
  font-size: 60px;
  margin-bottom: 15px;
  color: #3b6b94 !important;
}

.ant-form-item.add-services-close-button-from label {
  width: 100%;
}

.pointer {
  cursor: pointer;
}

.ant-modal-confirm-body-wrapper .ant-modal-confirm-body .ant-modal-confirm-content button.ant-btn.ant-btn-default {
  width: 100%;
  background: transparent !important;
  border: 0 !important;
  color: #252425 !important;
  box-shadow: none !important;
  font-size: 22px;
  white-space: normal;
  line-height: 1.2;
  font-weight: 600;
  padding: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
  height: unset;
}

.ant-input-affix-wrapper>.ant-input:not(textarea) {
  padding: 0 10px !important;
  border-radius: 8px;
}

.ant-upload-list-picture .ant-upload-list-item-thumbnail img,
.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {
  width: 40px !important;
  height: 40px !important;
  overflow: hidden;
  object-fit: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ant-input-number.ant-input-number-in-form-item.ant-input-number-status-success.position-number {
  width: 206px !important;
}

.ant-input-number.ant-input-number-in-form-item.ant-input-number-status-error.position-number {
  width: 206px !important;
}

.ant-input-number.ant-input-number-in-form-item.position-number {
  width: 206px !important;
}

.ant-form-horizontal .ant-form-item-control {
  min-width: unset !important;
}

.customRow .ant-form-item-row {
  display: flex;
}

.add-question-form .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space-item+.ant-space-item {
  flex: 0 0 40px;
  max-width: 40px;
  margin-left: 5px !important;
  height: 40px;
}

.add-question-form .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space-item {
  width: 100%;
  flex-basis: calc(100% - 55px);
  max-width: calc(100% - 55px);
}

.add-question-form .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space-item .ant-form-item .ant-row.ant-form-item-row {
  margin: 0 !important;
}

.add-question-form .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space-item .ant-form-item .ant-col.ant-form-item-control {
  padding: 0;
}

.add-question-form .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space-item+.ant-space-item span.anticon.anticon-minus-circle {
  border-radius: 2px;
  height: 40px;
  width: 40px;
  margin-top: -1px;
  position: unset;
}

.add-question-form .ant-form-item.form-add-option .ant-row.ant-form-item-row {
  margin: 0 !important;
}

.add-question-form .ant-form-item.form-add-option .ant-row.ant-form-item-row .ant-col.ant-form-item-control {
  margin-top: -1px;
  padding: 0;
}

.add-question-form .ant-form-item.form-add-option .ant-row.ant-form-item-row .ant-col.ant-form-item-control button.ant-btn.ant-btn-dashed.ant-btn-icon-only.ant-btn-block {
  margin-top: 0;
}

.add-question-form .ant-space-item {
  align-items: center;
}

.add-question-form .ant-input-number.ant-input-number-in-form-item.position-number {
  width: 100% !important;
}

.add-question-form .ant-input-number.ant-input-number-in-form-item.position-number input {
  height: 38px !important;
}

.ant-form-item.add_btn_wrap {
  width: auto !important;
  margin-top: 15px;
}

.ant-form-item.add_btn_wrap .ant-col.ant-form-item-control {
  width: auto !important;
  flex: 0 0 100%;
  padding: 0 5px;
}

.ant-form-item.add_btn_wrap .ant-row.ant-form-item-row {
  margin: 0 -5px;
}

.ant-form-item.add_btn_wrap button.ant-btn.ant-btn-dashed.ant-btn-block {
  height: 40px;
}

.ant-form-item.add_btn_wrap button.ant-btn.ant-btn-dashed.ant-btn-block {
  height: 40px;
}

.ant-row.question-position-wrap {
  margin: 0 !important;
}

.ant-row.question-position-wrap .ant-col {
  padding: 0 !important;
}

.add-question-inner-form .ant-space-item {
  margin: 0 !important;
}

.add-question-inner-form .ant-space-item .ant-col .ant-row.ant-form-item-row {
  margin: 0 !important;
}

.add-question-inner-form .ant-space-item .ant-col .ant-row.ant-form-item-row .ant-col.ant-form-item-label {
  padding: 0 !important;
}

.add-question-inner-form .ant-space-item .ant-col .ant-row.ant-form-item-row .ant-col.ant-form-item-control {
  padding: 0 !important;
}

.add-question-inner-form .ant-space.ant-space-horizontal.ant-space-align-baseline {
  padding: 0 !important;
}

.ant-row.customRow {
  margin: 0 -5px;
}

.ant-row.customRow .ant-col {
  padding: 0 5px;
}

.ant-row.customRow .ant-col .ant-col {
  padding: 0 !important;
}

.ant-form-item.footer-btn-cls .ant-form-item-control-input-content {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin: 0 -5px;
}

.ant-form-item.footer-btn-cls .ant-form-item-control-input-content button.ant-btn.ant-btn-primary {
  margin-right: 5px;
  margin-left: 5px;
}

.add-question-inner-form {
  margin-bottom: 15px;
}

.add-question-inner-form span.anticon.anticon-minus-circle {
  border-radius: 2px;
  height: 40px;
  width: 40px;
  /* margin-top: -1px; */
}

.ant-picker .ant-picker-input>input {
  min-width: 100px;
}

.ant-picker {
  padding: 8px 16px !important;
  border-radius: 8px !important;
  box-shadow: none !important;
}

.ant-select.ant-select-multiple .ant-select-selector {
  padding: 8px 11px !important;
  border-radius: 8px !important;
}

.successPageOuter {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.submit-new-main-buttonh .ant-form-item-control-input-content {
  display: flex;
  justify-content: end;
}

.main-new-location-newh label {
  width: 100%;
}

.succesOuter {
  padding: 50px;
  max-width: 700px;
}

.succesOuter .logo-wrap {
  width: 120px;
  margin: 0 auto;
}

.succesOuter .logo-wrap img {
  width: 100%;
}

.successCardContent {
  padding-top: 50px;
}

.successCardContent .icon {
  width: 100px;
  height: 100px;
  border-radius: 50px;
  overflow: hidden;
  margin: 0 auto;
}

.successCardContent .icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
}

.successCardContent .thankyou-cont h3 {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  color: green;
  margin: 16px 0 0;
}

.successCardContent .thankyou-cont .pera {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  color: #5c5c5c;
  margin-top: 8px;
}

/* .ant-picker:hover, .ant-picker.ant-picker-focused {
  border-color: #252425 !important;
  box-shadow: none !important;
 }
 .ant-picker-range .ant-picker-active-bar {
  background: #252425 !important;
 } */

/* td.ant-table-cell:has(>.cta_wrap) {
  min-width: 300px !important;
} */
.ant-table-thead>tr>th {
  position: relative;
  color: rgb(255 255 255 / 100%) !important;
  font-weight: 600 !important;
  text-align: left;
  background: #3B6B94 !important;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
}

.ant-table-filter-dropdown-btns button.ant-btn.ant-btn-primary.ant-btn-sm {
  padding: 5px !important;
  width: 50px;
  height: 30px !important;
}

.ant-table-filter-dropdown-btns {
  align-items: center;
}

.ant-modal-content {
  position: relative;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-radius: 8px !important;
  overflow: hidden !important;
  box-shadow: 0 3px 6px 4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05) !important;
  pointer-events: auto;
}

.ant-modal-title {
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600 !important;
  font-size: 22px !important;
  line-height: 22px;
  word-wrap: break-word;
  text-align: center;
}

/* .ant-modal {
  max-width: 600px !important;
  width: 600px !important;
} */
button.notification-box.dropdown-toggle.btn.btn-primary {
  padding: 0;
  border: 0;
  background: transparent !important;
  position: relative;
  width: 30px;
}

button.notification-box.dropdown-toggle.btn.btn-primary:after {
  content: "";
  inset: unset !important;
  position: absolute;
  height: 8px;
  width: 8px;
  background: #ff3b30;
  border-radius: 50%;
  top: 0px !important;
  right: 0px !important;
  opacity: 1 !important;
  box-shadow: none !important;
  outline: 0 !important;
  border: 0 !important;
}

button.profile-box.dropdown-toggle.btn.btn-primary {
  background-color: transparent;
  border: none;
  padding: 0px !important;
}

.profileDropdownMain {
  margin-left: 25px;
}

.profileDropdownMain {
  align-items: center;
  display: flex;
  gap: 8px;
}

.profileDropdownMain .ant-btn.ant-btn-default.ant-dropdown-trigger {
  background-color: initial !important;
  border: none !important;
  box-shadow: none !important;
  color: #000 !important;
  display: block !important;
  font-size: 14px;
  height: auto !important;
  line-height: normal;
  padding: 0;
  text-align: end;
}

.userImg {
  align-items: center;
  background: #fff;
  border: 1px solid #cbcbcb;
  border-radius: 50%;
  display: flex;
  height: 50px;
  justify-content: center;
  overflow: hidden;
  width: 50px;
}

.userImg {
  align-items: center;
  background: #fff;
  border: 1px solid #cbcbcb;
  border-radius: 50%;
  display: flex;
  height: 50px;
  justify-content: center;
  overflow: hidden;
  width: 50px;
}

.profileDropdownMain .ant-image img {
    height: 100%;
    object-fit: cover;
    object-position: top;
    width: 100%;
    max-width: 40px;
}

.profileDropdownMain .ant-btn.ant-btn-default.ant-dropdown-trigger .userName {
  font-size: 15px;
  font-weight: 700;
}

button.profile-box.dropdown-toggle.btn.btn-primary img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.ant-tabs-tab.ant-tabs-tab-active {
  background-color: #3B6B94b3;
  color: #fff;
  border-color: #3B6B94b3;
}

.pageHeadingSearch.pageHeadingSearchnew-add-faqq {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 10px;
}

.title-left h4 {
  margin: 0;
}

button.ant-btn.ant-btn-default.ant-dropdown-trigger.notification-box:hover img {
  filter: brightness(0);
}

.button-sec.main-new-add-faq-butons_main {
  display: flex;
  align-items: center;
  justify-content: end;
}

.primary_btn.btnStyle.main-new-add-faq-butons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: white !important;
  background: #3B6B94 !important;
}

.ant-card-head-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.main-new-lat-10-biiking-header h4 {
  font-size: 20px;
  font-weight: 600;
  line-height: 20px;
}

.primary_btn.btnStyle.main-new-add-faq-butons img {
  filter: brightness(100);
}

.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #ffffff;
  text-shadow: 0 0 0.25px currentcolor;
  font-size: 14px;
  font-weight: 600;
}
.ant-tabs.client-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  text-shadow: none !important;
  color: #ffffff !important;
  background: transparent !important;
}

.ant-tabs-ink-bar {
  background: transparent !important;
}

.ant-tabs:not(.client-tabs) .ant-tabs-tab {
  padding: 10px !important;
  font-size: 14px !important;
  font-weight: 600;
  max-width: 300px !important;
  width: 100% !important;
  min-width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f7f8f9 !important;
  border-radius: 8px;
  margin: 5px !important;
  border: 1px solid #e8ecf4 !important;
  color: #ababab !important;
}

.notification-box.show.dropdown .dropdown-menu.show {
  box-shadow: 0px 0px 25px 0px #0000000f;
  border-radius: 20px;
  margin: 0 !important;
  width: fit-content;
  overflow: hidden;
}

.ant-input-number-input {
  width: 100%;
  height: 40px !important;
  outline: none !important;
  box-shadow: none !important;
  border-radius: 8px;
}

li.ant-menu-submenu.ant-menu-submenu-inline.car-menagments {
  padding: 10px 16px;
  color: #ffffff;

  white-space: nowrap;
  border-bottom: solid 1px #cccccc29;
  border-radius: 0 !important;
}

i.ant-menu-submenu-arrow {
  color: #fff;
}

li.ant-menu-submenu.ant-menu-submenu-inline.car-menagments:hover i.ant-menu-submenu-arrow {
  color: #fff;
}

li.ant-menu-submenu.ant-menu-submenu-inline.car-menagments ul.ant-menu.ant-menu-sub.ant-menu-inline {
  background-color: #3e4245;
}

li.ant-menu-submenu.ant-menu-submenu-inline.car-menagments .ant-menu-submenu-title:hover {
  color: #fff;
}

.ant-picker-range .ant-picker-clear {
  right: 34px !important;
}

.ant-tag-green {
  color: #ffffff !important;
  background: #2ebf57 !important;
  border-color: #2ebf57 !important;
  border-radius: 0.375rem !important;
  cursor: pointer;
}

.w-100.d-flex.align-items-baseline.text-head_right_cont {
  align-items: center !important;
  gap: 10px;
}

.ant-tag-red {
  border-radius: 0.375rem !important;
  color: #fff !important;
  background: #fa4545 !important;
  border-color: #fa4545 !important;
  cursor: pointer;
}

.main-new-contact-us-form10 {
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
}

.ant-tabs-tab:hover {
  color: #000000;
}
.main-new-contact-us-form10 input.form-control {
    height: 45px !important;
    border-radius: 8px !important;
    border: 1px solid #e8ecf4 !important;
    background: #f7f8f9 !important;
    box-shadow: inset 0 0 20px 20px #f7f8f9 !important;
    overflow: hidden;
    width: 100%;
}
.main-new-contact-us-form10 .ant-form-item-control-input-content input {
    height: 45px !important;
}
span.main-caricon img {
  display: inline-flex;
  flex: 0 0 20px;
  max-width: 20px;
  width: 20px;
  max-height: 20px;
  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  margin-right: 11px;
  vertical-align: middle;
  filter: brightness(23.5);
}

.home-cards {
  position: relative;
  display: block;
  margin: 25px 0 30px;
  background-color: #ffffff;
  border-radius: 30px;
}

.home-card-inner {
  padding: 45px 25px 20px;
}

.home-cards .icon {
  position: absolute;
  top: -20px;
  left: 20px;
  z-index: 0;
  font-size: 50px;
  height: 50px;
  width: 50px;
  background-color: #ff9800;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
}

.home-cards .icon img {
  width: 30px;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
  display: block;
}

.card-counts h2 {
  font-size: 30px;
  color: #303841;
  font-weight: bold;
}

.headding-card h4 {
  font-size: 18px;
  color: #303841;
  margin: 0;
}

.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  font-size: 12px;
  text-align: center;
  background-color: #ffffff !important;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  outline: none;
  transition: all 0.3s;
}

.dlx-box h6 {
  font-size: 16px;
  font-weight: 700;
}

/* .dlx-box {
  display: flex;
  gap: 15px;
} */
.dlx-box p {
  font-size: 14px;
  font-weight: 600;
}

.dlx-main-box {
  display: flex;
  flex-wrap: wrap;
  column-gap: 50px;
  row-gap: 15px;
}

.car-filtter img {
  max-width: 50px;
  width: 100%;
  height: 50px;
  object-fit: cover;
  border: 1px solid #ccc;
  border-radius: 10px;
}

.ant-card.criclebox.tablespace.mb-24.new-tabls-button-design .ant-card-body {
  position: relative;
}

.car-filtter {
  display: flex;
  gap: 16px;
  align-items: baseline;
}

.driver-details h4 {
  font-size: 20px;
  font-weight: 600;
  color: #ff9800;
  border-bottom: 1px solid #fecf00;
  margin-bottom: 18px;
}

.textarea-inn textarea {
  border-radius: 15px !important;
}

.ant-select.ant-select-in-form-item.select-show-inn.ant-select-multiple.ant-select-show-search {
  height: 100% !important;
}

.select-show-inn .ant-select-selector {
  border-radius: 15px !important;
}

.timeline {
  max-width: 640px;
  display: flex;
  padding: 34px 30px;
  background-color: #fff;
  border-radius: 18px;
  flex-direction: column;
}

.timeline__header {
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 2px solid #f0f0f8;
  padding: 34px 70px;
  border-radius: 5px;
  position: relative;
}

.timeline__header::after {
  content: "";
  width: 100%;
  height: 70px;
  bottom: 0px;
  left: 0px;
  position: absolute;
  z-index: 2;
  background-color: #f0f0f8;
}

.timeline__header span {
  margin-bottom: 10px;
  text-align: center;
  color: gray;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: bold;
}

.timeline__header h1 {
  margin-bottom: 100px;
  font-size: 20px;
  color: #262245;
  text-align: center;
}

.timeline__header .process {
  height: 8px;
  background-color: #fff;
  border-radius: 3px;
  z-index: 4;
}

.timeline__header .process .xd {
  width: 50%;
  border-radius: 3px;
  height: 8px;
  background-color: #2563eb;
}

.line {
  padding: 10px 90px;
  position: relative;
  /* margin-top: 50px; */
}

.line::before {
  position: absolute;
  width: 2px;
  height: 100%;
  left: 90px;
  background-color: #2563eb;
  content: "";
}

.line .content {
  position: relative;
  padding-left: 30px;
}

.line .content+.content {
  margin-top: 40px;
}

.line .content h1 {
  font-size: 16px;
  margin-bottom: 5px;
  margin-top: 15px;
}

.line .content p {
  font-size: 14px;
}

.line .content::before {
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: #2563eb;
  content: "";
  left: -9px;
  border-radius: 50%;
}

.notification-card {
  margin-top: 16px;
}

.view-main-list {
  padding: 16px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background-color: #fff;
}

.main-dltall-not-all {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 10px;
}

.notification-card .ant-list-item-meta-avatar {
  margin-right: 16px;
  width: 60px !important;
  height: 60px !important;
}

.notification-card span.ant-avatar.ant-avatar-circle.ant-avatar-image {
  width: 60px;
  height: 60px;
  display: flex;
  left: inherit;
  align-items: center;
  justify-content: center;
  background: #d19e6569;
}

h4.main-logo-header-ui98 {
  font-size: 20px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 15px;
}

.view-inner-cls {
  margin-bottom: 12px;
}

/* .ant-popover-arrow {
  display: none;
}
.ant-popover-title {
  text-align: center;
  font-size: 21px;
  font-weight: 700;
  line-height: 30px;
}
.ant-popover-content {
  border-radius: 12px !important;
  overflow: hidden;
  border: 1px solid #00000029;
}
.ant-popover-inner-content {
  padding: 0 !important;
}
.ant-table-cell {
  text-align: center !important;
} */
.notifivation-teexxt.dropdown-menu.show h4 {
  font-size: 16px;
  font-weight: 700;
  line-height: 25px;
}

.notifivation-teexxt.dropdown-menu.show h4 span {
  font-weight: 400 !important;
}

.spin_loader {
  height: 100vh;
  width: 100vw;
  background: #00000052;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1111;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

span.ant-avatar.ant-avatar-circle.ant-avatar-image img {
  width: 30px;
  height: 30px;
}

.ant-select-selector {
    background: #ffffff !important;
    height: 40px !important;
    display: flex;
    align-items: center;
    border-radius: 8px !important;
    border: 1px solid #d9d9d9 !important;
    background-color: #ffffff !important;
    min-width: 120px !important;
    width: 100% !important;
}

span.ant-input-affix-wrapper {
  border: none !important;
}
span.ant-input-affix-wrapper.ant-input-password input {
    border: none !important;
    background: transparent !important;
}
.ant-table-filter-column {
    justify-content: flex-start !important;
    gap: 10px !important;
}
.main-new-upload-graph-name-insturction {
  font-size: 13px;
  font-weight: 600;
  color: #000000a6;
  margin: 0;
  margin-top: 5px;
}

.ant-btn-primary:hover,
.ant-btn:hover {
  background: transparent !important;
  color: transparent;
  border: 1px solid #3B6B94 !important;
  color: #3B6B94 !important;
}

.ant-modal-footer button.ant-btn.ant-btn-primary,
.ant-modal-confirm-btns button.ant-btn.ant-btn-primary {
  background: #3B6B94 !important;
  color: #fff !important;
}

.main-new-add-ons-category-ones-ikj-plus {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-top: 5px;
}

.main-new-add-ons-category-ones-ikj-plus .ant-form-item.add-services-close-button-from {
  width: 100% !important;
}

.main-new-add-ons-category-ones-ikj-plus input#price_add_on {
  width: 100% !important;
}

.ant-select.main-new-select-absolute.ant-select-single.ant-select-show-arrow {
  position: absolute;
  top: 20px;
  right: 20px;
}

/* 
.main-new-time-slot-radiobutton-main4545 {
  background-color: rgb(249, 249, 249);
  padding: 15px;
  border-radius: 8px;
  margin-top: 20px;
} */

.main-new-time-slot-radiobutton {
  display: flex !important;
  align-items: center !important;
  padding: 10px 15px !important;
  background: rgb(255, 255, 255);
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 5px;
}

.main-new-time-slot-radiobutton-main4545 .ant-radio-inner {
  top: -3px !important;
}

.ant-modal-confirm-body span.anticon.anticon-question-circle {
  font-size: 70px;
  margin: 0;
  margin-bottom: 20px;
  width: 100%;
  text-align: center;
  justify-content: center;
}

.main-new-header-of-table10 {
  gap: 15px;
}

span.ant-select-selection-placeholder {
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600;
}

/* Select placeholders inside the table modals (Add/Edit Content Theme, etc.) use the same
   light hint gray as the text inputs, instead of reading like entered text. */
.ant-modal.table_modal span.ant-select-selection-placeholder {
  color: #b8bfc7 !important;
}

.ant-form-item span.ant-input-affix-wrapper.ant-input-affix-wrapper-has-feedback {
  box-shadow: none !important;
}

.main-new-clildren-class-menuy .ant-menu-submenu-title {
  padding: 0px !important;
}

.main-new-clildren-class-menuy span.ant-menu-title-content a {
  padding: 0px 0px !important;
}

.main-new-clildren-class-menuy .active::after {
  background: none !important;
}

.main-new-clildren-class-menuy .ant-menu-submenu-arrow::before,
.main-new-clildren-class-menuy .ant-menu-submenu-arrow::after {
  background-color: #000 !important;
}

.main-new-clildren-class-menuy .ant-menu-submenu-arrow:hover:before,
.main-new-clildren-class-menuy .ant-menu-submenu-arrow:hover::after {
  background-color: #000 !important;
}

li.ant-menu-submenu.ant-menu-submenu-inline.main-new-clildren-class-menuy102.ant-menu-submenu-active .ant-menu-submenu-arrow::before,
li.ant-menu-submenu.ant-menu-submenu-inline.main-new-clildren-class-menuy102.ant-menu-submenu-active .ant-menu-submenu-arrow::after {
  background-color: #000 !important;
}

.main-new-clildren-class-menuy .ant-menu-submenu-expand-icon,
.main-new-clildren-class-menuy .ant-menu-submenu-arrow {
  right: 23px !important;
}

.main-new-clildren-class-menuy ul.ant-menu.ant-menu-sub.ant-menu-inline {
  margin-left: 25px;
  background: none !important;
}

.ant-menu-submenu-title {
  padding-left: 0px !important;
}

.ant-menu-submenu-title {
  margin: 6px 15px !important;
  padding: 0px !important;
  border-radius: 10px;
  width: unset !important;
  font-weight: 500 !important;
  padding: 6px 16px !important;
  color: #000 !important;
}

.ant-menu-submenu-title span.ant-menu-title-content {
  margin: 0px !important;
}

li.ant-menu-submenu span.ant-menu-title-content a {
  margin-left: 30px !important;
}

.ant-modal-footer {
  display: flex;
  align-items: center;
  justify-content: end;
}

.ant-card-head-wrapper input.ant-input.ant-input-lg {
  border: none !important;
}

.notification-header img {
  filter: brightness(100) !important;
}

ul.ant-menu.ant-menu-sub.ant-menu-inline li.ant-menu-item.ant-menu-item-only-child a {
  line-height: 30px;
}

ul.ant-menu.ant-menu-sub.ant-menu-inline li.ant-menu-item.ant-menu-item-only-child a.active {
  background: none !important;
  color: #3B6B94;
}

li.ant-menu-item.ant-menu-item-only-child {
  background: white !important;
}

.ant-menu-submenu-selected .ant-menu-submenu-title {
  background: #3B6B94 !important;
  color: white;
}

li.ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-open.ant-menu-submenu-selected .ant-menu-submenu-title span.ant-menu-title-content {

  color: white;
}
li.ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-open.ant-menu-submenu-selected .ant-menu-submenu-title span.ant-menu-title-content img{
    filter: invert(1);
}
.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .active .icon img {
    filter: invert(1);
}
.ant-modal-confirm-btns {
  display: flex;
  align-items: center;
  justify-content: end;
  border-top: 1px solid #f0f0f0;
  padding-top: 10px;
}
.button-group.button-group-new-mian {
    display: flex;
    align-items: center;
    justify-content: end;
}
button.ant-btn.ant-btn-primary.active-button-maink {
    background: #1d9cc9 !important;
    border-color: #1d9cc9 !important;
}
.notification-group .ant-list-item-meta {
    align-items: center !important;
}
.ant-modal-confirm-body p {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
}
button.ant-btn.ant-btn-default.table-light-fill-btn {
  background: #EDF3FF;
}
.client-profile-img-outer {
    display: flex;
    align-items: center;
    gap: 20px;
}
.client-profile-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}
.client-profile-view-page {
  background: var(--bg-app);
  padding: 20px;
  border-radius: var(--r-lg);
}
.view-client-text p {
  color: var(--text-secondary);
  font-weight: var(--fw-medium);
  font-size: var(--fs-base);
  line-height: var(--lh-normal);
  letter-spacing: 0;
  margin: 0;
}
.view-client-text h6 {
  font-weight: var(--fw-bold);
  font-size: var(--fs-2xl);
  line-height: var(--lh-tight);
  letter-spacing: 0;
  color: var(--text-primary);
  margin: 0;
}
.view-client-img  img {
    width: 100%;
}
.view-client-img {
    width: 80px;
    height: 80px;
    border-radius: 10px;
    flex: 0 0 auto;
}
.acc-card-main {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  background: var(--bg-surface);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
  border-radius: var(--r-lg);
  padding: 14px 20px;
  max-width: none;
  width: 100%;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(25% - 15px);
  min-width: 220px;
  transition: box-shadow var(--dur-base) var(--ease-out);
}
.acc-card-main:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-3px);
}
.acc-client-outer-list {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    gap: 15px;
}
.acc-client-outer-list > .acc-card-main {
  animation: ime-fade-in-up var(--dur-slow) var(--ease-out) both;
}
.acc-client-outer-list > .acc-card-main:nth-child(1) { animation-delay: 0ms; }
.acc-client-outer-list > .acc-card-main:nth-child(2) { animation-delay: 60ms; }
.acc-client-outer-list > .acc-card-main:nth-child(3) { animation-delay: 120ms; }
.acc-client-outer-list > .acc-card-main:nth-child(4) { animation-delay: 180ms; }

.acc-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  min-width: 52px;
  border-radius: var(--r-md);
  background: var(--brand-gradient-soft);
  box-shadow: inset 0 0 0 1px var(--brand-100);
  font-size: 22px;
  flex-shrink: 0;
  transition: background var(--dur-base) var(--ease-out);
}
.acc-card-main:hover .acc-card-icon {
  background: linear-gradient(135deg, var(--brand-100) 0%, #d9f2f3 100%);
}

/* ── Stats wrapper: cards row + account manager bar ────────────────────── */
.acc-stats-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

/* ── Account Manager bar ───────────────────────────────────────────────── */
.acc-manager-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8faff;
  border: 1px solid #e4eaf5;
  border-radius: 12px;
  padding: 10px 18px;
  gap: 16px;
}
.acc-manager-bar-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.acc-manager-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #e8eeff;
  color: #4361ee;
  font-size: 15px;
  flex-shrink: 0;
}
.acc-manager-info {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.acc-manager-label {
  font-size: 11px;
  font-weight: 500;
  color: #8896ab;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1;
}
.acc-manager-name {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.3;
}
.acc-manager-bar-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.acc-manager-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  border: 1px solid #dde3f0;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 12.5px;
  color: #475569;
  font-weight: 400;
  white-space: nowrap;
}
.acc-manager-chip .anticon {
  color: var(--brand-600);
  font-size: 12px;
}
.acc-card-breakdown {
    color: #64748b;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.35;
    margin-top: 6px;
    white-space: nowrap;
}
.acc-card-breakdown span[role="button"] {
    cursor: pointer;
}
.acc-card-breakdown span[role="button"]:hover {
    color: var(--brand-600);
    text-decoration: underline;
}
.acc-card-breakdown .acc-card-breakdown-disabled {
    color: #9ca3af;
    cursor: default;
    pointer-events: none;
    text-decoration: none;
}
.acc-card-text h4 {
  font-weight: var(--fw-bold);
  font-size: var(--fs-xl);
  line-height: 100%;
  letter-spacing: 0;
  color: var(--text-primary);
  margin: 0;
}
.acc-card-text h6 {
  color: var(--text-muted);
  font-weight: var(--fw-medium);
  font-size: var(--fs-sm);
  line-height: 100%;
  letter-spacing: 0.02em;
  vertical-align: middle;
  margin-bottom: 8px;
}
button.ant-btn.edit-icon-btn {
    width: 50px;
    height: 50px !important;
    border-radius: 50% !important;
    background: #FFFFFF !important;
    border-color  : #FFFFFF !important;
    padding: 5px !important;
}
.preferences-card-header h6 {
  color: var(--text-primary);
  font-weight: var(--fw-bold);
  font-size: var(--fs-lg);
  line-height: var(--lh-tight);
  letter-spacing: 0;
  margin: 0;
}
.preferences-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}.preferences-card-list-menubar h6 {
    font-weight: 500;
    font-size: 18px;
    line-height: 150%;
    letter-spacing: 0;
    margin-bottom: 5px;
}
.preferences-card-list-menubar {
    max-width: 318px;
    width: 100%;
}
.preferences-card-list-menubar ul {
    padding-left: 18px;
    margin: 0;
}
.preferences-card-list-menubar ul li {
    color: #1e293b;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.6;
}
.preferences-card-list {
    display: flex;
    gap: 15px;
    width: 100%;
}
.acces-client-calender {
  margin-top: 24px;
  background: var(--bg-surface);
  padding: 16px;
  border-radius: var(--r-lg);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}
/* ── Client Tabs — pill nav bar, full-width ── */
.ant-tabs.client-tabs .ant-tabs-nav {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 8px 10px;
  box-shadow: 0 1px 4px rgba(15,23,42,0.06), 0 4px 16px rgba(15,23,42,0.04);
  margin-bottom: 24px !important;
}
.ant-tabs.client-tabs .ant-tabs-nav::before {
  border-bottom: none !important;
}
.ant-tabs.client-tabs .ant-tabs-nav-wrap {
  overflow-x: auto !important;
  flex: 1 1 !important;
}
.ant-tabs.client-tabs .ant-tabs-nav-list {
  width: 100% !important;
  flex-wrap: nowrap !important;
  gap: 2px;
}
.ant-tabs.client-tabs .ant-tabs-ink-bar {
  display: none !important;
}
.ant-tabs.client-tabs .ant-tabs-tab {
  flex: 1 1 !important;
  min-width: fit-content !important;
  justify-content: center !important;
  background: transparent !important;
  border: none !important;
  padding: 11px 10px !important;
  border-radius: 10px !important;
  width: auto !important;
  max-width: none !important;
  margin: 0 !important;
  color: inherit !important;
  white-space: nowrap !important;
  transition: background 0.18s ease !important;
}
.ant-tabs.client-tabs .ant-tabs-tab:hover {
  background: rgba(59,107,148,0.07) !important;
}
.ant-tabs.client-tabs .ant-tabs-tab.ant-tabs-tab-active {
  background: linear-gradient(135deg, #3B6B94 0%, #071E31 100%) !important;
  box-shadow: 0 3px 10px rgba(59,107,148,0.35) !important;
  color: #ffffff !important;
}
.ant-tabs.client-tabs .ant-tabs-tab.ant-tabs-tab-active span.tab-label {
  color: #ffffff !important;
  font-weight: 700 !important;
}
.ant-tabs.client-tabs span.tab-label {
  font-size: 13.5px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0;
  color: #5a7080 !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
}
.ant-tabs.client-tabs .ant-tabs-tab + .ant-tabs-tab {
  margin: 0 2px !important;
}
.calendar-controls .ant-btn-default {
    display: inline-flex !important;
    height: unset !important;
    align-items: center;
    justify-content: center;
    border-radius: 7px !important;
    color: #92929D !important;
    border-color: #42424229 !important;
    background: transparent !important;
    box-shadow: unset !important;
}
.client-profile-header-02 p {
    font-size: 14px;
    color: black;
}
.action-footer-buttons {
    display: flex;
    justify-content: end;
    gap: 20px;
}
button.ant-btn.submitted-btn {
  background: var(--brand-gradient) !important;
  padding: 0 24px;
  color: #fff !important;
  border-radius: var(--r-md) !important;
  font-weight: var(--fw-semibold);
  font-size: var(--fs-base);
  height: 40px !important;
  border: none !important;
}
button.ant-btn.schedule-btn {
  background: var(--brand-500) !important;
  padding: 0 24px;
  color: #fff !important;
  border-radius: var(--r-md) !important;
  font-weight: var(--fw-semibold);
  font-size: var(--fs-base);
  height: 40px !important;
  border: none !important;
}
.action-footer-buttons button.ant-btn.ant-btn-default.submitted-btn {
    max-width: 250px !important;
    width: 100%;
}
.profile-followers {
  color: var(--text-secondary);
  font-weight: var(--fw-regular);
  font-size: var(--fs-base);
  line-height: 100%;
  letter-spacing: 0;
  margin: 8px 0;
}
.profile-date {
  font-weight: var(--fw-semibold);
  font-size: var(--fs-base);
  line-height: 100%;
  letter-spacing: 0;
  color: var(--text-secondary);
}
.profile-post-images {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
}
.profile-header {
    display: flex;
    gap: 10px;
    align-items: flex-start;
}
.drawer--up-body {
    padding: 70px 30px !important;
}
.action-icons {
    display: flex;
    align-items: center;
}
.ant-table-tbody>tr>td.ant-table-cell .action-icons .ant-btn.ant-btn-default {
  align-items: center;
  padding: 0px  !important;
  width: 36px !important;
  height: 36px !important;
  margin-right: 10px;
  display: inline-flex !important;
  gap: 7px;
  background: #EDF3FF !important;
  border-radius: 45px !important;
  font-weight: 400 !important;
  text-transform: capitalize !important;
  letter-spacing: 0px !important;
}
.ant-table-tbody>tr>td.ant-table-cell .action-icons button.ant-btn.ant-btn-default.table-light-fill-btn {
  background: #EDF3FF;
}
.ant-table-tbody>tr>td.ant-table-cell .action-icons button.ant-btn.ant-btn-default.table-primary-fill-btn {
  background: #3B6B94 !important;
}
.ant-table-tbody>tr>td.ant-table-cell .action-icons button.ant-btn.ant-btn-default.table-danger-fill-btn {
  background: #FF3030 !important;
}
.ant-table-tbody>tr>td.ant-table-cell .action-icons button.ant-btn.ant-btn-default.table-danger-fill-btn img {
  filter: brightness(18.5);
}
button.ant-btn.delete-fill-btn {
    max-width: 250px;
    width: 100%;
    background-color: #071E31 !important;
    margin: 0 auto;
    height: 50px !important;
    color: #fff !important;
    font-weight: 500;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0px;
}
.delete-modal-body p {
    font-weight: 400;
    font-size: 22px;
    line-height: 1.5;
    letter-spacing: -0.27px;
    text-align: center;
    color: #686868;
    margin: 0;
}
.delete-modal-body h3 {
    color: #414454;
    font-weight: 600;
    font-size: 32px;
    line-height: 150%;
    letter-spacing: 0;
    text-align: center;
    margin: 0;
}
.delete-modal-body img {
    max-width: 150px;
    height: 150px;
    margin: 0 auto;
    width: 100%;
}
.delete-modal-body {
    display: flex;
    flex-direction: column;
    gap: 25px;
    text-align: center;
    max-width: 400px;
    margin: 0 auto;
}
.ant-modal-mask {
    backdrop-filter: blur(4px);
    background: #00000040 !important;
}
.ant-modal.table_modal.delete-modal .ant-modal-body {
    padding: 35px 36px !important;
}
.ant-modal.table_modal .ant-modal-content {
    box-shadow: 0px 4px 30px 4px #00000021;
    border-radius: 25px !important;
    overflow: hidden;
}
.repport-headding-sec {
    display: flex;
    gap: 50px;
    align-items: end;
    justify-content: space-between;
}
.report-count-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  margin-top: 20px;
}

/* ─── KPI card styles — matches user panel exactly ─── */
.report-count-grid .content-card.kpi-card {
  background: #ffffff;
  border: 1px solid #E5E7EB;
  border-radius: 10px;
  padding: 14px 14px 14px 18px;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.report-count-grid .content-card.kpi-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
}
.report-count-grid .content-card.kpi-card::before {
  content: "";
  position: absolute;
  top: 0; left: 0; bottom: 0;
  width: 3px;
  background: #0A66C2;
}
.report-count-grid .content-card.kpi-card .content-idea-card { display: block; }
.report-count-grid .content-card.kpi-card .content-idea-card h6 {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6B7280;
  margin: 0;
}
.report-count-grid .content-card.kpi-card .report-count-detail-bar { margin-top: 0; }
.report-count-grid .content-card.kpi-card .report-count-detail-bar h4 {
  font-weight: 700;
  font-size: 30px;
  line-height: 1.1;
  letter-spacing: -0.5px;
  text-align: left;
  color: #0F172A;
  margin: 0;
}
.report-count-grid .content-card.kpi-card .report-count-detail-bar h6 {
  font-weight: 400;
  font-size: 11.5px;
  line-height: 1.3;
  color: #64748B;
  text-align: left;
  margin: 6px 0 0;
}
.report-count-grid .kpi-followers::before   { background: #0A66C2; }
.report-count-grid .kpi-posts::before       { background: #6366F1; }
.report-count-grid .kpi-likes::before       { background: #F59E0B; }
.report-count-grid .kpi-comments::before    { background: #10B981; }
.report-count-grid .kpi-shares::before      { background: #06B6D4; }
.report-count-grid .kpi-impressions::before { background: #8B5CF6; }
.report-count-grid .kpi-reach::before       { background: #EC4899; }
@media (min-width: 1600px) {
  .report-count-grid .content-card.kpi-card .report-count-detail-bar h4 { font-size: 36px; }
  .report-count-grid .content-card.kpi-card .content-idea-card h6       { font-size: 12px; }
}
@media (max-width: 1100px) {
  .report-count-grid { grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); }
}
.card-top-icon img {
    width: 25px;
}
.card-top-icon {
    position: absolute;
    top: 15px;
    right: 15px;
}
.content-idea-card h6 {
    color: #1D1E24;
    font-size: 15px;
    line-height: 100%;
    letter-spacing: 0px;
    margin: 0;
    margin-bottom: 10px;
    font-weight: 500;
}
.content-card {
    background: #fff;
    border-radius: 15px;
    padding: 15px;
    position: relative;
    border: 1px solid #CBD5E1;
    display: grid;
    gap: 15px;
}
.inner-day-report {
    font-weight: 500;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0px;
    text-align: center;
    color: #3F4753;
    margin-top: 50px;
}
/* Skeleton shimmer used while report data is (re)loading after a period change */
.report-count-grid .content-card.kpi-card.kpi-card--loading .report-count-detail-bar h4,
.report-count-grid .content-card.kpi-card.kpi-card--loading .report-count-detail-bar h6 {
  color: transparent;
  border-radius: 4px;
  background: linear-gradient(90deg, #eceff3 25%, #f6f7f9 37%, #eceff3 63%);
  background-size: 400% 100%;
  animation: report-shimmer 1.4s ease infinite;
}
.report-count-grid .content-card.kpi-card.kpi-card--loading .report-count-detail-bar h4 {
  display: inline-block;
  width: 60%;
  min-height: 30px;
}
.report-count-grid .content-card.kpi-card.kpi-card--loading .report-count-detail-bar h6 {
  display: inline-block;
  width: 80%;
  min-height: 14px;
}
@keyframes report-shimmer {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}
.report-period-dropdown {
  min-width: 260px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  padding: 8px 0;
}
.report-period-dropdown .ant-radio-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 16px;
  margin: 0;
}
.report-period-dropdown .ant-radio-wrapper:hover {
  background: #f5f7fa;
}
.report-period-dropdown .report-period-custom-range {
  padding: 8px 16px 4px;
}
.report-period-dropdown .report-period-footer {
  padding: 12px 16px 4px;
  border-top: 1px solid #eef1f4;
  margin-top: 4px;
}

.incam-price-count {
    color: #00B468;
    font-weight: 500;
    font-size: 22px;
    line-height: 100%;
    letter-spacing: 0px;
    text-align: center;
}
.report-count-detail-bar h6 {
    font-weight: 500;
    line-height: 100%;
    letter-spacing: 0px;
    color: #3F4753;
    text-align: center;
    margin: 12px 0px;
}
.report-count-detail-bar h4 {
    font-weight: 600;
    font-size: 50px;
    line-height: 100%;
    letter-spacing: 0px;
    text-align: center;
    color: #1D1E24;
    margin: 0;
}
.report-count-detail-bar {
    margin-top: 40px;
}
.report-section-01 {
    margin-bottom: 20px;
}
.headding-titals h4 {
    color: #110B2A;
    font-weight: 700;
    font-size: 32px;
    line-height: 150%;
    letter-spacing: 0;
    margin: 0;
}
.repport-headding-sec {
    display: flex;
    gap: 50px;
    align-items: end;
    justify-content: space-between;
}
.chart-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}
.report-weekly-card {
    margin-top: 20px;
    border: 0.71px solid #CBD5E1;
    border-radius: 10px;
    padding: 10px;
}
.headding-titals h4 {
    color: #110B2A;
    font-weight: 700;
    font-size: 32px;
    line-height: 150%;
    letter-spacing: 0;
    margin: 0;
}
button.ant-btn.report-btn {
    border: 0.71px solid #CBD5E1 !important;
    font-weight: 700;
    font-size: 10px;
    line-height: 14.1px;
    letter-spacing: 0;
    color: #475569 !important;
    gap: 5px;
    border-radius: 50px !important;
    padding: 7px 10px !important;
    background: transparent !important;
    height: 31px !important;
}
span.highlight-tag {
    color: #475569;
    font-weight: 600;
    font-size: 10px;
    line-height: 11.28px;
    letter-spacing: 0;
    text-align: center;
}
.chart-left-outer {
    display: flex;
    align-items: center;
    gap: 5px;
}
.headline-actions {
    flex: 0 0 auto;
    display: flex;
    gap: 24px;
}
.headline-text {
    font-weight: 500;
    font-size: 18px;
    line-height: 1.4;
    letter-spacing: 0px;
    color: #1D1E24;
}
.searching-listbar {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    gap: 10px;
}

.headline-actions button.ant-btn.ant-btn-default {
    background: transparent !important;
    border: none !important;
    padding: 0px !important;
    box-shadow: unset !important;
}
.headlines-section, .topics-section, .trends-section {
    margin-top: 30px;
}
.headline-toll-headding {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}
.headline-toll-headding h6 {
    color: #1D1E24;
    font-weight: 600;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0px;
    margin: 0;
}
.headline-actions {
    flex: 0 0 auto;
    display: flex;
    gap: 24px;
}
.tag-topics {
    background: #fff;
    padding: 8px 16px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0px;
    color: #1D1E24;
    border: 1px solid #3B6B9433;
}
.tags-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 20px;
}
section.headlines-section h6 {
    color: #000000;
    font-weight: 600;
    font-size: 20px;
    line-height: 100%;
    letter-spacing: 0px;
    margin-bottom: 20px;
}
.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-content {
    height: 100% !important;
    width: 100% !important;
}
.content-area {
    flex: 1 1;
    padding: 15px;
    background: #F2F5FF;
    border-radius: 10px;
}
.header-02-writing {
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin: 20px 0px;
}
.writing-header-bar h6 {
    font-weight: 600;
    font-size: 25px;
    line-height: 100%;
    letter-spacing: 0px;
    margin: 0;
}
.sidebar-left-research {
    width: 100%;
    background: #F2F5FF;
    padding: 30px;
    border-radius: 10px;
    max-width: 600px;
}
.sidebar-left-research.writing-ass {
    max-width: 100%;
    padding: 20px;
}
.writing-ass-footer {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 15px;
}
.writing-ass-footer.writing-button-group {
    justify-content: space-between;
    align-items: center;
}
.writing-button-comp {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
    width: 50%;
}
.footer-writing-btn {
    position: relative;
    display: flex;
    justify-content: end;
    gap: 10px;
    align-items: center;
    margin-top: 150px;
    flex-wrap: wrap;
}
.writing-ass-footer button.ant-btn.fill-btn {
    height: 35px !important;
    max-width: 150px;
    width: 100%;
}
.writing-ass-footer button.ant-btn.borderd-btn {
    border: 1px solid #D7D7D7 !important;
    font-weight: 500;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0px;
    height: 35px !important;
    color: #071E31 !important;
    max-width: 150px;
    width: 100%;
    background: white !important;
}
.writing-ass-footer.writing-button-group button.ant-btn.submitted-btn {
    background: #071E31;
    padding: 10px 20px;
    color: #fff !important;
    border-radius: 6px !important;
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0px;
    height: 35px !important;
}
.writing-ass-footer.writing-button-group button.ant-btn.schedule-btn {
    background: #3B6B94;
    padding: 10px 20px;
    color: #fff !important;
    border-radius: 6px !important;
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0px;
    height: 35px !important;
}
.writing-list-bar ul li.active {
    background-color: #3B6B94;
    border-color: #3B6B94;
    box-shadow: 0 4px 12px rgba(59, 107, 148, 0.2);
    font-weight: 500;
    color: #fff;
    border-radius: 6px !important;
}
.writing-list-bar ul li {
    padding: 10px;
    margin-bottom: 8px;
    border: 1px solid #D9E2EF;
    border-radius: 6px;
    background-color: #fff;
    transition: all 0.3s ease;
}
.writing-list-bar ul {
    padding: 0px;
    margin: 0px;
    list-style: none;
}
.writing-list-bar {
    padding: 15px;
    background: #F2F5FF;
    border-radius: 10px;
}
.writing-list-bar ul li a {
    font-weight: 500;
    font-size: 14px;
    line-height: 1.4;
    letter-spacing: 0px;
    color: #3F4753 !important;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.writing-list-bar ul li.active a {
    color: #fff !important;
    white-space: normal;
}
button.ant-btn.run-button {
    font-weight: 500 !important;
    font-size: 20px !important;
    line-height: 100% !important;
    letter-spacing: 0px !important;
    margin-top: 25px;
    height: 50px !important;
}

.writing-assistant-chat-container {
  
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  max-height: 60vh;
  margin: 0 auto;
  overflow-y: auto;
  overflow-x: hidden;
  scroll-behavior: smooth;
}
button.ant-btn.ant-btn-default.table-primary-fill-btn {
  background: #3B6B94 !important;
  color: #fff !important;
}
.chat-bubble.left {
  align-self: flex-start;
  background-color: #F2F5FF;
  border-top-left-radius: 4px;
}
.chat-content {
  line-height: 1.4;
}
.chat-bubble.right {
  align-self: flex-end;
  background-color: #3B6B94;
  color: white;
  border-top-right-radius: 4px;
}
.chat-bubble {
  max-width: 70%;
  padding: 10px 14px;
  border-radius: 18px;
  position: relative;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}
.chat-bubble {
  animation: fadeIn 0.3s ease-in-out;
}
.post-image {
    width: 100%;
    border-radius: 8px;
}
.post-detail-page {
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 13px;
    margin-bottom: 0px;
}
button.ant-btn.post-edit-btn {
    padding: 0px;
    outline: none;
    border: 0px !important;
    box-shadow: none !important;
    background: transparent !important;
}
.ant-upload-list-picture-card .ant-upload-list-item-info {
    width: 100% !important;
}
.custom-upload-item-video-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
  cursor: pointer;
  display: block;
}

.custom-upload-item-delete {
    position: absolute;
    right: 0;
    top: 0;
    background: #ff0000a6 !important;
    border-radius: 50px;
    width: 18px !important;
    height: 18px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    color: black;
    z-index: 1024;
    font-size: 10px;
}
.ant-upload-list-picture-card .ant-upload-list-item-info .ant-upload-list-item-thumbnail {
    height: 100% !important;
    width: 100% !important;
}
.ant-upload-list-picture-card .ant-upload-list-item {
    height: 100% !important;
    margin: 0;
}
.ant-upload-list-picture-card .ant-upload-list-item-info .ant-upload-list-item-thumbnail .ant-upload-list-item-image {
    height: 100% !important;
    width: 100% !important;
    object-fit: cover;
}
.ant-upload-list-picture-card span.anticon.anticon-delete {
    height: fit-content !important;
}
.ant-row.ant-form-item-row .rdw-editor-wrapper {
    border: solid 1px #D7D7D7 !important;
    border-radius: 10px;
    overflow: hidden;
}
.post-comment-toggle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
}
.post-comment-toggle p {
    color: #071E31;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0px;
    margin: 0;
}
.upload-post-description {
    margin: 24px 0px;
}
.ant-drawer.post-upload-drawer .ant-drawer-header-title {
    justify-content: end;
    position: absolute;
    right: 0px;
    top: 30px;
}
.ant-drawer.post-upload-drawer .ant-drawer-header-title .ant-drawer-close {
    color: rgb(0 0 0) !important;
    font-size: 22px;
}
button.ant-btn.ant-btn-default.ant-drawer-close.main-new-drawer-claose {
    background: transparent !important;
    box-shadow: unset !important;
    border: none !important;
}
button.ant-btn.ant-btn-default.fill-btn {
    background: var(--brand-gradient) !important;
    color: #fff !important;
    font-weight: var(--fw-semibold);
    font-size: var(--fs-base);
    line-height: 100%;
    letter-spacing: 0;
    height: 36px !important;
    border-radius: var(--r-md) !important;
    border: none !important;
    box-shadow: var(--shadow-brand);
}
.post-editor-title {
    font-weight: var(--fw-semibold);
    font-size: var(--fs-lg);
    line-height: 100%;
    letter-spacing: 0;
    color: var(--text-primary);
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 18px;
}
.ant-modal-confirm-body {
    display: grid;
    place-content: center;
    text-align: center;
}
.ant-modal-confirm-body .ant-modal-confirm-content {
margin: 0px !important;
}
span.ant-modal-confirm-title {
    font-size: 22px !important;
    font-weight: 500 !important;
}

/* Delete Account confirm (User.js) — the account name + optional
   active-contract warning, added to that modal's \`content\`. Sized/spaced
   to match the shared .ant-modal-confirm look (centered icon+title above,
   14px muted-gray body text) rather than reading as a bolted-on afterthought. */
.delete-account-confirm-content p {
  margin: 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1.6;
}
.delete-account-confirm-warning {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 16px;
  padding: 10px 14px;
  background: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 8px;
  text-align: left;
  font-size: 13px;
  font-weight: 500;
  color: #874d00;
}
.delete-account-confirm-warning .anticon {
  margin-top: 2px;
  flex-shrink: 0;
  color: #d48806;
  font-size: 15px;
}

/* Bulk-delete confirm (BrandManager.js's "Delete Selected" — Customer
   Management/User.js has no bulk delete) — the list of selected accounts'
   names, between the two <p>s. Left-aligned like the warning box, capped
   height with its own scroll so selecting 20 rows doesn't blow the modal
   off-screen. */
.delete-account-confirm-list + p {
  margin-top: 12px !important;
}
.delete-account-confirm-list {
  margin: 8px 0 0;
  padding: 8px 14px;
  max-height: 140px;
  overflow-y: auto;
  text-align: left;
  list-style: disc;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.75);
}
.delete-account-confirm-list li {
  padding: 2px 0;
}

.research-mode-select {
  position: absolute;
  bottom: 6px;
  right: 8px;
  width: auto;
  min-width: 68px;
  max-width: 90px;
  height: 20px;
  font-size: 11px;
  background: #f5f5f5;
  border-radius: 12px;
  box-shadow: inset 0 0 0 1px #d9d9d9;
}

.best-model-strip {
  font-weight: 600;
  margin-bottom: 8px;
}

.rag-scrollable-content {
  max-height: 300px;
  overflow-y: auto;
  padding: 12px;
  background: #fafafa;
  border-radius: 6px;
  border: 1px solid #eaeaea;
}

.rag-analysis {
  margin-top: 16px;
  padding: 12px;
  background: #fffbe6;
  border-radius: 6px;
  border: 1px solid #ffe58f;
}

.rag-analysis pre {
  white-space: pre-wrap;
  word-break: break-word;
}

.rag-result-card {
  border-radius: 12px;
  padding: 16px;
}

.rag-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.rag-title {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rag-subtitle {
  font-size: 13px;
  color: #888;
}

.rag-content {
  max-height: 420px;
  overflow-y: auto;
  padding: 14px;
  background: #fafafa;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.7;
}

.rag-content h1,
.rag-content h2,
.rag-content h3 {
  margin-top: 16px;
}

.rag-analysis {
  margin-top: 16px;
  display: grid;
  gap: 12px;
}

.analysis-card {
  border-radius: 10px;
  background: #fafafa;
}

.analysis-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.analysis-card-header h6 {
  margin: 0;
  font-size: 14px;
}

.analysis-card-body {
  max-height: 260px;
  overflow-y: auto;
  padding: 10px;
  background: #fff;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.6;
}

.model-answer-card {
  border-radius: 10px;
  background: #ffffff;
}

.model-answer-card .analysis-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.error-text {
  color: #d4380d;
  background: #fff2f0;
  padding: 10px;
  border-radius: 6px;
  font-size: 13px;
}

.score-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  font-size: 13px;
}



/* actual select box */
.research-mode-select .ant-select-selector {
  height: 20px !important;
  padding: 0 6px !important;
  line-height: 20px !important;
}

/* selected text */
.research-mode-select .ant-select-selection-item {
  line-height: 20px !important;
  font-size: 11px;
  padding: 0 !important;
}

/* remove extra spacing */
.research-mode-select .ant-select-selection-search {
  display: none;
}

/* Brand assignee picker (Manual Onboarding — Content Strategy Deck card).
   Two global rules fight a size="small" select here: .ant-select-selector
   forces height:40px !important, and .ant-select-single .ant-select-selector
   .ant-select-selection-placeholder forces line-height:42px !important. Class
   selectors here previously lost that specificity fight (or won it after a
   fix but still rendered wrong in testing) — using the wrapper's #id below
   guarantees this wins over any class-only rule, no specificity math needed. */
#content-strategy-assignee-wrap .ant-select-selector {
  height: 24px !important;
  padding: 0 7px !important;
  line-height: 22px !important;
}
#content-strategy-assignee-wrap .ant-select-selection-placeholder,
#content-strategy-assignee-wrap .ant-select-selection-item {
  line-height: 22px !important;
  padding: 0 !important;
}
#content-strategy-assignee-wrap .ant-select-selection-search {
  inset-inline-start: 7px !important;
  inset-inline-end: 7px !important;
}
#content-strategy-assignee-wrap .ant-select-selection-search-input {
  height: 22px !important;
}
.create-post-container {
  background:
    radial-gradient(circle at top left, rgba(10, 102, 194, 0.1), transparent 34%),
    linear-gradient(135deg, #f8fafd 0%, #eef3f8 52%, #f6f8fb 100%);
  border: 1px solid rgba(120, 143, 175, 0.16);
  border-radius: 24px;
  min-height: calc(100vh - 120px);
  padding: 26px;
}

.post-up-header {
  display: flex;
  gap: 14px;
  align-items: center;
  margin-bottom: 18px;
  color: #071e31;
}

.post-up-header-avatar {
  border: 3px solid #fff;
  box-shadow: 0 14px 30px rgba(30, 54, 86, 0.16);
}

.post-up-header h6 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 16px;
  font-weight: 700;
}

.drawer--up-body {
  padding: 24px 0 0;
}

.post-preview-panel {
  display: flex;
  flex-direction: column;
  gap: 14px;
  height: 100%;
}

.post-preview-label {
  color: #446584;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.linkedin-preview-shell {
  background:
    linear-gradient(#ffffff, #ffffff) padding-box,
    linear-gradient(135deg, rgba(10, 102, 194, 0.26), rgba(116, 139, 166, 0.1)) border-box;
  border: 1px solid transparent;
  border-radius: 22px;
  box-shadow: 0 22px 48px rgba(31, 54, 84, 0.1);
  padding: 22px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.linkedin-preview-shell:hover {
  transform: translateY(-2px);
  box-shadow: 0 28px 60px rgba(31, 54, 84, 0.14);
}

.linkedin-preview-shell .profile-header {
  gap: 14px;
  align-items: center;
}

.linkedin-preview-shell .profile-post-images {
  width: 58px;
  height: 58px;
  min-width: 58px;
}

.linkedin-preview-shell .profile-post-images img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid #eef4fb;
}

.linkedin-preview-shell .profile-name {
  color: #111827;
  font-size: 17px;
  font-weight: 800;
}

.linkedin-preview-shell .profile-followers {
  color: #65748b;
  font-size: 14px;
  line-height: 1.5;
  margin: 3px 0;
}

.linkedin-preview-shell .profile-date {
  color: #25364f;
  font-size: 14px;
  font-weight: 600;
  /* The date text and calendar icon are two inline siblings inside a plain
     block div — on a narrow preview card there's just barely not enough
     width for both, so the browser wraps mid-content ("Aug 2" / "1" +
     icon on the next line) instead of keeping the date intact. Laying them
     out as a non-wrapping flex row keeps "Aug 21 📅" together as one unit. */
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.linkedin-preview-title {
  margin-top: 18px;
  color: #102033;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
}

.linkedin-preview-text,
.linkedin-preview-placeholder {
  margin-top: 14px;
  color: #1f2937;
  font-size: 15px;
  /* Real LinkedIn post copy renders at a much tighter line-height than
     1.8 — that value inflated every single line break (not just the
     genuinely blank ones the post text contains via "\\n\\n"), making
     even adjacent, non-blank lines look double-spaced in this preview. */
  line-height: 1.5;
  white-space: pre-wrap;
}

.linkedin-preview-text p,
.linkedin-preview-text ul,
.linkedin-preview-text ol {
  margin-bottom: 12px;
}

/* Hanging indent for list-marker lines ("- " / "1. ") in the plain-text
   preview — negative text-indent pulls the marker itself back out to the
   margin, padding-left pushes everything (including a wrapped second line)
   in by the same amount, so a wrapped bullet/numbered line lines up under
   its own text instead of falling back to the left margin. Matches how the
   real published post wraps on LinkedIn. */
.linkedin-preview-list-line {
  padding-left: 1.4em;
  text-indent: -1.4em;
}

.linkedin-preview-placeholder {
  color: #73839a;
  background: linear-gradient(135deg, #f8fbff, #f2f6fb);
  border: 1px dashed #c8d6e7;
  border-radius: 14px;
  padding: 18px;
}

.linkedin-preview-shell .upload-post-description {
  margin: 18px 0 8px;
}

.linkedin-preview-shell .post-image,
.linkedin-preview-shell .post-video {
  border-radius: 20px;
  overflow: hidden;
}

.post-contant-outerpanel {
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid #dfe7f1;
  border-radius: 22px;
  box-shadow: 0 22px 52px rgba(31, 54, 84, 0.09);
  padding: 22px;
}

.post-contant-outerpanel .ant-form-item {
  margin-bottom: 18px;
}

.post-contant-outerpanel .ant-form-item-label > label {
  color: #102033;
  font-size: 13px;
  font-weight: 700;
}

.post-contant-outerpanel .ant-input,
.post-contant-outerpanel .ant-select-selector,
.post-contant-outerpanel .rdw-editor-wrapper {
  border-radius: 12px !important;
}

.post-contant-outerpanel .rdw-editor-wrapper {
  border: 1px solid #d7e0eb;
  overflow: visible;
  background: #fff;
}

.post-contant-outerpanel .ant-input,
.post-contant-outerpanel .ant-select-selector {
  min-height: 38px;
  border-color: #d7e0eb !important;
  box-shadow: none !important;
}

.post-contant-outerpanel .ant-input:focus,
.post-contant-outerpanel .ant-select-focused .ant-select-selector,
.post-contant-outerpanel .rdw-editor-wrapper:focus-within {
  border-color: #3b6b94 !important;
  box-shadow: 0 0 0 3px rgba(59, 107, 148, 0.12) !important;
}

.post-contant-outerpanel .rdw-editor-toolbar {
  border: 0;
  border-bottom: 1px solid #e6ebf3;
  margin-bottom: 0;
  padding: 9px 12px;
  background: #f7f9fc;
  border-radius: 12px 12px 0 0;
}

.post-contant-outerpanel .rdw-editor-main {
  min-height: 220px;
  padding: 14px 16px;
  font-size: 16px;
  /* Matches the LinkedIn Preview panel's line-height (1.5) — this cascades
     to every block equally (tight or blank), so a value looser than the
     preview made even single, non-blank line breaks look pre-spaced in the
     editor, and made a genuinely-added blank line hard to tell apart from
     the existing baseline gap. */
  line-height: 1.5;
  color: #16233f;
  border-radius: 0 0 12px 12px;
}

/* react-draft-wysiwyg's OWN shipped CSS (react-draft-wysiwyg.css) ships an
   UNSCOPED ".public-DraftStyleDefault-block { margin: 1em 0; }" rule that
   applies to every block in every Editor instance on the page, regardless
   of preset — that's what actually made a single Enter look like a full
   paragraph gap instead of a tight line break (a previous attempt to
   override this was scoped to ".editorClassName", which is not a real
   class — the actual editorClassName prop value is "custom-editor" — so it
   silently never matched anything). This scoped selector has higher
   specificity than the library's bare one and reliably wins regardless of
   CSS load order. */
.post-contant-outerpanel .rdw-editor-main .public-DraftStyleDefault-block {
  margin: 0;
  /* Per-paragraph direction: Arabic paragraphs read right-to-left, English stay left-to-right. */
  unicode-bidi: plaintext;
  text-align: start;
}

/* A blank line the user types (an empty paragraph, just a <br> with no
   text) has no content to size a line-height box against, so its rendered
   height isn't guaranteed the way a text-containing block's is — the
   editor's own live view could under-represent consecutive blank lines
   (visually reading as fewer than were actually typed) even though the
   underlying data and the plain-text LinkedIn Preview (which renders
   literal "\\n" characters, not box-model height) both have the correct
   count. Pinning each block to exactly one line-height (matching the 1.5
   set on .rdw-editor-main, not a taller value) keeps the editor's own view
   honest with however many blank lines are really there, while making a
   pressed-twice blank line take up exactly the same vertical space as a
   single line of text. Scoped to .post-empty-block (set via blockStyleFn)
   only — applying this to every block, blank or not, inflated ordinary
   paragraphs too and produced visibly oversized gaps between adjacent,
   non-blank lines. */
.post-contant-outerpanel .rdw-editor-main .public-DraftStyleDefault-block.post-empty-block {
  min-height: 1.5em;
}

/* Same fix, same reasoning, for the Blog Write outline builder's "outline"
   preset (.normal-editor-shell-outline) — it was missing this scoped
   override entirely, so react-draft-wysiwyg's unscoped 1em block margin was
   still winning there and stacking up into the "too much space between
   lines" look reported on that editor specifically. */
.normal-editor-shell-outline .rdw-editor-main {
  font-size: 15px;
  line-height: 1.5;
}
.normal-editor-shell-outline .rdw-editor-main .public-DraftStyleDefault-block {
  margin: 0;
}
.normal-editor-shell-outline .rdw-editor-main .public-DraftStyleDefault-block.post-empty-block {
  min-height: 1.5em;
}

.normal-editor-shell-linkedin .rdw-option-wrapper {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 10px;
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}

.normal-editor-shell-linkedin .rdw-option-wrapper:hover,
.normal-editor-shell-linkedin .rdw-option-wrapper.rdw-option-active {
  background: #e8f1fb;
  color: #0a66c2;
}

.normal-editor-shell-linkedin .rdw-dropdown-wrapper,
.normal-editor-shell-linkedin .rdw-link-dropdown,
.normal-editor-shell-linkedin .rdw-emoji-dropdown {
  border: 0;
  border-radius: 12px;
  box-shadow: none;
  background: transparent;
}

.normal-editor-shell-linkedin .rdw-editor-toolbar,
.normal-editor-shell-linkedin .rdw-emoji-wrapper,
.normal-editor-shell-linkedin .rdw-emoji-dropdown {
  position: relative;
  overflow: visible;
}

.normal-editor-shell-linkedin .rdw-editor-toolbar {
  flex-wrap: nowrap;
  align-items: center;
  z-index: 5;
}

.normal-editor-shell-linkedin .rdw-editor-toolbar > div {
  flex-shrink: 0;
  flex-grow: 0;
  margin-right: 8px;
}

.normal-editor-shell-linkedin .rdw-link-modal,
.normal-editor-shell-linkedin .rdw-emoji-modal {
  border-radius: 16px;
  border: 1px solid #dfe7f2;
  box-shadow: 0 18px 48px rgba(22, 35, 63, 0.14);
  z-index: 1200;
}

.normal-editor-shell-linkedin .custom-emoji-toolbar {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
}

.normal-editor-shell-linkedin .custom-emoji-trigger {
  font-size: 18px;
  line-height: 1;
}

.normal-editor-shell-linkedin .custom-emoji-modal {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 244px;
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 6px;
  padding: 10px;
  border-radius: 16px;
  border: 1px solid #dfe7f2;
  background: #ffffff;
  box-shadow: 0 18px 48px rgba(22, 35, 63, 0.14);
  z-index: 1201;
}

.normal-editor-shell-linkedin .custom-emoji-item {
  border: 0;
  background: transparent;
  border-radius: 10px;
  font-size: 20px;
  line-height: 1;
  padding: 8px 0;
  cursor: pointer;
}

.normal-editor-shell-linkedin .custom-emoji-item:hover {
  background: #eef4ff;
}

/* Calendar/post composer polish */
.ant-drawer.post-upload-drawer .ant-drawer-body {
  padding: 0 !important;
  overflow: hidden !important;
  background: #eef4fa;
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
}

.ant-drawer.post-upload-drawer .ant-drawer-content {
  background: #eef4fa;
}

.post-upload-drawer .create-post-container {
  flex: 1 1 auto;
  min-height: 0;
  border-radius: 0;
  border: 0;
  padding: 22px 28px 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.post-upload-drawer .post-up-header {
  flex: 0 0 auto;
  min-height: 52px;
  margin-bottom: 24px;
}

.post-upload-drawer .post-up-header h6,
.post-upload-drawer .post-editor-title,
.post-upload-drawer .post-preview-label,
.post-upload-drawer .post-contant-outerpanel .ant-form-item-label > label,
.post-upload-drawer .post-comment-toggle p {
  color: #071e31 !important;
}

/* Visibility selector (Anyone / Connections only) — mirrors LinkedIn's own
   native post-composer visibility picker. .post-comment-toggle's default
   layout is a single-row label+switch pair; this block instead holds a
   label plus a full-width, multi-row radio list, so it needs its own
   flex-direction rather than the row layout the base class expects. */
.post-visibility-block {
  flex-direction: column !important;
  align-items: stretch !important;
  gap: 10px !important;
}

.post-visibility-group.ant-radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.post-visibility-group .ant-radio-wrapper.post-visibility-option {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0;
  padding: 10px 14px;
  border: 1px solid #e3eaf2;
  border-radius: 12px;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.post-visibility-group .ant-radio-wrapper.post-visibility-option:hover {
  border-color: #b9cee5;
}

.post-visibility-group .ant-radio-wrapper-checked.post-visibility-option {
  border-color: #0a66c2;
  background: #f0f6ff;
}

.post-visibility-group .ant-radio-wrapper.post-visibility-option > span:last-child {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  padding: 0;
}

.post-visibility-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f1f5f9;
  color: #334155;
  font-size: 16px;
  flex-shrink: 0;
}

.post-visibility-text {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.post-visibility-text strong {
  color: #071e31;
  font-size: 14px;
  font-weight: 700;
}

.post-visibility-text small {
  color: #65748b;
  font-size: 12px;
}

.post-upload-drawer .drawer--up-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 0 0 24px;
}

.post-upload-drawer .drawer--up-body > .ant-row {
  align-items: flex-start;
}

.post-upload-drawer .post-preview-panel {
  position: sticky;
  top: 0;
  min-height: auto;
}

.post-upload-drawer .linkedin-preview-shell,
.post-upload-drawer .post-contant-outerpanel {
  border-radius: 16px;
}

.post-upload-drawer .post-contant-outerpanel {
  padding: 0;
  overflow: visible !important;
}

.post-upload-drawer .post-editor-title {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 54px;
  padding: 0 18px;
  margin: 0;
  border-bottom: 1px solid #e3eaf2;
  font-size: 16px;
  font-weight: 800;
  flex-wrap: nowrap;
}

.post-upload-drawer .post-editor-icon-box {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3b6b94 0%, #0a66c2 100%);
  box-shadow: 0 6px 16px rgba(10, 102, 194, 0.28);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
}

.post-upload-drawer .post-editor-title-text {
  flex: 1 1;
  /* Without this, a flex item with nowrap text ignores flex:1 shrinking and
     instead forces the whole row to its full content width — pushing the
     link/delete icons and "Edit Post" button on narrow screens past the
     drawer's edge instead of leaving them room. */
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #071e31;
  font-size: 16px;
  font-weight: 800;
  white-space: nowrap;
}

.post-upload-drawer .post-editor-title > img {
  display: none;
}

.post-upload-drawer .post-editor-title .post-detail-page {
  margin-bottom: 0;
  flex-shrink: 0;
}

.post-upload-drawer .post-editor-title .post-edit-btn {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px !important;
  border: 1px solid #e3eaf2 !important;
  background: #f6f9fc !important;
  padding: 0 !important;
  transition: background 0.18s, border-color 0.18s;
}

.post-upload-drawer .post-editor-title .post-edit-btn:hover {
  background: #e8f0f7 !important;
  border-color: #c7d9ec !important;
}

.post-upload-drawer .post-editor-title .post-edit-btn img {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.post-upload-drawer .post-editor-title .fill-btn {
  height: 34px !important;
  padding: 0 16px !important;
  font-size: 13px !important;
  font-weight: 700;
  border-radius: 8px !important;
  white-space: nowrap;
}

.post-upload-drawer .post-contant-outerpanel > .ant-form-item,
.post-upload-drawer .post-contant-outerpanel > .post-comment-toggle,
.post-upload-drawer .post-contant-outerpanel > div:not(.post-editor-title):not(.action-footer-buttons) {
  margin-left: 18px;
  margin-right: 18px;
}

.post-upload-drawer .post-contant-outerpanel .ant-form-item {
  margin-bottom: 14px;
}

.post-upload-drawer .post-contant-outerpanel .rdw-editor-main {
  min-height: 210px;
  max-height: 34vh;
  overflow-y: auto;
}

/* Footer sits naturally at the bottom of the form content — no sticky, no float */
.post-upload-drawer .action-footer-buttons,
.post-upload-drawer .post-contant-outerpanel .action-footer-buttons {
  position: static !important;
  bottom: auto !important;
  z-index: auto !important;
  display: flex;
  /* \`wrap\` (not \`nowrap\`) is what actually makes this responsive: with
     several long labels ("Send for Review", "Publish", "Save as Draft",
     etc.), any container narrower than roughly 700-750px can't fit them
     all on one row. \`wrap\` is a no-op on wide screens (buttons only wrap
     once they'd genuinely overflow) but lets them drop to a second row
     instead of the old forced-nowrap approach, which — combined with
     \`min-width: 0\` below — let the browser cram every button into one row
     by shrinking each below its own readable text width, producing
     overlapping/clipped labels instead of ever actually wrapping. */
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  padding: 14px 18px !important;
  margin: 16px 0 0 !important;
  border-top: 1px solid #e3eaf2;
  background: #fff !important;
  backdrop-filter: none;
  border-radius: 0 0 16px 16px;
}

.post-upload-drawer .action-footer-buttons .ant-btn {
  /* !important + box-sizing/line-height pinned explicitly on every one of
     these — antd's own per-variant rules (default vs primary vs
     dangerous/"danger") carry their own padding/line-height/border, and
     without pinning all of them here those variants (e.g. "Override & Send
     to Client", a plain \`danger type="primary"\` button with no extra class)
     render visibly shorter/thinner than the rest, exactly the reported
     "buttons aren't uniform" bug. */
  flex: 1 1 auto;
  /* A real min-width (not 0) is what lets \`flex-wrap: wrap\` above actually
     trigger — with min-width:0 the browser could always cram every button
     into one row by shrinking each below its own label's width, so wrap
     never kicked in and text just overlapped instead. */
  min-width: 150px;
  box-sizing: border-box !important;
  height: 46px !important;
  min-height: 46px !important;
  line-height: 1 !important;
  padding: 0 16px !important;
  border-radius: 10px !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  white-space: nowrap;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.post-upload-drawer .action-footer-buttons button.ant-btn.ant-btn-default.submitted-btn {
  max-width: none !important;
  width: auto;
}

.post-upload-drawer .post-action-btn {
  min-width: 86px;
}

/* LinkedIn preview — all 4 action buttons on ONE row */
.linkedin-preview-shell .action-buttons {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  margin-top: 14px;
  width: 100%;
}

.linkedin-preview-shell .post-action-btn {
  flex: 1 1;
  min-width: 0;
  height: 40px;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  color: #334155;
  font-weight: 700;
  box-shadow: 0 8px 18px rgba(31, 54, 84, 0.05);
  white-space: nowrap;
  padding: 0 8px !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

@media (max-width: 991px) {
  .post-upload-drawer .create-post-container {
    padding: 18px 16px 0;
  }

  .post-upload-drawer .post-preview-panel {
    position: static;
  }

  .post-upload-drawer .action-footer-buttons {
    gap: 8px;
  }

  .post-upload-drawer .action-footer-buttons .ant-btn {
    font-size: 13px !important;
    padding: 0 10px !important;
  }
}

@media (max-width: 1200px) {
  .post-upload-drawer .create-post-container { padding: 18px 20px 0 !important; }
  .post-upload-drawer .drawer--up-body { padding: 0 !important; }
  .post-upload-drawer .post-contant-outerpanel { padding: 0 !important; }
  .post-upload-drawer .linkedin-preview-shell { padding: 18px !important; }
}

@media (max-width: 992px) {
  .post-upload-drawer .drawer--up-body .ant-row { flex-direction: column !important; }
  .post-upload-drawer .drawer--up-body .ant-col { max-width: 100% !important; flex: 0 0 100% !important; }
  .post-upload-drawer .create-post-container { padding: 16px 16px 0 !important; }
  .post-upload-drawer .post-contant-outerpanel { padding: 0 !important; }
  .post-upload-drawer .linkedin-preview-shell { padding: 16px !important; }
  button.ant-btn.submitted-btn, button.ant-btn.schedule-btn { font-size: 14px !important; height: 42px !important; padding: 0 16px !important; min-width: 110px; }
}

@media (max-width: 768px) {
  .ant-drawer.post-upload-drawer { width: 100% !important; }
  .post-upload-drawer .create-post-container { padding: 12px 12px 0 !important; }
  .post-upload-drawer .post-up-header h6 { font-size: 14px !important; }
  /* post-contant-outerpanel is correctly 0 — its children carry their own
     left/right margins. The preview card has no such per-child spacing, so
     zeroing it out too (as this used to) left every element inside it —
     name, date, title, caption, like/comment counts, action buttons —
     flush against the card's edges with no breathing room at all. */
  .post-upload-drawer .post-contant-outerpanel { padding: 0 !important; border-radius: 14px !important; }
  .post-upload-drawer .linkedin-preview-shell { padding: 16px !important; border-radius: 14px !important; }
  /* No forced nowrap here — the base rule's \`flex-wrap: wrap\` (with a real
     min-width on each button) already lets footer buttons drop to a second
     row the moment they don't fit, instead of overlapping/clipping like
     they did when this used to force nowrap at every width down to 600px. */
  .post-upload-drawer .action-footer-buttons { gap: 8px !important; }
  button.ant-btn.submitted-btn, button.ant-btn.schedule-btn { font-size: 13px !important; height: 42px !important; padding: 0 10px !important; max-width: none !important; }
}

/* Multiple footer buttons genuinely don't fit side-by-side on a phone-width
   screen without truncating their labels. Stack them full-width instead of
   forcing them into one nowrap row. */
@media (max-width: 600px) {
  .post-upload-drawer .action-footer-buttons,
  .post-upload-drawer .post-contant-outerpanel .action-footer-buttons {
    flex-wrap: wrap !important;
    flex-direction: column !important;
    gap: 10px !important;
    padding: 12px 14px !important;
  }

  .post-upload-drawer .action-footer-buttons .ant-btn {
    flex: 1 1 100% !important;
    width: 100% !important;
    min-width: 0 !important;
    max-width: none !important;
    white-space: normal !important;
    text-align: center;
    line-height: 1.25;
  }

  button.ant-btn.submitted-btn,
  button.ant-btn.schedule-btn {
    white-space: normal !important;
    min-width: 0 !important;
  }

  /* The toolbar (B / I / S, undo/redo, list options) is forced
     \`flex-wrap: nowrap\` with every group \`flex-shrink: 0\` (see the base
     .normal-editor-shell-linkedin .rdw-editor-toolbar rule) so it never
     drops icons — great on desktop, but on a phone-width editor there just
     isn't room for every group on one row, so the icons overlap/squeeze
     into each other instead of the toolbar simply growing taller. Letting
     it wrap fixes that without touching the 34px icon sizing. */
  .normal-editor-shell-linkedin .rdw-editor-toolbar {
    flex-wrap: wrap !important;
    row-gap: 4px;
  }

  .normal-editor-shell-linkedin .rdw-editor-toolbar > div {
    margin-right: 4px !important;
  }
}

@media (max-width: 480px) {
  .post-upload-drawer .create-post-container { padding: 10px 10px 0 !important; }
  .post-upload-drawer .post-contant-outerpanel { padding: 0 !important; border-radius: 12px !important; }
  .post-upload-drawer .linkedin-preview-shell { padding: 14px !important; border-radius: 12px !important; }
  .post-upload-drawer .post-editor-title { font-size: 15px !important; gap: 8px !important; padding: 0 12px !important; }
  .post-upload-drawer .post-editor-title-text { font-size: 14px !important; }
  .post-upload-drawer .post-editor-title .post-edit-btn { width: 30px !important; height: 30px !important; }
  .post-upload-drawer .post-editor-title .fill-btn { padding: 0 10px !important; font-size: 12px !important; }
  button.ant-btn.submitted-btn, button.ant-btn.schedule-btn { font-size: 13px !important; height: 40px !important; }
}

/* Below ~400px, "Like / Comment / Repost / Send" (4 full-label buttons) no
   longer fit on one row without the last one (Send) getting pushed past the
   card edge — tighten padding/gap/font so all 4 stay fully visible. */
@media (max-width: 400px) {
  .linkedin-preview-shell .action-buttons {
    gap: 4px;
  }

  .linkedin-preview-shell .post-action-btn {
    padding: 0 4px !important;
    font-size: 12px !important;
    gap: 4px;
  }
}

:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .ant-drawer.post-upload-drawer .ant-drawer-body,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .ant-drawer.post-upload-drawer .ant-drawer-content {
  background: #0f172a;
}

:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .create-post-container {
  background:
    radial-gradient(circle at top left, rgba(46, 141, 218, 0.18), transparent 36%),
    linear-gradient(135deg, #111827 0%, #0f172a 58%, #111827 100%);
}

:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .post-up-header h6,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .post-editor-title,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .post-preview-label,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .post-contant-outerpanel .ant-form-item-label > label,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .post-comment-toggle p,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .linkedin-preview-title,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .linkedin-preview-text,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .profile-name,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .profile-date {
  color: #f8fafc !important;
}

:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .linkedin-preview-shell,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .post-contant-outerpanel {
  background: #111827;
  border-color: #26364d;
  box-shadow: 0 22px 52px rgba(0, 0, 0, 0.28);
}

:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .profile-followers,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .linkedin-preview-placeholder {
  color: #cbd5e1;
}

:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .linkedin-preview-placeholder,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .rdw-editor-toolbar {
  background: #172033;
  border-color: #2b3b52;
}

:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .ant-input,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .ant-select-selector,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .rdw-editor-wrapper,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .rdw-editor-main {
  background: #0f172a !important;
  border-color: #2b3b52 !important;
  color: #f8fafc !important;
}

:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .ant-input::placeholder,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .public-DraftEditorPlaceholder-root {
  color: #94a3b8 !important;
}

:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .action-footer-buttons {
  background: rgba(17, 24, 39, 0.96);
  border-color: #26364d;
}

/* drawer--up-body is the scroll container; body stays hidden */
.post-upload-drawer .post-contant-outerpanel {
  overflow: visible !important;
}

.post-upload-drawer .post-contant-outerpanel .rdw-editor-main {
  max-height: none;
  overflow-y: visible;
}

/* LinkedIn-style emoji picker */
.normal-editor-shell-linkedin .linkedin-emoji-picker.custom-emoji-modal {
  width: 360px;
  max-width: calc(100vw - 32px);
  max-height: 390px;
  padding: 0;
  overflow: hidden;
  border-radius: 8px;
  background: #ffffff;
}

.linkedin-emoji-search-row {
  display: grid;
  grid-template-columns: 24px 1fr 34px;
  align-items: center;
  gap: 6px;
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.linkedin-emoji-search-icon {
  color: #38434f;
  font-size: 24px;
  line-height: 1;
  transform: rotate(-20deg);
}

.linkedin-emoji-search {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #56687a;
  border-radius: 4px;
  background: #eef3f8;
  color: #111827;
  font-size: 15px;
  outline: none;
}

.linkedin-emoji-search:focus {
  border-color: #0a66c2;
  box-shadow: 0 0 0 2px rgba(10, 102, 194, 0.16);
}

.linkedin-emoji-close {
  width: 32px;
  height: 32px;
  border: 0;
  background: transparent;
  color: #38434f;
  cursor: pointer;
  font-size: 30px;
  line-height: 1;
}

.linkedin-emoji-tabs {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  background: #ebe6de;
  border-bottom: 1px solid #d8d2c8;
}

.linkedin-emoji-tab {
  height: 54px;
  border: 0;
  border-bottom: 3px solid transparent;
  background: transparent;
  color: #3f3f3f;
  cursor: pointer;
  font-size: 25px;
}

.linkedin-emoji-tab.active {
  border-bottom-color: #0a66c2;
}

.linkedin-emoji-sections {
  max-height: 245px;
  overflow-y: auto;
  padding: 12px 12px 18px;
}

.linkedin-emoji-section + .linkedin-emoji-section {
  margin-top: 16px;
}

.linkedin-emoji-section-title {
  color: #666666;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
}

.linkedin-emoji-grid {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 8px;
}

.normal-editor-shell-linkedin .linkedin-emoji-picker .custom-emoji-item {
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 6px;
  font-size: 24px;
}

.linkedin-emoji-empty {
  color: #6b7280;
  font-size: 14px;
  padding: 10px 0 16px;
}

:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .normal-editor-shell-linkedin .linkedin-emoji-picker.custom-emoji-modal {
  background: #111827;
  border-color: #334155;
}

:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-emoji-search-row,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-emoji-tabs {
  border-color: #334155;
}

:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-emoji-tabs {
  background: #1f2937;
}

:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-emoji-search {
  background: #0f172a;
  border-color: #475569;
  color: #f8fafc;
}

:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-emoji-search-icon,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-emoji-close,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-emoji-section-title,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-emoji-empty {
  color: #cbd5e1;
}

/* Emoji picker clipping fix */
.post-upload-drawer .normal-editor-shell-linkedin .rdw-editor-wrapper,
.post-upload-drawer .normal-editor-shell-linkedin .custom-wrapper,
.post-upload-drawer .normal-editor-shell-linkedin .rdw-editor-toolbar,
.post-upload-drawer .normal-editor-shell-linkedin .rdw-editor-toolbar > div,
.normal-editor-shell-linkedin .rdw-editor-wrapper,
.normal-editor-shell-linkedin .custom-wrapper,
.normal-editor-shell-linkedin .rdw-editor-toolbar,
.normal-editor-shell-linkedin .rdw-editor-toolbar > div,
.normal-editor-shell-linkedin .custom-emoji-toolbar {
  overflow: visible !important;
}

.normal-editor-shell-linkedin .custom-emoji-toolbar {
  position: static;
}

.normal-editor-shell-linkedin .linkedin-emoji-picker.custom-emoji-modal {
  position: absolute;
  left: 8px;
  top: calc(100% + 8px);
  width: 440px;
  max-width: min(440px, calc(100vw - 48px));
  max-height: 390px;
  z-index: 5000;
  border: 1px solid #d0d7de;
  border-radius: 8px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.22);
}

.normal-editor-shell-linkedin .linkedin-emoji-search-row {
  grid-template-columns: 28px 1fr 32px;
  padding: 10px 12px;
}

.normal-editor-shell-linkedin .linkedin-emoji-tabs {
  grid-template-columns: repeat(8, 1fr);
}

.normal-editor-shell-linkedin .linkedin-emoji-tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.normal-editor-shell-linkedin .linkedin-emoji-sections {
  max-height: 250px;
}

.normal-editor-shell-linkedin .linkedin-emoji-grid {
  grid-template-columns: repeat(8, 36px);
  justify-content: start;
}

/* Final LinkedIn emoji picker layout override */
.normal-editor-shell-linkedin .custom-emoji-modal.linkedin-emoji-picker {
  display: block !important;
  grid-template-columns: none !important;
  gap: 0 !important;
  width: 440px !important;
  min-width: 440px;
  padding: 0 !important;
}

.normal-editor-shell-linkedin .linkedin-emoji-picker .linkedin-emoji-search-row {
  display: grid !important;
  grid-template-columns: 30px minmax(0, 1fr) 34px !important;
}

.normal-editor-shell-linkedin .linkedin-emoji-picker .linkedin-emoji-tabs {
  display: grid !important;
  grid-template-columns: repeat(8, minmax(0, 1fr)) !important;
}

.normal-editor-shell-linkedin .linkedin-emoji-picker .linkedin-emoji-sections {
  display: block !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  max-height: 250px !important;
  height: 250px;
  padding-bottom: 42px !important;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  touch-action: pan-y;
  scroll-behavior: auto;
}

.normal-editor-shell-linkedin .linkedin-emoji-picker .linkedin-emoji-section:last-child {
  padding-bottom: 28px;
}

.normal-editor-shell-linkedin .linkedin-emoji-picker .custom-emoji-item {
  scroll-margin-bottom: 36px;
}

.normal-editor-shell-linkedin .linkedin-emoji-picker .linkedin-emoji-grid {
  display: grid !important;
  grid-template-columns: repeat(8, 36px) !important;
}

.normal-editor-shell-linkedin .linkedin-emoji-picker .linkedin-emoji-search {
  min-width: 0;
}

/* SYNCED ARTICLE EDITOR UI START */

.linkedin-article-composer {
  width: 100%;
  padding: 0;
  background: linear-gradient(180deg, #ffffff 0%, #fbfbfa 100%);
}

.linkedin-article-author-row {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 260px;
  padding: 0 22px;
}

.linkedin-article-author-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1px solid #ffffff;
  background: linear-gradient(135deg, #dce8f5, #c8d9ed);
  color: #0f2f4a;
  font-size: 20px;
  font-weight: 800;
  box-shadow: 0 8px 22px rgba(10, 102, 194, 0.14);
  overflow: hidden;
}

.linkedin-article-author-avatar img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.linkedin-article-author-name {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #111827;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.2;
}

.linkedin-article-author-caret {
  color: #4b5563;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.linkedin-article-author-type {
  color: #4b5563;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
}

.linkedin-article-toolbar-shell {
  position: sticky;
  top: 0;
  z-index: 6;
  display: grid;
  grid-template-columns: minmax(230px, 1fr) auto minmax(230px, 1fr);
  align-items: center;
  width: 100%;
  min-height: 82px;
  margin: 0 0 36px;
  padding: 10px 28px;
  border-top: 1px solid #f8fafc;
  border-bottom: 1px solid #e5e7eb;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(16px);
  box-shadow: 0 12px 34px rgba(15, 23, 42, 0.07);
}

.linkedin-article-toolbar-start {
  justify-self: start;
}

.linkedin-article-toolbar-center {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 50px;
  padding: 7px 14px;
  border: 1px solid #d8d3ca;
  border-radius: 999px;
  background: linear-gradient(180deg, #f8f6f1 0%, #f0ede8 100%);
  box-shadow:
    0 16px 38px rgba(15, 23, 42, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.86);
}

.linkedin-article-toolbar-end {
  min-width: 230px;
  justify-self: end;
}

.linkedin-article-toolbar-spacer {
  width: 230px;
}

.linkedin-article-toolbar-group {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.linkedin-article-toolbar-group + .linkedin-article-toolbar-group {
  margin-left: 4px;
  padding-left: 10px;
  border-left: 1px solid #d6d1c8;
}

.linkedin-article-style-select {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-width: 132px;
  padding: 0;
  border-radius: 999px;
}

.linkedin-article-style-select select {
  width: 100%;
  border: 0;
  background: transparent;
  color: #0f172a;
  font-size: 15px;
  font-weight: 800;
  appearance: none;
  outline: none;
  padding: 5px 28px 5px 12px;
  cursor: pointer;
}

.linkedin-article-style-caret {
  position: absolute;
  right: 10px;
  color: #334a6b;
  pointer-events: none;
  font-size: 12px;
  line-height: 1;
}

.linkedin-article-toolbar-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #333333;
  font-size: 17px;
  font-weight: 800;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;
}

.linkedin-article-toolbar-button:hover,
.linkedin-article-toolbar-button.active {
  background: #e8f3ff;
  color: #0a66c2;
  box-shadow: inset 0 0 0 1px rgba(10, 102, 194, 0.1);
}

.linkedin-article-toolbar-button:hover {
  transform: translateY(-1px) scale(1.02);
}

.linkedin-article-toolbar-text {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}

.linkedin-article-toolbar-quote {
  position: relative;
  display: inline-block;
  width: 22px;
  height: 18px;
}

.linkedin-article-toolbar-quote::before,
.linkedin-article-toolbar-quote::after {
  content: "";
  position: absolute;
  top: 2px;
  width: 7px;
  height: 11px;
  border-radius: 2px 2px 6px 6px;
  background: currentColor;
  transform: skew(-8deg);
}

.linkedin-article-toolbar-quote::before {
  left: 3px;
}

.linkedin-article-toolbar-quote::after {
  right: 3px;
}

.linkedin-article-toolbar-code {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.linkedin-article-toolbar-divider {
  width: 18px;
  height: 2px;
  border-radius: 999px;
  background: currentColor;
}

.normal-editor-shell-article .custom-wrapper,
.normal-editor-shell-article .rdw-editor-wrapper {
  border: 0 !important;
  border-radius: 0 !important;
  overflow: visible !important;
}

.linkedin-article-cover-shell {
  max-width: 900px;
  margin: 0 auto 34px;
}

.linkedin-article-title-shell {
  max-width: 900px;
  margin: 0 auto 18px;
}

.linkedin-article-title-input {
  display: block;
  width: 100%;
  min-height: 64px;
  overflow: hidden;
  resize: none;
  border: 0;
  outline: 0;
  background: transparent;
  color: #191919;
  font-family: inherit;
  font-size: 44px;
  font-weight: 600;
  line-height: 1.16;
  letter-spacing: 0;
  padding: 0;
}

.linkedin-article-title-input::placeholder {
  color: #777777;
}

.linkedin-article-title-input:disabled {
  color: #191919;
  opacity: 1;
  cursor: default;
}

.linkedin-article-cover-stage {
  position: relative;
  overflow: hidden;
  min-height: 380px;
  border: 1px solid #d8d8d8;
  background: #f3f0eb;
}

.linkedin-article-cover-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 380px;
  padding: 40px 24px 86px;
  text-align: center;
}

.linkedin-article-cover-placeholder p {
  margin: 0;
  color: #111827;
  font-size: 18px;
  line-height: 1.55;
}

.linkedin-article-cover-placeholder-icon {
  position: relative;
  width: 92px;
  height: 72px;
  margin-bottom: 28px;
  border: 4px solid #dbe5f0;
  background: #eef3f8;
}

.linkedin-article-cover-mountain,
.linkedin-article-cover-sun {
  position: absolute;
  display: block;
}

.linkedin-article-cover-mountain {
  left: 14px;
  bottom: 14px;
  width: 44px;
  height: 28px;
  background: linear-gradient(135deg, #6d88a8, #95abc2);
  clip-path: polygon(0 100%, 35% 38%, 62% 73%, 100% 12%, 100% 100%);
}

.linkedin-article-cover-sun {
  right: 12px;
  top: 12px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #f3b45d;
}

.linkedin-article-cover-media {
  display: block;
  width: 100%;
  min-height: 380px;
  max-height: 460px;
  object-fit: cover;
}

.linkedin-article-cover-trigger {
  position: absolute;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%);
  min-width: 236px;
  min-height: 42px;
  border: 1.5px solid #3f3f3f;
  border-radius: 999px;
  background: #ffffff;
  color: #1f2937;
  font-size: 16px;
  font-weight: 700;
  padding: 0 24px;
}

.linkedin-article-cover-trigger:hover {
  background: #ffffff;
}

.linkedin-article-hidden-upload,
.linkedin-article-inline-upload {
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

.normal-editor-shell-article .custom-editor {
  min-height: 420px;
  padding: 0;
  border: 0;
}

.normal-editor-shell-article .rdw-editor-wrapper,
.normal-editor-shell-article .custom-wrapper,
.normal-editor-shell-article .custom-editor {
  background: transparent !important;
  box-shadow: none !important;
}

.normal-editor-shell-article .rdw-editor-main {
  max-width: 900px;
  min-height: 420px;
  margin: 0 auto;
  padding: 0 0 36px;
  color: #191919;
  font-size: 21px;
  line-height: 1.65;
  background: transparent;
}

.normal-editor-shell-article .rdw-editor-main h1,
.normal-editor-shell-article .rdw-editor-main h2,
.normal-editor-shell-article .rdw-editor-main h3 {
  color: #191919;
  margin: 2px 0 4px;
  font-weight: 800;
}

.normal-editor-shell-article .rdw-editor-main h1 {
  font-size: 40px;
  line-height: 1.08;
}

.normal-editor-shell-article .rdw-editor-main h2 {
  font-size: 30px;
  line-height: 1.16;
}

.normal-editor-shell-article .rdw-editor-main h3 {
  font-size: 24px;
  line-height: 1.22;
}

.normal-editor-shell-article .rdw-editor-main p {
  margin: 0 0 12px;
}

.normal-editor-shell-article .public-DraftStyleDefault-block {
  /* The ".rdw-editor-main p" rule above was meant to give every article
     paragraph a 12px bottom gap (blog-style spacing) — but it never
     applied: blocks render as <div>, not <p>, in the live editing view, so
     that selector silently matched nothing. Meanwhile react-draft-wysiwyg's
     own unscoped ".public-DraftStyleDefault-block" rule (margin: 1em 0,
     ~16px both sides) WAS applying, giving every paragraph an oversized,
     uneven gap instead of the intended 12px bottom-only gap. This restates
     that same 12px intent directly on the block that's actually rendered,
     with higher specificity than the library's rule. */
  margin: 0 0 12px;
  min-height: 1.65em;
}

.normal-editor-shell-article .public-DraftEditor-content {
  min-height: 520px;
  cursor: text;
}

.normal-editor-shell-article .public-DraftEditor-content::after {
  content: "";
  display: block;
  clear: both;
}

.normal-editor-shell-article .linkedin-article-writing-prompt {
  color: #8b98a9;
  font-weight: 400;
}

.normal-editor-shell-article .linkedin-article-empty-body-block {
  position: relative;
  min-height: 260px !important;
}

.normal-editor-shell-article .linkedin-article-empty-body-block::before {
  content: "Write your article...";
  position: absolute;
  top: 0;
  left: 0;
  color: #8b98a9;
  font-size: 22px;
  font-weight: 400;
  line-height: 1.65;
  pointer-events: none;
}

.normal-editor-shell-article .public-DraftEditor-content > div > div:last-child
  .public-DraftStyleDefault-block {
  min-height: 260px;
}

.normal-editor-shell-article .rdw-editor-main ul,
.normal-editor-shell-article .rdw-editor-main ol {
  margin: 8px 0 20px 28px;
  padding-left: 18px;
}

.normal-editor-shell-article .rdw-editor-main li {
  margin: 4px 0;
  padding-left: 6px;
  line-height: 1.55;
}

.normal-editor-shell-article .rdw-editor-main li > div,
.normal-editor-shell-article .rdw-editor-main li > p {
  display: inline;
  margin: 0 !important;
}

.normal-editor-shell-article .rdw-editor-main li > div:empty,
.normal-editor-shell-article .rdw-editor-main li > p:empty {
  display: none;
}

.normal-editor-shell-article .public-DraftStyleDefault-ul,
.normal-editor-shell-article .public-DraftStyleDefault-ol {
  margin: 10px 0 20px !important;
  padding: 0 !important;
}

.normal-editor-shell-article .public-DraftStyleDefault-unorderedListItem,
.normal-editor-shell-article .public-DraftStyleDefault-orderedListItem {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
  line-height: 1.55 !important;
}

.normal-editor-shell-article
  .public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR {
  margin-left: 1.9em !important;
}

.normal-editor-shell-article
  .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR::before {
  left: -40px !important;
  width: 32px !important;
  top: 0;
}

.normal-editor-shell-article .rdw-editor-main blockquote {
  margin: 22px 0;
  padding-left: 18px;
  border-left: 4px solid #c9d7e6;
  color: #4a5f7e;
  font-size: 22px;
  line-height: 1.55;
}

.linkedin-article-divider-block {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  margin: 30px 0;
  min-height: 42px;
}

.linkedin-article-divider-line {
  display: block;
  width: 100%;
  height: 1px;
  background: #d8d8d8;
}

.linkedin-article-divider-delete {
  position: absolute;
  right: 0;
  top: 50%;
  z-index: 3;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: 0;
  border-radius: 50%;
  background: #666666;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  opacity: 0;
  transform: translateY(-50%) scale(0.96);
  pointer-events: none;
  transition: opacity 0.18s ease, transform 0.18s ease, background 0.18s ease;
}

.linkedin-article-divider-block:hover .linkedin-article-divider-delete,
.linkedin-article-divider-delete:focus-visible {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(-50%) scale(1);
}

.linkedin-article-divider-delete:hover {
  background: #4f4f4f;
}

.normal-editor-shell-article .rdw-editor-main pre {
  margin: 20px 0;
  padding: 16px 18px;
  border-radius: 18px;
  background: #f6f8fb;
  color: #18314f;
  font-size: 15px;
  line-height: 1.7;
}

.normal-editor-shell-article .rdw-editor-main img {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 24px auto;
}

.normal-editor-shell-article .linkedin-article-image-block {
  width: min(520px, 100%);
  margin: 30px auto;
  text-align: center;
  cursor: grab;
  transition: opacity 0.18s ease, transform 0.18s ease, width 0.2s ease;
}

.normal-editor-shell-article .linkedin-article-image-dragging {
  opacity: 0.52;
  transform: scale(0.985);
}

.normal-editor-shell-article .linkedin-article-image-block-wide {
  width: min(880px, 100%);
}

.normal-editor-shell-article .linkedin-article-image-align-left {
  float: left;
  width: min(360px, 46%);
  margin: 8px 30px 20px 0;
}

.normal-editor-shell-article .linkedin-article-image-align-right {
  float: right;
  width: min(360px, 46%);
  margin: 8px 0 20px 30px;
}

.normal-editor-shell-article .linkedin-article-image-align-center,
.normal-editor-shell-article .linkedin-article-image-block-wide {
  clear: both;
}

.normal-editor-shell-article
  .linkedin-article-image-block-wide.linkedin-article-image-align-left,
.normal-editor-shell-article
  .linkedin-article-image-block-wide.linkedin-article-image-align-right {
  float: none;
  margin: 30px auto;
}

.normal-editor-shell-article .linkedin-article-image-frame {
  position: relative;
  display: inline-block;
  width: 100%;
  overflow: hidden;
  background: #f3f0eb;
}

.normal-editor-shell-article .linkedin-article-image-frame::after {
  content: "";
  position: absolute;
  inset: 0;
  opacity: 0;
  background: rgba(0, 0, 0, 0.38);
  transition: opacity 0.18s ease;
  pointer-events: none;
}

.normal-editor-shell-article .linkedin-article-image-frame:hover::after {
  opacity: 1;
}

.normal-editor-shell-article .linkedin-article-image-frame img {
  display: block;
  width: 100%;
  max-width: none;
  height: auto;
  margin: 0;
  filter: brightness(var(--article-image-brightness, 100%))
    contrast(var(--article-image-contrast, 100%))
    saturate(var(--article-image-saturation, 100%))
    grayscale(var(--article-image-grayscale, 0%))
    sepia(var(--article-image-sepia, 0%));
  object-fit: cover;
  transform: scale(var(--article-image-zoom, 1)) rotate(var(--article-image-rotate, 0deg));
  transform-origin: center;
}

.normal-editor-shell-article .linkedin-article-image-ratio-square .linkedin-article-image-frame {
  aspect-ratio: 1 / 1;
}

.normal-editor-shell-article .linkedin-article-image-ratio-4-1 .linkedin-article-image-frame {
  aspect-ratio: 4 / 1;
}

.normal-editor-shell-article .linkedin-article-image-ratio-3-4 .linkedin-article-image-frame {
  aspect-ratio: 3 / 4;
}

.normal-editor-shell-article .linkedin-article-image-ratio-16-9 .linkedin-article-image-frame {
  aspect-ratio: 16 / 9;
}

.normal-editor-shell-article .linkedin-article-image-ratio-square .linkedin-article-image-frame img,
.normal-editor-shell-article .linkedin-article-image-ratio-4-1 .linkedin-article-image-frame img,
.normal-editor-shell-article .linkedin-article-image-ratio-3-4 .linkedin-article-image-frame img,
.normal-editor-shell-article .linkedin-article-image-ratio-16-9 .linkedin-article-image-frame img {
  height: 100%;
}

.normal-editor-shell-article .linkedin-article-image-actions {
  position: absolute;
  top: 18px;
  right: 18px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  max-width: calc(100% - 36px);
  opacity: 0;
  transition: opacity 0.18s ease;
}

.normal-editor-shell-article .linkedin-article-image-frame:hover .linkedin-article-image-actions,
.normal-editor-shell-article .linkedin-article-image-actions:focus-within {
  opacity: 1;
}

.normal-editor-shell-article .linkedin-article-image-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid rgba(255, 255, 255, 0.86);
  border-radius: 50%;
  background: rgba(36, 36, 36, 0.72);
  color: #ffffff;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.18s ease, transform 0.18s ease;
}

.normal-editor-shell-article .linkedin-article-image-actions button:hover {
  background: rgba(17, 17, 17, 0.9);
  transform: translateY(-1px);
}

.normal-editor-shell-article .linkedin-article-image-drag {
  cursor: grab;
}

@media (max-width: 720px) {
  .normal-editor-shell-article .linkedin-article-image-align-left,
  .normal-editor-shell-article .linkedin-article-image-align-right,
  .normal-editor-shell-outline .linkedin-article-image-align-left,
  .normal-editor-shell-outline .linkedin-article-image-align-right,
  .linkedin-article-preview-content .linkedin-article-image-align-left,
  .linkedin-article-preview-content .linkedin-article-image-align-right,
  .public-article-content .linkedin-article-image-align-left,
  .public-article-content .linkedin-article-image-align-right {
    float: none;
    width: 100%;
    margin: 24px auto;
  }
}

.normal-editor-shell-article .linkedin-article-empty-atomic {
  display: none;
}

/* Same hover-icon image toolbar (drag/resize/edit/delete) as the article
   editor above, now also for the Blog Write outline builder's images —
   outline's own image button already inserts via the exact same
   insertImage()/ArticleImageBlock renderer the article preset uses (see
   NormalEditor.js's customBlockRenderFunc/mousedown-capture handlers,
   extended to toolbarPreset==="outline" too), so the underlying image
   entity was always compatible; it just had no matching CSS here to make
   it look and behave the same way — react-draft-wysiwyg's own default
   plain "L C R" alignment buttons were showing instead, since without this
   scoped CSS the custom hover toolbar renders with no positioning/opacity
   rules at all. Duplicated rather than just adding ".normal-editor-shell-
   outline" to every selector above, so article's own image sizing (520px/
   880px wide) can be tuned independently later without touching this. */
.normal-editor-shell-outline .rdw-editor-main img {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 12px auto;
}

.normal-editor-shell-outline .linkedin-article-image-block {
  width: min(520px, 100%);
  margin: 16px auto;
  text-align: center;
  cursor: grab;
  transition: opacity 0.18s ease, transform 0.18s ease, width 0.2s ease;
}

.normal-editor-shell-outline .linkedin-article-image-dragging {
  opacity: 0.52;
  transform: scale(0.985);
}

.normal-editor-shell-outline .linkedin-article-image-block-wide {
  width: min(720px, 100%);
}

.normal-editor-shell-outline .linkedin-article-image-align-left {
  float: left;
  width: min(300px, 46%);
  margin: 8px 24px 16px 0;
}

.normal-editor-shell-outline .linkedin-article-image-align-right {
  float: right;
  width: min(300px, 46%);
  margin: 8px 0 16px 24px;
}

.normal-editor-shell-outline .linkedin-article-image-align-center,
.normal-editor-shell-outline .linkedin-article-image-block-wide {
  clear: both;
}

.normal-editor-shell-outline
  .linkedin-article-image-block-wide.linkedin-article-image-align-left,
.normal-editor-shell-outline
  .linkedin-article-image-block-wide.linkedin-article-image-align-right {
  float: none;
  margin: 16px auto;
}

.normal-editor-shell-outline .linkedin-article-image-frame {
  position: relative;
  display: inline-block;
  width: 100%;
  overflow: hidden;
  background: #f3f0eb;
  border-radius: 10px;
}

.normal-editor-shell-outline .linkedin-article-image-frame::after {
  content: "";
  position: absolute;
  inset: 0;
  opacity: 0;
  background: rgba(0, 0, 0, 0.38);
  transition: opacity 0.18s ease;
  pointer-events: none;
}

.normal-editor-shell-outline .linkedin-article-image-frame:hover::after {
  opacity: 1;
}

.normal-editor-shell-outline .linkedin-article-image-frame img {
  display: block;
  width: 100%;
  max-width: none;
  height: auto;
  margin: 0;
  filter: brightness(var(--article-image-brightness, 100%))
    contrast(var(--article-image-contrast, 100%))
    saturate(var(--article-image-saturation, 100%))
    grayscale(var(--article-image-grayscale, 0%))
    sepia(var(--article-image-sepia, 0%));
  object-fit: cover;
  transform: scale(var(--article-image-zoom, 1)) rotate(var(--article-image-rotate, 0deg));
  transform-origin: center;
}

.normal-editor-shell-outline .linkedin-article-image-ratio-square .linkedin-article-image-frame {
  aspect-ratio: 1 / 1;
}

.normal-editor-shell-outline .linkedin-article-image-ratio-4-1 .linkedin-article-image-frame {
  aspect-ratio: 4 / 1;
}

.normal-editor-shell-outline .linkedin-article-image-ratio-3-4 .linkedin-article-image-frame {
  aspect-ratio: 3 / 4;
}

.normal-editor-shell-outline .linkedin-article-image-ratio-16-9 .linkedin-article-image-frame {
  aspect-ratio: 16 / 9;
}

.normal-editor-shell-outline .linkedin-article-image-ratio-square .linkedin-article-image-frame img,
.normal-editor-shell-outline .linkedin-article-image-ratio-4-1 .linkedin-article-image-frame img,
.normal-editor-shell-outline .linkedin-article-image-ratio-3-4 .linkedin-article-image-frame img,
.normal-editor-shell-outline .linkedin-article-image-ratio-16-9 .linkedin-article-image-frame img {
  height: 100%;
}

.normal-editor-shell-outline .linkedin-article-image-actions {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  max-width: calc(100% - 24px);
  opacity: 0;
  transition: opacity 0.18s ease;
}

.normal-editor-shell-outline .linkedin-article-image-frame:hover .linkedin-article-image-actions,
.normal-editor-shell-outline .linkedin-article-image-actions:focus-within {
  opacity: 1;
}

.normal-editor-shell-outline .linkedin-article-image-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid rgba(255, 255, 255, 0.86);
  border-radius: 50%;
  background: rgba(36, 36, 36, 0.72);
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.18s ease, transform 0.18s ease;
}

.normal-editor-shell-outline .linkedin-article-image-actions button:hover {
  background: rgba(17, 17, 17, 0.9);
  transform: translateY(-1px);
}

.normal-editor-shell-outline .linkedin-article-image-drag {
  cursor: grab;
}

.normal-editor-shell-outline .linkedin-article-empty-atomic {
  display: none;
}

.linkedin-image-edit-overlay {
  position: fixed;
  inset: 0;
  z-index: 5000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.56);
}

.linkedin-image-edit-modal {
  width: min(1130px, calc(100vw - 58px));
  max-height: min(760px, calc(100vh - 42px));
  overflow: hidden;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.32);
}

.linkedin-image-edit-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 0 20px 0 24px;
  border-bottom: 1px solid #e5e7eb;
}

.linkedin-image-edit-header strong {
  color: #1f2937;
  font-size: 20px;
  font-weight: 800;
}

.linkedin-image-edit-header button,
.linkedin-image-edit-panel-head button,
.linkedin-image-edit-tools button {
  border: 0;
  background: transparent;
  color: #404040;
  cursor: pointer;
}

.linkedin-image-edit-header button {
  font-size: 22px;
}

.linkedin-image-edit-body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 378px;
  min-height: 590px;
  background: #f5f7fa;
}

.linkedin-image-edit-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 590px;
  overflow: hidden;
  background: #f1f3f5;
}

.linkedin-image-edit-preview img {
  display: block;
  width: 100%;
  max-height: 590px;
  filter: brightness(var(--article-image-brightness, 100%))
    contrast(var(--article-image-contrast, 100%))
    saturate(var(--article-image-saturation, 100%))
    grayscale(var(--article-image-grayscale, 0%))
    sepia(var(--article-image-sepia, 0%));
  object-fit: contain;
  transform: scale(var(--article-image-zoom, 1)) rotate(var(--article-image-rotate, 0deg));
  transform-origin: center;
}

.linkedin-image-edit-preview-square img,
.linkedin-image-edit-preview-4-1 img,
.linkedin-image-edit-preview-3-4 img,
.linkedin-image-edit-preview-16-9 img {
  width: auto;
  max-width: 82%;
  object-fit: cover;
}

.linkedin-image-edit-preview-square img {
  aspect-ratio: 1 / 1;
}

.linkedin-image-edit-preview-4-1 img {
  aspect-ratio: 4 / 1;
}

.linkedin-image-edit-preview-3-4 img {
  aspect-ratio: 3 / 4;
}

.linkedin-image-edit-preview-16-9 img {
  aspect-ratio: 16 / 9;
}

.linkedin-image-edit-panel {
  display: flex;
  flex-direction: column;
  gap: 22px;
  padding: 22px 24px 24px;
  background: #ffffff;
}

.linkedin-image-edit-panel-head {
  display: flex;
  align-items: center;
  gap: 18px;
  color: #4b5563;
  font-size: 14px;
  font-weight: 700;
}

.linkedin-image-edit-panel-head button {
  font-size: 22px;
}

.linkedin-image-edit-tabs {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-bottom: 1px solid #e5e7eb;
}

.linkedin-image-edit-tabs button {
  height: 46px;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: #4a4a4a;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
}

.linkedin-image-edit-tabs button.active {
  border-bottom-color: #057642;
  color: #057642;
}

.linkedin-image-edit-tools {
  display: flex;
  gap: 22px;
  color: #3f3f3f;
}

.linkedin-image-edit-tools button {
  font-size: 22px;
}

.linkedin-image-edit-section p,
.linkedin-image-edit-range span {
  display: block;
  margin: 0 0 12px;
  color: #666666;
  font-size: 14px;
  font-weight: 500;
}

.linkedin-image-ratio-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.linkedin-image-ratio-options button {
  height: 34px;
  border: 1px solid #b6b6b6;
  border-radius: 999px;
  background: #ffffff;
  color: #444444;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  padding: 0 14px;
}

.linkedin-image-ratio-options button.active {
  border-color: #057642;
  background: #057642;
  color: #ffffff;
}

.linkedin-image-edit-range input {
  width: 100%;
  accent-color: #057642;
}

.linkedin-image-edit-range span {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.linkedin-image-edit-range span em {
  color: #6b7280;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
}

.linkedin-image-filter-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.linkedin-image-filter-grid button {
  border: 1px solid #d7dce2;
  border-radius: 10px;
  background: #ffffff;
  color: #303030;
  cursor: pointer;
  overflow: hidden;
  padding: 0 0 10px;
  text-align: left;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.linkedin-image-filter-grid button.active {
  border-color: #057642;
  box-shadow: 0 0 0 2px rgba(5, 118, 66, 0.12);
}

.linkedin-image-filter-grid button > span:last-child {
  display: block;
  padding: 9px 10px 0;
  font-size: 13px;
  font-weight: 800;
}

.linkedin-image-filter-thumb {
  display: block;
  height: 76px;
  overflow: hidden;
  background: #eef2f6;
}

.linkedin-image-filter-thumb img {
  display: block;
  width: 100%;
  height: 100%;
  filter: brightness(var(--article-image-brightness, 100%))
    contrast(var(--article-image-contrast, 100%))
    saturate(var(--article-image-saturation, 100%))
    grayscale(var(--article-image-grayscale, 0%))
    sepia(var(--article-image-sepia, 0%));
  object-fit: cover;
}

.linkedin-image-edit-apply {
  height: 40px;
  margin-top: auto;
  border: 0;
  border-radius: 999px;
  background: #0a66c2;
  color: #ffffff;
  cursor: pointer;
  font-size: 15px;
  font-weight: 800;
}

.normal-editor-shell-article .rdw-editor-placeholder {
  top: 4px;
  left: calc((100% - 900px) / 2);
  color: #6f6f6f;
  font-size: 20px;
  line-height: 1.6;
}

.normal-editor-shell-article,
.normal-editor-shell-article .custom-wrapper,
.normal-editor-shell-article .rdw-editor-wrapper,
.normal-editor-shell-article .rdw-editor-toolbar,
.normal-editor-shell-article .custom-emoji-toolbar {
  overflow: visible !important;
}

.normal-editor-shell-article .custom-emoji-toolbar {
  position: relative;
  display: inline-flex;
}

.normal-editor-shell-article .custom-emoji-trigger.rdw-option-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  min-width: 34px;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #2f2f2f;
  box-shadow: none;
  font-size: 17px;
}

.normal-editor-shell-article .custom-emoji-trigger.rdw-option-wrapper:hover {
  background: #e0e8f3;
  color: #0a66c2;
}

.normal-editor-shell-article .linkedin-emoji-picker.custom-emoji-modal {
  position: absolute;
  top: calc(100% + 10px);
  left: 50%;
  z-index: 5000;
  display: block !important;
  grid-template-columns: none !important;
  gap: 0 !important;
  width: 440px !important;
  min-width: 440px;
  max-width: min(440px, calc(100vw - 48px));
  max-height: 390px;
  padding: 0 !important;
  overflow: hidden;
  transform: translateX(-50%);
  border: 1px solid #d0d7de;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 18px 42px rgba(16, 24, 40, 0.24);
}

.normal-editor-shell-article .linkedin-emoji-picker .linkedin-emoji-search-row {
  display: grid !important;
  grid-template-columns: 30px minmax(0, 1fr) 34px !important;
  padding: 10px 12px;
}

.normal-editor-shell-article .linkedin-emoji-picker .linkedin-emoji-tabs {
  display: grid !important;
  grid-template-columns: repeat(8, minmax(0, 1fr)) !important;
}

.normal-editor-shell-article .linkedin-emoji-picker .linkedin-emoji-sections {
  display: block !important;
  height: 250px;
  max-height: 250px !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  padding-bottom: 42px !important;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  touch-action: pan-y;
}

.normal-editor-shell-article .linkedin-emoji-picker .linkedin-emoji-section:last-child {
  padding-bottom: 28px;
}

.normal-editor-shell-article .linkedin-emoji-picker .linkedin-emoji-grid {
  display: grid !important;
  grid-template-columns: repeat(8, 36px) !important;
  justify-content: start;
}

.normal-editor-shell-article .linkedin-emoji-picker .custom-emoji-item {
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 6px;
  font-size: 24px;
  scroll-margin-bottom: 36px;
}

.normal-editor-shell-article .linkedin-emoji-picker .linkedin-emoji-search {
  min-width: 0;
}

:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-article-composer,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-article-toolbar-shell {
  background: #ffffff;
}

:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-article-title-input,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .normal-editor-shell-article .rdw-editor-main,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .normal-editor-shell-article .rdw-editor-main h1,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .normal-editor-shell-article .rdw-editor-main h2,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .normal-editor-shell-article .rdw-editor-main h3,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-article-author-name,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-article-author-type,
:is([data-theme="dark"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-article-cover-placeholder p {
  color: #191919;
}

.ant-form-item-has-error .normal-editor-shell-article .rdw-editor-wrapper,
.ant-form-item-has-error .normal-editor-shell-article .custom-wrapper,
.ant-form-item-has-error .normal-editor-shell-article .custom-editor {
  border-color: transparent !important;
  box-shadow: none !important;
}

.linkedin-article-import-button.ant-btn {
  display: block;
  min-width: 150px;
  height: 38px !important;
  margin: 14px auto 0 !important;
  border: 1px solid #d0d5dd !important;
  border-radius: 999px !important;
  background: #ffffff !important;
  color: #334155 !important;
  font-size: 13px;
  font-weight: 700;
  box-shadow: none !important;
}

.linkedin-article-composer-readonly .linkedin-article-toolbar-shell {
  display: none;
}

.post-contant-outerpanel .post-editor-title {
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 14px;
  border-bottom: 1px solid #edf1f6;
  color: #071e31;
  font-size: 18px;
  font-weight: 800;
}

.post-contant-outerpanel .post-editor-title > img {
  width: 42px;
  height: 42px;
  margin-right: 10px;
  padding: 10px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3b6b94, #0a66c2);
  box-shadow: 0 12px 22px rgba(59, 107, 148, 0.24);
}

.post-contant-outerpanel .post-comment-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: -4px 0 10px;
  padding: 10px 12px;
  border: 1px solid #e4ebf4;
}

.linkedin-article-preview-modal .ant-modal-content {
  overflow: hidden;
  border-radius: 18px;
  background: #eef3f8;
  box-shadow: 0 28px 80px rgba(15, 23, 42, 0.22);
}

.linkedin-article-preview-modal .ant-modal-close {
  top: 16px;
  right: 16px;
}

.linkedin-article-preview-modal .ant-modal-body {
  padding: 0;
}

.linkedin-article-preview-shell {
  max-height: calc(100vh - 96px);
  overflow-y: auto;
  background: #eef3f8;
}

.linkedin-article-share-panel {
  width: min(720px, calc(100% - 40px));
  margin: 28px auto 18px;
  overflow: hidden;
  border: 1px solid #d8e1ec;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 16px 44px rgba(15, 23, 42, 0.09);
}

.linkedin-article-share-panel .linkedin-article-preview-author {
  padding: 18px 22px 8px;
}

.linkedin-article-share-textarea.ant-input {
  display: block;
  width: calc(100% - 44px);
  margin: 0 22px 18px;
  padding: 10px 0;
  border: 0;
  box-shadow: none;
  color: #111827;
  font-size: 18px;
  line-height: 1.5;
  resize: none;
}

.linkedin-article-share-textarea.ant-input:focus {
  border: 0;
  box-shadow: none;
}

.linkedin-article-share-card {
  display: grid;
  grid-template-columns: 150px 1fr;
  margin: 0 22px 22px;
  overflow: hidden;
  border: 1px solid #d9dde3;
  border-radius: 10px;
  background: #f8fafc;
}

.linkedin-article-share-thumb {
  display: grid;
  min-height: 112px;
  place-items: center;
  overflow: hidden;
  background: #f3f0eb;
}

.linkedin-article-share-thumb img,
.linkedin-article-share-thumb video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.linkedin-article-share-card-body {
  padding: 16px 18px;
}

.linkedin-article-share-card-body h3 {
  margin: 0 0 8px;
  color: #111827;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.25;
}

.linkedin-article-share-card-body p {
  display: -webkit-box;
  margin: 0 0 10px;
  overflow: hidden;
  color: #475569;
  font-size: 14px;
  line-height: 1.45;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.linkedin-article-share-card-body span {
  color: #64748b;
  font-size: 13px;
}

.linkedin-article-preview-page {
  width: min(900px, calc(100% - 40px));
  min-height: 720px;
  margin: 28px auto 0;
  background: #ffffff;
  border: 1px solid #dde3ea;
  box-shadow: 0 18px 60px rgba(15, 23, 42, 0.1);
}

.linkedin-article-preview-author {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 40px 18px;
}

.linkedin-article-preview-avatar {
  display: grid;
  width: 52px;
  height: 52px;
  place-items: center;
  overflow: hidden;
  border-radius: 50%;
  background: #dbeafe;
  color: #0a66c2;
  font-size: 20px;
  font-weight: 800;
}

.linkedin-article-preview-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.linkedin-article-preview-name {
  color: #111827;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.2;
}

.linkedin-article-preview-subtitle {
  margin-top: 2px;
  color: #475569;
  font-size: 13px;
}

.linkedin-article-preview-cover {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 360px;
  margin: 0 40px;
  overflow: hidden;
  border: 1px solid #d7d2ca;
  background: #f3f0eb;
}

.linkedin-article-preview-cover img,
.linkedin-article-preview-cover video {
  display: block;
  width: 100%;
  max-height: 520px;
  object-fit: cover;
}

.linkedin-article-preview-cover-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: #475569;
  text-align: center;
}

.linkedin-article-preview-body {
  max-width: 760px;
  margin: 0 auto;
  padding: 36px 12px 86px;
}

.linkedin-article-preview-body h1 {
  margin: 0 0 10px;
  color: #1f2937;
  font-size: 44px;
  font-weight: 600;
  line-height: 1.15;
  letter-spacing: 0;
}

.linkedin-article-preview-content h1,
.linkedin-article-preview-content h2,
.linkedin-article-preview-content h3,
.public-article-content h1,
.public-article-content h2,
.public-article-content h3 {
  margin: 4px 0 4px;
}

.linkedin-article-preview-content {
  color: #111827;
  font-size: 18px;
  line-height: 1.75;
}

.linkedin-article-preview-content::after,
.public-article-content::after {
  content: "";
  display: block;
  clear: both;
}

.linkedin-article-preview-content p {
  margin: 0 0 12px;
}

.linkedin-article-preview-content ul,
.linkedin-article-preview-content ol {
  margin: 0 0 18px 24px;
  padding: 0;
}

.linkedin-article-preview-content li {
  margin-bottom: 8px;
}

.linkedin-article-preview-content blockquote {
  margin: 26px 0;
  padding-left: 20px;
  border-left: 4px solid #0a66c2;
  color: #334155;
  font-size: 22px;
  line-height: 1.55;
}

.linkedin-article-preview-content hr {
  height: 1px;
  margin: 34px 0;
  border: 0;
  background: #d4d4d4;
}

.linkedin-article-preview-content img {
  max-width: 100%;
  border-radius: 4px;
}

.linkedin-article-preview-content .linkedin-article-image,
.public-article-content .linkedin-article-image {
  width: min(620px, 100%);
  margin: 30px auto;
  text-align: center;
}

.linkedin-article-preview-content .linkedin-article-image-size-wide,
.public-article-content .linkedin-article-image-size-wide {
  width: min(760px, 100%);
}

.linkedin-article-preview-content .linkedin-article-image-align-left,
.public-article-content .linkedin-article-image-align-left {
  float: left;
  width: min(340px, 46%);
  margin: 8px 28px 18px 0;
}

.linkedin-article-preview-content .linkedin-article-image-align-right,
.public-article-content .linkedin-article-image-align-right {
  float: right;
  width: min(340px, 46%);
  margin: 8px 0 18px 28px;
}

.linkedin-article-preview-content .linkedin-article-image-align-center,
.linkedin-article-preview-content .linkedin-article-image-size-wide,
.public-article-content .linkedin-article-image-align-center,
.public-article-content .linkedin-article-image-size-wide {
  clear: both;
}

.linkedin-article-preview-content
  .linkedin-article-image-size-wide.linkedin-article-image-align-left,
.linkedin-article-preview-content
  .linkedin-article-image-size-wide.linkedin-article-image-align-right,
.public-article-content
  .linkedin-article-image-size-wide.linkedin-article-image-align-left,
.public-article-content
  .linkedin-article-image-size-wide.linkedin-article-image-align-right {
  float: none;
  margin: 30px auto;
}

.linkedin-article-preview-content .linkedin-article-image img,
.public-article-content .linkedin-article-image img {
  display: block;
  width: 100%;
  max-width: none;
  height: auto;
  margin: 0;
  border-radius: 0;
  filter: brightness(var(--article-image-brightness, 100%))
    contrast(var(--article-image-contrast, 100%))
    saturate(var(--article-image-saturation, 100%))
    grayscale(var(--article-image-grayscale, 0%))
    sepia(var(--article-image-sepia, 0%));
  object-fit: cover;
  transform: scale(var(--article-image-zoom, 1)) rotate(var(--article-image-rotate, 0deg));
  transform-origin: center;
}

.linkedin-article-preview-content .linkedin-article-image-ratio-square,
.public-article-content .linkedin-article-image-ratio-square {
  aspect-ratio: 1 / 1;
  overflow: hidden;
}

.linkedin-article-preview-content .linkedin-article-image-ratio-4-1,
.public-article-content .linkedin-article-image-ratio-4-1 {
  aspect-ratio: 4 / 1;
  overflow: hidden;
}

.linkedin-article-preview-content .linkedin-article-image-ratio-3-4,
.public-article-content .linkedin-article-image-ratio-3-4 {
  aspect-ratio: 3 / 4;
  overflow: hidden;
}

.linkedin-article-preview-content .linkedin-article-image-ratio-16-9,
.public-article-content .linkedin-article-image-ratio-16-9 {
  aspect-ratio: 16 / 9;
  overflow: hidden;
}

.linkedin-article-preview-content .linkedin-article-image-ratio-square img,
.linkedin-article-preview-content .linkedin-article-image-ratio-4-1 img,
.linkedin-article-preview-content .linkedin-article-image-ratio-3-4 img,
.linkedin-article-preview-content .linkedin-article-image-ratio-16-9 img,
.public-article-content .linkedin-article-image-ratio-square img,
.public-article-content .linkedin-article-image-ratio-4-1 img,
.public-article-content .linkedin-article-image-ratio-3-4 img,
.public-article-content .linkedin-article-image-ratio-16-9 img {
  height: 100%;
}

.linkedin-article-preview-footer {
  position: sticky;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  padding: 18px 28px;
  border-top: 1px solid #dbe3ec;
  background: rgba(248, 250, 252, 0.94);
  backdrop-filter: blur(12px);
}

.linkedin-article-preview-footer .ant-btn {
  height: 46px;
  min-width: 150px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
}

.linkedin-article-preview-publish {
  min-width: 118px !important;
  border-color: #001f35 !important;
  background: #001f35 !important;
}

/* .blog-mark-published-btn removed — the "Mark as Published" button now
   reuses .submitted-btn (same class "Send for Review" uses), which already
   has the correct height/padding/radius/font AND this same brand gradient,
   instead of this one-off class that only set background/color and left
   height/padding/radius to antd's defaults. */

.linkedin-article-native-button.ant-btn {
  min-width: 220px !important;
  border: 1px solid #0a66c2 !important;
  background: #ffffff !important;
  color: #0a66c2 !important;
}

.linkedin-article-native-button.ant-btn:hover {
  border-color: #004182 !important;
  background: #eef6ff !important;
  color: #004182 !important;
}

.linkedin-native-help p {
  margin: 0 0 14px;
  color: #334155;
  font-size: 14px;
  line-height: 1.6;
}

.linkedin-native-help textarea.ant-input {
  border-radius: 10px;
  color: #111827;
  font-size: 14px;
  line-height: 1.6;
}

.article-editor-count {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: -14px;
  margin-bottom: 16px;
  color: #64748b;
  font-size: 13px;
  line-height: 1.4;
}

.article-editor-count strong {
  color: #d93025;
  font-weight: 600;
}

.article-editor-count-error {
  color: #d93025;
}

.ant-row.ant-form-item-row .normal-editor-shell-article .rdw-editor-wrapper,
.ant-row.ant-form-item-row .normal-editor-shell-article .custom-wrapper,
.ant-row.ant-form-item-row .normal-editor-shell-article .custom-editor,
.linkedin-article-composer .normal-editor-shell-article .rdw-editor-wrapper,
.linkedin-article-composer .normal-editor-shell-article .custom-wrapper,
.linkedin-article-composer .normal-editor-shell-article .custom-editor {
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.linkedin-article-composer .normal-editor-shell-article .rdw-editor-main {
  border-top: 0 !important;
}

@media (max-width: 767px) {
  .linkedin-article-preview-page {
    width: calc(100% - 20px);
    min-height: 560px;
    margin-top: 18px;
  }

  .linkedin-article-preview-author {
    padding: 20px 20px 16px;
  }

  .linkedin-article-preview-cover {
    min-height: 240px;
    margin: 0 20px;
  }

  .linkedin-article-preview-body {
    padding: 28px 20px 84px;
  }

  .linkedin-article-preview-body h1 {
    font-size: 34px;
  }

  .linkedin-article-preview-footer {
    flex-direction: column;
    align-items: stretch;
  }

  .linkedin-article-preview-footer .ant-btn {
    width: 100%;
  }
}

.linkedin-article-composer .linkedin-article-author-row {
  min-width: 250px !important;
  gap: 12px;
  padding: 0 !important;
}

.linkedin-article-composer .linkedin-article-author-avatar {
  width: 50px !important;
  height: 50px !important;
  border: 0 !important;
  background: #d8e5f3 !important;
  color: #0b4778 !important;
  box-shadow: none !important;
}

.linkedin-article-composer .linkedin-article-author-name {
  color: #111827 !important;
  font-size: 18px !important;
  font-weight: 700 !important;
  line-height: 1.05;
}

.linkedin-article-composer .linkedin-article-author-caret {
  color: #4b5563;
  font-size: 13px;
}

.linkedin-article-composer .linkedin-article-author-type {
  margin-top: 2px !important;
  color: #111827 !important;
  font-size: 15px !important;
  line-height: 1.15;
}

.linkedin-article-composer .linkedin-article-toolbar-center {
  min-height: 50px !important;
  gap: 8px !important;
  padding: 6px 18px !important;
  border: 0 !important;
  border-radius: 999px !important;
  background: #f3f1ed !important;
  box-shadow: none !important;
}

.linkedin-article-composer .linkedin-article-style-select {
  min-width: 118px;
}

.linkedin-article-composer .linkedin-article-style-select select {
  color: #1f2937 !important;
  font-size: 17px !important;
  font-weight: 700 !important;
}

.linkedin-article-composer .linkedin-article-toolbar-group {
  gap: 5px;
}

.linkedin-article-composer .linkedin-article-toolbar-group + .linkedin-article-toolbar-group {
  margin-left: 7px !important;
  padding-left: 12px !important;
  border-left: 1px solid #ded8cf !important;
}

.linkedin-article-composer .linkedin-article-toolbar-button,
.linkedin-article-composer .custom-emoji-trigger.rdw-option-wrapper {
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  border-radius: 50% !important;
  color: #333333 !important;
  font-size: 19px !important;
}

.linkedin-article-composer .linkedin-article-toolbar-button:hover,
.linkedin-article-composer .linkedin-article-toolbar-button.active,
.linkedin-article-composer .custom-emoji-trigger.rdw-option-wrapper:hover {
  background: #dcecff !important;
  color: #0a66c2 !important;
  transform: none !important;
}

.linkedin-article-actions {
  min-width: 180px !important;
}

/* Was a bordered "Next" text button — now an icon-only circular CTA (an
   arrow, not text) so it reads as the one standout primary action among
   the otherwise-plain icon buttons in this row, rather than another
   same-weight rectangle. Uses --brand-gradient (steel blue -> dark navy),
   the same gradient this app already uses for its other primary CTAs (see
   e.g. "+ Create Blog Write Request" on the Blog Write Requests page) —
   two earlier versions of this (a steel-blue->turquoise gradient, then a
   flat solid #3B6B94) both missed that reference; fixed to match it
   exactly this time. */
.linkedin-article-preview-button {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 42px !important;
  min-width: 42px !important;
  height: 42px !important;
  padding: 0 !important;
  border: none !important;
  border-radius: 50% !important;
  background: var(--brand-gradient, linear-gradient(135deg, #3B6B94 0%, #071E31 100%)) !important;
  color: #ffffff !important;
  font-size: 17px;
  box-shadow: 0 6px 16px rgba(7, 30, 49, 0.35) !important;
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
}

.linkedin-article-preview-button:hover {
  filter: brightness(1.15);
  transform: translateY(-2px) scale(1.04);
  box-shadow: 0 10px 22px rgba(7, 30, 49, 0.45) !important;
}

.linkedin-article-preview-button:disabled {
  background: #cbd5e1 !important;
  color: #f1f5f9 !important;
  box-shadow: none !important;
  transform: none;
  filter: none;
  cursor: not-allowed;
}

/* "Send Request to Blog Writer" — CreateBlogManually.js's Create Blog page
   header. Same --brand-gradient as every other primary CTA in this app —
   same fix/reasoning as .linkedin-article-preview-button above. */
.blog-send-writer-request-btn.ant-btn {
  border: none !important;
  background: var(--brand-gradient, linear-gradient(135deg, #3B6B94 0%, #071E31 100%)) !important;
  color: #ffffff !important;
  font-weight: 600;
  box-shadow: 0 6px 16px rgba(7, 30, 49, 0.3) !important;
  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;
}
.blog-send-writer-request-btn.ant-btn:hover,
.blog-send-writer-request-btn.ant-btn:focus {
  color: #ffffff !important;
  filter: brightness(1.15);
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(7, 30, 49, 0.4) !important;
}
.blog-send-writer-request-btn.ant-btn .anticon {
  color: #ffffff !important;
}

.linkedin-article-composer {
  background:
    linear-gradient(180deg, #f8fbff 0%, #ffffff 210px) !important;
}

.linkedin-article-composer .normal-editor-before,
.linkedin-article-composer .normal-editor-shell-article .rdw-editor-main {
  position: relative;
  z-index: 1;
}

.linkedin-article-composer .linkedin-article-toolbar-shell {
  position: sticky !important;
  top: 0;
  z-index: 20 !important;
  margin-bottom: 30px !important;
  background:
    linear-gradient(90deg, #ffffff 0%, #fbfdff 46%, #ffffff 100%) !important;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.055) !important;
}

.linkedin-article-composer .linkedin-article-toolbar-center {
  border: 1px solid #e5ded2 !important;
  background: linear-gradient(180deg, #fbfaf7 0%, #efebe5 100%) !important;
  box-shadow:
    0 16px 36px rgba(15, 23, 42, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.94) !important;
}

.linkedin-article-cover-shell,
.linkedin-article-title-shell,
.normal-editor-shell-article .rdw-editor-main {
  max-width: 880px !important;
}

.linkedin-article-cover-stage {
  border-color: #e3dfd7 !important;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.08);
}

.linkedin-article-cover-media {
  max-height: 480px !important;
}

.linkedin-article-title-shell {
  margin-top: 28px !important;
}

.linkedin-article-title-input {
  color: #0f172a !important;
  font-weight: 600 !important;
}

/* LinkedIn article header strength */
.linkedin-article-composer .linkedin-article-toolbar-shell {
  grid-template-columns: minmax(280px, 1fr) auto minmax(180px, 1fr) !important;
  min-height: 74px !important;
  margin-bottom: 30px !important;
  padding: 10px 56px !important;
  border-top: 0 !important;
  border-bottom: 1px solid #d8dadd !important;
  background: #ffffff !important;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04) !important;
}

.linkedin-article-composer .linkedin-article-author-row {
  gap: 12px !important;
  min-width: 280px !important;
}

.linkedin-article-composer .linkedin-article-author-avatar {
  width: 48px !important;
  height: 48px !important;
  border: 0 !important;
  background: #d9e5f2 !important;
  color: #0a4778 !important;
  font-size: 21px !important;
  font-weight: 800 !important;
  box-shadow: none !important;
}

.linkedin-article-composer .linkedin-article-author-name {
  color: #111111 !important;
  font-size: 18px !important;
  font-weight: 800 !important;
  line-height: 1.08 !important;
}

.linkedin-article-composer .linkedin-article-author-caret {
  color: #3d3d3d !important;
  font-size: 14px !important;
  font-weight: 800 !important;
}

.linkedin-article-composer .linkedin-article-author-type {
  margin-top: 1px !important;
  color: #111111 !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 1.15 !important;
}

.linkedin-article-composer .linkedin-article-toolbar-center {
  min-height: 48px !important;
  gap: 7px !important;
  padding: 5px 18px !important;
  border: 0 !important;
  border-radius: 999px !important;
  background: #f3f1ed !important;
  box-shadow: none !important;
}

.linkedin-article-composer .linkedin-article-style-select {
  min-width: 78px !important;
}

.linkedin-article-composer .linkedin-article-style-select select {
  color: #111111 !important;
  font-size: 17px !important;
  font-weight: 800 !important;
  padding: 5px 18px 5px 10px !important;
}

.linkedin-article-composer .linkedin-article-style-caret {
  right: 4px !important;
  color: #111111 !important;
  font-size: 11px !important;
}

.linkedin-article-composer .linkedin-article-toolbar-group + .linkedin-article-toolbar-group {
  margin-left: 8px !important;
  padding-left: 14px !important;
  border-left: 1px solid #d8d2c9 !important;
}

.linkedin-article-composer .linkedin-article-toolbar-button,
.linkedin-article-composer .custom-emoji-trigger.rdw-option-wrapper {
  width: 38px !important;
  height: 38px !important;
  min-width: 38px !important;
  color: #303030 !important;
  font-size: 22px !important;
  font-weight: 900 !important;
}

.linkedin-article-composer .linkedin-article-toolbar-button .anticon svg,
.linkedin-article-composer .custom-emoji-trigger.rdw-option-wrapper .anticon svg {
  width: 22px !important;
  height: 22px !important;
}

.linkedin-article-composer .linkedin-article-toolbar-text {
  font-size: 24px !important;
  font-weight: 900 !important;
}

.linkedin-article-composer .linkedin-article-toolbar-quote {
  width: 24px !important;
  height: 20px !important;
}

.linkedin-article-composer .linkedin-article-toolbar-quote::before,
.linkedin-article-composer .linkedin-article-toolbar-quote::after {
  width: 8px !important;
  height: 13px !important;
  border-radius: 2px 2px 7px 7px !important;
}

.linkedin-article-composer .linkedin-article-toolbar-code {
  font-size: 16px !important;
  font-weight: 900 !important;
}

.linkedin-article-composer .linkedin-article-toolbar-divider {
  width: 22px !important;
  height: 2px !important;
}

.linkedin-article-actions {
  gap: 10px !important;
}

.linkedin-article-action-button.ant-btn,
.linkedin-article-action-icon {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  height: 38px !important;
  border: 1px solid #d8e2ef !important;
  border-radius: 999px !important;
  background: #ffffff !important;
  color: #314761 !important;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06) !important;
  font-size: 14px;
  font-weight: 700;
  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease, transform 0.18s ease;
}

.linkedin-article-action-button.ant-btn {
  min-width: 152px;
  padding: 0 16px !important;
}

.linkedin-article-action-icon {
  width: 38px;
  min-width: 38px;
  padding: 0;
  cursor: pointer;
}

.linkedin-article-action-button.ant-btn:hover,
.linkedin-article-action-icon:hover {
  border-color: #9ec5f1 !important;
  background: #eef6ff !important;
  color: #0a66c2 !important;
  transform: translateY(-1px);
}

.linkedin-article-delete-button:hover {
  border-color: #fecaca !important;
  background: #fff1f2 !important;
  color: #dc2626 !important;
}

.linkedin-article-action-icon:disabled {
  cursor: not-allowed;
  opacity: 0.48;
  transform: none;
}

.linkedin-article-cover-trigger {
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.2);
}

.public-article-page {
  min-height: 100vh;
  padding: 42px 18px 72px;
  background: #f3f2ef;
  color: #111827;
}

.public-article-card {
  width: min(920px, 100%);
  min-height: calc(100vh - 114px);
  margin: 0 auto;
  padding: 40px 56px 72px;
  background: #ffffff;
  box-shadow: 0 18px 54px rgba(15, 23, 42, 0.08);
}

.public-article-header {
  margin-bottom: 28px;
}

.public-article-author {
  display: flex;
  align-items: center;
  gap: 13px;
}

.public-article-avatar {
  display: grid;
  width: 52px;
  height: 52px;
  place-items: center;
  overflow: hidden;
  border-radius: 50%;
  background: #dbeafe;
  color: #0a66c2;
  font-size: 20px;
  font-weight: 800;
}

.public-article-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.public-article-author-name {
  color: #111827;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.2;
}

.public-article-author-meta {
  margin-top: 2px;
  color: #64748b;
  font-size: 14px;
}

.public-article-cover {
  display: block;
  width: 100%;
  max-height: 520px;
  margin-bottom: 36px;
  object-fit: cover;
  background: #f3f0eb;
}

.public-article-card h1 {
  margin: 0 0 30px;
  color: #191919;
  font-size: 46px;
  font-weight: 700;
  line-height: 1.15;
}

.public-article-content {
  color: #191919;
  font-size: 19px;
  line-height: 1.76;
}

.public-article-content p {
  margin: 0 0 18px;
}

.public-article-content ul,
.public-article-content ol {
  margin: 0 0 18px 24px;
  padding: 0;
}

.public-article-content hr {
  height: 1px;
  margin: 34px 0;
  border: 0;
  background: #d4d4d4;
}

.public-article-content blockquote {
  margin: 26px 0;
  padding-left: 20px;
  border-left: 4px solid #0a66c2;
  color: #334155;
  font-size: 22px;
}

.public-article-content img {
  max-width: 100%;
}

.public-article-state {
  width: min(680px, 100%);
  margin: 20vh auto 0;
  padding: 32px;
  border-radius: 12px;
  background: #ffffff;
  color: #334155;
  text-align: center;
  font-size: 18px;
  box-shadow: 0 18px 54px rgba(15, 23, 42, 0.08);
}

@media (max-width: 767px) {
  .public-article-page {
    padding: 0;
  }

  .public-article-card {
    min-height: 100vh;
    padding: 28px 22px 56px;
    box-shadow: none;
  }

  .public-article-card h1 {
    font-size: 34px;
  }
}

@media (max-width: 1100px) {
  .linkedin-article-composer .linkedin-article-toolbar-shell {
    grid-template-columns: 1fr !important;
    gap: 14px;
  }

  .linkedin-article-composer .linkedin-article-toolbar-start,
  .linkedin-article-composer .linkedin-article-toolbar-center,
  .linkedin-article-composer .linkedin-article-toolbar-end {
    justify-self: center;
  }

  .linkedin-article-actions {
    min-width: 0 !important;
    justify-content: center;
    flex-wrap: wrap;
  }
}

@media (max-width: 767px) {
  .linkedin-article-action-button.ant-btn {
    min-width: 142px;
  }

  .linkedin-article-composer .linkedin-article-toolbar-center {
    max-width: 100%;
    overflow-x: auto;
  }
}

/* SYNCED ARTICLE EDITOR UI END */
/* Blog list rows */
.blr-list-container {
  background: #ffffff;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}

.blr-wrapper {
  border-bottom: 1px solid #f0f0f0;
  background: #ffffff;
}

.blr-wrapper:last-child {
  border-bottom: 0;
}

.blr-row {
  display: flex;
  align-items: flex-start;
  gap: 0;
  padding: 14px 18px 14px 0;
  cursor: pointer;
  transition: background 0.15s ease;
  -webkit-user-select: none;
          user-select: none;
  min-height: 64px;
}

.blr-row:hover {
  background: #f9fafb;
}

.blr-bar {
  flex: 0 0 4px;
  align-self: stretch;
  min-height: 52px;
  border-radius: 0 3px 3px 0;
  margin-right: 14px;
}

.blr-content {
  flex: 1 1;
  min-width: 0;
  padding-right: 10px;
}

.blr-top {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 5px;
  flex-wrap: wrap;
}

.blr-type-badge {
  display: inline-flex;
  align-items: center;
  height: 19px;
  padding: 0 7px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.blr-type-ai {
  background: #ede9fe;
  color: #6d28d9;
}

.blr-type-manual {
  background: #e0f2fe;
  color: #0369a1;
}

.blr-status-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.blr-status-label {
  font-size: 12px;
  font-weight: 600;
}

.blr-title {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
  line-height: 1.35;
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.blr-outline {
  font-size: 12.5px;
  font-weight: 500;
  color: #374151;
  line-height: 1.45;
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.blr-preview {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.45;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 5px;
}

.blr-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11.5px;
  color: #9ca3af;
  flex-wrap: wrap;
}

.blr-meta-sep {
  color: #d1d5db;
}

.blr-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding-top: 1px;
}

.blr-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #e5e7eb;
  border-radius: 50%;
  background: #ffffff;
  color: #4b5563;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.14s, border-color 0.14s, color 0.14s;
  flex-shrink: 0;
}

.blr-action-btn:hover {
  background: #eff6ff;
  border-color: #93c5fd;
  color: #0a66c2;
}

.blr-action-btn-download:hover {
  background: #f0fdf4;
  border-color: #86efac;
  color: #16a34a;
}

.blr-action-btn-delete:hover {
  background: #fff1f2;
  border-color: #fca5a5;
  color: #dc2626;
}

.blr-chevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: 0;
  background: transparent;
  color: #9ca3af;
  font-size: 11px;
  cursor: pointer;
  transition: transform 0.2s ease, color 0.15s ease;
  flex-shrink: 0;
  margin-left: 2px;
}

.blr-chevron.blr-chevron-open {
  transform: rotate(180deg);
  color: #0a66c2;
}

.blr-expanded {
  padding: 14px 20px 16px 18px;
  background: #f8fafc;
  border-top: 1px solid #f0f0f0;
  animation: blr-slide-down 0.18s ease;
}

@keyframes blr-slide-down {
  from { opacity: 0; transform: translateY(-6px); }
  to { opacity: 1; transform: translateY(0); }
}

.blr-expanded-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 20px;
}

@media (max-width: 640px) {
  .blr-expanded-grid {
    grid-template-columns: 1fr;
  }
}

.blr-expanded-section {
  min-width: 0;
}

.blr-expanded-label {
  font-size: 10.5px;
  font-weight: 700;
  color: #9ca3af;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  margin-bottom: 5px;
}

.blr-expanded-text {
  font-size: 13px;
  color: #374151;
  line-height: 1.6;
}

.blr-empty {
  padding: 40px;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
}
/* Monthly report account highlights */
.monthly-report-highlights-title {
  font-size: 40px !important;
  font-weight: 500 !important;
  line-height: 1.1 !important;
  margin-bottom: 24px !important;
}

.monthly-report-highlights .ant-card {
  border-radius: 18px !important;
}

.monthly-report-highlights .ant-card-head {
  border-bottom: 0 !important;
  padding: 22px 28px 0 !important;
  min-height: auto !important;
}

.monthly-report-highlights .ant-card-head-title {
  font-size: 24px !important;
  line-height: 1.25 !important;
  font-weight: 800 !important;
  color: #111827 !important;
}

.monthly-report-highlights .ant-card-body {
  padding: 34px 28px 28px !important;
  min-height: 154px;
}

.monthly-report-highlights .ant-card-body > div[style*="font-style: italic"] {
  font-size: 18px !important;
  margin-bottom: 20px !important;
}

.monthly-report-highlights .ant-card-body span[style*="font-size: 22px"] {
  font-size: 32px !important;
  line-height: 1.1 !important;
}

.monthly-report-highlights .ant-card-body span[style*="font-size: 14px"] {
  font-size: 20px !important;
}

.monthly-report-highlights .ant-input-number {
  height: 62px !important;
  font-size: 22px !important;
}

.monthly-report-highlights .ant-input-number-input {
  height: 60px !important;
  font-size: 22px !important;
}

.monthly-report-highlights .ant-col > div[style*="font-size: 12px"] {
  font-size: 16px !important;
  margin-bottom: 8px !important;
}

/* Monthly report post performance section */
.monthly-report-post-section .ant-card {
  border-radius: 18px !important;
}

.monthly-report-post-section .ant-card-head {
  border-bottom: 0 !important;
  min-height: auto !important;
  padding: 22px 28px 0 !important;
}

.monthly-report-post-section .ant-card-head-title {
  color: #111827 !important;
  font-size: 24px !important;
  font-weight: 800 !important;
  line-height: 1.25 !important;
}

.monthly-report-post-section .ant-card-body {
  padding: 28px !important;
}

.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table {
  font-size: 18px !important;
  table-layout: fixed !important;
  width: 100% !important;
}

.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table-thead > tr > th {
  background: #f4f6fb !important;
  color: #0f172a !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  padding: 18px 10px !important;
  white-space: nowrap !important;
}

.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table-tbody > tr > td {
  color: #374151 !important;
  font-size: 18px !important;
  padding: 18px 10px !important;
  vertical-align: middle !important;
}

.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table-cell {
  white-space: nowrap !important;
}

.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table-cell a,
.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table-cell:nth-child(2) {
  display: block !important;
  max-width: 100% !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table-content {
  overflow-x: hidden !important;
}

.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .monthly-report-date-cell {
  overflow: visible !important;
  text-overflow: clip !important;
}

.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .monthly-report-date-text {
  display: inline-block !important;
  font-size: 17px !important;
  letter-spacing: 0 !important;
  line-height: 1.25 !important;
  min-width: 96px !important;
  overflow: visible !important;
  white-space: nowrap !important;
}

.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table-body {
  scrollbar-color: #151033 #d4d4d8;
  scrollbar-width: auto;
}

/* "Status of Blogs" card (2nd card in the same column) — same header/cell
   treatment as the Engagement Tracking table above it, so the two editable
   tables in this section read as one consistent design instead of the
   Engagement table looking finished and this one looking like a bare
   default antd table. Blog Title has no fixed width (unlike the Engagement
   table's Date/Likes/Comments), so table-layout stays auto here rather than
   fixed — that's what was making its input cramped. */
.monthly-report-post-section > .ant-col:first-child > .ant-card:nth-child(2) .ant-table-thead > tr > th {
  background: #f4f6fb !important;
  color: #0f172a !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  padding: 14px 10px !important;
  white-space: nowrap !important;
}

/* Kills the default antd column-divider (a dark ::before bar between header
   cells) on both editable tables in this section — same treatment the
   brand-manager panel's site-wide table styling already applies, scoped
   here instead of going global so it can't affect any other admin table. */
.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table-thead > tr > th::before,
.monthly-report-post-section > .ant-col:first-child > .ant-card:nth-child(2) .ant-table-thead > tr > th::before {
  background-color: transparent !important;
}

.monthly-report-post-section > .ant-col:first-child > .ant-card:nth-child(2) .ant-table-tbody > tr > td {
  color: #374151 !important;
  font-size: 15px !important;
  padding: 12px 10px !important;
  vertical-align: middle !important;
}

.monthly-report-post-section > .ant-col:first-child > .ant-card:nth-child(2) .ant-input {
  border-radius: 8px !important;
}

.monthly-report-post-section > .ant-col:last-child > .ant-card:first-child .ant-card-body {
  font-size: 18px !important;
  line-height: 1.6 !important;
}

.monthly-report-post-section > .ant-col:last-child > .ant-card:first-child .ant-input {
  border-radius: 10px !important;
  font-size: 20px !important;
  height: 60px !important;
  padding: 0 18px !important;
}

.monthly-report-post-section > .ant-col:last-child > .ant-card:first-child .ant-upload .ant-btn {
  border-radius: 10px !important;
  font-size: 22px !important;
  height: 78px !important;
  padding: 0 30px !important;
}

.monthly-report-post-section > .ant-col:last-child > .ant-card:first-child img {
  max-height: 280px !important;
}
.writing-pro-card {
  background: #fff;
}

.writing-pro-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

.writing-pro-header h4 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #06163a;
}

.writing-pro-header p {
  margin: 4px 0 0;
  color: #697184;
  font-size: 14px;
}

.writing-pro-layout {
  display: grid;
  grid-template-columns: minmax(250px, 300px) minmax(0, 1fr) minmax(260px, 320px);
  gap: 18px;
  align-items: start;
}

.writing-pro-panel,
.writing-pro-main {
  border: 1px solid #edf0f6;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 10px 28px rgba(13, 38, 76, 0.06);
}

.writing-pro-panel {
  padding: 16px;
}

.writing-pro-actions,
.writing-pro-submit,
.writing-pro-toolbar-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.writing-pro-actions {
  flex-direction: column;
}

.writing-pro-history {
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid #edf0f6;
}

.writing-pro-history h5,
.writing-pro-list h5 {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 700;
  color: #06163a;
}

.writing-pro-history button {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3px;
  text-align: left;
  border: 1px solid #edf0f6;
  background: #f8fafd;
  color: #1f2937;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 8px;
  cursor: pointer;
}

.writing-pro-history button.active {
  border-color: #0b7bea;
  background: #eef7ff;
}

.writing-pro-history button span {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.writing-pro-history button small {
  color: #7b8495;
}

.writing-pro-main {
  min-width: 0;
  overflow: hidden;
}

.writing-pro-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 16px;
  border-bottom: 1px solid #edf0f6;
}

.writing-pro-toolbar strong {
  display: block;
  font-size: 18px;
  color: #06163a;
}

.writing-pro-toolbar span {
  color: #697184;
  font-size: 13px;
}

.writing-pro-main .contant-editer iframe {
  border: 0 !important;
  min-height: 520px;
}

.writing-pro-main .contant-editer .description-editor-local {
  background: #fff;
  border: 0;
  color: #1f2937;
  font-size: 16px;
  line-height: 1.7;
  min-height: 520px;
  outline: none;
  overflow-y: auto;
  padding: 16px;
  width: 100%;
}

.writing-pro-main .contant-editer .description-editor-local:empty::before {
  color: #9ca3af;
  content: attr(data-placeholder);
  pointer-events: none;
}

.writing-pro-submit {
  justify-content: flex-end;
  padding: 14px 16px;
  border-top: 1px solid #edf0f6;
}

.writing-pro-metric,
.writing-pro-list {
  margin-top: 14px;
  padding: 14px;
  border: 1px solid #edf0f6;
  border-radius: 8px;
  background: #f9fbff;
}

.writing-pro-metric span {
  display: block;
  color: #697184;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.writing-pro-metric strong {
  display: block;
  margin-top: 6px;
  color: #082b63;
  font-size: 24px;
}

.writing-pro-metric p,
.writing-pro-list p {
  margin: 8px 0 0;
  color: #4c5668;
  line-height: 1.5;
}

@media (max-width: 1200px) {
  .writing-pro-layout {
    grid-template-columns: 1fr;
  }

  .writing-pro-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
}

/* Keep the staff article workflow visible: edit, Next, then review actions in preview. */
.linkedin-article-composer .linkedin-article-toolbar-shell {
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) !important;
}

.linkedin-article-composer .linkedin-article-toolbar-end {
  display: flex !important;
  min-width: 0 !important;
  justify-self: end !important;
}

.linkedin-article-composer .linkedin-article-actions {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 8px !important;
  min-width: 0 !important;
}

.linkedin-article-preview-avatar {
  flex: 0 0 52px;
  width: 52px !important;
  height: 52px !important;
}

.linkedin-article-preview-avatar img {
  display: block;
  width: 52px !important;
  height: 52px !important;
  max-width: 52px !important;
  object-fit: cover !important;
}


/* =========================================================
   Header responsive overrides — sidebar-aware
   ========================================================= */

@media (max-width: 1600px) {
  .section-headding h6 {
    font-size: 26px !important;
    line-height: 1.2 !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .layout-dashboard .ant-layout-header {
    padding: 12px 24px 12px 16px !important;
  }
  .layout-dashboard .header-control {
    gap: 12px !important;
  }
}

@media (max-width: 1400px) {
  .section-headding h6 {
    font-size: 22px !important;
    line-height: 1.2 !important;
  }
  .layout-dashboard .ant-layout-header {
    padding: 10px 20px 10px 14px !important;
  }
  .layout-dashboard .header-control {
    gap: 8px !important;
  }
}

@media (max-width: 1200px) {
  .section-headding h6 {
    font-size: 20px !important;
  }
  .layout-dashboard .ant-layout-header {
    padding: 8px 16px 8px 12px !important;
  }
}

/* ── LinkedIn post preview — interactions row ── */
.post-interactions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.like-counts {
  display: flex;
  align-items: center;
  gap: 5px;
}

.like-counts img {
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
}

.like-counts span {
  color: #585757;
  font-weight: 400;
  font-size: 16px;
}

.cm-reort-text {
  display: flex;
  gap: 10px;
}

.cm-reort-text span {
  color: #585757;
  font-weight: 500;
  font-size: 15px;
  letter-spacing: -0.14px;
}

/* =========================================================
   Writing Assistant — new UI (wa-* classes)
   ========================================================= */

.wa-root {
  padding: 4px 0 24px;
}

.wa-page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  gap: 16px;
}

.wa-page-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.wa-page-header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%);
  color: #fff;
  font-size: 20px;
  flex-shrink: 0;
  box-shadow: 0 4px 14px rgba(11, 123, 234, 0.3);
}

.wa-page-title {
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  line-height: 1.3;
}

.wa-page-subtitle {
  font-size: 13px;
  color: #64748b;
  margin: 2px 0 0;
}

.wa-history-btn {
  flex-shrink: 0;
  background: #ffffff !important;
  color: #334155 !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}
.wa-history-btn:hover {
  background: #f0f8ff !important;
  border-color: #0b7bea !important;
  color: #0b7bea !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(11, 123, 234, 0.18);
}

.wa-layout {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  gap: 16px;
  align-items: stretch;
  height: calc(100vh - 210px);
  min-height: 560px;
}

.wa-sidebar {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(15,23,42,.06), 0 4px 20px rgba(15,23,42,.04);
  overflow: hidden;
}

.wa-sidebar-tabs.ant-tabs { height: 100%; }
.wa-sidebar-tabs .ant-tabs-nav { margin: 0; padding: 0 8px; background: #f8fafd; border-bottom: 1px solid #e2e8f0 !important; }
.wa-sidebar-tabs .ant-tabs-tab { padding: 12px 10px !important; font-size: 13px !important; }
.wa-sidebar-tabs .ant-tabs-tab-active .ant-tabs-tab-btn { color: #0b7bea !important; font-weight: 600 !important; }
.wa-sidebar-tabs .ant-tabs-ink-bar { background: #0b7bea !important; }
.wa-sidebar-tabs .ant-tabs-content-holder { padding: 16px; }

.wa-tab-label { display: flex; align-items: center; gap: 5px; }
.wa-tab-badge { display: inline-flex; align-items: center; justify-content: center; min-width: 18px; height: 18px; padding: 0 5px; border-radius: 10px; background: #0b7bea; color: #fff; font-size: 10px; font-weight: 700; line-height: 1; margin-left: 2px; }

.wa-form-actions { display: flex; flex-direction: column; gap: 10px; margin-top: 8px; }
.wa-generate-row { display: flex; align-items: center; gap: 8px; }
.wa-generate-row .wa-btn-generate.ant-btn-block { width: auto; flex: 1 1 auto; min-width: 0; }

.wa-btn-generate { background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%) !important; border: none !important; box-shadow: 0 3px 10px rgba(11,123,234,.28) !important; font-weight: 600 !important; }
.wa-btn-generate:hover { opacity: 0.9; box-shadow: 0 4px 14px rgba(11,123,234,.38) !important; }
.wa-btn-search { border-color: #e2e8f0 !important; color: #475569 !important; }
.wa-textarea { resize: none !important; font-size: 13px !important; }

.wa-content-bank { display: flex; flex-direction: column; gap: 0; }
.wa-bank-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; font-size: 12px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; color: #94a3b8; }
.wa-bank-item { width: 100%; display: flex; flex-direction: column; gap: 2px; text-align: left; border: 1px solid #f1f5f9; background: #fafbfd; border-radius: 8px; padding: 10px 12px; margin-bottom: 6px; cursor: pointer; transition: border-color .15s ease, background .15s ease, box-shadow .15s ease; }
.wa-bank-item:hover { border-color: #bfdbfe; background: #eff6ff; box-shadow: 0 2px 8px rgba(11,123,234,.08); }
.wa-bank-item.active { border-color: #0b7bea; background: #eff6ff; box-shadow: 0 2px 10px rgba(11,123,234,.14); }
.wa-bank-item-title { font-size: 13px; font-weight: 600; color: #1e293b; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.wa-bank-item-meta { font-size: 11px; color: #94a3b8; }
.wa-bank-item-words { margin-left: 4px; color: #cbd5e1; }
.wa-bank-empty { display: flex; flex-direction: column; align-items: center; padding: 28px 16px; text-align: center; }
.wa-bank-empty p { margin: 0; font-size: 13px; color: #94a3b8; }
.wa-bank-empty small { font-size: 11px; color: #cbd5e1; margin-top: 4px; }

/* ── Chat sidebar (chat history + drafts) ─────────────────────────────────── */
.wa-chat-sidebar { display: flex; flex-direction: column; border: 1px solid #e2e8f0; border-radius: 14px; background: #fff; box-shadow: 0 1px 4px rgba(15,23,42,.06), 0 4px 20px rgba(15,23,42,.04); overflow: hidden; height: 100%; min-height: 0; }
.wa-chat-sidebar-top { padding: 14px 14px 8px; }
.wa-new-chat-btn.ant-btn { background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%) !important; border: none !important; font-weight: 600 !important; box-shadow: 0 3px 10px rgba(11,123,234,.28) !important; }
.wa-chat-sidebar-search { padding: 0 14px 10px; }
.wa-chat-sidebar-toggle { padding: 0 14px 10px; }
.wa-chat-sidebar-list { flex: 1 1; min-height: 0; overflow-y: auto; padding: 4px 10px 10px; }
.wa-chat-sidebar-group { margin-bottom: 6px; }
.wa-chat-sidebar-group-label { font-size: 11px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; color: #94a3b8; padding: 10px 8px 4px; }
.wa-chat-sidebar-item { display: flex; align-items: center; gap: 8px; padding: 8px; border-radius: 8px; cursor: pointer; transition: background .15s ease; }
.wa-chat-sidebar-item:hover { background: #f1f5f9; }
.wa-chat-sidebar-item.active { background: #eff6ff; }
.wa-chat-sidebar-item-icon { color: #94a3b8; font-size: 13px; flex-shrink: 0; }
.wa-chat-sidebar-item.active .wa-chat-sidebar-item-icon { color: #0b7bea; }
.wa-chat-sidebar-item-title { flex: 1 1; min-width: 0; font-size: 13px; color: #334155; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.wa-chat-sidebar-item.active .wa-chat-sidebar-item-title { color: #0b7bea; font-weight: 600; }
.wa-chat-sidebar-item-body { flex: 1 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.wa-chat-sidebar-item-body .wa-chat-sidebar-item-title { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.wa-chat-sidebar-item-meta { font-size: 11px; color: #94a3b8; }
.wa-chat-sidebar-item-delete { opacity: 0; border: none; background: transparent; color: #94a3b8; cursor: pointer; padding: 4px; border-radius: 6px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; transition: opacity .15s ease, background .15s ease, color .15s ease; }
.wa-chat-sidebar-item:hover .wa-chat-sidebar-item-delete { opacity: 1; }
.wa-chat-sidebar-item-delete:hover { background: #fee2e2; color: #dc2626; }
.wa-chat-sidebar-empty { padding: 24px 12px; text-align: center; font-size: 13px; color: #94a3b8; }
.wa-chat-sidebar-footer { padding: 8px 10px; border-top: 1px solid #f1f5f9; flex-shrink: 0; }

/* ── Chat column (conversation thread + composer) ─────────────────────────── */
.wa-chat-column { display: flex; flex-direction: column; border: 1px solid #e2e8f0; border-radius: 14px; background: #fff; box-shadow: 0 1px 4px rgba(15,23,42,.06), 0 4px 20px rgba(15,23,42,.04); overflow: hidden; min-width: 0; height: 100%; min-height: 0; }
.wa-chat-thread { flex: 1 1; min-height: 0; overflow-y: auto; padding: 20px; display: flex; flex-direction: column; gap: 16px; background: #fbfcfe; }

.wa-chat-empty { margin: auto; text-align: center; max-width: 420px; padding: 24px; }
.wa-chat-empty-icon { width: 56px; height: 56px; border-radius: 16px; background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%); color: #fff; display: flex; align-items: center; justify-content: center; font-size: 24px; margin: 0 auto 14px; box-shadow: 0 4px 14px rgba(11,123,234,.3); }
.wa-chat-empty h3 { font-size: 17px; font-weight: 700; color: #0f172a; margin: 0 0 6px; }
.wa-chat-empty p { font-size: 13px; color: #64748b; margin: 0 0 18px; }
.wa-chat-starters { display: flex; flex-wrap: wrap; gap: 8px; justify-content: center; }
.wa-chat-starter-chip { border: 1px solid #e2e8f0; background: #fff; color: #334155; font-size: 12.5px; padding: 8px 14px; border-radius: 20px; cursor: pointer; transition: border-color .15s ease, background .15s ease, color .15s ease; }
.wa-chat-starter-chip:hover { border-color: #93c5fd; background: #eff6ff; color: #0b7bea; }

.wa-msg { display: flex; }
.wa-msg-user { justify-content: flex-end; }
.wa-msg-assistant { justify-content: flex-start; }
.wa-msg-bubble { border-radius: 16px; font-size: 14px; line-height: 1.55; }
.wa-msg-user .wa-msg-bubble { max-width: 78%; background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%); color: #fff; padding: 10px 16px; border-bottom-right-radius: 4px; white-space: pre-wrap; word-wrap: break-word; }
.wa-msg-assistant .wa-msg-bubble { max-width: 92%; width: 100%; }
.wa-msg-card { background: #fff; border: 1px solid #e2e8f0; border-bottom-left-radius: 4px; box-shadow: 0 1px 3px rgba(15,23,42,.04); }
.wa-msg-static { padding: 14px 16px; font-size: 14px; color: #1e293b; line-height: 1.65; }
.wa-msg-static p { margin: 0 0 10px; }
.wa-msg-static p:last-child { margin-bottom: 0; }
.wa-msg-typing { display: flex; align-items: center; gap: 8px; padding: 12px 16px; color: #64748b; font-size: 13px; }
.wa-msg-card.wa-editor-surface { flex: none; min-height: 0; }
.wa-msg-card.wa-editor-surface .contant-editer .description-editor-local { min-height: 200px; border-radius: 12px; }

/* ── Current draft actions bar ─────────────────────────────────────────────── */
.wa-draft-actions { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 16px; border-top: 1px solid #e8edf5; background: #f8fafd; flex-shrink: 0; flex-wrap: wrap; }

/* ── Composer ──────────────────────────────────────────────────────────────── */
.wa-composer { border-top: 1px solid #e2e8f0; background: #fff; flex-shrink: 0; padding: 12px 16px 14px; }
.wa-composer-input-row { display: flex; align-items: flex-end; gap: 8px; }
.wa-composer-settings-toggle { flex-shrink: 0; width: 36px; height: 36px; border-radius: 10px; border: 1px solid #e2e8f0; background: #fff; color: #64748b; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 15px; transition: background .15s ease, color .15s ease, border-color .15s ease; }
.wa-composer-settings-toggle:hover { background: #f1f5f9; }
.wa-composer-settings-toggle.active { background: #eff6ff; border-color: #bfdbfe; color: #0b7bea; }

.wa-settings-anchor { position: relative; flex-shrink: 0; }
.wa-settings-panel { position: absolute; bottom: calc(100% + 10px); left: 0; width: 240px; background: #fff; border: 1px solid #eef2f7; border-radius: 16px; box-shadow: 0 16px 40px rgba(15,23,42,.16), 0 4px 12px rgba(15,23,42,.08); padding: 16px; z-index: 20; }
.wa-settings-panel .ant-form-item { margin-bottom: 16px; }
.wa-settings-panel .ant-form-item:last-child { margin-bottom: 0; }
.wa-settings-panel .ant-form-item-label > label { font-size: 13px; font-weight: 700; color: #0f172a; height: auto; }
.wa-settings-panel .ant-select-selector, .wa-settings-panel .ant-input { border-radius: 10px !important; }
.wa-settings-panel .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) { background: linear-gradient(135deg, #3B6B94 0%, #071E31 100%) !important; border-color: #3B6B94 !important; color: #fff !important; box-shadow: -1px 0 0 0 #3B6B94 !important; }
.wa-settings-panel .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before { background-color: #3B6B94 !important; }
.wa-settings-panel .ant-radio-button-wrapper:hover { color: #3B6B94 !important; }
.wa-settings-panel .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover { background: linear-gradient(135deg, #4a7ba8 0%, #0d2a42 100%) !important; border-color: #4a7ba8 !important; color: #fff !important; }

.wa-composer-textarea { flex: 1 1; min-width: 0; }
.wa-composer-textarea textarea.ant-input, .wa-composer-textarea.ant-input { border-radius: 18px !important; padding: 8px 16px !important; resize: none !important; font-size: 14px !important; border-color: #e2e8f0 !important; }
.wa-composer-textarea textarea.ant-input:focus, .wa-composer-textarea.ant-input:focus { border-color: #0b7bea !important; box-shadow: 0 0 0 2px rgba(11,123,234,.12) !important; }
.wa-composer-send.ant-btn { flex-shrink: 0; width: 36px; height: 36px; min-width: 36px; padding: 0; background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%) !important; border: none !important; box-shadow: 0 3px 10px rgba(11,123,234,.28) !important; }
.wa-composer-send.ant-btn[disabled] { background: #e2e8f0 !important; box-shadow: none !important; color: #94a3b8 !important; }

.wa-editor-panel { display: flex; flex-direction: column; border: 1px solid #e2e8f0; border-radius: 14px; background: #fff; box-shadow: 0 1px 4px rgba(15,23,42,.06), 0 4px 20px rgba(15,23,42,.04); overflow: hidden; min-width: 0; }

.wa-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 16px; background: #f8fafd; border-bottom: 1px solid #e8edf5; flex-shrink: 0; }
.wa-toolbar-left { display: flex; align-items: center; gap: 10px; flex-shrink: 0; }
.wa-editor-label { font-size: 13px; font-weight: 700; color: #1e293b; white-space: nowrap; }
.wa-generating-badge { display: inline-flex; align-items: center; gap: 5px; padding: 2px 10px; border-radius: 20px; background: #eff6ff; border: 1px solid #bfdbfe; font-size: 11px; color: #0b7bea; font-weight: 600; animation: wa-pulse 1.5s ease-in-out infinite; }
@keyframes wa-pulse { 0%,100%{opacity:1} 50%{opacity:.6} }

/* Stop control — spinning ring + morphing core */
:root { --wa-stop-color: #ef4444; }
@keyframes wa-stop-spin { to { transform: rotate(360deg); } }
.wa-stop-icon, .wa-stop-pill { position: relative; display: inline-flex; align-items: center; justify-content: center; border: none; cursor: pointer; background: #fff; box-shadow: 0 0 0 1px rgba(239,68,68,.35); transition: box-shadow .2s ease, transform .12s ease; }
.wa-stop-icon:hover, .wa-stop-pill:hover { box-shadow: 0 0 0 1px rgba(239,68,68,.6); transform: translateY(-1px); }
.wa-stop-icon:active, .wa-stop-pill:active { transform: translateY(0) scale(.94); }
.wa-stop-icon { width: 32px; height: 32px; border-radius: 50%; flex-shrink: 0; align-self: center; }
.wa-stop-ring { position: absolute; inset: 0; width: 100%; height: 100%; animation: wa-stop-spin 2.2s linear infinite; }
.wa-stop-ring circle { fill: none; stroke: var(--wa-stop-color); stroke-width: 2; stroke-dasharray: 18 76; stroke-linecap: round; }
.wa-stop-core { position: relative; z-index: 1; width: 11px; height: 11px; background: var(--wa-stop-color); border-radius: 2px; transition: border-radius .18s ease, transform .18s ease; }
.wa-stop-icon:hover .wa-stop-core, .wa-stop-pill:hover .wa-stop-core { border-radius: 50%; transform: scale(.85); }
.wa-stop-pill { width: 100%; height: 40px; gap: 10px; border-radius: 999px; margin-top: 8px; font-size: 13px; font-weight: 600; color: var(--wa-stop-color); }
.wa-stop-ring-wrap { position: relative; display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px; flex-shrink: 0; }
.wa-stop-ring-wrap .wa-stop-ring circle { stroke-width: 2.4; stroke-dasharray: 12 51; }
.wa-stop-ring-wrap .wa-stop-core { width: 7px; height: 7px; }

.wa-toolbar-actions { display: flex; align-items: center; gap: 6px; flex-wrap: nowrap; flex-shrink: 0; }
.wa-tool-btn.ant-btn, .wa-tool-btn .ant-btn { font-size: 12px !important; height: 28px !important; padding: 0 10px !important; border-radius: 7px !important; white-space: nowrap !important; border-color: #e2e8f0 !important; color: #475569 !important; background: #fff !important; transition: all .15s ease !important; }
.wa-tool-btn.ant-btn:hover, .wa-tool-btn .ant-btn:hover { border-color: #0b7bea !important; color: #0b7bea !important; background: #eff6ff !important; }
.wa-tool-btn-ghost.ant-btn { border-color: transparent !important; background: transparent !important; color: #94a3b8 !important; padding: 0 7px !important; }
.wa-tool-btn-ghost.ant-btn:hover { color: #0b7bea !important; border-color: transparent !important; background: #eff6ff !important; }
.wa-tool-btn-hashtag.ant-btn { color: #7c3aed !important; border-color: #ddd6fe !important; background: #f5f3ff !important; }
.wa-tool-btn-hashtag.ant-btn:hover { background: #ede9fe !important; border-color: #c4b5fd !important; }
.wa-toolbar-divider { width: 1px; height: 18px; background: #e2e8f0; flex-shrink: 0; margin: 0 2px; }
.wa-hashtag-panel { background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; padding: 12px 14px; margin-bottom: 10px; box-shadow: 0 2px 10px rgba(0,0,0,0.06); }
.wa-hashtag-panel-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; }
.wa-hashtag-panel-title { font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.06em; }
.wa-hashtag-panel-actions { display: flex; align-items: center; gap: 8px; }
.wa-hashtag-add-all { font-size: 11.5px; font-weight: 600; color: #7c3aed; background: #f5f3ff; border: 1px solid #ddd6fe; border-radius: 6px; padding: 3px 10px; cursor: pointer; transition: background 0.15s; line-height: 1.5; }
.wa-hashtag-add-all:hover { background: #ede9fe; }
.wa-hashtag-close { font-size: 13px; color: #94a3b8; background: none; border: none; cursor: pointer; padding: 2px 5px; line-height: 1; border-radius: 4px; }
.wa-hashtag-close:hover { color: #475569; background: #f1f5f9; }
.wa-hashtag-chips { display: flex; flex-wrap: wrap; gap: 6px; }
.wa-hashtag-chip { font-size: 12.5px; font-weight: 500; color: #6d28d9; background: #f5f3ff; border: 1px solid #ddd6fe; border-radius: 20px; padding: 4px 13px; cursor: pointer; transition: all 0.15s; line-height: 1.4; }
.wa-hashtag-chip:hover { background: #ede9fe; border-color: #c4b5fd; }
.wa-hashtag-chip-added { color: #15803d; background: #f0fdf4; border-color: #86efac; opacity: 0.65; cursor: default; }

.wa-editor-hint { display: flex; align-items: center; gap: 7px; padding: 5px 16px; font-size: 11.5px; color: #94a3b8; background: #fafbfd; border-bottom: 1px solid #f1f5f9; flex-shrink: 0; }
.wa-hint-dot { display: inline-block; width: 6px; height: 6px; border-radius: 50%; background: #0b7bea; flex-shrink: 0; }

.wa-editor-surface { flex: 1 1; min-height: 0; }
.wa-editor-surface .contant-editer { height: 100%; }
.wa-editor-surface .contant-editer .description-editor-local { background: #fff; border: 0; color: #1e293b; font-size: 15px; line-height: 1.85; min-height: 440px; outline: none; overflow-y: auto; padding: 22px 24px; width: 100%; }
.wa-editor-surface .contant-editer .description-editor-local:empty::before { content: attr(data-placeholder); color: #c4cdd8; pointer-events: none; font-style: italic; }

.wa-editor-footer { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 16px; border-top: 1px solid #e8edf5; background: #f8fafd; flex-shrink: 0; flex-wrap: wrap; }
.wa-footer-stats { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #64748b; }
.wa-stat { font-weight: 600; color: #475569; }
.wa-stat small { font-weight: 400; color: #94a3b8; margin-left: 1px; }
.wa-stat-sep { color: #cbd5e1; }
.wa-char-count { font-weight: 700 !important; cursor: default; }
.wa-footer-actions { display: flex; align-items: center; gap: 8px; flex-wrap: nowrap; }
.wa-action-ghost.ant-btn { border-color: transparent !important; color: #94a3b8 !important; background: transparent !important; }
.wa-action-ghost.ant-btn:hover { border-color: #e2e8f0 !important; color: #475569 !important; background: #f8fafd !important; }
.wa-btn-send-post.ant-btn { background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%) !important; border: none !important; box-shadow: 0 2px 8px rgba(11,123,234,.25) !important; font-weight: 600 !important; }
.wa-btn-send-post.ant-btn:hover { opacity: .9 !important; }

.wa-analysis { margin-top: 16px; padding: 20px 20px 24px; border: 1px solid #e2e8f0; border-radius: 14px; background: #fff; box-shadow: 0 1px 4px rgba(15,23,42,.06), 0 4px 20px rgba(15,23,42,.04); }
.wa-analysis-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin-bottom: 18px; }
.wa-analysis-title { font-size: 16px; font-weight: 700; color: #0f172a; margin: 0; }
.wa-analysis-subtitle { font-size: 13px; color: #64748b; margin: 3px 0 0; }
.wa-analyze-btn.ant-btn { background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%) !important; border: none !important; box-shadow: 0 3px 10px rgba(11,123,234,.28) !important; font-weight: 600 !important; flex-shrink: 0; }

.wa-metric-card { padding: 22px; border: 1px solid #e8edf5; border-radius: 14px; background: #fff; height: 100%; transition: box-shadow .18s ease, transform .18s ease, border-color .18s ease; display: flex; flex-direction: column; gap: 0; }
.wa-metric-card:hover { box-shadow: 0 6px 24px rgba(11,123,234,.09); transform: translateY(-2px); border-color: #c7dcfc; }
.wa-metric-card-top { display: flex; align-items: center; gap: 10px; margin-bottom: 16px; }
.wa-metric-card-top .wa-metric-icon { margin-bottom: 0; flex-shrink: 0; }
.wa-metric-card-top .wa-metric-label { margin-bottom: 0; }
.wa-metric-icon { display: inline-flex; align-items: center; justify-content: center; width: 38px; height: 38px; border-radius: 10px; font-size: 16px; margin-bottom: 14px; flex-shrink: 0; }
.wa-metric-label { font-size: 11px; font-weight: 700; letter-spacing: .07em; text-transform: uppercase; color: #94a3b8; margin-bottom: 8px; }
.wa-metric-value { font-size: 38px; font-weight: 800; line-height: 1; margin-bottom: 10px; letter-spacing: -1px; }
.wa-metric-badge { display: inline-block; font-size: 11px; font-weight: 700; letter-spacing: .05em; text-transform: uppercase; padding: 3px 10px; border-radius: 20px; margin-bottom: 10px; }
.wa-metric-note { font-size: 12.5px; color: #64748b; line-height: 1.6; margin: 0; padding-top: 6px; }
.wa-metric-card-fill { margin-top: auto; }
.wa-metric-card-list { padding: 20px 22px; }
.wa-metric-list-header { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; padding-bottom: 12px; border-bottom: 1px solid #f1f5f9; }
.wa-metric-icon-sm { width: 30px; height: 30px; border-radius: 8px; font-size: 13px; }
.wa-suggestion-list { list-style: none; margin: 0; padding: 0; }
.wa-suggestion-list li { font-size: 12.5px; color: #475569; padding: 7px 0 7px 14px; position: relative; line-height: 1.55; border-bottom: 1px solid #f8fafc; display: flex; align-items: flex-start; justify-content: space-between; gap: 8px; }
.wa-suggestion-list li:last-child { border-bottom: none; }
.wa-suggestion-list li::before { content: "›"; position: absolute; left: 0; color: #0b7bea; font-weight: 700; font-size: 14px; }
.wa-suggestion-text { flex: 1 1; }
.wa-suggestion-apply-btn { flex-shrink: 0; font-size: 11px; font-weight: 600; color: #2563eb; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 6px; padding: 3px 10px; cursor: pointer; white-space: nowrap; transition: background 0.15s; margin-top: 1px; line-height: 1.5; }
.wa-suggestion-apply-btn:hover { background: #dbeafe; }
.wa-suggestion-apply-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.wa-fact-checks { display: flex; flex-direction: column; }
.wa-fact-item { padding: 11px 0; border-bottom: 1px solid #f1f5f9; }
.wa-fact-item:last-child { border-bottom: none; padding-bottom: 0; }
.wa-fact-claim { font-size: 12.5px; font-weight: 500; line-height: 1.5; padding: 7px 10px; border-radius: 6px; margin-bottom: 7px; }
.wa-fact-claim-false { background: #fef2f2; color: #7f1d1d; }
.wa-fact-claim-partial { background: #fffbeb; color: #78350f; }
.wa-fact-claim-true { background: #f0fdf4; color: #14532d; }
.wa-fact-claim-unverified { background: #f8fafc; color: #334155; }
.wa-fact-badge { display: inline-flex; align-items: center; font-size: 11px; font-weight: 700; padding: 3px 10px; border-radius: 20px; margin-bottom: 7px; letter-spacing: 0.01em; }
.wa-fact-explanation { font-size: 12px; color: #475569; line-height: 1.5; margin-bottom: 6px; }
.wa-fact-explanation strong { display: block; font-size: 10px; text-transform: uppercase; letter-spacing: 0.06em; color: #94a3b8; margin-bottom: 3px; font-weight: 700; }
.wa-fact-explanation p { margin: 0; }
.wa-fact-sources { display: flex; flex-direction: column; gap: 3px; margin-top: 4px; }
.wa-fact-source-link { font-size: 11.5px; color: #0b7bea; text-decoration: none; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block; max-width: 100%; }
.wa-fact-source-link:hover { text-decoration: underline; }
.wa-fact-no-source { font-size: 11.5px; color: #94a3b8; font-style: italic; }
.wa-fact-retry-btn { margin-top: 7px; display: inline-flex; align-items: center; gap: 4px; font-size: 11.5px; font-weight: 600; color: #6b7280; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px; padding: 3px 10px; cursor: pointer; transition: all 0.15s; }
.wa-fact-retry-btn:hover { color: #0b7bea; border-color: #bfdbfe; background: #eff6ff; }
.wa-fact-actions-row { display: flex; gap: 6px; margin-top: 7px; flex-wrap: wrap; }
.wa-fact-actions-row .wa-fact-retry-btn { margin-top: 0; }
.wa-fact-fix-btn { display: inline-flex; align-items: center; gap: 4px; font-size: 11.5px; font-weight: 600; color: #fff; background: #1d4ed8; border: none; border-radius: 6px; padding: 3px 10px; cursor: pointer; transition: background 0.15s; }
.wa-fact-fix-btn:hover:not(:disabled) { background: #1e40af; }
.wa-fact-fix-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.wa-fact-edit { margin-top: 8px; }
.wa-fact-edit-input { width: 100%; font-size: 12px; padding: 6px 10px; border: 1px solid #bfdbfe; border-radius: 7px; outline: none; color: #1e293b; background: #f8faff; line-height: 1.5; box-sizing: border-box; }
.wa-fact-edit-input:focus { border-color: #0b7bea; background: #fff; }
.wa-fact-edit-actions { display: flex; gap: 6px; margin-top: 6px; }
.wa-fact-verify-btn { font-size: 11.5px; font-weight: 600; color: #fff; background: #0b7bea; border: none; border-radius: 6px; padding: 4px 14px; cursor: pointer; }
.wa-fact-verify-btn:hover { background: #0369a1; }
.wa-fact-cancel-btn { font-size: 11.5px; font-weight: 500; color: #64748b; background: #f1f5f9; border: 1px solid #e2e8f0; border-radius: 6px; padding: 4px 12px; cursor: pointer; }
.wa-fact-cancel-btn:hover { background: #e2e8f0; }
.wa-accuracy-banner { display: flex; align-items: center; justify-content: space-between; gap: 8px; padding: 8px 12px; border-radius: 8px; border: 1px solid; margin-bottom: 12px; font-size: 13px; }
.wa-accuracy-pct { flex: 1 1; font-size: 13px; }
.wa-fix-content-btn { flex-shrink: 0; padding: 4px 12px; border-radius: 6px; border: none; font-size: 12px; font-weight: 600; cursor: pointer; background: #1d4ed8; color: #fff; transition: background 0.15s; }
.wa-fix-content-btn:hover:not(:disabled) { background: #1e40af; }
.wa-fix-content-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.wa-linkedin-checks { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 16px; }
.wa-check-chip { display: inline-flex; align-items: center; gap: 5px; padding: 5px 13px; border-radius: 20px; font-size: 12.5px; font-weight: 500; line-height: 1.4; border: 1px solid transparent; white-space: nowrap; }
.wa-check-pass { background: #f0fdf4; border-color: #86efac; color: #15803d; }
.wa-check-fail { background: #fef2f2; border-color: #fca5a5; color: #b91c1c; }
.wa-check-dot { font-size: 13px; font-weight: 700; line-height: 1; }
.wa-check-label { font-weight: 600; }
.wa-check-value { opacity: 0.8; }
.wa-metric-empty { font-size: 12.5px; color: #c8d2e0; margin: 8px 0 0; font-style: italic; line-height: 1.6; }

.wa-modal-title { display: flex; align-items: center; gap: 8px; font-size: 16px; font-weight: 700; color: #0f172a; }
.wa-humanize-modal .ant-modal-content { border-radius: 14px !important; }

/* ── Paste-your-own-content modal ────────────────────────────────────────── */

.wa-paste-modal .ant-modal-content {
  border-radius: 14px !important;
  padding: 24px 24px 20px;
}

.wa-paste-modal .ant-modal-header {
  margin-bottom: 4px;
  padding: 0;
  border-bottom: none;
}

.wa-paste-modal-desc {
  margin: 4px 0 14px;
  color: #64748b;
  font-size: 13px;
  line-height: 1.6;
}

.wa-paste-modal-textarea.ant-input {
  border-radius: 10px;
  border-color: #e2e8f0;
  font-size: 13.5px;
  line-height: 1.6;
  padding: 12px 14px;
  resize: vertical;
}

.wa-paste-modal-textarea.ant-input:hover {
  border-color: #93c5fd;
}

.wa-paste-modal-textarea.ant-input:focus {
  border-color: #0b7bea;
  box-shadow: 0 0 0 3px rgba(11, 123, 234, 0.1);
}

.wa-paste-modal .ant-modal-footer {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.wa-paste-modal .ant-modal-footer .ant-btn {
  border-radius: 8px;
  height: 36px;
  padding: 0 18px;
  font-weight: 600;
}

.wa-paste-modal .ant-modal-footer .ant-btn-primary {
  background: #0b7bea;
  border-color: #0b7bea;
}

.wa-paste-modal .ant-modal-footer .ant-btn-primary:hover {
  background: #0968c9;
  border-color: #0968c9;
}
.wa-diff-panel { border-radius: 10px; padding: 16px; min-height: 240px; display: flex; flex-direction: column; gap: 10px; }
.wa-diff-original { background: #f8fafd; border: 1px solid #e2e8f0; }
.wa-diff-humanized { background: #f0fdf4; border: 1px solid #bbf7d0; }
.wa-diff-label { font-size: 10.5px; font-weight: 700; letter-spacing: .07em; text-transform: uppercase; color: #94a3b8; }
.wa-diff-content { font-size: 13.5px; color: #334155; line-height: 1.7; white-space: pre-wrap; flex: 1 1; }
.wa-diff-loading { display: flex; align-items: center; gap: 8px; color: #64748b; font-size: 13px; font-style: italic; padding: 12px 0; }

@media (max-width: 1100px) {
  .wa-layout { grid-template-columns: 1fr; height: auto; min-height: 0; }
  .wa-sidebar { max-width: 100%; }
  .wa-chat-sidebar { height: 260px; }
  .wa-chat-column { height: calc(100vh - 420px); min-height: 420px; }
}
@media (max-width: 768px) {
  .wa-page-header { flex-direction: column; align-items: flex-start; gap: 12px; }
  .wa-toolbar { flex-wrap: wrap; }
  .wa-toolbar-actions { flex-wrap: wrap; width: 100%; }
  .wa-editor-footer, .wa-draft-actions { flex-direction: column; align-items: flex-start; }
  .wa-footer-actions { flex-wrap: wrap; width: 100%; }
  .wa-analysis-header { flex-direction: column; align-items: flex-start; }
  .wa-analyze-btn.ant-btn { width: 100%; }
}
@media (max-width: 575.98px) {
  .wa-root { padding: 4px 0 16px; }
  .wa-page-header-icon {
    width: 40px;
    height: 40px;
    font-size: 18px;
  }
  .wa-page-title { font-size: 18px; }
  .wa-page-subtitle { font-size: 12px; }
  .wa-history-btn.ant-btn { width: 100%; }
  .wa-root .ant-radio-group {
    flex-wrap: wrap !important;
    gap: 6px;
  }
  .wa-root .ant-radio-group .ant-radio-button-wrapper {
    flex: 1 0 30% !important;
    border-radius: 6px !important;
  }
  .wa-editor-surface .contant-editer .description-editor-local {
    min-height: 280px;
    padding: 16px;
    font-size: 14px;
  }
  .wa-msg-card.wa-editor-surface .contant-editer .description-editor-local {
    min-height: 220px;
  }
  .wa-editor-surface .contant-editer .description-editor-local,
  .wa-diff-content {
    overflow-wrap: break-word;
    word-break: break-word;
  }
  .wa-footer-actions .ant-btn,
  .wa-toolbar-actions .ant-btn {
    flex: 1 1 auto;
  }
}

/* Research Assistant modern parity with user panel */
.research-assistant-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.research-assistant-heading h4 {
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: 0;
  color: #0f172a;
  margin: 0;
}

.research-assistant-heading p {
  font-size: 13px;
  line-height: 1.5;
  color: #64748b;
  margin: 2px 0 0;
}

.research-assistant-heading .chat-history-toggle-btn {
  border-radius: 8px !important;
  border: 1px solid #e2e8f0 !important;
  background: #ffffff !important;
  color: #334155 !important;
  font-weight: 600 !important;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.research-assistant-heading .chat-history-toggle-btn:hover {
  transform: translateY(-1px);
  border-color: #0b7bea !important;
  color: #0b7bea !important;
  background: #f0f8ff !important;
  box-shadow: 0 4px 12px rgba(11, 123, 234, 0.18);
}

.research-assistant-heading + .research-container {
  display: grid;
  grid-template-columns: minmax(260px, 300px) minmax(0, 1fr);
  gap: 16px;
  align-items: stretch;
}

.research-assistant-heading + .research-container > .sidebar-left-research {
  width: 100%;
  max-width: none;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 18px;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06), 0 4px 20px rgba(15, 23, 42, 0.04);
}

.research-assistant-heading + .research-container > .sidebar-left-research h6,
.research-assistant-heading + .research-container .ant-form-item-label > label,
.research-assistant-heading + .research-container .ant-form-item-label > label > div {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  color: #334155;
  margin: 0;
}

.research-assistant-heading + .research-container .textarea-with-mode {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.research-assistant-heading + .research-container .topic-textarea,
.research-assistant-heading + .research-container .dropdown-research-select .ant-select-selector {
  border-radius: 8px !important;
  border: 1px solid #e2e8f0 !important;
  background: #ffffff !important;
  font-size: 13px !important;
  box-shadow: none !important;
}

.research-assistant-heading + .research-container .dropdown-research-select .ant-select-selector {
  height: 40px !important;
  padding: 4px 11px !important;
}

.research-assistant-heading + .research-container .mode-select {
  align-self: flex-end;
  width: 100%;
}

.research-assistant-heading + .research-container .mode-select .ant-select-selector {
  border-radius: 6px !important;
  border-color: #e2e8f0 !important;
  background: #f8fafd !important;
  font-size: 12px !important;
  min-height: 24px !important;
}

.research-assistant-heading + .research-container button.ant-btn.run-button {
  height: 44px !important;
  margin-top: 18px;
  border: none !important;
  border-radius: 10px !important;
  background: linear-gradient(135deg, #3B6B94 0%, #071E31 100%) !important;
  color: #ffffff !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  line-height: 1 !important;
  letter-spacing: 0;
  box-shadow: 0 3px 10px rgba(7, 30, 49, 0.35) !important;
  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;
}

.research-assistant-heading + .research-container button.ant-btn.run-button:hover {
  opacity: 0.92;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(7, 30, 49, 0.45) !important;
}

.research-assistant-heading + .research-container > .content-area {
  min-width: 0;
  padding: 0;
  background: transparent;
  border-radius: 0;
  animation: research-assistant-content-in 0.35s ease both;
}

@keyframes research-assistant-content-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.research-assistant-heading + .research-container .headlines-section,
.research-assistant-heading + .research-container .topics-section,
.research-assistant-heading + .research-container .trends-section {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 18px;
  margin-top: 16px;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);
}

.research-assistant-heading + .research-container .headlines-section.mt-0,
.research-assistant-heading + .research-container .headlines-section:first-child {
  margin-top: 0 !important;
}

.research-assistant-heading + .research-container .headline-toll-headding {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.research-assistant-heading + .research-container section.headlines-section h6,
.research-assistant-heading + .research-container .headline-toll-headding h6 {
  color: #0f172a;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0;
  text-transform: uppercase;
  margin: 0;
}

.research-assistant-heading + .research-container .headlines-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.research-assistant-heading + .research-container .headline-card,
.research-assistant-heading + .research-container .ant-card.ant-card-bordered.headline-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  background: #f8fafd;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.research-assistant-heading + .research-container .headline-card:hover {
  transform: translateY(-2px);
  border-color: rgba(11, 123, 234, 0.65);
  box-shadow: 0 6px 16px rgba(11, 123, 234, 0.12);
}

.research-assistant-heading + .research-container .headline-card .ant-card-body {
  width: 100%;
  padding: 0 !important;
}

.research-assistant-heading + .research-container .searching-listbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.research-assistant-heading + .research-container .headline-text {
  min-width: 0;
  color: #1e293b;
  font-size: 13.5px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0;
}

.research-assistant-heading + .research-container .headline-actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
}

.research-assistant-heading + .research-container .headline-actions button.ant-btn,
.research-assistant-heading + .research-container .tag-topics button.ant-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  width: auto;
  height: 28px !important;
  padding: 0 8px !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 7px !important;
  background: #f8fafd !important;
  color: #0f172a !important;
  box-shadow: none !important;
  font-size: 12px;
  font-weight: 600;
  transition: transform 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
}

.research-assistant-heading + .research-container .headline-actions button.ant-btn-primary,
.research-assistant-heading + .research-container .tag-topics button.ant-btn-primary,
.research-assistant-heading + .research-container button.table-primary-fill-btn {
  border-color: transparent !important;
  background: #0b7bea !important;
  color: #ffffff !important;
}

.research-assistant-heading + .research-container .headline-actions button.ant-btn:hover,
.research-assistant-heading + .research-container .tag-topics button.ant-btn:hover {
  border-color: #0b7bea !important;
  transform: translateY(-1px) scale(1.04);
  opacity: 0.92;
}

.research-assistant-heading + .research-container .tags-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
}

.research-assistant-heading + .research-container .tag-topics {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  background: #f8fafd;
  padding: 8px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  color: #1e293b;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.35;
  letter-spacing: 0;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, background 0.18s ease;
}

.research-assistant-heading + .research-container .tag-topics:hover {
  transform: translateY(-2px);
  border-color: #0b7bea;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(11, 123, 234, 0.15);
}

.research-assistant-heading + .research-container .tag-topics span {
  color: #0ea5e9;
}

.research-assistant-heading + .research-container .no-headlines,
.research-assistant-heading + .research-container .no-data-message,
.research-assistant-heading + .research-container .no-research-done {
  width: 100%;
  min-height: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 14px;
  padding: 40px 24px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06), 0 4px 20px rgba(15, 23, 42, 0.04);
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
}

.research-assistant-heading + .research-container .no-headlines img {
  max-width: 240px;
  width: 100%;
  margin: 0 auto 12px;
}

@media (max-width: 991.98px) {
  .research-assistant-heading + .research-container {
    grid-template-columns: 1fr;
  }

  .research-assistant-heading + .research-container > .sidebar-left-research,
  .research-assistant-heading + .research-container > .content-area {
    min-width: 0;
    max-width: 100%;
  }

  .research-assistant-heading + .research-container .searching-listbar {
    align-items: flex-start;
    flex-direction: column;
  }
}

@media (max-width: 575.98px) {
  .research-assistant-heading {
    align-items: flex-start;
  }

  .research-assistant-heading .chat-history-toggle-btn {
    width: 100%;
  }

  .research-assistant-heading + .research-container .headline-toll-headding {
    align-items: flex-start;
    flex-direction: column;
  }
}

/* Vault module parity with user panel */
.vault-layout {
  background: transparent;
}

.vault-layout .vault-sider {
  border-radius: 14px 0 0 14px;
  overflow: hidden;
}

.vault-layout .vault-sider .ant-menu {
  background: #fff;
}

.vault-layout .valult-tabs-listing {
  font-weight: 600;
}

.vault-category-bar {
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  padding: 4px 8px;
}

.vault-category-bar .ant-menu.ant-menu-horizontal {
  display: flex;
  flex-wrap: nowrap;
  min-width: max-content;
  line-height: 1.2;
  border-bottom: 0;
  background: transparent;
}

.vault-category-bar .ant-menu.ant-menu-horizontal > li.ant-menu-item.valult-tabs-listing {
  flex: 0 0 auto;
  margin: 4px;
  padding: 0 14px;
  height: 38px;
  line-height: 38px;
  top: 0;
  border-radius: 6px;
  border-bottom: 0 !important;
}

.vault-category-bar .ant-menu.ant-menu-horizontal > li.ant-menu-item.valult-tabs-listing::after {
  border-bottom: 0 !important;
}

.vault-category-bar .ant-menu.ant-menu-horizontal > li.ant-menu-item.valult-tabs-listing span {
  font-size: 14px;
}

@media (max-width: 991.98px) {
  .vault-layout .ant-card-head-wrapper {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .vault-layout .ant-card-head-wrapper .ant-card-extra {
    width: 100%;
    margin-left: 0;
  }

  .vault-layout .ant-card-extra > .d-flex {
    width: 100%;
    gap: 12px !important;
  }

  .vault-layout .ant-card-extra .pageHeadingSearch,
  .vault-layout .ant-card-extra .role-wrap {
    width: 100%;
    flex: 1 1 100%;
  }

  .vault-layout .ant-card-extra .pageHeadingSearch .ant-input-search,
  .vault-layout .ant-card-extra .pageHeadingSearch .searchInput,
  .vault-layout .ant-card-extra .role-wrap .ant-picker.ant-picker-range,
  .vault-layout .ant-card-extra .role-wrap .ant-select.ant-select-single {
    width: 100% !important;
  }

  .vault-layout .ant-card-extra .role-wrap .ant-picker-range .ant-picker-input {
    flex: 1 1;
    min-width: 0;
  }

  .vault-layout .ant-card-extra .role-wrap .ant-picker-range .ant-picker-input > input {
    width: 100% !important;
    text-align: left;
  }

  .vault-layout .ant-card-extra .role-wrap .ant-select .ant-select-selection-placeholder {
    color: rgba(0, 0, 0, 0.45);
    opacity: 1;
  }

  .vault-layout .ant-card-extra .ant-space,
  .vault-layout .ant-card-extra [style*="display: flex"] {
    width: 100%;
    flex-wrap: wrap;
  }

  .vault-layout .ant-card-extra .ant-space .ant-space-item,
  .vault-layout .ant-card-extra [style*="display: flex"] > .ant-btn {
    flex: 1 1 auto;
  }

  .vault-layout .ant-card-extra .ant-space .ant-space-item .ant-btn,
  .vault-layout .ant-card-extra [style*="display: flex"] > .ant-btn {
    width: 100%;
  }
}


/* ===== NOTIFICATIONS PAGE ===== */
.notif-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 24px 60px;
}
.notif-body { display: flex; gap: 24px; align-items: flex-start; }
.notif-feed { flex: 1 1; min-width: 0; }
.notif-filters { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 20px; }
.notif-filter-pill { display: inline-flex; align-items: center; gap: 6px; padding: 6px 14px; border-radius: 99px; border: 1px solid rgba(7,30,49,0.1); background: #fff; font-size: 13px; font-weight: 500; color: #5a7080; cursor: pointer; transition: all 0.18s; }
.notif-filter-pill:hover { border-color: #3B6B94; color: #3B6B94; }
.notif-filter-pill--active { background: linear-gradient(135deg,#3B6B94 0%,#071E31 100%); border-color: transparent; color: #fff !important; }
.notif-filter-count { display: inline-flex; align-items: center; justify-content: center; min-width: 18px; height: 18px; padding: 0 5px; border-radius: 99px; background: rgba(255,255,255,0.22); font-size: 11px; font-weight: 700; }
.notif-filter-pill:not(.notif-filter-pill--active) .notif-filter-count { background: rgba(7,30,49,0.08); color: #071E31; }
.notif-sidebar { width: 280px; flex: 0 0 280px; display: flex; flex-direction: column; gap: 16px; position: sticky; top: 24px; }
.notif-sidebar__card { background: #fff; border: 1px solid rgba(7,30,49,0.07); border-radius: 16px; padding: 20px; }
.notif-sidebar__card-label { font-size: 11px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #9aaab8; margin: 0 0 16px; }
.notif-ring-wrap { position: relative; width: 100px; height: 100px; margin: 0 auto 14px; }
.notif-ring { width: 100px; height: 100px; border-radius: 50%; background: conic-gradient(#3B6B94 0% var(--pct), rgba(7,30,49,0.08) var(--pct) 100%); }
.notif-ring-inner { position: absolute; inset: 12px; border-radius: 50%; background: #fff; display: flex; flex-direction: column; align-items: center; justify-content: center; }
.notif-ring-pct { font-size: 20px; font-weight: 700; color: #071E31; line-height: 1; }
.notif-ring-sub { font-size: 10px; color: #9aaab8; margin-top: 2px; }
.notif-ring-legend { display: flex; align-items: center; justify-content: center; gap: 8px; font-size: 12px; color: #5a7080; }
.notif-legend-dot { width: 8px; height: 8px; border-radius: 50%; display: inline-block; }
.notif-legend-dot--read { background: #3B6B94; }
.notif-legend-dot--unread { background: rgba(7,30,49,0.12); }
.notif-cat-list { display: flex; flex-direction: column; gap: 4px; }
.notif-cat-row { display: flex; align-items: center; gap: 10px; padding: 8px 10px; border-radius: 8px; cursor: pointer; transition: background 0.15s; }
.notif-cat-row:hover { background: rgba(7,30,49,0.04); }
.notif-cat-row--active { background: rgba(59,107,148,0.08); }
.notif-cat-dot { width: 8px; height: 8px; border-radius: 50%; flex: 0 0 auto; }
.notif-cat-dot--green   { background: #16a34a; }
.notif-cat-dot--blue    { background: #3B6B94; }
.notif-cat-dot--purple  { background: #7c3aed; }
.notif-cat-dot--amber   { background: #d97706; }
.notif-cat-dot--teal    { background: #0e7490; }
.notif-cat-dot--indigo  { background: #4338ca; }
.notif-cat-dot--default { background: #3B6B94; }
.notif-cat-name { flex: 1 1; font-size: 13px; font-weight: 500; color: #071E31; }
.notif-cat-count { font-size: 12px; font-weight: 700; color: #9aaab8; background: rgba(7,30,49,0.06); border-radius: 99px; padding: 1px 8px; }
.notif-sidebar__actions { display: flex; flex-direction: column; gap: 8px; }
.notif-qa-btn { display: flex; align-items: center; gap: 8px; width: 100%; padding: 9px 14px; border-radius: 8px; border: 1px solid rgba(7,30,49,0.1); background: transparent; font-size: 13px; font-weight: 500; color: #3B6B94; cursor: pointer; transition: all 0.18s; }
.notif-qa-btn:hover { background: rgba(59,107,148,0.08); border-color: #3B6B94; }
.notif-qa-btn--danger { color: #ef4444; }
.notif-qa-btn--danger:hover { background: rgba(239,68,68,0.06); border-color: rgba(239,68,68,0.3); }
.notif-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 32px; padding-bottom: 24px; border-bottom: 1px solid rgba(7,30,49,0.08); }
.notif-header__left { display: flex; align-items: center; gap: 16px; }
.notif-header__icon-wrap { width: 52px; height: 52px; border-radius: 14px; background: linear-gradient(135deg,#3B6B94 0%,#071E31 100%); display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 16px rgba(59,107,148,0.35); }
.notif-header__bell { font-size: 22px !important; color: #fff !important; }
.notif-header__title { font-size: 26px; font-weight: 700; color: #071E31; margin: 0 0 2px; font-family: 'Greycliff CF', sans-serif; }
.notif-header__sub { font-size: 14px; color: #7a8fa0; margin: 0; display: flex; align-items: center; gap: 8px; }
.notif-count-chip { display: inline-flex; align-items: center; justify-content: center; min-width: 22px; height: 22px; padding: 0 7px; border-radius: 99px; background: linear-gradient(135deg,#3B6B94 0%,#071E31 100%); color: #fff; font-size: 12px; font-weight: 700; }
.notif-menu-btn { width: 40px; height: 40px; border-radius: 10px; border: 1px solid rgba(7,30,49,0.12); background: #fff; color: #3B6B94; font-size: 20px; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.18s; }
.notif-menu-btn:hover { background: linear-gradient(135deg,#3B6B94 0%,#071E31 100%); color: #fff; border-color: transparent; }
.notif-timeline { display: flex; flex-direction: column; gap: 10px; }
.notif-card { display: flex; align-items: center; gap: 16px; padding: 16px 20px; border-radius: 14px; background: #fff; border: 1px solid rgba(7,30,49,0.07); cursor: pointer; position: relative; transition: transform 0.18s, box-shadow 0.18s, border-color 0.18s; }
.notif-card:hover { transform: translateY(-2px); box-shadow: 0 6px 24px rgba(7,30,49,0.1); }
.notif-card--unread { border-left: 3px solid #3B6B94; background: linear-gradient(90deg,rgba(59,107,148,0.04) 0%,#fff 50%); }
.notif-card--read { border-left: 3px solid transparent; opacity: 0.82; }
.notif-card__icon { width: 44px; height: 44px; border-radius: 12px; display: flex; align-items: center; justify-content: center; flex: 0 0 auto; font-size: 18px !important; }
.notif-icon--green   { background: rgba(34,197,94,0.12);  color: #16a34a !important; }
.notif-icon--blue    { background: rgba(59,107,148,0.12); color: #3B6B94 !important; }
.notif-icon--purple  { background: rgba(139,92,246,0.12); color: #7c3aed !important; }
.notif-icon--amber   { background: rgba(245,158,11,0.12); color: #d97706 !important; }
.notif-icon--teal    { background: rgba(108,229,232,0.18);color: #0e7490 !important; }
.notif-icon--indigo  { background: rgba(99,102,241,0.12); color: #4338ca !important; }
.notif-icon--default { background: rgba(7,30,49,0.08);   color: #3B6B94 !important; }
.notif-card__body { flex: 1 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
.notif-type-badge { display: inline-flex; align-items: center; font-size: 10px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; padding: 2px 8px; border-radius: 99px; width: fit-content; }
.notif-badge--green   { background: rgba(34,197,94,0.12);  color: #16a34a; }
.notif-badge--blue    { background: rgba(59,107,148,0.12); color: #3B6B94; }
.notif-badge--purple  { background: rgba(139,92,246,0.12); color: #7c3aed; }
.notif-badge--amber   { background: rgba(245,158,11,0.12); color: #d97706; }
.notif-badge--teal    { background: rgba(108,229,232,0.22);color: #0e7490; }
.notif-badge--indigo  { background: rgba(99,102,241,0.12); color: #4338ca; }
.notif-badge--default { background: rgba(7,30,49,0.07);   color: #3B6B94; }
.notif-card__sub-title { font-size: 12px; font-weight: 600; color: #3B6B94; }
.notif-card__desc { font-size: 14px; font-weight: 500; color: #071E31; margin: 0; line-height: 1.45; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.notif-card__time { font-size: 12px; color: #9aaab8; }
.notif-card__actions { display: flex; align-items: center; gap: 10px; flex: 0 0 auto; }
.notif-pulse-dot { width: 10px; height: 10px; border-radius: 50%; background: #6CE5E8; box-shadow: 0 0 0 0 rgba(108,229,232,0.6); animation: notif-pulse 1.8s ease-in-out infinite; display: block; }
@keyframes notif-pulse { 0%{box-shadow:0 0 0 0 rgba(108,229,232,0.6)} 70%{box-shadow:0 0 0 8px rgba(108,229,232,0)} 100%{box-shadow:0 0 0 0 rgba(108,229,232,0)} }
.notif-delete-btn { width: 32px; height: 32px; border-radius: 8px; border: 1px solid transparent; background: transparent; color: #bcc8d4; font-size: 14px; display: flex; align-items: center; justify-content: center; cursor: pointer; opacity: 0; transition: opacity 0.18s, background 0.18s, color 0.18s; }
.notif-card:hover .notif-delete-btn { opacity: 1; }
.notif-delete-btn:hover { background: rgba(239,68,68,0.08); border-color: rgba(239,68,68,0.2); color: #ef4444; }
.notif-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 80px 24px; text-align: center; }
.notif-empty__graphic { width: 80px; height: 80px; border-radius: 24px; background: linear-gradient(135deg,#3B6B94 0%,#071E31 100%); display: flex; align-items: center; justify-content: center; margin-bottom: 20px; box-shadow: 0 8px 24px rgba(59,107,148,0.3); }
.notif-empty__bell { font-size: 36px !important; color: #fff !important; }
.notif-empty__title { font-size: 22px; font-weight: 700; color: #071E31; margin: 0 0 8px; }
.notif-empty__sub { font-size: 14px; color: #9aaab8; margin: 0; max-width: 320px; }
.notif-pagination { display: flex; justify-content: center; padding: 32px 0 0; }
.notif-pagination .ant-pagination-item-active { background: linear-gradient(135deg,#3B6B94 0%,#071E31 100%); border-color: transparent; }
.notif-pagination .ant-pagination-item-active a { color: #fff; }
@media (max-width: 768px) {
  .notif-body { flex-direction: column; }
  .notif-sidebar { width: 100%; flex: none; position: static; }
  .notif-page { padding: 20px 16px 40px; }
}


/* ═══════════════════════════════════════════════════════════════
   Table Row Actions — soft icon buttons + kebab menu
   ═══════════════════════════════════════════════════════════════ */
.row-actions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.row-action-btn {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid transparent;
  background: #f1f5f9;
  color: #475569;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.16s ease;
  padding: 0;
  line-height: 1;
}
.row-action-btn i { font-size: 13px; }
.row-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12);
}
.row-action-view {
  background: rgba(59, 107, 148, 0.10);
  color: #3b6b94;
}
.row-action-view:hover {
  background: #3b6b94;
  color: #ffffff;
}
.row-action-edit {
  background: rgba(16, 185, 129, 0.10);
  color: #059669;
}
.row-action-edit:hover {
  background: #059669;
  color: #ffffff;
}
.row-action-contract {
  background: rgba(245, 158, 11, 0.12);
  color: #d97706;
}
.row-action-contract:hover {
  background: #d97706;
  color: #ffffff;
}
.row-action-delete {
  background: rgba(239, 68, 68, 0.10);
  color: #dc2626;
}
.row-action-delete:hover {
  background: #dc2626;
  color: #ffffff;
}
.row-action-more {
  background: #f1f5f9;
  color: #64748b;
}
.row-action-more:hover {
  background: #071e31;
  color: #ffffff;
}

/* dropdown menu */
.row-actions-menu {
  border-radius: 12px !important;
  padding: 6px !important;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.14) !important;
  min-width: 200px;
}
.row-actions-menu .ant-dropdown-menu-item,
.row-actions-menu .ant-menu-item {
  border-radius: 8px !important;
  padding: 9px 12px !important;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}
.row-actions-menu .ant-dropdown-menu-item i,
.row-actions-menu .ant-menu-item i {
  width: 18px;
  text-align: center;
  font-size: 12.5px;
  color: #64748b;
}
.row-actions-menu .ant-dropdown-menu-item:hover,
.row-actions-menu .ant-menu-item:hover {
  background: rgba(59, 107, 148, 0.08) !important;
}
.row-actions-menu .ant-dropdown-menu-item-danger i,
.row-actions-menu .ant-menu-item-danger i {
  color: #ef4444;
}

/* ── Graphics Oversight: header filters in one row ── */
.gfx-oversight-filters {
  flex-wrap: nowrap !important;
}
.gfx-oversight-card .ant-card-head-wrapper {
  flex-wrap: nowrap !important;
}
.gfx-oversight-card .ant-card-head-title {
  width: auto !important;
  flex: 0 0 auto !important;
  white-space: nowrap;
}
.gfx-oversight-card .ant-card-extra {
  flex: 1 1 auto;
  min-width: 0;
}
@media (max-width: 900px) {
  .gfx-oversight-filters {
    flex-wrap: wrap !important;
  }
  .gfx-oversight-card .ant-card-head-wrapper {
    flex-wrap: wrap !important;
  }
  .gfx-oversight-card .ant-card-head-title {
    width: 100% !important;
  }
}

/* ═══════════════════════════════════════════════════════════════
   Graphics Oversight (Admin) — hero, toolbar, pills
   ═══════════════════════════════════════════════════════════════ */

/* ── Hero header ── */
.gfx-req-hero {
  border-radius: 20px;
  padding: 22px 26px;
  margin-bottom: 20px;
  background: var(--brand-gradient, linear-gradient(135deg, #3B6B94 0%, #071E31 100%));
  box-shadow: 0 10px 24px -6px rgba(7, 30, 49, 0.45);
}
.gfx-req-hero-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}
.gfx-req-hero-eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.65);
  margin-bottom: 4px;
}
.gfx-req-hero-title {
  margin: 0;
  color: #ffffff;
  font-size: 21px;
  font-weight: 700;
  letter-spacing: -0.2px;
}

/* ── Hero right-side stat ── */
.gfx-hero-done {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(108, 229, 232, 0.28);
  flex-shrink: 0;
}
.gfx-hero-done-ring {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(108, 229, 232, 0.16);
  border: 1.5px solid rgba(108, 229, 232, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #6CE5E8;
}
.gfx-hero-done-value {
  font-size: 22px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.1;
}
.gfx-hero-done-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.60);
}
@media (max-width: 640px) {
  .gfx-hero-done { display: none; }
}

/* ── Toolbar card ── */
.gfx-oversight-toolbar-card .ant-card-body {
  padding: 16px 20px !important;
}
.gfx-oversight-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}
.gfx-oversight-search {
  flex: 1 1 240px;
  min-width: 200px;
  max-width: 320px;
  border-radius: 10px !important;
}
.gfx-oversight-select {
  width: 190px !important;
}
.gfx-oversight-select .ant-select-selector {
  border-radius: 10px !important;
}
.gfx-oversight-select--sm {
  width: 140px !important;
}
@media (max-width: 700px) {
  .gfx-oversight-search,
  .gfx-oversight-select,
  .gfx-oversight-select--sm {
    width: 100% !important;
    max-width: none;
  }
}

/* ── Priority dot + pill (table cell) ── */
.gfx-priority-dot {
  border-radius: 50%;
  display: inline-block;
  width: 7px;
  height: 7px;
}
.gfx-priority-dot.priority-urgent { background: #F5222D; }
.gfx-priority-dot.priority-high   { background: #FA8C16; }
.gfx-priority-dot.priority-medium { background: #3B6B94; }
.gfx-priority-dot.priority-low    { background: #94A3B8; }
.gfx-priority-pill-sm {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-secondary, #475569);
}

/* ── Status pill (table cell) ── */
.gfx-status-pill {
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.gfx-status--neutral { background: #F1F5F9; color: #64748B; }
.gfx-status--info    { background: #EFF6FF; color: #1D4ED8; }
.gfx-status--warn     { background: #FFFBEB; color: #B45309; }
.gfx-status--success { background: #ECFDF5; color: #047857; }
.gfx-status--danger  { background: #FEF2F2; color: #B91C1C; }

/* ── Row action buttons: disabled state ── */
.row-action-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* ═══════════════════════════════════════════════════════════════
   Admin Home Dashboard — overview strip + card header nowrap fix
   ═══════════════════════════════════════════════════════════════ */

.home-overview-strip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.home-overview-eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: var(--brand-500, #3B6B94);
  margin-bottom: 3px;
}
.home-overview-date {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary, #0F172A);
  letter-spacing: -0.2px;
}

/* Fix title + search overlapping/wrapping in the renewals/expired cards —
   same root cause as the Dashboard/Oversight toolbars: a global
   \`.tablespace .ant-card-head-title { width: 100% }\` rule forces the title
   onto its own full-width line, pushing the search input down. */
.home-header-nowrap .ant-card-head-wrapper {
  flex-wrap: nowrap !important;
}
.home-header-nowrap .ant-card-head-title {
  width: auto !important;
  flex: 0 0 auto !important;
  white-space: nowrap;
}
.home-header-nowrap .ant-card-extra {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 700px) {
  .home-header-nowrap .ant-card-head-wrapper {
    flex-wrap: wrap !important;
  }
  .home-header-nowrap .ant-card-head-title {
    width: 100% !important;
  }
  .home-header-nowrap .ant-card-extra .ant-input-search {
    width: 100% !important;
  }
}

/* Avatar + name rows inside the "Latest" tables */
.color-badge-table {
  display: flex;
  align-items: center;
  gap: 10px;
}
.color-badge-table img {
  border-radius: 50%;
  object-fit: cover;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
}
.color-badge-table p {
  margin: 0;
  font-size: 13.5px;
  color: var(--text-secondary, #475569);
}
.tag-name-text p {
  font-weight: 600;
  color: var(--text-primary, #0F172A) !important;
}

/* ── Hero CTA button (solid pill on gradient hero) ── */
.gfx-hero-cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 20px;
  border-radius: 9999px;
  background: #ffffff;
  color: var(--brand-700, #1D3C56);
  border: none;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
  flex-shrink: 0;
}
.gfx-hero-cta:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.22);
  opacity: 0.95;
}

/* ═══════════════════════════════════════════════════════════════
   Edit Preferences Panel — multi-select tag chips
   (tagRender in ClientPreferenceEditModal.js had zero matching CSS,
   so each selected value rendered as a bare block-level <p> with
   a close icon stacked underneath instead of an inline chip.)
   ═══════════════════════════════════════════════════════════════ */
.ant-select.multi-select .ant-select-selector {
  min-height: 44px !important;
  border-radius: 10px !important;
  padding: 6px 8px !important;
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  gap: 6px !important;
}
.ant-select.multi-select .ant-select-selection-overflow {
  gap: 6px;
  row-gap: 6px;
}
.ant-select.multi-select .ant-select-selection-search {
  margin: 0 !important;
}
.ant-select.multi-select .ant-select-selection-placeholder {
  padding-left: 4px;
}

.multiselect-card-box.edit-preferences-selected {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--brand-50, #EAF1F6);
  border: 1px solid var(--brand-100, #D2E2EC);
  border-radius: 9999px;
  padding: 4px 8px 4px 12px;
  margin: 0;
  max-width: 100%;
}
.multiselect-card-box.edit-preferences-selected p {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: var(--brand-700, #1D3C56);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.multiselect-card-box.edit-preferences-selected .remove-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  color: var(--brand-400, #5A8AAB);
  font-size: 13px;
  line-height: 1;
  transition: color 0.15s ease;
}
.multiselect-card-box.edit-preferences-selected .remove-tag:hover {
  color: var(--error, #EF4444);
}

/* ===== Research Assistant: Graphical Insights, Content Ideas & Mindmap (ported from user panel) ===== */
/* ── Tabs ── */
.ant-tabs.tabs-main-research .ant-tabs-nav {
  margin-bottom: 20px;
}

.ant-tabs.tabs-main-research .ant-tabs-tab {
  color: #475569;
  font-size: 13.5px;
  line-height: 1;
  font-weight: 600;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  padding: 9px 18px;
  border-radius: 10px;
  margin-right: 10px !important;
  transition: background-color 0.2s ease, transform 0.18s ease, box-shadow 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.ant-tabs.tabs-main-research .ant-tabs-tab:hover {
  border-color: #0b7bea;
  color: #0b7bea;
}

.ant-tabs.tabs-main-research .ant-tabs-tab.ant-tabs-tab-active {
  background: #0b7bea !important;
  border-color: transparent !important;
  box-shadow: 0 2px 6px rgba(11, 123, 234, 0.25);
}

.ant-tabs.tabs-main-research .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #fff;
  text-shadow: none;
}

.ant-tabs.tabs-main-research .ant-tabs-nav::before {
  display: none;
}

.ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
  display: none;
}

/* ── Section cards (Headlines / Topics / Trends) ── */
section.headlines-section h6,
.headline-toll-headding h6 {
  color: #0f172a;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  margin: 0;
}

.ant-card.ant-card-bordered.headline-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  background: #f8fafd;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  animation: research-content-in 0.4s ease both;
}
.ant-card.ant-card-bordered.headline-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(11, 123, 234, 0.12);
  border-color: #0b7beaaa;
}

.searching-listbar {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  gap: 10px;
}

.headline-text {
  font-weight: 500;
  font-size: 13.5px;
  line-height: 1.5;
  color: #1e293b;
}

.headlines-section,
.topics-section,
.trends-section {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 18px;
  margin-top: 16px;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);
}
.headlines-section {
  margin-top: 0;
}

.headline-actions {
  flex: 0 0 auto;
  display: flex;
  gap: 8px;
}

.headline-actions button {
  padding: 0 !important;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px !important;
  border: 1px solid #e2e8f0 !important;
  background: #f8fafd !important;
  transition: transform 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
}
.headline-actions button:hover {
  border-color: #0b7bea !important;
  transform: translateY(-1px) scale(1.06);
  opacity: 0.92;
}
.headline-actions button:active {
  transform: scale(0.96);
}

.headline-toll-headding {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.headlines-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.headline-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  background: #f8fafd;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  cursor: default;
  animation: research-content-in 0.4s ease both;
}
.headline-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(11, 123, 234, 0.12);
  border-color: #0b7beaaa;
}
.headlines-list .headline-card:nth-child(1) { animation-delay: 0.02s; }
.headlines-list .headline-card:nth-child(2) { animation-delay: 0.06s; }
.headlines-list .headline-card:nth-child(3) { animation-delay: 0.10s; }
.headlines-list .headline-card:nth-child(4) { animation-delay: 0.14s; }
.headlines-list .headline-card:nth-child(5) { animation-delay: 0.18s; }
.headlines-list .headline-card:nth-child(n + 6) { animation-delay: 0.22s; }

.tags-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
}

.tag-topics {
  background: #f8fafd;
  padding: 8px 14px;
  border-radius: 9px;
  font-weight: 500;
  font-size: 13px;
  color: #1e293b;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, background 0.18s ease;
}
.tag-topics:hover {
  transform: translateY(-2px);
  border-color: #0b7bea;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(11, 123, 234, 0.15);
}
.tag-topics button.ant-btn {
  transition: transform 0.15s ease, opacity 0.15s ease;
}
.tag-topics button.ant-btn:hover {
  transform: scale(1.15);
  opacity: 0.85;
}
.tag-topics button.ant-btn:active {
  transform: scale(0.96);
}

/* ── Prompt History button ── */
.chat-history-toggle-btn {
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}
.chat-history-toggle-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(11, 123, 234, 0.18);
}

/* Respect users who prefer no motion */
@media (prefers-reduced-motion: reduce) {
  .content-area,
  .headlines-list .headline-card {
    animation: none;
  }
  button.ant-btn.run-button,
  .headline-card,
  .tag-topics,
  .ant-tabs.tabs-main-research .ant-tabs-tab {
    transition: none;
  }
}

/* --- "Get more ideas" button in the Select-a-Content-Idea modal --- */
button.ant-btn.load-more-ideas-btn {
  height: 40px;
  padding: 0 22px;
  border-radius: 8px;
  font-weight: 600;
  color: #0b7bea;
  background: #eff8ff;
  border: 1px solid #0b7bea55;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}
button.ant-btn.load-more-ideas-btn:hover {
  color: #ffffff;
  background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%);
  border-color: transparent;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(11, 123, 234, 0.28);
}

/* --- Dynamic SVG mind map (Content Ideas) --- */
.mindmap-canvas {
  position: relative;
  width: 100%;
}
.dynamic-mindmap-svg {
  width: 100%;
  height: auto;
  display: block;
  max-width: 560px;
  margin: 0 auto;
  overflow: visible;
}

/* Clickable nodes — pop in on load, lift/glow on hover */
.dynamic-mindmap-svg .mm-node {
  cursor: pointer;
  transform-box: fill-box;
  transform-origin: center;
  animation: mm-pop 0.45s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}
.dynamic-mindmap-svg .mm-node circle {
  transition: filter 0.18s ease;
}
.dynamic-mindmap-svg .mm-node:hover circle {
  filter: drop-shadow(0 4px 8px rgba(11, 123, 234, 0.4));
}
.dynamic-mindmap-svg .mm-node.mm-selected circle {
  filter: drop-shadow(0 4px 10px rgba(11, 123, 234, 0.45));
}
/* Gentle pulse on the selected node's halo ring */
.dynamic-mindmap-svg .mm-selected > circle:first-of-type {
  animation: mm-halo 1.6s ease-in-out infinite;
}

@keyframes mm-pop {
  0% {
    opacity: 0;
    transform: scale(0.2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes mm-halo {
  0%,
  100% {
    opacity: 0.25;
  }
  50% {
    opacity: 0.6;
  }
}

/* Floating detail panel shown when a node is clicked */
.mindmap-detail {
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 12px;
  box-shadow: 0 8px 22px rgba(11, 123, 234, 0.18);
  animation: research-content-in 0.25s ease both;
  z-index: 2;
}
.mm-detail-dot {
  flex: 0 0 auto;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.mm-detail-label {
  flex: 1 1 auto;
  font-size: 13.5px;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mm-detail-actions {
  flex: 0 0 auto;
  display: flex;
  gap: 6px;
}

@media (prefers-reduced-motion: reduce) {
  .dynamic-mindmap-svg .mm-node,
  .dynamic-mindmap-svg .mm-node circle,
  .dynamic-mindmap-svg .mm-selected > circle:first-of-type,
  .mindmap-detail {
    animation: none;
    transition: none;
  }
}

/* ── Graphical Insights tab ── */
.graphical-insights-container {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 18px;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);
}

.graphical-chart-headding {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin: 0 0 16px;
}

.graphical-chart-headding h6 {
  color: #0f172a;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  margin: 0;
}

.score-box {
  display: flex;
  gap: 10px;
  align-items: center;
}

.graphical-chart-headding h6.score-label {
  color: #64748b;
  font-weight: 600;
  font-size: 12.69px;
  line-height: 16.93px;
  letter-spacing: 0;
}

.graphical-chart-headding .score-value {
  font-weight: 700;
  font-size: 20px;
  line-height: 26.8px;
  letter-spacing: 0;
  text-align: center;
  color: #0f172a;
}

.chart-card {
  border: 1px solid #e2e8f0;
  padding: 16px;
  border-radius: 12px;
  background-color: #fff;
  max-width: 670px;
  width: 100%;
}

.interest-main-section {
  display: flex;
  gap: 16px;
}

.score-area {
  border: 1px solid #e2e8f0;
  padding: 10px;
  border-radius: 12px;
  background-color: #fff;
  max-width: 225px;
  width: 100%;
  flex: 0 0 auto;
}

button.ant-btn.report-btn {
  border: 1px solid #e2e8f0 !important;
  font-weight: 700;
  font-size: 10px;
  line-height: 14.1px;
  letter-spacing: 0;
  color: #64748b !important;
  gap: 5px;
  border-radius: 50px !important;
  padding: 7px 10px !important;
}

.chart-footer .ant-tag {
  border-color: #F0FDF4;
  background: #F0FDF4;
  font-weight: 600;
  font-size: 12px;
  line-height: 11.28px;
  text-align: center;
  color: #22C55E;
  padding: 5px 10px;
  border-radius: 50px;
}

span.highlight-tag {
  color: #64748b;
  font-weight: 600;
  font-size: 10px;
  line-height: 11.28px;
  letter-spacing: 0;
  text-align: center;
}

.chart-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 12px;
}

span.month-text {
  color: #64748b;
  font-weight: 500;
  font-size: 11.28px;
  line-height: 15.52px;
  text-align: center;
}

span.growth-text {
  color: #0f172a;
  font-weight: 700;
  font-size: 21.16px;
  line-height: 26.8px;
  letter-spacing: 0;
  text-align: center;
}

.link-box {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.metric-name {
  color: #64748b;
  font-weight: 600;
  font-size: 12.69px;
  line-height: 16.93px;
  letter-spacing: 0;
  margin-bottom: 5px;
}

.link-metric a.link-url {
  font-weight: 500;
  font-size: 10px;
  line-height: 18.28px;
  letter-spacing: 0;
  color: #22C55E;
}

.metric-value {
  color: #0f172a;
  font-weight: 700;
  font-size: 21.16px;
  line-height: 26.8px;
  letter-spacing: 0;
  padding-right: 20px;
  position: relative;
}

span.negative {
  font-weight: 600;
  font-size: 12px;
  line-height: 15.28px;
  color: #F43F5E;
}

span.positive {
  font-weight: 600;
  font-size: 12px;
  line-height: 15.28px;
  color: #22C55E;
}

.metric-right-icon {
  width: 28px;
  height: 28px;
  position: absolute;
  right: 0;
  background: #eff8ff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  bottom: 0;
}

span.ant-tag.status-tag {
  border: 1px solid #22C55E;
  background: #22C55E33;
  font-weight: 500;
  font-size: 13px;
  text-align: center;
  color: #0f172a;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px !important;
}

/* ── Content Ideas tab ── */
.topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 10px;
}

.view-buttons {
  display: flex;
  gap: 8px;
}

.tab-btn {
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 6px 16px;
  cursor: pointer;
  font-weight: 500;
}

.tab-btn.active {
  background: #0b7bea;
  color: white;
  border-color: #0b7bea;
}

.top-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.content-idea-card h6 {
  color: #0f172a;
  font-size: 13px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin: 0 0 10px;
  font-weight: 700;
}

.content-idea-card p {
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0px;
  color: #1e293b;
  margin: 0;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  gap: 16px;
}

.content-card {
  background: #fff;
  border-radius: 14px;
  padding: 16px;
  position: relative;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);
  display: grid;
  gap: 14px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}
.content-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(11, 123, 234, 0.12);
  border-color: #0b7beaaa;
}

.card-top-icon {
  position: absolute;
  top: 16px;
  right: 16px;
}

.card-top-icon img {
  width: 22px;
}

/* Each cell inside a keyword card (Keyword / Search volume / Subtopic
   bullets / Trending) — had no styling of its own before, so it fell back to
   raw browser defaults (h6/p margins, inline-flow button) and looked cramped
   next to the absolutely-positioned bird icon. */
.content-idea-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.content-idea-card h6 {
  margin: 0;
  padding-right: 28px; /* clears the top-right bird icon */
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.content-idea-card .card-sub {
  margin: 0;
  color: #64748b;
  font-size: 12px;
}

.write-idea-btn.ant-btn {
  align-self: flex-start;
  margin-top: 4px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  /* .ant-btn-primary globally forces height/padding via !important (fighting
     size="small") — match !important here so this stays compact regardless. */
  height: 28px !important;
  line-height: 1;
  padding: 0 10px !important;
}

/* Angle-variety badge on each content idea (Contrarian / Data-Driven /
   Story-Led / How-To / Trend-Spotting / Personal Take) — so the 10 ideas
   read as genuinely different angles, not ten variations of one flavor. */
.angle-tag {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
  background: #eff6ff;
  color: #0b7bea;
}
.angle-tag-contrarian { background: #fef2f2; color: #dc2626; }
.angle-tag-data-driven { background: #eff6ff; color: #0b7bea; }
.angle-tag-story-led { background: #fdf4ff; color: #a21caf; }
.angle-tag-how-to { background: #f0fdf4; color: #16a34a; }
.angle-tag-trend-spotting { background: #fff7ed; color: #ea580c; }
.angle-tag-personal-take { background: #fefce8; color: #ca8a04; }

/* Source-confidence badge on each headline — see user-panel main.css for
   the full explanation. */
.confidence-badge {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
  vertical-align: middle;
}
.confidence-badge-none { background: #f1f5f9; color: #64748b; }

/* Favicon strip: shows the actual corroborating sites, up to 3, with a
   "+N" overflow. Hovering reveals the full list (domain + link) via
   antd Tooltip — see .confidence-tooltip below. */
.confidence-sources {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  vertical-align: middle;
  cursor: default;
}
.confidence-favicon {
  width: 15px;
  height: 15px;
  border-radius: 3px;
  margin-left: -4px;
  border: 1.5px solid #fff;
  background: #fff;
  object-fit: cover;
}
.confidence-favicon:first-child { margin-left: 0; }
.confidence-more {
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
  margin-left: 4px;
}
.confidence-tooltip {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 260px;
}
.confidence-tooltip-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 4px;
  border-radius: 6px;
  /* App's global .ant-tooltip-inner override makes tooltips WHITE, not
     antd's default dark — so this needs a dark, legible color, not
     white-on-white. */
  color: #334155;
  text-decoration: none;
  font-size: 12px;
  font-weight: 500;
}
.confidence-tooltip-row:hover {
  color: #0b7bea;
  text-decoration: underline;
  background: #f1f5f9;
}
.confidence-tooltip-domain {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

ul.bullets li {
  color: #475569;
  font-weight: 500;
  font-size: 13px;
  line-height: 1.5;
}

.bullets {
  padding-left: 16px;
  margin-bottom: 0px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.fire-headding {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.fire-headding .trend-label {
  margin: 0px;
}

.fire-headding img {
  width: 20px;
}

button.ant-btn.show-more-btn {
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0px;
  text-align: center;
  color: #0b7bea !important;
  box-shadow: none !important;
}

button.ant-btn::after {
  display: none;
}

.content-ideas-container {
  margin-top: 0;
}

button.ant-btn.tab-btn-content {
  border: 1px solid #e2e8f0 !important;
  padding: 8px 16px;
  color: #475569 !important;
  font-weight: 600;
  font-size: 13px;
  line-height: 1;
  letter-spacing: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 9px;
  background: #fff !important;
  transition: border-color 0.18s ease, color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;
}

button.ant-btn.tab-btn-content .tab-icon {
  font-size: 14px;
  color: inherit;
}

button.ant-btn.tab-btn-content:hover {
  border-color: #0b7bea !important;
  color: #0b7bea !important;
}

button.ant-btn.tab-btn-content.active {
  border: 1px solid transparent !important;
  background: #0b7bea !important;
  color: #fff !important;
  box-shadow: 0 2px 6px rgba(11, 123, 234, 0.25);
}

button.ant-btn.export-btn {
  border: 1px solid #e2e8f0 !important;
  background: #f8fafd;
  color: #334155 !important;
  font-weight: 600;
  gap: 5px;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  height: 32px !important;
  border-radius: 8px;
}

button.ant-btn.create-contant-btn {
  background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%) !important;
  border: none !important;
  color: #fff !important;
  font-weight: 600;
  gap: 6px;
  font-size: 13px;
  line-height: 100%;
  height: 38px !important;
  border-radius: 9px;
  letter-spacing: 0px;
  box-shadow: 0 3px 10px rgba(11, 123, 234, 0.28);
  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;
}

button.ant-btn.create-contant-btn:hover {
  opacity: 0.92;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(11, 123, 234, 0.35);
}

button.ant-btn.create-contant-btn img {
  filter: brightness(8.5);
}

.ant-select.contant-select .ant-select-selector {
  height: 32px !important;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}

.ant-select.contant-select {
  max-width: 100px;
  width: 100%;
}

.ant-select.contant-select span.ant-select-selection-item {
  color: #334155 !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  letter-spacing: 0px;
}

.owerview-cards {
  background-color: #fff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: 18px;
  border-radius: 14px;
}

h6.ow-headding {
  color: #0f172a;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  margin-bottom: 14px;
}

h3.ow-headding {
  color: #0f172a;
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 14px;
}

ul.owerview-listing {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

ul.owerview-listing li {
  border: 1px solid #e2e8f0;
  background: #f8fafd;
  padding: 12px 14px;
  border-radius: 10px;
  color: #1e293b;
  font-weight: 500;
  font-size: 13.5px;
  line-height: 1.5;
  transition: transform 0.18s ease, border-color 0.18s ease;
}

ul.owerview-listing li:hover {
  transform: translateY(-1px);
  border-color: #0b7bea55;
}

ul.questions-listing li span {
  border: 1px solid #e2e8f0;
  padding: 15px 10px;
  border-radius: 10px;
  color: #1e293b;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0px;
  max-width: 80px;
  width: 100%;
  cursor: pointer;
}

ul.questions-listing li {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

ul.questions-listing {
  padding: 0;
  margin: 0;
  list-style: none;
}

.mind-map-grid {
  background-color: #fff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);
  padding: 20px;
  border-radius: 14px;
}

.listing-mindmap {
  margin: 18px 0px 12px;
}

.age-box-outer {
  border-radius: 8px !important;
  padding: 10px;
  min-height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  background: #fff;
}

button.ant-btn.age-change-btn {
  width: 30px;
  height: 30px !important;
  padding: 0px !important;
  margin: 0px !important;
  color: #000000 !important;
  font-size: 25px !important;
}

button.ant-btn.age-change-btn span {
  font-size: 25px !important;
}

.age-number-count {
  color: #3F4753;
  font-weight: 700;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0;
}

.header-02-writing {
  flex-wrap: wrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin: 20px 0px;
}

.writing-header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.writing-header-bar h6 {
  font-weight: 600;
  font-size: 25px;
  line-height: 100%;
  letter-spacing: 0px;
  margin: 0;
}

.header-02-writing h6 {
  color: #071E31;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0px;
  margin: 0;
}

.header-02-writing .post-detail-page {
  margin: 0px;
}

.writing-ass-footer {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 15px;
}

button.ant-btn.borderd-btn {
  border: 1px solid #D7D7D7 !important;
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0px;
  height: 35px !important;
  color: #071E31 !important;
  max-width: 150px;
  width: 100%;
}

.writing-ass-footer button.ant-btn.fill-btn {
  height: 35px !important;
  max-width: 150px;
  width: 100%;
}

.footer-writing-btn {
  position: relative;
  display: flex;
  justify-content: end;
  gap: 10px;
  align-items: center;
  margin-top: 150px;
  flex-wrap: wrap;
}

.repport-headding-sec {
  display: flex;
  gap: 50px;
  align-items: end;
  justify-content: space-between;
}

.report-headding-action {
  flex: 0 0 auto;
}

.report-headding-action .top-actions button.ant-btn {
  height: 42px !important;
}

.report-count-grid {
  display: grid;
  /* 7 KPI cards (Followers, Posts, Likes, Comments, Shares, Impressions, Reach)
     fit on one row at ~1100px+. Cards stretch via auto-fit when there's room. */
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  margin-top: 20px;
}

/* ===== Research Assistant tabs nested inside client-tabs =====
   Full-width, evenly-spaced blue pills — identical across admin & staff.
   High specificity + !important so these beat both the outer \`.client-tabs\`
   distribution/active-gradient rules and any older \`.tabs-main-research\` rules. */
.ant-tabs.client-tabs .ant-tabs.tabs-main-research .ant-tabs-nav {
  margin-bottom: 20px !important;
}
.ant-tabs.client-tabs .ant-tabs.tabs-main-research .ant-tabs-nav-list {
  width: 100% !important;
  flex: 1 1 auto !important;
  gap: 12px !important;
  justify-content: space-between !important;
}
.ant-tabs.client-tabs .ant-tabs.tabs-main-research .ant-tabs-tab {
  flex: 1 1 !important;
  min-width: 0 !important;
  margin: 0 !important;
  justify-content: center !important;
  background: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  padding: 7px 14px !important;
  box-shadow: none !important;
}
.ant-tabs.client-tabs .ant-tabs.tabs-main-research .ant-tabs-tab .ant-tabs-tab-btn {
  color: #475569 !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  text-shadow: none !important;
}
.ant-tabs.client-tabs .ant-tabs.tabs-main-research .ant-tabs-tab:hover {
  border-color: #0b7bea !important;
}
.ant-tabs.client-tabs .ant-tabs.tabs-main-research .ant-tabs-tab:hover .ant-tabs-tab-btn {
  color: #0b7bea !important;
}
.ant-tabs.client-tabs .ant-tabs.tabs-main-research .ant-tabs-tab.ant-tabs-tab-active {
  background: #0b7bea !important;
  border-color: transparent !important;
  box-shadow: 0 2px 6px rgba(11, 123, 234, 0.25) !important;
}
.ant-tabs.client-tabs .ant-tabs.tabs-main-research .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #ffffff !important;
}

/* ── Reschedule Post modal ── */
.reschedule-modal .ant-modal-header {
  padding: 22px 24px !important;
  margin-bottom: 0 !important;
  border-bottom: 1px solid var(--border, #E7E9F2) !important;
}
.reschedule-modal .ant-modal-title {
  text-align: center !important;
  font-size: 19px !important;
}
.reschedule-modal .ant-modal-body {
  padding: 24px !important;
}
.reschedule-modal .ant-modal-close {
  top: 18px !important;
  right: 18px !important;
}
.reschedule-modal .ant-modal-content {
  padding: 0 !important;
  border-radius: 16px !important;
  overflow: hidden;
}
.reschedule-modal label {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: var(--text-secondary, #475569) !important;
}
.reschedule-modal .ant-picker,
.reschedule-modal input {
  border-radius: 10px !important;
  height: 44px !important;
}
.reschedule-modal .ant-btn.submitted-btn,
.reschedule-modal .ant-btn {
  border-radius: 10px !important;
  height: 46px !important;
  font-weight: 700 !important;
  background: var(--brand-gradient, linear-gradient(135deg, #3B6B94 0%, #071E31 100%)) !important;
  border: none !important;
  color: #fff !important;
}

/* Pulse animation reused by the results-panel shimmer title */
@keyframes research-loading-pulse {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

/* Shimmer skeleton shown in the results panel while research runs */
.research-shimmer {
  width: 100%;
}

.research-shimmer-header {
  margin-bottom: 22px;
}

.research-shimmer-title {
  font-size: 22px;
  font-weight: 800;
  margin: 0 0 6px;
  background: linear-gradient(
    90deg,
    #0b7bea,
    #0ea5e9,
    #38bdf8,
    #0b7bea
  );
  background-size: 300% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  animation: research-title-gradient 3s linear infinite;
}

@keyframes research-title-gradient {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 300% 50%;
  }
}

.research-shimmer-subtitle {
  font-size: 12px;
  color: #8c8c8c;
  margin: 0;
}

.shimmer-block {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  background: linear-gradient(
    90deg,
    #e2e8f0,
    #dbeafe,
    #e0f2fe,
    #e2e8f0
  );
  background-size: 300% 100%;
  animation: shimmer-flow 2.4s ease-in-out infinite;
}

@keyframes shimmer-flow {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 300% 50%;
  }
}

.shimmer-block::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    100deg,
    rgba(255, 255, 255, 0) 0,
    rgba(255, 255, 255, 0.9) 45%,
    rgba(255, 255, 255, 0.9) 55%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: translateX(-100%);
  animation: shimmer-sweep 1.3s ease-in-out infinite;
}

@keyframes shimmer-sweep {
  100% {
    transform: translateX(100%);
  }
}

.shimmer-heading {
  width: 180px;
  height: 18px;
  margin: 18px 0 14px;
}

.shimmer-card-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.shimmer-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 18px 20px;
  box-shadow: 0 4px 14px rgba(11, 123, 234, 0.06);
  animation: shimmer-card-float 2.6s ease-in-out infinite;
}

.shimmer-card:nth-child(2) {
  animation-delay: 0.2s;
}
.shimmer-card:nth-child(3) {
  animation-delay: 0.4s;
}
.shimmer-card:nth-child(4) {
  animation-delay: 0.6s;
}

@keyframes shimmer-card-float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-3px);
  }
}

.shimmer-line {
  height: 14px;
}

.shimmer-line-lg {
  width: 85%;
  margin-bottom: 10px;
}

.shimmer-line-sm {
  width: 55%;
}

.shimmer-tag-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.shimmer-tag {
  width: 110px;
  height: 34px;
  border-radius: 8px;
}

/* Stagger the tag shimmer so they flow out of sync */
.shimmer-tag:nth-child(2n) {
  animation-delay: 0.3s;
}
.shimmer-tag:nth-child(3n) {
  animation-delay: 0.6s;
  width: 90px;
}
/* ── LinkedIn live-post delete warning ─────────────────────────────────── */
/* Ported from user-panel-Imergey's main.css to match its delete-post modal,
   which this file's delete modals (FullCalender.js, accessModule/PostTabs.js)
   now mirror. */
.delete-linkedin-warning {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fff8e6;
  border: 1.5px solid #f5a623;
  border-radius: 10px;
  padding: 12px 16px;
  margin-bottom: 18px;
}

.delete-linkedin-warning-icon {
  font-size: 20px;
  line-height: 1.4;
  flex-shrink: 0;
}

.delete-linkedin-warning-text {
  font-size: 13.5px;
  color: #7a4f00;
  line-height: 1.55;
}

.delete-linkedin-warning-text strong {
  display: block;
  font-size: 14px;
  color: #5c3700;
  margin-bottom: 2px;
}

/* Delete confirm button — red to signal destructive action */
.delete-confirm-btn {
  background: #e53935 !important;
  border-color: #e53935 !important;
  color: #fff !important;
}

.delete-confirm-btn:hover {
  background: #c62828 !important;
  border-color: #c62828 !important;
}

/* Cancel button in delete modal */
.action-footer-buttons .cancel-btn,
.cancel-btn {
  background: #f5f5f5 !important;
  border-color: #d9d9d9 !important;
  color: #555 !important;
  min-width: 110px;
}

.action-footer-buttons .cancel-btn:hover,
.cancel-btn:hover {
  background: #ebebeb !important;
  border-color: #bbb !important;
  color: #333 !important;
}

.shimmer-tag:nth-child(4n) {
  width: 130px;
}

/* Analytics Graph legend (Reports tab) */
.analytics-chart-legend {
  display: flex;
  align-items: center;
  gap: 18px;
  flex-wrap: wrap;
  margin-bottom: 14px;
  padding: 8px 14px;
  background: #f8f9fc;
  border: 1px solid #eef1f6;
  border-radius: 8px;
}
.analytics-chart-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #5b6477;
  font-weight: 500;
}
.analytics-chart-legend-dot {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
}
.analytics-chart-legend-dot-tracked { background: #6c63f5; }
.analytics-chart-legend-dot-untracked { background: #bfc5d2; }
.analytics-chart-legend-hint {
  color: #8a94a6;
  font-style: italic;
}
.analytics-chart-legend-hint .anticon {
  color: #94a3b8;
}

/* --- Customizable dashboard: drag handle + dragging state --- */
.dashboard-section-drag-handle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
}
.dashboard-section-drag-handle:active {
  cursor: grabbing;
}
.dashboard-section-drag-handle .anticon {
  color: #b0b7c3;
  font-size: 14px;
}
.dashboard-section-dragging {
  opacity: 0.45;
}

/* ═══════════════════════════════════════════════════════════════════════
   Customer Management — professional table refresh (scoped to .customer-table)
   Brand: Midnight #071D31 · Steel Blue #3B6B94 · Turquoise #6CE5E8
   Goal: tighter rows (kill the dead vertical whitespace), branded header,
   zebra striping, refined hover, polished toolbar + pagination. Everything
   here is scoped so no other table in the app is touched.
   ═══════════════════════════════════════════════════════════════════════ */

/* — Card shell — */
.ant-card.criclebox.customer-table {
  border-radius: 16px;
  border: 1px solid #eef1f6;
  box-shadow: 0 12px 34px rgba(7, 29, 49, 0.06);
  overflow: hidden;
}
.ant-card.criclebox.customer-table .ant-card-body {
  padding: 0;
}

/* — Card head: tighter, branded, with an accent bar before the title — */
.ant-card.criclebox.customer-table .ant-card-head {
  padding: 18px 24px;
  background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);
  border-bottom: 1px solid #eef1f6;
  min-height: auto;
}
.ant-card.criclebox.customer-table .ant-card-head-title {
  padding: 0;
  overflow: visible;
  white-space: normal;
}
/* Creative title block: gradient icon chip + title + subtitle */
.cm-title {
  display: flex;
  align-items: center;
  gap: 14px;
}
.cm-title-icon {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  background: linear-gradient(135deg, #3b6b94 0%, #071d31 100%);
  color: #6ce5e8;
  font-size: 18px;
  box-shadow: 0 8px 18px rgba(7, 29, 49, 0.22);
  position: relative;
}
.cm-title-icon::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 13px;
  border: 1px solid rgba(108, 229, 232, 0.35);
}
.cm-title-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}
.cm-title-main {
  font-size: 19px;
  font-weight: 700;
  color: #071d31;
  letter-spacing: 0.2px;
}
.cm-title-sub {
  font-size: 12.5px;
  font-weight: 500;
  color: #8a97a8;
  letter-spacing: 0.1px;
}

/* — Toolbar: give every control the same height + soft rounding — */
.customer-table .gfx-toolbar .ant-input-affix-wrapper,
.customer-table .gfx-toolbar .ant-input-search .ant-input,
.customer-table .gfx-toolbar .ant-picker,
.customer-table .gfx-toolbar .ant-btn {
  height: 40px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
}
.customer-table .gfx-toolbar .ant-input-search .ant-input-search-button {
  height: 40px;
  border-radius: 0 10px 10px 0;
}
.customer-table .gfx-toolbar .ant-btn:not(.ant-btn-primary) {
  border-color: #dbe2ec;
  color: #334f68;
  font-weight: 600;
}
.customer-table .gfx-toolbar .ant-btn:not(.ant-btn-primary):hover {
  border-color: #3b6b94;
  color: #3b6b94;
}
.customer-table .gfx-toolbar .ant-btn-primary {
  font-weight: 600;
  box-shadow: 0 6px 16px rgba(59, 107, 148, 0.24);
}

/* — Table header: soft slate band, steel-blue uppercase labels — */
.ant-card.criclebox.customer-table .ant-table-thead > tr > th {
  background: #f4f7fb !important;
  color: #3b6b94 !important;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  padding: 14px 20px !important;
  border-bottom: 1px solid #e6ecf4 !important;
}
/* kill AntD's default column divider bars in the header */
.ant-card.criclebox.customer-table .ant-table-thead > tr > th::before {
  display: none !important;
}
.ant-card.criclebox.customer-table .ant-table-thead th.ant-table-column-has-sorters:hover {
  background: #eaf1f8 !important;
}
/* align first/last columns with the card head's 24px edge */
.ant-card.criclebox.customer-table .ant-table-thead > tr > th:first-child,
.ant-card.criclebox.customer-table .ant-table-tbody > tr > td:first-child {
  padding-left: 24px !important;
}
/* ...EXCEPT on #bm-staff-table-card (BrandManager.js), whose first column
   is a row-selection checkbox, not a real data column — see the
   #bm-staff-table-card override up near the base ".ant-card.criclebox
   table th" rule; an #id selector always beats this rule's class chain
   regardless of source order. */
.ant-card.criclebox.customer-table .ant-table-thead > tr > th:last-child,
.ant-card.criclebox.customer-table .ant-table-tbody > tr > td:last-child {
  padding-right: 24px !important;
}

/* — Table body: tighter rows (the whitespace fix) + zebra + clean borders — */
.ant-card.criclebox.customer-table .ant-table-tbody > tr > td {
  padding: 9px 20px !important;
  border-bottom: 1px solid #f1f4f9 !important;
  color: #33475b;
  font-size: 14px;
  line-height: 1.3;
  vertical-align: middle;
}
.ant-card.criclebox.customer-table .ant-table-tbody > tr:nth-child(even) > td {
  background: #fafbfd;
}
.ant-card.criclebox.customer-table .ant-table-tbody > tr:hover > td,
.ant-card.criclebox.customer-table .ant-table-tbody > tr.ant-table-row-hover > td {
  background: #eef5fb !important;
}
/* left accent that appears on row hover */
.ant-card.criclebox.customer-table .ant-table-tbody > tr > td:first-child {
  box-shadow: inset 3px 0 0 transparent;
  transition: box-shadow 0.15s ease;
}
.ant-card.criclebox.customer-table .ant-table-tbody > tr:hover > td:first-child {
  box-shadow: inset 3px 0 0 #6ce5e8;
}

/* — Profile image: compact, rounded, subtle ring (trims row height) —
   Was 38px — the "no image" placeholder icon in particular read as louder/
   more prominent than an actual photo at that size, next to the now-bolder
   name text in the merged Client column. */
.ant-card.criclebox.customer-table .ant-table-tbody .ant-image img,
.ant-card.criclebox.customer-table .ant-table-tbody .main-new-class-image-no img {
  width: 28px !important;
  height: 28px !important;
  border-radius: 8px !important;
  object-fit: cover;
  box-shadow: 0 0 0 1px #e6ecf4;
}
.ant-card.criclebox.customer-table .ant-table-tbody .main-new-class-image-no {
  width: 28px;
  height: 28px;
}
.ant-card.criclebox.customer-table .main-new-class-image-no {
  display: inline-flex;
}

/* — Status pills: consistent, rounded, quiet borders — */
.ant-card.criclebox.customer-table .ant-table-tbody .ant-tag {
  border-radius: 999px;
  padding: 2px 12px;
  font-weight: 600;
  font-size: 12px;
  border: none;
  margin: 0;
}

/* — Pagination: brand the active page — */
.ant-card.criclebox.customer-table .ant-pagination {
  padding: 16px 24px;
  margin: 0;
}
.ant-card.criclebox.customer-table .ant-pagination .ant-pagination-item-active {
  background: #071d31;
  border-color: #071d31;
  border-radius: 8px;
}
.ant-card.criclebox.customer-table .ant-pagination .ant-pagination-item-active a {
  color: #ffffff;
}
.ant-card.criclebox.customer-table .ant-pagination .ant-pagination-item,
.ant-card.criclebox.customer-table .ant-pagination .ant-pagination-prev .ant-pagination-item-link,
.ant-card.criclebox.customer-table .ant-pagination .ant-pagination-next .ant-pagination-item-link {
  border-radius: 8px;
}

/* ═══════════════════════════════════════════════════════════════════════
   Session Expiry — "session expired, please log in again" modal
   ═══════════════════════════════════════════════════════════════════════ */
.session-expired-modal .ant-modal-content {
  border-radius: 18px;
  overflow: hidden;
  padding: 0;
  box-shadow: 0 24px 60px rgba(7, 29, 49, 0.28);
}
.session-expired-modal .ant-modal-body {
  padding: 0;
}
.session-expired-body {
  text-align: center;
  padding: 34px 30px 30px;
}
.session-expired-icon {
  width: 74px;
  height: 74px;
  margin: 0 auto 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 32px;
  color: #ffffff;
  background: linear-gradient(135deg, #3b6b94 0%, #071d31 100%);
  box-shadow: 0 10px 24px rgba(7, 29, 49, 0.26);
  position: relative;
}
.session-expired-icon::after {
  content: "";
  position: absolute;
  inset: -6px;
  border-radius: 50%;
  border: 2px solid rgba(108, 229, 232, 0.35);
}
.session-expired-title {
  font-size: 21px;
  font-weight: 700;
  color: #071d31;
  margin: 0 0 8px;
}
.session-expired-text {
  font-size: 14px;
  line-height: 1.55;
  color: #6b7889;
  margin: 0 auto 24px;
  max-width: 320px;
}
.session-expired-btn.ant-btn {
  height: 46px;
  border-radius: 11px;
  font-weight: 600;
  font-size: 15px;
  background: #071d31;
  border-color: #071d31;
  box-shadow: 0 8px 18px rgba(7, 29, 49, 0.24);
}
.session-expired-btn.ant-btn:hover,
.session-expired-btn.ant-btn:focus {
  background: #3b6b94;
  border-color: #3b6b94;
}

/* Demo-account "Login Password" field (User.js Add Customer form). AntD
   renders Input.Password + addonAfter as:
     span.ant-input-group-wrapper.demo-password-input   <- our className lands HERE
       span.ant-input-wrapper.ant-input-group           <- display:table, width:100% by default
         span.ant-input-affix-wrapper (input + eye icon) <- table-cell, width:100% by default
         span.ant-input-group-addon ("Generate")         <- table-cell, width:1px (auto-sized)
   A global rule elsewhere in this file
   (".ant-input-group-wrapper { width: fit-content !important; }") forces
   that OUTERMOST span to shrink-wrap its content — collapsing the whole
   input+button assembly to a sliver — and every rule below it (the table's
   own width:100%, the affix wrapper's width:100%) is powerless against that
   because the table itself has no definite width to distribute in the first
   place. Overriding just the outer wrapper, with matching !important and
   higher specificity (two classes on the same element beats the global
   rule's one), is enough: once it has a real width, antd's own default CSS
   correctly stretches everything inside it. */
.demo-password-input.ant-input-group-wrapper {
  width: 100% !important;
}
/* A second global rule (".ant-input-wrapper.ant-input-group { max-width:
   260px; ... }", a few hundred lines above in this file) caps the actual
   input+addon table at 260px regardless of the wrapper's own width — found
   by testing this fix in a real browser rather than trusting the wrapper
   fix alone. It has no !important, so out-specificing it (three classes
   here vs its two) is enough; no !important needed to match it, per the
   project's own rule against adding !important where the original didn't
   have it (see feedback_css_important_overrides memory). */
.demo-password-input .ant-input-wrapper.ant-input-group {
  max-width: none;
  width: 100%;
}
.demo-password-input .ant-input-group-addon {
  background: #f7f9f8;
  padding: 0 16px;
  white-space: nowrap;
}
.demo-password-input input.ant-input {
  height: 32px;
}
.demo-password-input .ant-input::placeholder {
  /* Matches the modal-wide placeholder color (.ant-modal-body input::placeholder
     above) so every field in this form reads consistently. */
  color: #b8bfc7;
  font-weight: 400;
}

/* ── Notes Detail popup ───────────────────────────────────────────── */
.note-detail { display: flex; flex-direction: column; gap: 20px; padding-top: 8px; }
.note-detail-meta { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.note-detail-item { background: #f6f8fc; border: 1px solid #e5eaf2; border-radius: 14px; padding: 14px 16px; min-width: 0; }
.note-detail-label { display: block; font-size: 11px; font-weight: 700; letter-spacing: 0.6px; text-transform: uppercase; color: #64748b; margin-bottom: 6px; }
.note-detail-value { display: block; font-size: 16px; font-weight: 600; color: #0f172a; line-height: 1.4; word-break: break-word; }
.note-detail-pill { display: inline-flex; align-items: center; gap: 6px; padding: 3px 12px; border-radius: 999px; font-size: 13px; font-weight: 700; }
.note-detail-pill.is-public { background: #dcfce7; color: #166534; }
.note-detail-pill.is-private { background: #fef3c7; color: #92400e; }
.note-detail-content { background: #ffffff; border: 1px solid #e5eaf2; border-radius: 14px; padding: 16px 18px; }
.note-detail-body { font-size: 16px; line-height: 1.65; color: #1e293b; white-space: pre-wrap; word-break: break-word; max-height: 340px; overflow-y: auto; }
@media (max-width: 640px) { .note-detail-meta { grid-template-columns: 1fr; } }
`, "",{"version":3,"sources":["webpack://./src/assets/styles/main.css"],"names":[],"mappings":"AAAA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;IACd,sCAAsC;AAC1C;AACA;EACE,2BAA2B;EAC3B,2DAA0D;EAC1D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,2DAA8D;EAC9D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,2DAA6D;EAC7D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,2DAA2D;EAC3D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,2DAA4D;EAC5D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,2DAA0D;EAC1D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,2DAAyD;EACzD,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;;;2CAGyC;EACzC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,kCAAkC;EAClC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;;;;;;;;;;;;;GAaG;AACH;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;;AAEA;;;;;GAKG;AACH;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;;;;;;;;EAUE,6BAA6B;AAC/B;;AAEA;;;;EAIE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,wCAAwC;AAC1C;;AAEA;;EAEE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;EAEE,aAAa;AACf;;AAEA;;GAEG;;AAEH;EACE,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;EAIE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;;;kBAGgB;EAChB,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;;;wBAGsB;;EAEtB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;mDACiD;AACnD;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;;EAEX,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAA8B;EAA9B,cAA8B;EAA9B,gCAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;AACA,6BAA6B,WAAW,EAAE;;AAE1C;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;AACA,qBAAqB,eAAe,EAAE,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc,EAAE,oBAAoB,EAAE;AACzJ,gBAAgB,sBAAsB,EAAE,uBAAuB,EAAE,cAAc,EAAE,cAAc,EAAE;;AAEjG,qBAAqB;AACrB,oBAAoB,mBAAmB,EAAE,EAAE,6BAA6B,cAAc,EAAE;AACxF,oBAAoB,mBAAmB,EAAE,EAAE,6BAA6B,cAAc,EAAE;AACxF,oBAAoB,mBAAmB,EAAE,EAAE,6BAA6B,cAAc,EAAE;AACxF,oBAAoB,mBAAmB,EAAE,EAAE,6BAA6B,cAAc,EAAE;AACxF,oBAAoB,mBAAmB,EAAE,EAAE,6BAA6B,cAAc,EAAE;AACxF,oBAAoB,mBAAmB,EAAE,EAAE,6BAA6B,cAAc,EAAE;;AAExF,qDAAqD;AACrD;EACE,iDAAiD;EACjD,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,qCAAqC;AACrC;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iHAAiH;EACjH,iCAAiC;;EAEjC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;GAGG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,aAAa;EACb,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;;EAEd,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wEAAiE;EACjE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0EAA0E;EAC1E,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,+DAA+D;EAC/D,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;;;;;;;;;;;;;;;;yCAgByC;AACzC;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;;;;;6CAM6C;AAC7C;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;iDAIiD;AACjD;EACE,qCAAqC;AACvC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;6CAM6C;AAC7C;EACE,qCAAqC;AACvC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;yEAKyE;AACzE;;EAEE,6BAA6B;AAC/B;;AAEA;;;;oEAIoE;AACpE;;;;EAIE,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;qEAEqE;AACrE;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;;AAEA;;;;8BAI8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;KAEG;EACH;;KAEG;AACL;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;KAEG;AACL;;AAEA;;;;GAIG;;AAEH;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uCAAuC;EACvC,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,wEAA+D;AACjE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;;;;;;EAQE,cAAc;EACd,YAAY;AACd;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;;EAEnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;;;;;;;;;;;GAWG;AACH;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,gBAAgB;;AAEhB;EACE;IACE,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,gBAAgB;;AAEhB;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA,gBAAgB;;AAEhB;EACE,uBAAuB;;EAEvB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,yDAAkD;EAClD,wBAAwB;EACxB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+DAA+D;EAC/D,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,uCAAuC;EACvC,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,OAAO;EACP,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;;;;;;;;;;gDAUgD;AAChD;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;;;;+BAI+B;AAC/B;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,SAAS;AACX;;AAEA;;mEAEmE;AACnE;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;6CAE6C;AAC7C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;mEAImE;AACnE;;;;EAIE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,UAAU;EACV,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,kDAAkD;EAClD,aAAa;EACb,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,YAAY;EACZ,6BAA6B;EAC7B,oCAAoC;EACpC,wBAAwB;EACxB,kDAAkD;EAClD,oCAAoC;EACpC,WAAW;EACX,iCAAiC;EACjC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,kDAAkD;EAClD,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;;;;;;;;GAWG;AACH;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;EACd,+BAA+B;EAC/B,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;iFACiF;AACjF;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0DAA0D;AAC5D;AACA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,uDAAuD;AACzD;AACA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA;;;;;;;EAOE,kDAAkD;EAClD,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;IACI,oCAAoC;IACpC,4BAA4B;IAC5B,yBAAyB;AAC7B;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,yBAAyB;EACzB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;;;oEAIoE;AACpE;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,SAAS;AACX;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,oDAAoD;EACpD,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;IACI,uBAAuB;AAC3B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,4BAA4B;EAC5B,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;;GAEG;AACH;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;;EAErB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,oBAAoB;EACpB,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;IAMI;;AAEJ;;GAEG;AACH;EACE,kBAAkB;EAClB,yCAAyC;EACzC,2BAA2B;EAC3B,gBAAgB;EAChB,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;EAC5B,SAAS;EACT,6BAA6B;EAC7B,2BAA2B;EAC3B;mFACiF;EACjF,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;GAGG;AACH;EACE,UAAU;EACV,SAAS;EACT,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX,eAAe;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;;EAEd,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,oCAAoC;IACpC,8BAA8B;IAC9B,kDAAkD;IAClD,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,uBAAuB;AAC3B;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;GAGG;AACH;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAGhB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EAInB,sBAAsB;AACxB;;AAEA;EAGE,aAAa;EAIb,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;GAmBG;AACH;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,oCAAoC;IACpC,oCAAoC;IACpC,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;AACA;IACI,uBAAuB;IACvB,kCAAkC;AACtC;AACA;IACI,sCAAsC;IACtC,oBAAoB;AACxB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;EAClC,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;;;;;;GAMG;;AAEH;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;8EAC8E;AAC9E;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,8BAA8B;IAC9B,gCAAgC;AACpC;AACA;IACI,8BAA8B;AAClC;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;EACzB,6BAA6B;EAC7B,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,iBAAiB;EACjB,0BAA0B;EAC1B,SAAS;AACX;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,gBAAgB;EAChB,sDAAsD;AACxD;AACA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,SAAS;AACb;AACA;EACE,8DAA8D;AAChE;AACA,uDAAuD,oBAAoB,EAAE;AAC7E,uDAAuD,qBAAqB,EAAE;AAC9E,uDAAuD,sBAAsB,EAAE;AAC/E,uDAAuD,sBAAsB,EAAE;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,sCAAsC;EACtC,4CAA4C;EAC5C,eAAe;EACf,cAAc;EACd,sDAAsD;AACxD;AACA;EACE,sEAAsE;AACxE;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;AACA;IACI,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,qBAAqB;AACzB;AACA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,SAAS;AACX;AACA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,kCAAkC;IAClC,uBAAuB;AAC3B;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,SAAS;AACX;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB,CAAC;IACG,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,SAAS;IACT,WAAW;AACf;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA,iDAAiD;AACjD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,yEAAyE;EACzE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,2BAA2B;EAC3B,oBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,QAAQ;AACV;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAsB;EACtB,iCAAiC;EACjC,kCAAkC;EAClC,kCAAkC;EAClC,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;EACpB,yBAAyB;EACzB,8BAA8B;EAC9B,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,wEAAwE;EACxE,uDAAuD;EACvD,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;IACI,+BAA+B;IAC/B,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;IACzB,kCAAkC;IAClC,kCAAkC;IAClC,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,SAAS;AACb;AACA;EACE,4CAA4C;EAC5C,eAAe;EACf,sBAAsB;EACtB,qCAAqC;EACrC,+BAA+B;EAC/B,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,uCAAuC;EACvC,eAAe;EACf,sBAAsB;EACtB,qCAAqC;EACrC,+BAA+B;EAC/B,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;IACI,2BAA2B;IAC3B,WAAW;AACf;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;AACA;IACI,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,QAAQ;EACR,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,qCAAqC;EACrC,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wBAAwB;AAC1B;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,oCAAoC;IACpC,cAAc;IACd,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,SAAS;AACb;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;AACA;IAEI,0BAA0B;IAC1B,gCAAgC;AACpC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,sCAAsC;IACtC,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,8BAA8B;AAClC;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,4CAA4C;EAC5C,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,SAAS;EAC1B,UAAU;EACV,mBAAmB;AACrB;AACA,+DAA+D,cAAc,EAAE;AAC/E;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,SAAS;AACX;AACA,qEAAqE,aAAa,EAAE;AACpF;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA,8CAA8C,mBAAmB,EAAE;AACnE,8CAA8C,mBAAmB,EAAE;AACnE,8CAA8C,mBAAmB,EAAE;AACnE,8CAA8C,mBAAmB,EAAE;AACnE,8CAA8C,mBAAmB,EAAE;AACnE,8CAA8C,mBAAmB,EAAE;AACnE,8CAA8C,mBAAmB,EAAE;AACnE;EACE,wEAAwE,eAAe,EAAE;EACzF,wEAAwE,eAAe,EAAE;AAC3F;AACA;EACE,qBAAqB,2DAA2D,EAAE;AACpF;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;AACA,iFAAiF;AACjF;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,4CAA4C;AAC9C;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,KAAK,6BAA6B,EAAE;EACpC,OAAO,0BAA0B,EAAE;AACrC;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;EAC7C,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;AACb;AACA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;AACb;AACA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,QAAQ;IACR,8BAA8B;IAC9B,4BAA4B;IAC5B,kCAAkC;IAClC,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,cAAc;IACd,aAAa;IACb,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;AAChC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,cAAc;IACd,aAAa;IACb,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,aAAa;AACjB;AACA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,4BAA4B;AAChC;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,8CAA8C;IAC9C,gBAAgB;IAChB,WAAW;IACX,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;IAC9B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,kCAAkC;AACpC;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,kCAAkC;AACtC;AACA;IACI,sBAAsB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,gCAAgC;IAChC,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;IACI,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;AACA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;AACA;IACI,4BAA4B;IAC5B,eAAe;AACnB;AACA;IACI,kCAAkC;IAClC,4BAA4B;IAC5B,uBAAuB;AAC3B;AACA;IACI,4CAA4C;IAC5C,sBAAsB;IACtB,+BAA+B;IAC/B,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,qCAAqC;IACrC,uBAAuB;IACvB,+BAA+B;AACnC;AACA;IACI,+BAA+B;IAC/B,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;IAC1B,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,kBAAkB;AACtB;AACA;AACA,sBAAsB;AACtB;AACA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;;;gFAGgF;AAChF;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;;;;gBAIgB;AAChB;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;;;AAIA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,4BAA4B;EAC5B,eAAe;EACf,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,aAAa;AACf;;AAEA;;;;;;+EAM+E;AAC/E;EACE,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;;EAEE,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;AACA;EACE,uBAAuB;AACzB;AACA;EACE;;kEAEgE;EAChE,2CAA2C;EAC3C,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE;;0FAEwF;EACxF,6BAA6B;EAC7B,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;EACb,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB;;;;6EAI2E;EAC3E,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf;;;yEAGuE;EACvE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;;;2CAK2C;AAC3C;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qDAAqD;EACrD,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;;;EAGE,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf;;;;iCAI+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;;;;;;;;oBASoB;AACpB;EACE,SAAS;EACT,+FAA+F;EAC/F,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;qBAcqB;AACrB;EACE,iBAAiB;AACnB;;AAEA;;;;sDAIsD;AACtD;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;EAGE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,YAAY;EACZ,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;sEAIsE;AACtE;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,+CAA+C;EAC/C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP;;;kDAGgD;EAChD,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;EAC9B,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;;EAGE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kFAAkF;AAClF;;EAEE,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb;;;;;;;;oEAQkE;EAClE,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE;;;;;;oCAMkC;EAClC,cAAc;EACd;;;wDAGsD;EACtD,gBAAgB;EAChB,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,6CAA6C;EAC7C,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;AACF;;AAEA;EACE,6CAA6C,+BAA+B,EAAE;EAC9E,uCAAuC,qBAAqB,EAAE;EAC9D,+CAA+C,qBAAqB,EAAE;EACtE,8CAA8C,wBAAwB,EAAE;AAC1E;;AAEA;EACE,gDAAgD,iCAAiC,EAAE;EACnF,gDAAgD,0BAA0B,EAAE,yBAAyB,EAAE;EACvG,6CAA6C,+BAA+B,EAAE;EAC9E,+CAA+C,qBAAqB,EAAE;EACtE,8CAA8C,wBAAwB,EAAE;EACxE,4DAA4D,0BAA0B,EAAE,uBAAuB,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AACjK;;AAEA;EACE,iCAAiC,sBAAsB,EAAE;EACzD,6CAA6C,+BAA+B,EAAE;EAC9E,yCAAyC,0BAA0B,EAAE;EACrE;;;;oEAIkE;EAClE,+CAA+C,qBAAqB,EAAE,8BAA8B,EAAE;EACtG,8CAA8C,wBAAwB,EAAE,8BAA8B,EAAE;EACxG;;;4EAG0E;EAC1E,6CAA6C,mBAAmB,EAAE;EAClE,4DAA4D,0BAA0B,EAAE,uBAAuB,EAAE,0BAA0B,EAAE,0BAA0B,EAAE;AAC3K;;AAEA;;sCAEsC;AACtC;EACE;;IAEE,0BAA0B;IAC1B,iCAAiC;IACjC,oBAAoB;IACpB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;;IAEE,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA;;;;;;gEAM8D;EAC9D;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,6CAA6C,+BAA+B,EAAE;EAC9E,+CAA+C,qBAAqB,EAAE,8BAA8B,EAAE;EACtG,8CAA8C,wBAAwB,EAAE,8BAA8B,EAAE;EACxG,yCAAyC,0BAA0B,EAAE,mBAAmB,EAAE,0BAA0B,EAAE;EACtH,8CAA8C,0BAA0B,EAAE;EAC1E,wDAAwD,sBAAsB,EAAE,uBAAuB,EAAE;EACzG,mDAAmD,0BAA0B,EAAE,0BAA0B,EAAE;EAC3G,4DAA4D,0BAA0B,EAAE,uBAAuB,EAAE;AACnH;;AAEA;;sEAEsE;AACtE;EACE;IACE,QAAQ;EACV;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,QAAQ;EACV;AACF;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE;;kEAEgE;AAClE;;AAEA;;;;;;;;;EASE,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;EAIE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA,+DAA+D;AAC/D;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;;;;;;;;;EASE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,YAAY;EACZ,yCAAyC;EACzC,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,sCAAsC;EACtC,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,0DAA0D;AAC5D;;AAEA;EACE,wBAAwB;EACxB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,+BAA+B;EAC/B,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,YAAY;AACd;;AAEA,mCAAmC;;AAEnC;EACE,WAAW;EACX,UAAU;EACV,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,iEAAiE;EACjE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,qCAAqC;EACrC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,6DAA6D;EAC7D;;2CAEyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gGAAgG;AAClG;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;;EAEE,oBAAoB;EACpB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,iEAAiE;AACnE;;AAEA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,SAAS;AACX;;AAEA;;;EAGE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;;EAGE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;;;;;;;;uDAQqD;EACrD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;EACtB,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,uCAAuC;EACvC,oBAAoB;EACpB,2EAA2E;AAC7E;;AAEA;;EAEE,UAAU;EACV,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,qEAAqE;AACvE;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;;EAIE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,+BAA+B;EAC/B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT;;;;yCAIuC;EACvC,iBAAiB;EACjB,wFAAwF;EACxF,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,4BAA4B;EAC5B,UAAU;EACV,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;;;;;;;;IAQE,WAAW;IACX,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;;;;;;wEAYwE;AACxE;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,qEAAqE;AACvE;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;;EAIE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,+BAA+B;EAC/B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT;;;;yCAIuC;EACvC,iBAAiB;EACjB,wFAAwF;EACxF,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,UAAU;EACV,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB;;;;yCAIuC;EACvC,mBAAmB;EACnB,wFAAwF;EACxF,wBAAwB;AAC1B;;AAEA;;;;EAIE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ;;;;yCAIuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;EAKE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;EACT,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,sCAAsC;EACtC,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,0DAA0D;EAC1D,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;;;;;EAQE,cAAc;AAChB;;AAEA;;;EAGE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,qDAAqD;EACrD,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;;;;;;EAQE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB;;;;yCAIuC;EACvC,iBAAiB;EACjB,wFAAwF;EACxF,wBAAwB;AAC1B;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;;;;8CAI8C;;AAE9C;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;EAME,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,2BAA2B;EAC3B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,4BAA4B;EAC5B,oBAAoB;EACpB,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;EAGE,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;;;;uBAQuB;AACvB;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;EAC7B,+FAA+F;EAC/F,yBAAyB;EACzB,eAAe;EACf,uDAAuD;EACvD,0EAA0E;AAC5E;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;EACvC,wDAAwD;AAC1D;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;kEAEkE;AAClE;EACE,uBAAuB;EACvB,+FAA+F;EAC/F,yBAAyB;EACzB,gBAAgB;EAChB,sDAAsD;EACtD,0EAA0E;AAC5E;AACA;;EAEE,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,uDAAuD;AACzD;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE;iEAC+D;AACjE;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,MAAM;EACN,sBAAsB;EACtB,8BAA8B;EAC9B;4EAC0E;EAC1E,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;EACpC,wEAAwE;EACxE;;sDAEoD;AACtD;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,4EAA4E;EAC5E,2BAA2B;EAC3B,8BAA8B;EAC9B,6BAA6B;EAC7B,wBAAwB;EACxB,2CAA2C;EAC3C,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,4BAA4B;EAC5B,oBAAoB;EACpB,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,wDAAwD;EACxD,eAAe;EACf,gBAAgB;EAChB,kGAAkG;AACpG;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AAEA;;EAEE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;;;IAGE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC,mBAAmB;AACnB;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,MAAM;EACN,yBAAyB;EACzB,eAAe;EACf,iCAAiC;EACjC,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,iDAAiD;EACjD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA,sCAAsC;AACtC;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,4CAA4C;AAC5C;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;;;;;;sDAMsD;AACtD;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;;;2EAG2E;AAC3E;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,+EAA+E;EAC/E,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA,yFAAyF;AACzF;EACE,oEAAoE;AACtE;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;AAC9B;;;AAGA;;8DAE8D;;AAE9D;EACE;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;EACA;IACE,uCAAuC;EACzC;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,uCAAuC;EACzC;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;;8DAE8D;;AAE9D;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,WAAW;EACX,eAAe;EACf,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;EAC7B,2BAA2B;EAC3B,kGAAkG;AACpG;AACA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,oBAAoB;EACpB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uEAAuE;EACvE,gBAAgB;AAClB;;AAEA,4BAA4B,YAAY,EAAE;AAC1C,iCAAiC,SAAS,EAAE,cAAc,EAAE,mBAAmB,EAAE,2CAA2C,EAAE;AAC9H,iCAAiC,6BAA6B,EAAE,0BAA0B,EAAE;AAC5F,0DAA0D,yBAAyB,EAAE,2BAA2B,EAAE;AAClH,qCAAqC,8BAA8B,EAAE;AACrE,4CAA4C,aAAa,EAAE;;AAE3D,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC9D,gBAAgB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,WAAW,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAE/P,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,eAAe,EAAE;AACtF,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACjE,kDAAkD,WAAW,EAAE,cAAc,EAAE,YAAY,EAAE;;AAE7F,mBAAmB,wEAAwE,EAAE,uBAAuB,EAAE,sDAAsD,EAAE,2BAA2B,EAAE;AAC3M,yBAAyB,YAAY,EAAE,sDAAsD,EAAE;AAC/F,iBAAiB,gCAAgC,EAAE,yBAAyB,EAAE;AAC9E,eAAe,uBAAuB,EAAE,0BAA0B,EAAE;;AAEpE,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,MAAM,EAAE;AAClE,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE,cAAc,EAAE;AAChN,gBAAgB,WAAW,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,eAAe,EAAE,8EAA8E,EAAE;AAC7S,sBAAsB,qBAAqB,EAAE,mBAAmB,EAAE,0CAA0C,EAAE;AAC9G,uBAAuB,qBAAqB,EAAE,mBAAmB,EAAE,2CAA2C,EAAE;AAChH,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACzI,qBAAqB,eAAe,EAAE,cAAc,EAAE;AACtD,sBAAsB,gBAAgB,EAAE,cAAc,EAAE;AACxD,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AACrH,mBAAmB,SAAS,EAAE,eAAe,EAAE,cAAc,EAAE;AAC/D,uBAAuB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEzE,gFAAgF;AAChF,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uEAAuE,EAAE,gBAAgB,EAAE,YAAY,EAAE,aAAa,EAAE;AACpP,uBAAuB,sBAAsB,EAAE;AAC/C,2BAA2B,wEAAwE,EAAE,uBAAuB,EAAE,2BAA2B,EAAE,sDAAsD,EAAE;AACnN,0BAA0B,oBAAoB,EAAE;AAChD,0BAA0B,oBAAoB,EAAE;AAChD,wBAAwB,SAAO,EAAE,aAAa,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AAC1F,yBAAyB,kBAAkB,EAAE;AAC7C,+BAA+B,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAC3J,wBAAwB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE,gCAAgC,EAAE;AAC3J,8BAA8B,mBAAmB,EAAE;AACnD,+BAA+B,mBAAmB,EAAE;AACpD,6BAA6B,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE;AAC9E,0DAA0D,cAAc,EAAE;AAC1E,8BAA8B,SAAO,EAAE,YAAY,EAAE,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACtJ,2DAA2D,cAAc,EAAE,gBAAgB,EAAE;AAC7F,6BAA6B,SAAO,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACrG,yDAAyD,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACzH,6BAA6B,eAAe,EAAE,cAAc,EAAE;AAC9D,+BAA+B,UAAU,EAAE,YAAY,EAAE,uBAAuB,EAAE,cAAc,EAAE,eAAe,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,oEAAoE,EAAE;AACxS,2DAA2D,UAAU,EAAE;AACvE,qCAAqC,mBAAmB,EAAE,cAAc,EAAE;AAC1E,yBAAyB,kBAAkB,EAAE,kBAAkB,EAAE,eAAe,EAAE,cAAc,EAAE;AAClG,0BAA0B,iBAAiB,EAAE,6BAA6B,EAAE,cAAc,EAAE;;AAE5F,gFAAgF;AAChF,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uEAAuE,EAAE,gBAAgB,EAAE,YAAY,EAAE,YAAY,EAAE,aAAa,EAAE;AACjQ,kBAAkB,SAAO,EAAE,aAAa,EAAE,gBAAgB,EAAE,aAAa,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,mBAAmB,EAAE;;AAElJ,iBAAiB,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,aAAa,EAAE;AACpF,sBAAsB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,6DAA6D,EAAE,WAAW,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,mBAAmB,EAAE,0CAA0C,EAAE;AACjS,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;AACxF,mBAAmB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACtE,oBAAoB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,uBAAuB,EAAE;AACvF,wBAAwB,yBAAyB,EAAE,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,eAAe,EAAE,yEAAyE,EAAE;AAC5O,8BAA8B,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;;AAE1F,UAAU,aAAa,EAAE;AACzB,eAAe,yBAAyB,EAAE;AAC1C,oBAAoB,2BAA2B,EAAE;AACjD,iBAAiB,mBAAmB,EAAE,eAAe,EAAE,iBAAiB,EAAE;AAC1E,8BAA8B,cAAc,EAAE,6DAA6D,EAAE,WAAW,EAAE,kBAAkB,EAAE,+BAA+B,EAAE,qBAAqB,EAAE,qBAAqB,EAAE;AAC7N,mCAAmC,cAAc,EAAE,WAAW,EAAE;AAChE,eAAe,gBAAgB,EAAE,yBAAyB,EAAE,8BAA8B,EAAE,wCAAwC,EAAE;AACtI,iBAAiB,kBAAkB,EAAE,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE;AACzF,mBAAmB,gBAAgB,EAAE;AACrC,8BAA8B,gBAAgB,EAAE;AAChD,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,cAAc,EAAE,eAAe,EAAE;AACpH,iCAAiC,UAAU,EAAE,aAAa,EAAE;AAC5D,2EAA2E,iBAAiB,EAAE,mBAAmB,EAAE;;AAEnH,iFAAiF;AACjF,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE;;AAE5M,iFAAiF;AACjF,eAAe,6BAA6B,EAAE,gBAAgB,EAAE,cAAc,EAAE,uBAAuB,EAAE;AACzG,yBAAyB,aAAa,EAAE,qBAAqB,EAAE,QAAQ,EAAE;AACzE,+BAA+B,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,eAAe,EAAE,yEAAyE,EAAE;AACtU,qCAAqC,mBAAmB,EAAE;AAC1D,sCAAsC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAElG,sBAAsB,kBAAkB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,kBAAkB,EAAE,yBAAyB,EAAE,OAAO,EAAE,YAAY,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,yEAAyE,EAAE,aAAa,EAAE,WAAW,EAAE;AACpQ,oCAAoC,mBAAmB,EAAE;AACzD,+CAA+C,gBAAgB,EAAE;AACjE,kDAAkD,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,YAAY,EAAE;AACnH,yEAAyE,8BAA8B,EAAE;AACzG,+FAA+F,wEAAwE,EAAE,gCAAgC,EAAE,sBAAsB,EAAE,yCAAyC,EAAE;AAC9Q,uGAAuG,oCAAoC,EAAE;AAC7I,qDAAqD,yBAAyB,EAAE;AAChF,qGAAqG,wEAAwE,EAAE,gCAAgC,EAAE,sBAAsB,EAAE;;AAEzO,wBAAwB,SAAO,EAAE,YAAY,EAAE;AAC/C,4EAA4E,8BAA8B,EAAE,4BAA4B,EAAE,uBAAuB,EAAE,0BAA0B,EAAE,gCAAgC,EAAE;AACjO,wFAAwF,gCAAgC,EAAE,qDAAqD,EAAE;AACjL,4BAA4B,cAAc,EAAE,WAAW,EAAE,YAAY,EAAE,eAAe,EAAE,UAAU,EAAE,wEAAwE,EAAE,uBAAuB,EAAE,sDAAsD,EAAE;AAC/P,sCAAsC,8BAA8B,EAAE,2BAA2B,EAAE,yBAAyB,EAAE;;AAE9H,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uEAAuE,EAAE,gBAAgB,EAAE,YAAY,EAAE;;AAErO,cAAc,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,gCAAgC,EAAE,cAAc,EAAE;AACxL,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,cAAc,EAAE;AAClF,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAC3F,uBAAuB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,6CAA6C,EAAE;AACtQ,sBAAsB,QAAQ,SAAS,EAAE,IAAI,UAAU,EAAE;;AAEzD,iDAAiD;AACjD,QAAQ,wBAAwB,EAAE;AAClC,0BAA0B,KAAK,yBAAyB,EAAE,EAAE;AAC5D,+BAA+B,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,YAAY,EAAE,eAAe,EAAE,gBAAgB,EAAE,yCAAyC,EAAE,oDAAoD,EAAE;AACzQ,2CAA2C,wCAAwC,EAAE,2BAA2B,EAAE;AAClH,6CAA6C,mCAAmC,EAAE;AAClF,gBAAgB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACnG,gBAAgB,kBAAkB,EAAE,QAAQ,EAAE,WAAW,EAAE,YAAY,EAAE,4CAA4C,EAAE;AACvH,uBAAuB,UAAU,EAAE,4BAA4B,EAAE,eAAe,EAAE,uBAAuB,EAAE,qBAAqB,EAAE;AAClI,gBAAgB,kBAAkB,EAAE,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,gCAAgC,EAAE,kBAAkB,EAAE,wDAAwD,EAAE;AAC3L,uEAAuE,kBAAkB,EAAE,qBAAqB,EAAE;AAClH,gBAAgB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,oBAAoB,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,2BAA2B,EAAE;AAC7J,qBAAqB,kBAAkB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;AACxJ,0CAA0C,iBAAiB,EAAE,uBAAuB,EAAE;AACtF,mCAAmC,UAAU,EAAE,WAAW,EAAE;;AAE5D,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACvG,8CAA8C,0BAA0B,EAAE,uBAAuB,EAAE,0BAA0B,EAAE,6BAA6B,EAAE,8BAA8B,EAAE,gCAAgC,EAAE,yBAAyB,EAAE,2BAA2B,EAAE,oCAAoC,EAAE;AAC9T,0DAA0D,gCAAgC,EAAE,yBAAyB,EAAE,8BAA8B,EAAE;AACvJ,6BAA6B,oCAAoC,EAAE,kCAAkC,EAAE,yBAAyB,EAAE,yBAAyB,EAAE;AAC7J,mCAAmC,yBAAyB,EAAE,oCAAoC,EAAE,8BAA8B,EAAE;AACpI,+BAA+B,yBAAyB,EAAE,gCAAgC,EAAE,8BAA8B,EAAE;AAC5H,qCAAqC,8BAA8B,EAAE,gCAAgC,EAAE;AACvG,sBAAsB,UAAU,EAAE,YAAY,EAAE,mBAAmB,EAAE,cAAc,EAAE,aAAa,EAAE;AACpG,oBAAoB,gBAAgB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,uCAAuC,EAAE;AACxK,2BAA2B,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;AACpH,0BAA0B,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AAChI,4BAA4B,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC1E,sBAAsB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,4BAA4B,EAAE,gBAAgB,EAAE;AACnO,4BAA4B,mBAAmB,EAAE;AACjD,oBAAoB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAC5J,0BAA0B,cAAc,EAAE,mBAAmB,EAAE;AAC/D,oBAAoB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE;AAC9D,mBAAmB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,eAAe,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;AAC1N,yBAAyB,mBAAmB,EAAE,qBAAqB,EAAE;AACrE,yBAAyB,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE,aAAa,EAAE,eAAe,EAAE;;AAErH,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,cAAc,EAAE,mBAAmB,EAAE,gCAAgC,EAAE,cAAc,EAAE;AAC7L,eAAe,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE;;AAExH,qBAAqB,SAAO,EAAE,aAAa,EAAE;AAC7C,qCAAqC,YAAY,EAAE;AACnD,+DAA+D,gBAAgB,EAAE,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,aAAa,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,WAAW,EAAE;AACrO,6EAA6E,+BAA+B,EAAE,cAAc,EAAE,oBAAoB,EAAE,kBAAkB,EAAE;;AAExK,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,SAAS,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC5M,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,cAAc,EAAE;AAClG,WAAW,gBAAgB,EAAE,cAAc,EAAE;AAC7C,iBAAiB,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACrE,eAAe,cAAc,EAAE;AAC/B,iBAAiB,2BAA2B,EAAE,eAAe,EAAE;AAC/D,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE;AACtF,2BAA2B,oCAAoC,EAAE,yBAAyB,EAAE,kCAAkC,EAAE;AAChI,iCAAiC,gCAAgC,EAAE,yBAAyB,EAAE,8BAA8B,EAAE;AAC9H,4BAA4B,wEAAwE,EAAE,uBAAuB,EAAE,qDAAqD,EAAE,2BAA2B,EAAE;AACnN,kCAAkC,sBAAsB,EAAE;;AAE1D,eAAe,gBAAgB,EAAE,uBAAuB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uEAAuE,EAAE;AACrM,sBAAsB,aAAa,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC9H,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE;AACnF,wBAAwB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAC1E,0BAA0B,wEAAwE,EAAE,uBAAuB,EAAE,sDAAsD,EAAE,2BAA2B,EAAE,cAAc,EAAE;;AAElO,kBAAkB,aAAa,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,YAAY,EAAE,6EAA6E,EAAE,aAAa,EAAE,sBAAsB,EAAE,MAAM,EAAE;AAC/O,wBAAwB,2CAA2C,EAAE,2BAA2B,EAAE,qBAAqB,EAAE;AACzH,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AAC1F,sCAAsC,gBAAgB,EAAE,cAAc,EAAE;AACxE,uCAAuC,gBAAgB,EAAE;AACzD,kBAAkB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,eAAe,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC5L,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAC5I,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,oBAAoB,EAAE;AACjH,mBAAmB,qBAAqB,EAAE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAC5L,kBAAkB,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACpG,uBAAuB,gBAAgB,EAAE;AACzC,uBAAuB,kBAAkB,EAAE;AAC3C,yBAAyB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE,oBAAoB,EAAE,gCAAgC,EAAE;AACrJ,qBAAqB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,eAAe,EAAE;AACrF,sBAAsB,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE;AAC/D,yBAAyB,iBAAiB,EAAE,cAAc,EAAE,uBAAuB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,gCAAgC,EAAE,aAAa,EAAE,uBAAuB,EAAE,8BAA8B,EAAE,QAAQ,EAAE;AAChP,oCAAoC,mBAAmB,EAAE;AACzD,iCAAiC,YAAY,EAAE,kBAAkB,EAAE,OAAO,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC/H,sBAAsB,SAAO,EAAE;AAC/B,2BAA2B,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,mBAAmB,EAAE,4BAA4B,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC5R,iCAAiC,mBAAmB,EAAE;AACtD,oCAAoC,YAAY,EAAE,mBAAmB,EAAE;AACvE,kBAAkB,aAAa,EAAE,sBAAsB,EAAE;AACzD,gBAAgB,eAAe,EAAE,gCAAgC,EAAE;AACnE,2BAA2B,mBAAmB,EAAE,iBAAiB,EAAE;AACnE,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AACnI,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,iBAAiB,oBAAoB,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE;AACnL,uBAAuB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC9F,8BAA8B,cAAc,EAAE,eAAe,EAAE,yBAAyB,EAAE,sBAAsB,EAAE,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AACxK,yBAAyB,SAAS,EAAE;AACpC,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,eAAe,EAAE;AACrF,uBAAuB,iBAAiB,EAAE,cAAc,EAAE,qBAAqB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,cAAc,EAAE,eAAe,EAAE;AAClL,6BAA6B,0BAA0B,EAAE;AACzD,qBAAqB,iBAAiB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAC5E,qBAAqB,eAAe,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,qBAAqB,EAAE;AAC/Q,2BAA2B,cAAc,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;AACvF,uBAAuB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE,eAAe,EAAE;AAClF,0CAA0C,aAAa,EAAE;AACzD,mBAAmB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,WAAW,EAAE,mBAAmB,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,4BAA4B,EAAE;AACnP,wCAAwC,mBAAmB,EAAE;AAC7D,4BAA4B,YAAY,EAAE,mBAAmB,EAAE;AAC/D,gBAAgB,eAAe,EAAE;AACjC,sBAAsB,WAAW,EAAE,eAAe,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,aAAa,EAAE,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AACpN,4BAA4B,qBAAqB,EAAE,gBAAgB,EAAE;AACrE,wBAAwB,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AAClE,sBAAsB,iBAAiB,EAAE,gBAAgB,EAAE,WAAW,EAAE,mBAAmB,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACnK,4BAA4B,mBAAmB,EAAE;AACjD,sBAAsB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACnL,4BAA4B,mBAAmB,EAAE;AACjD,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,QAAQ,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACpM,mBAAmB,SAAO,EAAE,eAAe,EAAE;AAC7C,sBAAsB,cAAc,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,YAAY,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,mBAAmB,EAAE,WAAW,EAAE,4BAA4B,EAAE;AAC/M,2CAA2C,mBAAmB,EAAE;AAChE,+BAA+B,YAAY,EAAE,mBAAmB,EAAE;AAClE,sBAAsB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACrF,iBAAiB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,6BAA6B,EAAE,mBAAmB,EAAE;AACzN,iBAAiB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC7E,iBAAiB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC7E,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACnE,kBAAkB,gBAAgB,EAAE;AACpC,kBAAkB,YAAY,EAAE;AAChC,mBAAmB,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAE7G,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACnH,wCAAwC,8BAA8B,EAAE;;AAExE,+EAA+E;;AAE/E;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,iBAAiB,mBAAmB,EAAE,aAAa,EAAE,iBAAiB,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AAC1H,oBAAoB,mBAAmB,EAAE,yBAAyB,EAAE;AACpE,qBAAqB,mBAAmB,EAAE,yBAAyB,EAAE;AACrE,iBAAiB,iBAAiB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE,cAAc,EAAE;AACxH,mBAAmB,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,SAAO,EAAE;AACxG,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAEvI;EACE,aAAa,0BAA0B,EAAE,YAAY,EAAE,aAAa,EAAE;EACtE,cAAc,eAAe,EAAE;EAC/B,mBAAmB,aAAa,EAAE;EAClC,kBAAkB,2BAA2B,EAAE,iBAAiB,EAAE;AACpE;AACA;EACE,kBAAkB,sBAAsB,EAAE,uBAAuB,EAAE,SAAS,EAAE;EAC9E,cAAc,eAAe,EAAE;EAC/B,sBAAsB,eAAe,EAAE,WAAW,EAAE;EACpD,uCAAuC,sBAAsB,EAAE,uBAAuB,EAAE;EACxF,qBAAqB,eAAe,EAAE,WAAW,EAAE;EACnD,sBAAsB,sBAAsB,EAAE,uBAAuB,EAAE;EACvE,0BAA0B,WAAW,EAAE;AACzC;AACA;EACE,WAAW,mBAAmB,EAAE;EAChC;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA,iBAAiB,eAAe,EAAE;EAClC,oBAAoB,eAAe,EAAE;EACrC,0BAA0B,WAAW,EAAE;EACvC;IACE,0BAA0B;IAC1B,QAAQ;EACV;EACA;IACE,wBAAwB;IACxB,6BAA6B;EAC/B;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;;IAEE,cAAc;EAChB;AACF;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,kGAAkG;AACpG;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,+EAA+E;AACjF;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,wEAAwE;EACxE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;EACjB,uDAAuD;EACvD,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,uDAAuD;AACzD;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,6EAA6E;AAC/E;;AAEA;;;EAGE,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;EAChC,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,uGAAuG;AACzG;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,+EAA+E;EAC/E,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA,wCAAwC;AACxC;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,MAAM;EACN,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;IACX,cAAc;EAChB;;EAEA;;;;IAIE,sBAAsB;EACxB;;EAEA;IACE,SAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,UAAU;EACZ;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;IAEE,WAAW;EACb;AACF;;;AAGA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;AACA,cAAc,aAAa,EAAE,SAAS,EAAE,uBAAuB,EAAE;AACjE,cAAc,SAAO,EAAE,YAAY,EAAE;AACrC,iBAAiB,aAAa,EAAE,eAAe,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAChF,qBAAqB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,mCAAmC,EAAE,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,qBAAqB,EAAE;AACpQ,2BAA2B,qBAAqB,EAAE,cAAc,EAAE;AAClE,6BAA6B,2DAA2D,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AAC7I,sBAAsB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE,kCAAkC,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACrO,yEAAyE,8BAA8B,EAAE,cAAc,EAAE;AACzH,iBAAiB,YAAY,EAAE,eAAe,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,gBAAgB,EAAE,SAAS,EAAE;AAC/H,uBAAuB,gBAAgB,EAAE,oCAAoC,EAAE,mBAAmB,EAAE,aAAa,EAAE;AACnH,6BAA6B,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACpJ,mBAAmB,kBAAkB,EAAE,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACzF,cAAc,YAAY,EAAE,aAAa,EAAE,kBAAkB,EAAE,qFAAqF,EAAE;AACtJ,oBAAoB,kBAAkB,EAAE,WAAW,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AAChL,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,cAAc,EAAE;AACrF,kBAAkB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACpE,qBAAqB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE,eAAe,EAAE,cAAc,EAAE;AAC7H,oBAAoB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,qBAAqB,EAAE;AACxF,0BAA0B,mBAAmB,EAAE;AAC/C,4BAA4B,8BAA8B,EAAE;AAC5D,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACnE,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,4BAA4B,EAAE;AACtJ,uBAAuB,8BAA8B,EAAE;AACvD,yBAAyB,iCAAiC,EAAE;AAC5D,iBAAiB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE;AAC9E,0BAA0B,mBAAmB,EAAE;AAC/C,0BAA0B,mBAAmB,EAAE;AAC/C,0BAA0B,mBAAmB,EAAE;AAC/C,0BAA0B,mBAAmB,EAAE;AAC/C,0BAA0B,mBAAmB,EAAE;AAC/C,0BAA0B,mBAAmB,EAAE;AAC/C,0BAA0B,mBAAmB,EAAE;AAC/C,kBAAkB,SAAO,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC9E,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AAC7I,0BAA0B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC3E,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,WAAW,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,mCAAmC,EAAE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,qBAAqB,EAAE;AAC3Q,sBAAsB,iCAAiC,EAAE,qBAAqB,EAAE;AAChF,wBAAwB,cAAc,EAAE;AACxC,8BAA8B,gCAAgC,EAAE,iCAAiC,EAAE;AACnG,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,oBAAoB,EAAE,2CAA2C,EAAE;AAC5K,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACrE,2BAA2B,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,2DAA2D,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,4CAA4C,EAAE;AACnP,sBAAsB,0BAA0B,EAAE,sBAAsB,EAAE;AAC1E,uBAAuB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,uCAAuC,EAAE;AACpI,qBAAqB,eAAe,EAAE,cAAc,EAAE,SAAS,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC/G,oBAAoB,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,YAAY,EAAE,cAAc,EAAE,mBAAmB,EAAE,2DAA2D,EAAE,WAAW,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACzQ,kBAAkB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,oCAAoC,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,qBAAqB,EAAE;AAChQ,wBAAwB,2DAA2D,EAAE,WAAW,EAAE,yBAAyB,EAAE;AAC7H,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACpE,cAAc,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,oCAAoC,EAAE,eAAe,EAAE,kBAAkB,EAAE,iEAAiE,EAAE;AACtQ,oBAAoB,2BAA2B,EAAE,wCAAwC,EAAE;AAC3F,sBAAsB,8BAA8B,EAAE,oEAAoE,EAAE;AAC5H,oBAAoB,kCAAkC,EAAE,aAAa,EAAE;AACvE,oBAAoB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,cAAc,EAAE,0BAA0B,EAAE;AAC7K,uBAAuB,gCAAgC,GAAG,yBAAyB,EAAE;AACrF,uBAAuB,iCAAiC,EAAE,yBAAyB,EAAE;AACrF,uBAAuB,iCAAiC,EAAE,yBAAyB,EAAE;AACrF,uBAAuB,iCAAiC,EAAE,yBAAyB,EAAE;AACrF,uBAAuB,kCAAkC,CAAC,yBAAyB,EAAE;AACrF,uBAAuB,iCAAiC,EAAE,yBAAyB,EAAE;AACrF,uBAAuB,8BAA8B,IAAI,yBAAyB,EAAE;AACpF,oBAAoB,SAAO,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC5F,oBAAoB,oBAAoB,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AAChN,wBAAwB,gCAAgC,GAAG,cAAc,EAAE;AAC3E,wBAAwB,iCAAiC,EAAE,cAAc,EAAE;AAC3E,wBAAwB,iCAAiC,EAAE,cAAc,EAAE;AAC3E,wBAAwB,iCAAiC,EAAE,cAAc,EAAE;AAC3E,wBAAwB,kCAAkC,CAAC,cAAc,EAAE;AAC3E,wBAAwB,iCAAiC,EAAE,cAAc,EAAE;AAC3E,wBAAwB,8BAA8B,IAAI,cAAc,EAAE;AAC1E,yBAAyB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC5E,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACrK,oBAAoB,eAAe,EAAE,cAAc,EAAE;AACrD,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,cAAc,EAAE;AACtF,mBAAmB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,yCAAyC,EAAE,gDAAgD,EAAE,cAAc,EAAE;AACpM,yBAAyB,GAAG,wCAAwC,EAAE,IAAI,wCAAwC,EAAE,KAAK,sCAAsC,EAAE;AACjK,oBAAoB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,uBAAuB,EAAE,cAAc,EAAE,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,eAAe,EAAE,UAAU,EAAE,wDAAwD,EAAE;AAChT,sCAAsC,UAAU,EAAE;AAClD,0BAA0B,gCAAgC,EAAE,iCAAiC,EAAE,cAAc,EAAE;AAC/G,eAAe,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AAC5I,wBAAwB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,2DAA2D,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE,2CAA2C,EAAE;AACpQ,qBAAqB,0BAA0B,EAAE,sBAAsB,EAAE;AACzE,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC1F,oBAAoB,eAAe,EAAE,cAAc,EAAE,SAAS,EAAE,gBAAgB,EAAE;AAClF,oBAAoB,aAAa,EAAE,uBAAuB,EAAE,iBAAiB,EAAE;AAC/E,gDAAgD,2DAA2D,EAAE,yBAAyB,EAAE;AACxI,kDAAkD,WAAW,EAAE;AAC/D;EACE,cAAc,sBAAsB,EAAE;EACtC,iBAAiB,WAAW,EAAE,UAAU,EAAE,gBAAgB,EAAE;EAC5D,cAAc,uBAAuB,EAAE;AACzC;;;AAGA;;oEAEoE;AACpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,cAAc;AAChB;AACA,oBAAoB,eAAe,EAAE;AACrC;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,wDAAwD;EACxD,gBAAgB;AAClB;AACA;;EAEE,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,cAAc;AAChB;;AAEA,wDAAwD;AACxD;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;;oEAEoE;;AAEpE,sBAAsB;AACtB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oFAAoF;EACpF,kDAAkD;AACpD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,iBAAiB,aAAa,EAAE;AAClC;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;AACA;EACE;;;IAGE,sBAAsB;IACtB,eAAe;EACjB;AACF;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,WAAW;AACb;AACA,oCAAoC,mBAAmB,EAAE;AACzD,oCAAoC,mBAAmB,EAAE;AACzD,oCAAoC,mBAAmB,EAAE;AACzD,oCAAoC,mBAAmB,EAAE;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,mCAAmC;AACnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;;AAE5D,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;oEAEoE;;AAEpE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;;;iEAGiE;AACjE;EACE,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,qCAAqC;AACvC;AACA;EACE,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA,wDAAwD;AACxD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,2EAA2E;EAC3E,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,aAAa;AACf;;AAEA;;;;;oEAKoE;AACpE;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,QAAQ;EACR,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,2CAA2C;EAC3C,qBAAqB;EACrB,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;;AAEA,yGAAyG;AACzG,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,2HAA2H;AAC7H;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,sDAAsD;AACtD;;EAEE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6EAA6E;EAC7E,6CAA6C;AAC/C;AACA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;EAC9B,6EAA6E;AAC/E;AACA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6EAA6E;EAC7E,eAAe;EACf,6CAA6C;AAC/C;AACA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,uBAAuB;AACzB;AACA,8CAA8C,sBAAsB,EAAE;AACtE,8CAA8C,sBAAsB,EAAE;AACtE,8CAA8C,sBAAsB,EAAE;AACtE,8CAA8C,sBAAsB,EAAE;AACtE,8CAA8C,sBAAsB,EAAE;AACtE,kDAAkD,sBAAsB,EAAE;;AAE1E;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,uGAAuG;AACzG;AACA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;AACjD;AACA;EACE,oDAAoD;AACtD;AACA;EACE,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,uDAAuD;AACzD;AACA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,uCAAuC;AACvC;EACE;;IAEE,eAAe;EACjB;EACA;;;;IAIE,gBAAgB;EAClB;AACF;;AAEA,uEAAuE;AACvE;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,8EAA8E;AAChF;AACA;EACE,cAAc;EACd,6DAA6D;EAC7D,yBAAyB;EACzB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,yDAAyD;AACzD;EACE,eAAe;EACf,uBAAuB;EACvB,wBAAwB;EACxB,8DAA8D;AAChE;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sDAAsD;AACxD;AACA;EACE,wDAAwD;AAC1D;AACA,kDAAkD;AAClD;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE;;IAEE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,8CAA8C;EAC9C,UAAU;AACZ;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,aAAa;EACb,QAAQ;AACV;;AAEA;EACE;;;;IAIE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,QAAQ;EACR,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,4CAA4C;EAC5C,aAAa;EACb,SAAS;EACT,6EAA6E;AAC/E;AACA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;iDAGiD;AACjD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,mBAAmB,EAAE,mCAAmC;EACxD,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB;8EAC4E;EAC5E,uBAAuB;EACvB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;0EAE0E;AAC1E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;;AAEhE;0BAC0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;AACA,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;;AAE9D;;kDAEkD;AAClD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;AACA,kCAAkC,cAAc,EAAE;AAClD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB;;sBAEoB;EACpB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,kGAAkG;AACpG;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wEAAwE;EACxE,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;EAC/C,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb;gFAC8E;EAC9E,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;kFAGkF;AAClF;EACE,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,yCAAyC;AAC3C;AACA;EACE,oBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,kCAAkC;EAClC,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yDAAyD;AAC3D;AACA;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0DAA0D;AAC5D;AACA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,gDAAgD;AAClD;AACA;;EAEE,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;;EAEE,8BAA8B;EAC9B,uBAAuB;EACvB,2BAA2B;EAC3B,+FAA+F;EAC/F,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,8DAA8D;AAC9D;EACE;;IAEE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA,oEAAoE;AACpE;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;;;;;GAMC;EACD,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;;;;;;GAMC;EACD,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;;GAMC;EACD,4BAA4B;EAC5B,kDAAkD;AACpD;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,uDAAuD;AACzD;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA,qDAAqD;AACrD;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA,6EAA6E;AAC7E;;gBAEgB;AAChB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,6DAA6D;AAC7D;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,kCAAkC;AAClC;;EAEE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;EAC9B,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA,sCAAsC,mBAAmB,EAAE;AAC3D,wCAAwC,mBAAmB,EAAE;AAC7D;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;AACf;;AAEA;;;;;;4EAM4E;;AAE5E,mBAAmB;AACnB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;AACA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,4CAA4C;EAC5C,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,oEAAoE;AACpE;;;;EAIE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA,mEAAmE;AACnE;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;EAC7B,2CAA2C;AAC7C;AACA,0DAA0D;AAC1D;EACE,wBAAwB;AAC1B;AACA;EACE,8BAA8B;AAChC;AACA,4DAA4D;AAC5D;;EAEE,6BAA6B;AAC/B;AACA;;;;gCAIgC;AAChC;;EAEE,8BAA8B;AAChC;;AAEA,8EAA8E;AAC9E;EACE,4BAA4B;EAC5B,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,8BAA8B;AAChC;AACA,0CAA0C;AAC1C;EACE,qCAAqC;EACrC,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;;AAEA;;;2CAG2C;AAC3C;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;;AAEA,yDAAyD;AACzD;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,kBAAkB;AACpB;;AAEA;;4EAE4E;AAC5E;EACE,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,6DAA6D;EAC7D,6CAA6C;EAC7C,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;AACA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;8CAe8C;AAC9C;EACE,sBAAsB;AACxB;AACA;;;;;;;2DAO2D;AAC3D;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE;6DAC2D;EAC3D,cAAc;EACd,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE,eAAe,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACnF,oBAAoB,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE;AAChG,oBAAoB,mBAAmB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,YAAY,EAAE;AAC3H,qBAAqB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAC9J,qBAAqB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AAClI,oBAAoB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACrJ,8BAA8B,mBAAmB,EAAE,cAAc,EAAE;AACnE,+BAA+B,mBAAmB,EAAE,cAAc,EAAE;AACpE,uBAAuB,mBAAmB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AAChH,oBAAoB,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE,qBAAqB,EAAE,sBAAsB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC5J,4BAA4B,oBAAoB,0BAA0B,EAAE,EAAE","sourcesContent":["html,\nbody {\n  overflow: auto !important;\n}\n\nbody {\n  padding: 0 0 0px 0;\n  background-color: #fafafa;\n  letter-spacing: -0.3px;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  line-height: 1.6;\n  font-weight: 400;\n    font-family: 'Greycliff CF' !important;\n}\n@font-face {\n  font-family: 'Greycliff CF';\n  src: url('../fonts/GreycliffCF-Heavy.woff') format('woff');\n  font-weight: 900;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Greycliff CF';\n  src: url('../fonts/GreycliffCF-ExtraBold.woff') format('woff');\n  font-weight: 800;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Visby Round CF Demi';\n  src: url('../fonts/GreycliffCF-DemiBold.woff') format('woff');\n  font-weight: 600;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Greycliff CF';\n  src: url('../fonts/GreycliffCF-Medium.woff') format('woff');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Greycliff CF';\n  src: url('../fonts/GreycliffCF-Regular.woff') format('woff');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Greycliff CF';\n  src: url('../fonts/GreycliffCF-Light.woff') format('woff');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n \n@font-face {\n  font-family: 'Greycliff CF';\n  src: url('../fonts/GreycliffCF-Bold.woff') format('woff');\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n.ant-layout.ant-layout-has-sider {\n  flex-direction: row;\n  color: #2563eb0f !important;\n  height: 100%;\n}\n\nh2.main-center-logo-2 {\n  font-size: 20px;\n  margin: 0;\n}\n\n.layout-dashboard {\n  background: transparent;\n  text-align: left;\n  position: relative;\n  overflow-x: hidden;\n}\n\n.ant-modal-body input::placeholder {\n  /* Was #000000c7 (near-black) — read as bold entered text rather than a\n     hint in every modal form (Add Customer, etc.). Matched to the lighter\n     gray used elsewhere (e.g. the demo password field) for one consistent\n     placeholder color across all modals. */\n  color: #b8bfc7;\n}\n\nform.ant-form.ant-form-vertical.change-pw.main-new-commition-text span.ant-input-affix-wrapper.ant-input-affix-wrapper-has-feedback {\n  border-radius: 10px;\n  border: 2px solid #ddd;\n}\n\n.ant-input-number-affix-wrapper.ant-input-number-affix-wrapper-status-success.ant-input-number-affix-wrapper-has-feedback {\n  width: 100%;\n  border-radius: 10px;\n}\n\n.ant-modal-footer button.ant-btn.ant-btn-default,\n.ant-modal-confirm-btns button.ant-btn.ant-btn-default {\n  background: transparent !important;\n  color: #3B6B94 !important;\n  font-weight: 700 !important;\n}\n\n.ant-drawer-content-wrapper {\n  border-radius: 0px 30px 30px 0px !important;\n  overflow: hidden;\n}\n\nlabel.ant-form-item-required {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n@media (min-width: 992px) {\n  .layout-dashboard {\n    overflow: auto;\n  }\n}\n\n/* .layout-dashboard .ant-layout-sider.sider-primary {\n  width: 280px ;\n  max-width: 280px ;\n  min-width: 280px;\n  position: fixed;\n  left: 0;\n  z-index: 99;\n  height: 100vh;\n  overflow: auto;\n  margin: 0;\n  padding: 33px 20px;\n  border-radius: 0px 67px 67px 0px;\n  overflow-x: hidden !important;\n} */\n.layout-dashboard .ant-layout-sider.sider-primary .brand img {\n  max-width: 150px; \n  width: 100%;\n}\n.notificationDropdownMain button {\n  background-color: transparent !important;\n  padding: 0px;\n  width: 35px;\n  height: 35px !important;\n}\n\n/* .layout-dashboard .ant-layout-sider.sider-primary hr {\n  margin: 0px 0 18px;\n  border: none;\n  height: 1px;\n  background-color: #f5f5f5;\n} */\n.layout-dashboard .ant-layout-sider.sider-primary .brand {\n  text-align: center;\n  font-weight: 600; \n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .brand span {\n  vertical-align: middle;\n  margin-left: 3px;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-layout-sider-children {\n  width: auto;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-inline {\n  border: none;\n}\n\n.layout-dashboard .ant-menu {\n  background: transparent;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-inline .ant-menu-item,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-inline .ant-menu-submenu {\n  margin: 0;\n  overflow: visible;\n}\n\n.toggale-headr {\n  display: flex;\n  align-items: center;\n}\n\n.notification-header button.ant-btn.ant-btn-default {\n  padding: 8px;\n  width: 40px;\n  height: 40px !important;\n  background: #3B6B94 !important;\n}\n\nimg.mian-new-header-logo {\n  width: 100px;\n}\n.ant-btn.ant-btn-link.sidebar-toggler svg {\n  width: 25px;\n  height: 25px;\n}\n\naside.ant-layout-sider.ant-layout-sider-light.sider-primary.ant-layout-sider-primary.visible-class {\n  width: 0px !important;\n  flex: 0px !important;\n  max-width: 0px !important;\n  min-width: 0px !important;\n  display: none;\n}\n\nbutton.ant-btn.ant-btn-link.sidebar-toggler:hover {\n  background: none !important;\n}\n\nbutton.ant-btn.ant-btn-link.sidebar-toggler.ps-0.d-none.d-lg-block:hover {\n  background: none !important;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu {\n  padding: 0 !important;\n  height: auto;\n  line-height: normal;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-inline .ant-menu-item:after,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-inline .ant-menu-submenu:after {\n  display: none;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item.ant-menu-item-selected,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item.ant-menu-item:active,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .ant-menu-submenu-selected,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item.ant-menu-submenu-title:active,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .ant-menu-submenu:active,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu.ant-menu-item-selected,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu.ant-menu-item:active,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu .ant-menu-submenu-selected,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu.ant-menu-submenu-title:active,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu .ant-menu-submenu:active {\n  background-color: transparent;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item.ant-menu-item-selected .active,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .active,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu.ant-menu-item-selected .active,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu .active {\n  font-weight: 700;\n  color: #fff;\n  background: #3B6B94;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .active::after {\n  content: \"\";\n  width: 5px;\n  height: 100%;\n  background-color: #3B6B94;\n  position: absolute;\n  right: 0;\n  border-radius: 0px 10px 10px 0;\n  left: 0;\n}\n\n.icon-box img {\n  width: 20px;\n  height: 20px;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary span.ant-menu-title-content {\n  margin: 0px 15px;\n  border-radius: 8px;\n}\n\n.for-card-title-mian .ant-card-head-title {\n  font-size: 20px;\n  font-weight: 600;\n  padding: 10px 0px !important;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item a,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu a {\n  padding: 6px 16px;\n  color: #000;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  border-bottom: solid 0px #cccccc29;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-primary .ant-menu-item.ant-menu-item-selected .active .icon,\n.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-primary .ant-menu-item .active .icon {\n  background-color: transparent !important;\n}\n\na {\n  color: #2563eb;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item.ant-menu-item-selected .active .icon,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .active .icon,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu.ant-menu-item-selected .active .icon,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu .active .icon {\n  background-color: transparent !important;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .icon,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu .icon {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  border-radius: 6px;\n  justify-content: flex-start;\n  align-items: center;\n  margin-right: 1px;\n  vertical-align: middle;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item.ant-menu-item-selected .active svg path,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .active svg path,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu.ant-menu-item-selected .active svg path,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu .active svg path {\n  fill: #fff;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item svg path,\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu svg path {\n  fill: #bfbfbf;\n}\n\n/* .layout-dashboard .ant-layout-sider.sider-primary .ant-menu-submenu a:hover {\n  color: #ffffff;\n} */\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-inline .ant-menu-item.menu-item-header {\n  padding: 10px 16px !important;\n  color: #8c8c8c;\n  font-weight: 700;\n  font-size: 13px;\n  text-transform: uppercase;\n  display: block;\n}\n\n.menu-item-header:hover {\n  color: inherit;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-zero-width {\n  overflow-x: hidden;\n  width: 210px;\n  margin: 0;\n  padding: 33px 0;\n}\n\n.layout-dashboard.has-sidebar .ant-layout-sider.sider-primary .aside-footer {\n  display: block;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-primary .footer-box {\n  background-color: #2563eb;\n  color: #fff;\n  box-shadow: none;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .footer-box {\n  background-color: #fff;\n  color: #141414;\n  padding: 16px;\n  border-radius: 8px;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n  margin-bottom: 8px;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-primary .footer-box .icon {\n  background-color: #fff;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .footer-box .icon {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);\n  border-radius: 6px;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 15px;\n  background-color: #2563eb;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-primary .footer-box h6 {\n  color: #fff;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .footer-box h6 {\n  font-weight: 600;\n  font-size: 16px;\n  color: #141414;\n  margin-bottom: 0;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-primary .footer-box p {\n  color: #f5f5f5;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .footer-box p {\n  color: #8c8c8c;\n  font-weight: 600;\n}\n\n.ant-menu-sub.ant-menu-inline {\n  padding-left: 24px;\n}\n\n.ant-menu-sub.ant-menu-inline .ant-menu-item .active::after {\n  background: transparent !important;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-primary .footer-box button {\n  background-color: #fff;\n  border-color: #f0f0f0;\n  color: #141414;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .footer-box button {\n  margin: 0;\n}\n\n.ant-btn-sm,\n.ant-radio-group-small .ant-radio-button-wrapper {\n  height: 34px;\n  font-size: 12px;\n  padding: 0 15px;\n}\n\n.ant-btn-sm {\n  border-radius: 4px;\n}\n\n.ant-btn-sm,\n.ant-radio-group-small .ant-radio-button-wrapper {\n  height: 34px;\n  font-size: 12px;\n  padding: 0 15px;\n}\n\n.ant-btn-sm {\n  border-radius: 4px;\n}\n\n.ant-btn,\n.ant-radio-group .ant-radio-button-wrapper {\n  font-weight: 600;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .aside-footer {\n  padding-top: 100px;\n  padding-bottom: 33px;\n}\n\n.ant-menu-inline.ant-menu-root .ant-menu-item,\n.ant-menu-inline.ant-menu-root .ant-menu-submenu-title {\n  display: block;\n}\n\n.ant-layout.ant-layout-has-sider>.ant-layout,\n.ant-layout.ant-layout-has-sider>.ant-layout-content {\n  overflow-x: hidden;\n}\n\n.layout-dashboard .ant-layout {\n  background: transparent;\n  position: relative;\n  min-height: calc(100vh - 0px);\n  width: 100%;\n  flex-shrink: 0;\n  padding-bottom: 35px;\n}\n\n.layout-dashboard .ant-layout-header {\n  background: #ffffff;\n  height: auto;\n  padding: 16px;\n  margin: 0px;\n  line-height: inherit;\n  border-radius: 0px;\n  transition: 0.2s;\n}\n\n.layout-dashboard .ant-breadcrumb>span .ant-breadcrumb-link a {\n  color: #8c8c8c;\n}\n\n.layout-dashboard .ant-breadcrumb>span:last-child .ant-breadcrumb-link {\n  color: #141414;\n}\n\n.layout-dashboard .ant-page-header-heading {\n  margin-top: 0;\n}\n\n.layout-dashboard .ant-page-header-heading .ant-page-header-heading-title {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 20px;\n  margin-top: 4px;\n}\n\n.layout-dashboard .ant-layout-header .ant-row {\n  align-items: center !important;\n  flex-wrap: nowrap !important;\n}\n.layout-dashboard .ant-layout-header .SectionMain {\n  flex-shrink: 0;\n}\n\n.layout-dashboard .header-control {\n  display: flex;\n  align-items: center;\n  margin-top: 0;\n  gap: 12px;\n  justify-content: flex-end;\n  flex-wrap: nowrap;\n  overflow: hidden;\n}\n\ntd.ant-table-cell label.ant-checkbox-wrapper {\n  margin: 0 !important;\n}\n\nbutton.ant-btn.ant-btn-default.ant-dropdown-trigger.notification-box {\n  border-radius: 50% !important;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n}\n\nspan.active_notification.active_notification-999 {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  background: red;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  font-size: 9px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbutton.ant-btn.ant-btn-default.ant-dropdown-trigger.notification-box img {\n  filter: brightness(100);\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown {\n  background: #fff;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n  border-radius: 12px;\n  min-width: 276px;\n  padding: 16px 8px;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown ul.ant-dropdown-menu-items {\n  margin: 0px;\n  padding: 0px;\n}\n\n.ant-dropdown.ant-dropdown-placement-bottomRight {\n  min-width: inherit !important;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown .ant-list-item {\n  padding: 5px 16px;\n  margin-bottom: 8px;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown .ant-avatar {\n  width: 36px;\n  height: 36px;\n  background-color: #fafafa;\n  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown .ant-list-item-meta-title {\n  line-height: normal;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdownt .ant-list-item-meta-description {\n  color: #8c8c8c;\n  font-size: 12px;\n  line-height: 12px;\n  font-weight: 600;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown .ant-list-item-meta-description svg {\n  width: 14px;\n  height: 14px;\n  fill: #8c8c8c;\n  vertical-align: middle;\n  margin-right: 4px;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown .ant-list-item-meta-description svg path {\n  fill: #8c8c8c;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown .ant-list-item-meta-description span {\n  vertical-align: middle;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown .ant-avatar .ant-avatar-string {\n  top: 6px;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.header-notifications-dropdown .ant-avatar .ant-avatar-string svg {\n  width: 22px;\n  height: 22px;\n}\n\n.h3,\n.h4,\nh3,\nh4 {\n  font-weight: 700;\n  color: #141414;\n}\n\n.ant-list-item-meta-title>a {\n  color: rgba(0, 0, 0, 0.65);\n  transition: all 0.3s;\n}\n\n.ant-list-item-meta-title {\n  margin-bottom: 4px;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  line-height: 22px;\n}\n\n.layout-dashboard .header-control .ant-btn-link {\n  height: auto;\n  padding: 0 7px;\n  margin: 0;\n  box-shadow: none;\n  color: #8c8c8c;\n  line-height: normal;\n  border: none !important;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-layout-sider-children {\n  overflow: auto;\n  overflow-x: hidden;\n  width: auto;\n}\n\n.ant-btn svg {\n  margin-right: 5px;\n}\n\n.layout-dashboard .header-control svg {\n  width: 13px;\n  height: 13px;\n}\n\n.layout-dashboard .header-control svg path {\n  fill: #141414;\n}\n\n.layout-dashboard .header-control .btn-sign-in {\n  height: auto;\n  padding: 0 7px;\n  margin: 0;\n  box-shadow: none;\n  color: #8c8c8c;\n}\n\n.layout-dashboard .header-control .btn-sign-in svg {\n  margin-right: 4px;\n}\n\n.layout-dashboard .header-control svg {\n  vertical-align: middle;\n}\n\n.layout-dashboard .header-control .header-search {\n  width: 213px;\n  margin: 0 7px 0 0;\n  border-radius: 6px;\n  height: 40px;\n  border: 1px solid #d9d9d9;\n}\n\n.layout-dashboard .header-control .anticon.anticon-search svg {\n  width: 16px;\n  height: 16px;\n}\n\n.layout-dashboard .header-control .header-search svg path {\n  fill: #8c8c8c;\n}\n\n.settings-drawer .drawer-content>hr {\n  margin: 18px 0;\n  border: none;\n  height: 1px;\n  background-color: #f5f5f5;\n}\n\n.ant-layout-sider-children hr {\n  margin: 0px 0px 18px !important;\n  border: none;\n  height: 1px;\n  background-color: #f5f5f5;\n}\n\n.settings-drawer .drawer-content>h6 {\n  font-size: 20px;\n  margin-bottom: 0;\n}\n\n.layout-dashboard .settings-drawer .drawer-content h6 {\n  font-weight: 600;\n  color: #141414;\n}\n\n.settings-drawer .drawer-content p {\n  color: #8c8c8c;\n}\n\np {\n  font-size: 14px;\n}\n\n.settings-drawer .drawer-content .sidebar-color h6 {\n  margin-bottom: 8px;\n}\n\n.h6,\nh6 {\n  font-size: 16px;\n}\n\n.drawer-sidebar .ant-drawer-body {\n  padding: 0px;\n}\n\n.drawer-sidebar .ant-drawer-body aside.ant-layout-sider.ant-layout-sider-light.sider-primary.ant-layout-sider-primary {\n  margin: 0px;\n}\n\n.layout-dashboard .header-control .header-search .ant-input-suffix .ant-input-search-icon.anticon-loading,\n.layout-dashboard .header-control .sidebar-toggler {\n  display: block;\n}\n\n.layout-dashboard .header-control .btn-sign-in span {\n  font-weight: 600;\n  vertical-align: middle;\n  display: none;\n}\n\n/* Old css start */\n.site-layout-background {\n  background: transparent;\n}\n\nheader.ant-layout-header.subheader {\n  background: transparent;\n}\n\n.sidemenu {\n  margin-top: 20px;\n  margin-left: 20px;\n}\n\n.logo img {\n  width: 32px;\n  margin-right: 10px;\n}\n\n.logo {\n  margin-bottom: 15px;\n}\n\n.logo span {\n  font-size: 16px;\n  font-weight: 600;\n}\n\nhr.horizontal.dark {\n  background-image: linear-gradient(90deg,\n      transparent,\n      rgb(0 0 0 / 12%),\n      transparent);\n  border: 0px;\n}\n\nhr.horizontal {\n  background-color: transparent;\n}\n\nhr:not([size]) {\n  height: 1px;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav {\n  background: transparent;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li {\n  padding: 10px 16px !important;\n  height: auto;\n  line-height: normal;\n  margin: 0px;\n  border: 0px;\n  font-size: 16px;\n  color: #141414;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li.ant-menu-item-selected {\n  box-shadow: 0px 20px 27px #0000000d;\n  border-radius: 8px;\n  background: #fff;\n  border: 0px;\n  font-weight: 600;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li.ant-menu-item-selected {\n  box-shadow: 0px 20px 27px #0000000d;\n  border-radius: 8px;\n  background: #fff;\n  border: 0px;\n  font-weight: 600;\n}\n\n.ant-menu-inline.ant-menu-root .ant-menu-item>.ant-menu-title-content,\n.ant-menu-inline.ant-menu-root .ant-menu-submenu-title>.ant-menu-title-content {\n  flex: auto;\n  min-width: 0;\n  overflow: visible;\n  text-overflow: ellipsis;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li::after {\n  display: none;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li span.anticon {\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n  background: #fff;\n  box-shadow: 0px 4px 6px #0000001f;\n  border-radius: 6px;\n  font-size: 16px;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li.ant-menu-item-selected span.anticon {\n  background: #2563eb;\n  color: #fff;\n}\n\n/* ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li:hover {\n  box-shadow: 0px 20px 27px #0000000d;\n  border-radius: 8px;\n  background: #fff;\n  border: 0px;\n  font-weight: 600;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav\n  li:hover\n  span.anticon {\n  background: #2563eb ;\n  color: #fff;\n} */\n\n.divder {\n  display: table;\n  width: 100%;\n  padding: 10px 15px;\n  color: #8c8c8c;\n  font-weight: 600;\n  margin: 15px 0px;\n}\n\n.ant-card.ant-card-bordered.documentation-card {\n  border: 0px;\n  box-shadow: 0px 20px 27px #0000000d;\n  border-radius: 8px;\n  background: #fff;\n}\n\n.p-15 {\n  padding: 15px;\n}\n\n.card-document {\n  width: 32px;\n  height: 32px;\n  text-align: center;\n  box-shadow: 0px 4px 6px #0000001f;\n  border-radius: 6px;\n  font-size: 19px;\n  background: #2563eb;\n  color: #fff;\n  direction: ltr;\n  margin-bottom: 15px;\n}\n\n.documentation-card h4 {\n  margin: 0px;\n}\n\n.left-nav {\n  /* height: 435px;\n  overflow: hidden;\n  overflow-y: auto;\n  padding-right: 15px; */\n\n  margin-top: 15px;\n}\n\n.ant-layout.ant-layout-has-sider {\n  background: #f3f2f7 !important;\n}\n\n.pageheader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.rightside-top {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: normal;\n}\n\n.signin {\n  white-space: nowrap;\n  margin: 0px 20px;\n}\n\n.signin span.ant-avatar {\n  margin-right: 9px;\n}\n\n.shadow-lg {\n  box-shadow: 0 8px 26px -4px hsla(0, 0%, 8%, 0.15),\n    0 8px 9px -5px hsla(0, 0%, 8%, 0.06) !important;\n}\n\n.ant-menu-inline,\n.ant-menu-vertical,\n.ant-menu-vertical-left {\n  border: 0px;\n}\n\n.header-top h4 {\n  margin: 0px;\n  font-size: 20px;\n}\n\n.header-top .subtitle {\n  display: block;\n  font-weight: normal;\n  color: #8c8c8c;\n  font-size: 14px;\n}\n\n.header-top {\n  margin-top: -10px;\n}\n\n.ant-drawer.ant-drawer-right.ant-drawer-open.colorside button.ant-drawer-close {\n  color: #000;\n}\n\n.header-top {\n  border-bottom: 1px solid rgb(140 140 140 / 7%);\n  padding-bottom: 15px;\n}\n\n.rightside-top span.ant-input-affix-wrapper {\n  border-radius: 4px;\n}\n\n.rightside-top span.ant-input-affix-wrapper span.ant-input-prefix {\n  color: #c0c0c0;\n}\n\n.setting button.ant-btn {\n  padding: 0px;\n  line-height: normal;\n  background: transparent;\n  border: 0px;\n  box-shadow: none;\n}\n\nbutton.ant-btn.bell {\n  padding: 0px;\n  border: 0px;\n  background: transparent;\n  box-shadow: none;\n  position: relative;\n}\n\nbutton.ant-btn.bell strong {\n  position: absolute;\n  top: -1px;\n  right: -5px;\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: #f5222d;\n  border-radius: 100%;\n  text-align: center;\n  line-height: normal;\n  font-weight: normal;\n  color: #fff;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.list-notifaction {\n  width: 336px;\n}\n\n.list-notifaction ul {\n  padding: 5px 10px;\n  margin: 0px;\n}\n\n.list-notifaction ul li {\n  display: block;\n  width: 100%;\n\n  clear: both;\n  font-weight: 400;\n  color: #67748e;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n\n.list-notifaction ul li a {\n  display: block;\n  padding: 10px;\n  border-radius: 8px;\n}\n\n.list-notifaction ul li a:hover {\n  color: #252f40;\n  background-color: #e9ecef;\n}\n\n.list-notifaction ul span.ant-avatar.ant-avatar-image {\n  width: 48px;\n  height: 48px;\n  border-radius: 0.75rem;\n}\n\n.list-notifaction ul li {\n  padding: 0px;\n}\n\n.ant-dropdown-menu.ant-dropdown-menu-split.list-notifaction {\n  border-radius: 0.75rem;\n}\n\n.list-notifaction .ant-list-item-meta-title {\n  font-weight: bold;\n  color: #141414;\n}\n\n.list-notifaction .ant-list-item-meta-title {\n  font-weight: bold;\n  color: #141414;\n}\n\n.list-notifaction .ant-avatar.ant-avatar-circle {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.list-notifaction ul li a span.ant-avatar-string {\n  line-height: normal;\n}\n\n.bnb2 {\n  color: #52c41a;\n  font-weight: 700;\n}\n\n.ant-card.criclebox {\n  box-shadow: 0px 20px 27px #0000000d;\n  border-radius: 12px;\n}\n\n.number span {\n  font-weight: 600;\n  color: #8c8c8c;\n  font-size: 16px;\n}\n\n.dashboard-card {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dashboard-card .cust_col {\n  flex: 0 0 calc(100% / 7 - 0px);\n  padding: 0 10px;\n}\n\n.dashboard-card .cust_col h3.ant-typography {\n  font-size: 14px;\n}\n\n.dashboard-card .cust_col .ant-card.criclebox {\n  height: 100%;\n}\n\n.dashboard-card .cust_col .ant-card.criclebox .ant-card-body {\n  height: 100%;\n}\n\n.dashboard-card .cust_col .ant-card.criclebox .number .ant-row.ant-row-middle {\n  margin: 0 !important;\n}\n\n.dashboard-card .cust_col .ant-card.criclebox .number .ant-row.ant-row-middle .ant-col {\n  padding: 0 !important;\n}\n\n.number h3 {\n  font-weight: 700 !important;\n  margin-bottom: 0px !important;\n  font-size: 30px !important;\n}\n\n.number h3 small {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n/* ── Stat-card icon — absolute circle, top-right corner ── */\n.number-dash-count {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n}\n.number-dash-count .number { width: 100%; }\n\n.icon-box {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  width: 42px;\n  height: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: #E8F0F7;\n  overflow: hidden;\n  box-sizing: border-box;\n  flex-shrink: 0;\n}\n.icon-box .anticon { font-size: 17px; line-height: 1; display: flex; align-items: center; justify-content: center; color: #3B6B94; pointer-events: none; }\n.icon-box svg { width: 17px !important; height: 17px !important; display: block; flex-shrink: 0; }\n\n/* Per-card colours */\n.card-0 .icon-box { background: #E8F0F7; } .card-0 .icon-box .anticon { color: #3B6B94; }\n.card-1 .icon-box { background: #E6F4FF; } .card-1 .icon-box .anticon { color: #1677FF; }\n.card-2 .icon-box { background: #FFF7E6; } .card-2 .icon-box .anticon { color: #FA8C16; }\n.card-3 .icon-box { background: #F6FFED; } .card-3 .icon-box .anticon { color: #52C41A; }\n.card-4 .icon-box { background: #F9F0FF; } .card-4 .icon-box .anticon { color: #722ED1; }\n.card-5 .icon-box { background: #FFF1F0; } .card-5 .icon-box .anticon { color: #F5222D; }\n\n/* Card container — anchor for icon + hide overflow */\n.ant-card.criclebox.count-card {\n  box-shadow: 6px 6px 54px 0px #0000000D !important;\n  border: 0px !important;\n  overflow: hidden !important;\n}\n.ant-card.criclebox.count-card .ant-card-body {\n  padding: 20px 30px !important;\n  overflow: hidden !important;\n  position: relative !important;\n}\n\n/* Breakdown text stays on one line */\n.dashboard-count-breakdown {\n  color: #6b7280;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1.35;\n  margin-top: 3px;\n  white-space: nowrap;\n  overflow: visible;\n}\n\n.icon-box-text_mainhh .ant-card-body {\n  padding: 12px !important;\n}\n\n.icon-box-text_mainhh .number {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.listpage {\n  padding-top: 15px;\n}\n\n.bar-chart {\n  background: transparent linear-gradient(62deg, #00369e 0%, #005cfd 53%, #a18dff 100%) 0% 0% no-repeat padding-box;\n  box-shadow: 0px 4px 6px #0000001f;\n\n  border-radius: 8px;\n}\n\n.chart-vistior {\n  margin-top: 30px;\n}\n\n.chart-vistior h5 {\n  margin: 0px;\n  font-weight: 700;\n}\n\n.ant-typography.lastweek {\n  color: #8c8c8c;\n  font-weight: 600;\n}\n\n.chart-visitor-count h4 {\n  margin: 0px;\n  font-weight: 700;\n}\n\n.chart-visitor-count span {\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: 600;\n}\n\n.linechart h5 {\n  font-weight: 700;\n  margin: 0px;\n}\n\n.linechart {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sales ul {\n  margin: 0px;\n  padding: 0px;\n  list-style: none;\n}\n\n.sales ul li:first-child span.anticon {\n  color: #b37feb;\n}\n\n.sales ul li:last-child span.anticon {\n  color: #2563eb;\n}\n\n.sales ul li {\n  color: #8c8c8c;\n  margin-bottom: 3px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.project-ant h4 {\n  margin: 0px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #141414;\n}\n\nspan.blue {\n  margin-left: 5px;\n  color: #2563eb;\n  font-weight: 600;\n}\n\n.project-ant h5 {\n  margin: 0px;\n  color: #141414;\n  font-weight: 700;\n}\n\nspan.blue {\n  margin-left: 5px;\n  color: #2563eb;\n  font-weight: 600;\n}\n\n.project-ant {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.antd-pro-pages-dashboard-analysis-style-salesExtra a {\n  display: inline-block;\n  padding: 7px 10px;\n  color: #595959;\n  border: 1px solid #d9d9d9;\n  text-align: center;\n  border-right: 1px solid transparent;\n}\n\n.antd-pro-pages-dashboard-analysis-style-salesExtra a:last-child {\n  border-right: 1px solid #d9d9d9;\n  border-radius: 0px 5px 5px 0px;\n}\n\n.antd-pro-pages-dashboard-analysis-style-salesExtra a:first-child {\n  border-radius: 5px 0px 0px 5px;\n}\n\n.antd-pro-pages-dashboard-analysis-style-salesExtra a:hover {\n  color: #2563eb;\n  border: 1px solid #2563eb;\n}\n\n.antd-pro-pages-dashboard-analysis-style-salesExtra a.active {\n  color: #2563eb;\n  border: 1px solid #2563eb;\n}\n\n.ant-list-box th {\n  text-align: left;\n  border-bottom: 1px solid #0000000d;\n  padding: 8px 0px;\n  color: #8c8c8c;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.ant-list-box td {\n  text-align: left;\n  border-bottom: 1px solid #0000000d;\n  padding: 16px 25px;\n  white-space: nowrap;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  border-radius: 7px;\n  box-shadow: 0 0 9px #cccccc85;\n  background-color: #ffffff;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.me-3 {\n  margin-right: 1rem !important;\n}\n\n.tootip-img {\n  width: 24px;\n  height: 24px;\n  border-radius: 100%;\n  border: 1px solid #fff;\n  position: relative;\n  z-index: 2;\n  cursor: pointer;\n}\n\n.avatar-group .tootip-img+.tootip-img {\n  margin-left: -10px;\n}\n\n.tootip-img:hover {\n  z-index: 3;\n  cursor: pointer;\n}\n\n.title-box h5 {\n  margin: 0px;\n}\n\n.text-xs {\n  color: #8c8c8c;\n}\n\n.percent-progress span.ant-progress-text {\n  display: flex;\n  margin-top: -27px;\n  color: #8c8c8c;\n  position: relative;\n  margin-left: 0px;\n}\n\n/* .percent-progress .ant-progress-outer {\n  margin-right: 0px;\n  padding-right: 0px;\n} */\n\n.percent-progress .ant-progress-status-exception .ant-progress-text {\n  color: #ff4d4f;\n}\n\n.ant-full-box {\n  width: 100%;\n  border: 1px dashed #d9d9d9;\n  padding: 10px;\n  height: auto;\n  color: #141414;\n  border-radius: 10px;\n}\n\n.uploadfile {\n  margin-top: 15px;\n}\n\n.uploadfile .ant-upload.ant-upload-select {\n  display: block;\n}\n\n.ant-timeline-item-tail {\n  left: 7px;\n}\n\n.ant-list-box h5 {\n  font-size: 14px;\n}\n\n.timeline-box h5 {\n  margin-bottom: 0px;\n  font-weight: 700;\n}\n\n.timelinelist h5 {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.timelinelist span {\n  color: #8c8c8c;\n  font-size: 12px;\n}\n\n.ant-muse span {\n  color: #8c8c8c;\n  font-weight: 600;\n}\n\n.ant-muse h5 {\n  margin: 0px 0px 15px !important;\n  font-size: 20px;\n}\n\n.bg-gradient-primary {\n  background-image: linear-gradient(310deg, #2152ff, #21d4fd);\n}\n\nimg {\n  max-width: 100%;\n}\n\n.border10 {\n  border-radius: 10px;\n}\n\n.py-4 {\n  padding: 20px;\n}\n\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n.icon-move-right .anticon-right {\n  color: #40a9ff;\n  margin-left: 2px;\n}\n\n.icon-move-right {\n  color: #2563eb;\n\n  display: block;\n}\n\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.gradent {\n  background: url(\"../images/info-card-2.jpg\") no-repeat center top;\n  background-size: cover;\n  padding: 15px;\n  border-radius: 15px;\n  color: #fff;\n}\n\n.gradent h5 {\n  color: #fff;\n}\n\n.gradent .ant-typography {\n  color: #fff;\n  font-size: 20px;\n}\n\n.gradent .icon-move-right {\n  color: #fff;\n}\n\n.gradent .icon-move-right .anticon-right {\n  color: #fff;\n}\n\n.copyright {\n  color: #8c8c8c;\n  margin: 6px 0;\n  text-align: center;\n}\n\n.copyright .anticon-heart {\n  color: #f5222d;\n  margin: 0px 5px;\n}\n\n.copyright a {\n  margin: 0px 5px;\n  color: #141414;\n  font-weight: 700;\n}\n\n.footer-menu ul {\n  margin: 0px;\n  padding: 0px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.footer-menu ul li {\n  list-style: none;\n}\n\n.footer-menu ul li a {\n  padding: 0.5rem 1rem;\n  display: block;\n  color: #8c8c8c;\n}\n\nspan.ismobile {\n  display: none;\n  margin-right: 15px;\n  cursor: pointer;\n}\n\n@media (max-width: 992px) {\n  .footer-menu ul {\n    justify-content: center;\n  }\n\n  footer.ant-layout-footer {\n    padding: 0px 15px;\n    text-align: center;\n  }\n\n  .project-ant {\n    display: block;\n  }\n\n  .ant-filtertabs {\n    text-align: right;\n  }\n\n  .rightside-top span.ant-input-affix-wrapper {\n    width: 200px;\n  }\n\n  .rightside-top {\n    justify-content: flex-end;\n  }\n\n  header.ant-layout-header.subheader {\n    padding: 0px 24px 0px 0px;\n  }\n\n  main.ant-layout-content.content-ant {\n    padding-left: 0px !important;\n  }\n\n  span.ismobile {\n    display: inline-block;\n  }\n\n  .bar-chart {\n    width: 100% !important;\n    max-width: 100%;\n  }\n\n  .full-width {\n    max-width: 100% !important;\n  }\n\n  .bar-chart {\n    width: 100% !important;\n  }\n\n  .icon-move-right {\n    margin-bottom: 15px;\n  }\n\n  .pageheader {\n    display: block;\n  }\n\n  .ant-cret img {\n    width: 100%;\n    height: 300px;\n    object-fit: cover;\n  }\n}\n\n.sidebar-color {\n  padding: 1.5rem 0px;\n}\n\n.theme-color button {\n  margin-right: 8px;\n  border: 0px;\n  width: 20px !important;\n  height: 20px !important;\n  padding: 0px;\n  box-shadow: none;\n  visibility: visible !important;\n  line-height: 20px !important;\n}\n\n.theme-color button:focus {\n  box-shadow: none;\n  border-color: transparent;\n}\n\n.theme-color button span {\n  opacity: 0;\n}\n\n.mb-2 {\n  margin-bottom: 25px;\n}\n\n.sidebarnav-color button {\n  width: 100%;\n  margin-right: 10px;\n  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 9%), 0 2px 3px -1px rgb(0 0 0 / 7%);\n  height: 40px;\n}\n\n.sidebarnav-color h5 {\n  margin: 0px;\n}\n\n.sidebarnav-color span.ant-typography {\n  color: #8c8c8c;\n}\n\n.sidebarnav-color .trans {\n  margin-top: 1rem;\n  display: flex;\n}\n\n.sidebarnav-color button:last-child {\n  margin-right: 0px;\n}\n\n.ant-docment button {\n  width: 100%;\n  margin-bottom: 10px;\n  border-radius: 5px;\n}\n\n.viewstar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 15px;\n}\n\n.viewstar a {\n  display: inline-block;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 16px;\n  border-radius: 0em 0.25em 0.25em 0em;\n  border: 1px solid #ddddde;\n  border-left: 0px;\n  color: #141414;\n}\n\n.viewstar a:first-child {\n  color: #24292e;\n  background-color: #eff3f6;\n  border-color: #cfd3d6;\n  background-image: linear-gradient(180deg, #fafbfc, #eff3f6 90%);\n  border-radius: 0.25em 0 0 0.25em;\n  border-left: 1px solid #ddddde;\n}\n\n.social {\n  text-align: center;\n  margin-top: 25px;\n}\n\n.social button {\n  margin: 0px 5px;\n  display: inline-flex;\n  align-items: center;\n}\n\n.ant-thank {\n  text-align: center;\n  margin-top: 25px;\n}\n\n.setting-drwer {\n  background: #fff;\n  border-radius: 50%;\n  bottom: 42px;\n  right: 30px;\n  font-size: 1.25rem;\n  z-index: 990;\n  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 16%);\n  width: 52px;\n  height: 52px;\n  text-align: center;\n  line-height: 60px;\n  position: fixed;\n  cursor: pointer;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li:active {\n  background: transparent;\n}\n\n.rightside-top .ant-input {\n  height: 30px;\n}\n\n.aside-footer {\n  padding-top: 100px;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li svg path {\n  color: #bfbfbf;\n}\n\n.cardbody .ant-card-body {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n.ant-card.criclebox .project-ant {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.ant-card.criclebox table th {\n  padding-left: 24px;\n  padding-right: 24px;\n  padding-top: 14px;\n  padding-bottom: 14px;\n  text-transform: capitalize;\n}\n\n/* The row-selection checkbox column (BrandManager.js's bulk-select,\n   #bm-staff-table-card) inherits that same 24px left/right padding from\n   the rule above — on an ~18px checkbox that reads as its own wide column\n   instead of a small checkbox tucked next to the Staff avatar. Two earlier\n   attempts at this (a plain \".ant-table-selection-column\" class selector,\n   then a \".bm-staff-table\"-scoped class-chain selector) both LOST to other\n   !important rules elsewhere in this file that happened to chain more\n   classes together — class-selector specificity fights are fragile since\n   any other rule can always out-chain another class selector. An #id\n   selector is immune to that: by the CSS spec an id beats ANY number of\n   chained classes, so this is guaranteed to win regardless of what else\n   exists in this file, now or added later. `#bm-staff-table-card` is set\n   only on this one Card (id=\"bm-staff-table-card\" in BrandManager.js).\n   Belt-and-braces: also sets the actual <col> width antd computes column\n   sizing from (.ant-table-selection-col), not just cell padding — a narrow\n   padding alone can still leave the column wider than its content if\n   something else is driving col width. */\n#bm-staff-table-card .ant-table-selection-col {\n  width: 32px !important;\n  min-width: 32px !important;\n}\n#bm-staff-table-card .ant-table-thead > tr > th:first-child,\n#bm-staff-table-card .ant-table-tbody > tr > td:first-child {\n  width: 32px !important;\n  min-width: 32px !important;\n  max-width: 32px !important;\n  padding: 14px 8px !important;\n  text-align: center !important;\n}\n\n/* Same fix, same reason, second table — User.js's Client table (bulk-select\n   added per direct request: \"put that checkbox on clients also like we\n   have on brands\"). Without this it inherits the exact same wide\n   .ant-card.criclebox table th padding the comment above explains, so the\n   checkbox column read just as oversized here as it did on Staff before\n   that fix. `#cm-clients-table-card` is set only on this one Card\n   (id=\"cm-clients-table-card\" in User.js). */\n#cm-clients-table-card .ant-table-selection-col {\n  width: 32px !important;\n  min-width: 32px !important;\n}\n#cm-clients-table-card .ant-table-thead > tr > th:first-child,\n#cm-clients-table-card .ant-table-tbody > tr > td:first-child {\n  width: 32px !important;\n  min-width: 32px !important;\n  max-width: 32px !important;\n  padding: 14px 8px !important;\n  text-align: center !important;\n}\n\n.ant-card.criclebox table th .ant-table-filter-trigger {\n  color: #fff !important;\n}\n\n/* Tables with a light header (Customer Management in User.js, Brand\n   Manager/Strategist in BrandManager.js — both tagged with the\n   `customer-table` class) have the shared white filter-icon rule above\n   make the funnel icon invisible. Scoped override back to AntD's normal\n   grey, only for tables opted into this class. */\n.ant-card.criclebox.customer-table table th .ant-table-filter-trigger {\n  color: rgba(0, 0, 0, 0.45) !important;\n}\n.ant-card.criclebox.customer-table table th .ant-table-filter-trigger:hover {\n  color: #1890ff !important;\n}\n.ant-card.criclebox.customer-table table th .ant-table-filter-trigger.active {\n  color: #1890ff !important;\n}\n\n/* Same white-icon-on-white-header problem, same fix — Graphics/Blog Write\n   Requests tables (CreateGraphicsRequest.js, GraphicsOversight.js,\n   CreateBlogWriteRequest.js, BlogWriteOversight.js) also have a light\n   header and are tagged \"tablespace\", not \"customer-table\", so the shared\n   \".criclebox table th .ant-table-filter-trigger { color: #fff }\" rule\n   above was making their new filter funnel icons invisible — present and\n   clickable, just rendered white-on-white. */\n.ant-card.criclebox.tablespace table th .ant-table-filter-trigger {\n  color: rgba(0, 0, 0, 0.45) !important;\n}\n.ant-card.criclebox.tablespace table th .ant-table-filter-trigger:hover {\n  color: #1890ff !important;\n}\n.ant-card.criclebox.tablespace table th .ant-table-filter-trigger.active {\n  color: #1890ff !important;\n}\n\n.percent-progress .ant-progress-bg {\n  height: 3px !important;\n}\n\n.uploadfile {\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.ant-card.tablespace .ant-card-body {\n  padding: 15px;\n}\n.active-feed-listing li {\n  list-style: none;\n  display: flex;\n  align-items: flex-start;\n  gap: 15px;\n  background: #f3f2f7;\n  margin-bottom: 10px;\n  border-radius: 10px;\n  padding: 10px;\n}\n.active-feed-listing ul{\n  padding: 0px !important;\n}\n.main-new-food-cart-header-nothidhi {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1e232c !important;\n  line-height: 20px;\n}\n\nli.ant-list-item.remamber-main.Notification-read .ant-list-item-meta-avatar img {\n  width: 60px;\n  height: 60px;\n}\n\n.main-time-for998 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.main-time-for998 h6 {\n  font-size: 14px;\n  color: #686868;\n  line-height: 20px;\n  margin: 0;\n  font-weight: 600;\n}\n\n.main-delete-out {\n  width: 32px;\n  height: 32px;\n  background: #3B6B94;\n  border-radius: 5px 0 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n\n.ant-list-item-meta-description {\n  font-size: 15px;\n  font-weight: 600;\n  color: #686868;\n  line-height: 18px;\n}\n\nli.ant-list-item.remamber-main {\n  border-radius: 14px;\n  padding: 12px;\n  box-shadow: 8px 8px 32px 0px #0000000d;\n  border: 1px solid #e8ecf4 !important;\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 10px;\n}\n\n.tablespace .ant-card-head-title {\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.ant-radio-button-wrapper:first-child {\n  border-radius: 4px 0 0 4px;\n}\n\n.ant-radio-button-wrapper:last-child {\n  border-radius: 0 4px 4px 0;\n}\n\nul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light.left-nav li.ant-menu-item-selected path {\n  color: #fff;\n}\n\n.ant-avatar-group .ant-avatar-square {\n  border-radius: 4px;\n}\n\n.shape-avatar {\n  margin-right: 20px;\n}\n\n.shape-avatar img {\n  border-radius: 4px;\n}\n\n.avatar-info h5 {\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 14px;\n  margin-bottom: 3px;\n}\n\n.avatar-info p {\n  font-size: 14px;\n  font-weight: 400;\n  color: #8c8c8c;\n  margin: 0px;\n}\n\n.ant-table-tbody>tr>td h5 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #141414;\n  margin-bottom: 0px;\n}\n\n.ant-table-tbody>tr>td p {\n  font-size: 14px;\n  color: #8c8c8c;\n  margin: 0px;\n}\n\n.tag-primary {\n  border-radius: 6px;\n  padding: 2px 12px;\n  font-size: 14px;\n  height: auto;\n  line-height: 24px;\n  font-weight: 600;\n}\n\n.ant-employed {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 500;\n  color: #8c8c8c;\n}\n\n.ant-employed a {\n  color: #8c8c8c;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.tag-badge {\n  border-radius: 6px;\n  padding: 2px 12px;\n  font-size: 14px;\n  height: auto;\n  line-height: 24px;\n  font-weight: 600;\n  background: #8c8c8c;\n  color: #fff;\n  outline: none;\n}\n\n.tag-badge:hover {\n  background: #8c8c8c;\n  color: #fff;\n  border-color: #8c8c8c;\n  opacity: 0.9;\n}\n\n.ant-avatar-group {\n  align-items: center;\n}\n\n.mb-24 {\n  margin-bottom: 24px;\n}\n\n.ant-table-thead>tr>th {\n  color: #8c8c8c;\n  font-weight: 700;\n  background-color: transparent;\n  font-size: 12px;\n}\n\n.ant-border-space th:before {\n  display: none;\n}\n\n.ant-table-tbody>tr>td,\n.ant-table-thead>tr>th {\n  padding: 16px 25px !important;\n}\n\n.tablespace {\n  overflow: hidden;\n}\n\n/* Customer Management table — tighter row padding than the site-wide\n   default. That default (16px 25px) is generous for tables with 1-2 lines\n   of dense content per cell; this table has many mostly-empty/short cells\n   (single tags, \"N/A\"s) across a lot of columns, so the same padding reads\n   as excess whitespace rather than breathing room. Scoped to .customer-table\n   (not the shared rule above) so no other table's spacing is affected. */\n.customer-table .ant-table-tbody>tr>td,\n.customer-table .ant-table-thead>tr>th {\n  padding: 10px 16px !important;\n}\n\n/* AntD renders a hidden \"measure row\" (ant-table-measure-row) to calculate\n   column widths — normally zero-height/invisible, but the !important\n   padding above (and the later, higher-specificity padding rule further\n   down this file) apply to it too, giving it real height and exposing it\n   as a blank white bar between the header and the first real row. */\n.customer-table .ant-table-measure-row,\n.customer-table .ant-table-measure-row > td,\n.ant-card.criclebox.customer-table .ant-table-measure-row,\n.ant-card.criclebox.customer-table .ant-table-tbody > tr.ant-table-measure-row > td {\n  height: 0 !important;\n  padding: 0 !important;\n  border: none !important;\n  line-height: 0 !important;\n}\n\n/* Center every column heading (title + sort arrows + filter icon all move\n   together as one inline group — AntD lays these out as flex children of\n   the header cell, so centering the cell centers the whole group). */\n.customer-table .ant-table-thead>tr>th {\n  text-align: center;\n}\n.customer-table .ant-table-thead>tr>th .ant-table-column-sorters {\n  justify-content: center;\n}\n\n/* Associated Staff column — role-tagged BM/BS rows. Fixed-width badges so\n   both rows' names start at the same x position regardless of \"BM\" vs \"BS\"\n   rendering slightly differently, and brand palette (steel blue / turquoise)\n   instead of generic antd tag colors so it reads as part of this app rather\n   than a default component. */\n.staff-role-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.staff-role-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.staff-role-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 20px;\n  flex-shrink: 0;\n  border-radius: 6px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n}\n.staff-role-badge-bm {\n  background: rgba(59, 107, 148, 0.12);\n  color: #3b6b94;\n}\n.staff-role-badge-bs {\n  background: rgba(24, 82, 80, 0.12);\n  color: #185250;\n}\n.staff-role-name {\n  font-size: 13px;\n  color: #334155;\n}\n\n.ant-table.ant-table-middle .ant-table-title,\n.ant-table.ant-table-middle .ant-table-footer,\n.ant-table.ant-table-middle .ant-table-thead>tr>th,\n.ant-table.ant-table-middle .ant-table-tbody>tr>td,\n.ant-table.ant-table-middle tfoot>tr>th,\n.ant-table.ant-table-middle tfoot>tr>td {\n  padding: 16px 25px;\n}\n\n.avatar-sm {\n  width: 25px;\n}\n\n.ant-progress-project {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.ant-progress-project .ant-progress-outer {\n  float: right;\n}\n\n.ant-progress-project .ant-progress-text {\n  margin: 0px 0px 0px 0px;\n  color: #8c8c8c;\n  font-weight: 600;\n}\n\n.semibold {\n  font-weight: 600;\n  color: #8c8c8c;\n}\n\n.text-sm {\n  font-size: 12px;\n  color: #8c8c8c;\n  font-weight: 600;\n}\n\n.ant-progress-project .ant-progress {\n  margin-right: 15px;\n}\n\n.semibold {\n  font-weight: 600;\n  color: #8c8c8c;\n}\n\n.text-sm {\n  font-size: 12px;\n  color: #8c8c8c;\n  font-weight: 600;\n}\n\n.ant-progress-project .ant-progress-bg {\n  height: 3px !important;\n}\n\n.ant-table-tbody>tr>td,\n.ant-table-thead>tr>th {\n  white-space: nowrap;\n}\n\n.h-full {\n  height: 100%;\n}\n\n@media (min-width: 1200px) {\n  .ant-col.col-img img {\n    height: 196px;\n  }\n\n  /* .bar-chart {\n    max-width: 438px;\n  } */\n  /* .full-width {\n    max-width: 658px;\n  } */\n}\n\n@media (max-width: 1024px) {\n  .bar-chart {\n    max-width: 100%;\n  }\n\n  .full-width {\n    max-width: 100%;\n  }\n\n  /* .ant-col.mobile-24 {\n    margin-bottom: 24px;\n  } */\n}\n\n/* \nbody {\n  overflow: visible !important;\n  width: 100% !important;\n} */\n\n.card-info-2 .ant-card-body {\n  height: 100%;\n}\n\n.col-content {\n  flex-grow: 1;\n  padding: 24px;\n  margin-right: 0;\n  border-radius: 8px;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.card-content p {\n  font-size: 16px;\n}\n\n.ant-layout-footer {\n  padding: 0px 50px;\n}\n\n/* sign up start */\n.layout-default.ant-layout.layout-sign-up header.ant-layout-header {\n  background-color: transparent;\n  color: #fff;\n  margin: 0;\n  padding: 0 20px;\n  z-index: 1;\n}\n\n.layout-default .ant-layout-header {\n  display: flex;\n}\n\n.header-col.header-nav {\n  margin-left: auto;\n  width: 100%;\n  margin-right: auto;\n}\n\n.header-col.header-nav .ant-menu-overflow {\n  justify-content: center;\n}\n\n.header-col.header-nav .ant-menu-horizontal {\n  background: transparent;\n  box-shadow: none;\n  border: 0px;\n}\n\n.layout-default.ant-layout.layout-sign-up {\n  padding: 11px;\n}\n\n.header-col.header-nav li:after {\n  display: none;\n}\n\n.sign-up-header {\n  height: 550px;\n  margin-top: -62.8px;\n  padding-top: 137.8px;\n  border-radius: 12px;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n  background-size: cover;\n  background-position: 50%;\n  text-align: center;\n  background: url(\"../images/bg-signup.jpg\") no-repeat center top;\n}\n\n.header-col.header-brand {\n  white-space: nowrap;\n}\n\n.header-col.header-brand h5 {\n  margin: 0px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.header-col.header-nav {\n  color: #fff;\n  font-weight: 600;\n}\n\n.header-col.header-nav ul li {\n  color: #fff !important;\n}\n\n.header-col.header-nav ul li img {\n  margin-top: -2px;\n  margin-right: 5px;\n}\n\n.header-col.header-btn button {\n  height: 34px;\n  padding: 0 16px;\n  border-radius: 34px;\n  line-height: 33px;\n}\n\n.sign-up-header .content {\n  padding-top: 40px;\n  max-width: 480px;\n  margin: auto;\n}\n\n.sign-up-header * {\n  color: #fff;\n}\n\n.sign-up-header .content h1 {\n  font-size: 48px;\n  color: #fff;\n}\n\n.text-lg {\n  font-size: 16px;\n}\n\n.card-signup .sign-up-gateways .ant-btn {\n  margin-right: 10px;\n  margin-left: 10px;\n  height: 60px;\n  width: 70px;\n  box-shadow: none;\n  border-radius: 6px;\n}\n\n.card-signup {\n  width: 100%;\n  max-width: 500px;\n  margin: auto;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n  border-radius: 12px;\n  margin-top: -190px;\n  margin-bottom: 20px;\n}\n\n.card-signup h5 {\n  text-align: center;\n  font-size: 20px;\n  font-weight: 600;\n  color: #141414;\n  margin: 0px;\n}\n\n.header-solid .ant-card-head {\n  border-bottom: 0;\n}\n\n.card-signup .sign-up-gateways .ant-btn img {\n  width: 20px;\n}\n\n.sign-up-gateways {\n  text-align: center;\n}\n\n.m-25,\n.mb-25,\n.my-25 {\n  margin-bottom: 25px;\n}\n\n.m-25,\n.mt-25,\n.my-25 {\n  margin-top: 25px;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.text-muted {\n  color: #8c8c8c;\n}\n\n.ant-input {\n  height: 40px;\n  border-radius: 8px !important;\n  border: 1px solid #d9d9d9 !important;\n  font-weight: 600;\n  color: #8c8c8c;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.text-dark {\n  color: #141414;\n}\n\n.ant-btn,\n.ant-radio-group .ant-radio-button-wrapper {\n  font-weight: 600;\n  font-size: 12px;\n  height: 40px;\n  padding: 0 15px;\n  line-height: 40px;\n}\n\n.ant-btn {\n  box-shadow: 0 2px 4px rgb(0 0 0 / 7%);\n  border-radius: 6px;\n}\n\n.layout-sign-up .ant-layout-footer {\n  padding: 24px 50px;\n}\n\n.layout-default .ant-layout-footer {\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  background: transparent;\n  text-align: center;\n}\n\n.layout-default .ant-layout-footer .ant-menu-horizontal {\n  border: none;\n  line-height: 1.5;\n  margin: 0 0 30px;\n  background-color: transparent;\n  font-size: 16px;\n}\n\n.layout-default .ant-layout-footer .ant-menu-horizontal {\n  text-align: center;\n  display: block;\n}\n\n.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-item,\n.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-item-active,\n.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-item-selected,\n.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-item:hover,\n.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-submenu,\n.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-submenu-active,\n.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-submenu-selected,\n.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-submenu:hover {\n  color: #8c8c8c;\n  border: none;\n}\n\n.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-item-active,\n.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-item-selected,\n.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-item:hover,\n.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-submenu-active,\n.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-submenu-selected,\n.layout-default .ant-layout-footer .ant-menu-horizontal>.ant-menu-submenu:hover {\n  color: #262626;\n}\n\n.layout-default.ant-layout.layout-sign-up .ant-layout-footer ul li:after {\n  display: none;\n}\n\n.layout-default.ant-layout.layout-sign-up footer.ant-layout-footer ul li a svg {\n  width: 18px;\n  height: 18px;\n}\n\n.layout-default .ant-layout-footer .menu-nav-social a svg {\n  fill: #8c8c8c;\n  vertical-align: middle;\n}\n\n.layout-default .ant-layout-footer .menu-nav-social a:hover svg {\n  fill: #2563eb;\n}\n\n.layout-default .ant-layout-footer .copyright a {\n  color: inherit;\n  font-weight: normal;\n}\n\n/* signin start csss */\n.layout-default.layout-signin header.ant-layout-header {\n  display: flex;\n  position: relative;\n  background-color: #fff;\n  color: #141414;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n  flex-direction: row;\n  padding: 0 50px;\n  height: 64px;\n  line-height: 64px;\n}\n\n.fill-muted {\n  fill: #8c8c8c;\n}\n\n.layout-default .ant-layout-header .header-brand h5 {\n  white-space: nowrap;\n\n  color: #141414;\n  margin: 0;\n}\n\n.layout-default .ant-layout-header .header-nav a svg {\n  margin-right: 5px;\n}\n\n.layout-default .ant-layout-header .header-nav a span,\n.layout-default .ant-layout-header .header-nav a svg {\n  vertical-align: middle;\n}\n\n.layout-default .ant-layout-header .header-nav a {\n  color: #141414;\n  padding: 6px 12px;\n  font-weight: 400;\n}\n\n.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-item,\n.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-item-active,\n.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-item-selected,\n.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-item:hover,\n.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-submenu,\n.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-submenu-active,\n.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-submenu-selected,\n.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-submenu:hover {\n  color: #8c8c8c;\n  font-weight: 600;\n  border: none;\n}\n\n.layout-default .ant-layout-header .header-nav .ant-menu-horizontal>.ant-menu-item {\n  padding: 0;\n}\n\n.sign-in {\n  padding: 0 20px;\n}\n\n.layout-default .ant-layout-content {\n  padding-top: 40px;\n}\n\n.font-regular {\n  font-weight: 400;\n}\n\n.signin h1 {\n  font-size: 48px;\n  font-weight: 700;\n  color: #141414;\n}\n\n.signin h5 {\n  font-weight: 400;\n  color: #8c8c8c;\n  font-size: 20px;\n  white-space: normal;\n}\n\n.ant-row.ant-form-item.username {\n  display: block;\n}\n\n.ant-row.ant-form-item.username .ant-col.ant-form-item-label .ant-form-item-required:before {\n  display: none;\n}\n\n.ant-row.ant-form-item.username .ant-col.ant-form-item-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #141414;\n}\n\n.signin .ant-form-item-control-input button.ant-switch {\n  margin-right: 5px;\n}\n\n.text-dark {\n  color: #141414;\n}\n\n.sign-img img {\n  width: 100%;\n  max-width: 500px;\n  margin: auto;\n  display: block;\n}\n\n/* .signin {\n  background-image: url(../images/Herro\\ Banner\\ neww.png) !important;\n  background-color: #fff !important;\n  height: 100%;\n  width: 100%;\n  background-position: center !important;\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n\n  position: fixed;\n  margin: 0;\n} */\n.layout-signin footer.ant-layout-footer svg {\n  width: 18px;\n  height: 18px;\n}\n\n.layout-signin footer.ant-layout-footer ul li:after {\n  display: none;\n}\n\n.layout-default .ant-layout-footer .copyright {\n  font-size: 16px;\n  color: #8c8c8c;\n}\n\n.row-col .ant-row {\n  margin-left: 0px;\n  margin-right: 0px;\n}\n\n.layout-default.ant-layout.layout-sign-up .header-col.header-brand h5 {\n  color: #fff;\n}\n\n.layout-default.ant-layout.layout-sign-up .header-col.header-nav a {\n  color: #fff;\n}\n\n.layout-default.ant-layout.layout-sign-up .header-col.header-nav svg path.fill-muted {\n  fill: #fff;\n}\n\n/* sign in end */\n\n@media (min-width: 768px) {\n  .sign-img img {\n    margin: 0;\n  }\n\n  .card-signup {\n    margin-bottom: 120px;\n  }\n\n  .card-signup .sign-up-gateways .ant-btn {\n    width: 100px;\n  }\n}\n\n/* end sign up */\n\n.rightside-top .signin {\n  display: inline-flex;\n}\n\n.rightside-top .signin svg {\n  margin-right: 5px;\n}\n\nbutton.ant-btn.bell strong {\n  position: absolute;\n  top: -1px;\n  right: -9px;\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  background: #f5222d;\n  border-radius: 100%;\n  text-align: center;\n  line-height: normal;\n  font-weight: normal;\n  color: #fff;\n}\n\n/* old css end */\n\n.layout-dashboard .ant-layout-footer {\n  background: transparent;\n\n  padding: 0;\n}\n\n.layout-dashboard .ant-layout-content {\n  padding: 0;\n  margin: 15px 15px 0;\n}\n\n.m-10,\n.mr-10,\n.mx-10 {\n  margin-right: 10px !important;\n}\n\n.ant-table-tbody>tr>td h6 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #141414;\n}\n\n.layout-dashboard .header-control .header-search input.ant-input {\n  height: auto;\n}\n\nsmall.redtext {\n  color: red;\n}\n\n.full-width path {\n  fill: transparent;\n}\n\n.bar-chart line.apexcharts-xaxis-tick {\n  stroke: transparent;\n}\n\nsection.ant-layout.layout-content .ant-layout-content.content-ant {\n  padding: 0px !important;\n}\n\n.layout-dashboard .ant-card {\n  border-radius: 12px;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n}\n\n.card-credit {\n  background-image: url(\"../images/info-card-3.jpg\");\n  background-position: 50%;\n  background-size: cover;\n  border: none;\n}\n\n.card-credit * {\n  color: #fff;\n}\n\n.card-credit .card-number {\n  word-spacing: 10px;\n  font-weight: 600;\n  margin-bottom: 45px;\n  font-size: 20px;\n}\n\n.ant-card-head-wrapper {\n  min-height: 72px;\n}\n\n.card-credit .ant-card-body {\n  padding-top: 15px;\n}\n\n.card-credit .card-footer {\n  display: flex;\n  align-items: flex-end;\n}\n\n.m-auto,\n.ml-auto {\n  margin-left: auto !important;\n}\n\n.m-30,\n.mr-30,\n.mx-30 {\n  margin-right: 30px !important;\n}\n\n.card-credit .card-footer h6,\n.card-credit .card-footer p {\n  margin-bottom: 0;\n}\n\n.card-credit .col-logo img {\n  max-width: 50px;\n}\n\n.card-credit .card-footer h6 {\n  font-weight: 700;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n.p-20 {\n  padding: \"0px 20px 0px 0px\";\n}\n\n.layout-default .ant-layout-content.p-0 {\n  padding: 0px;\n}\n\n.pt {\n  padding-top: 0px;\n}\n\n.widget-2 .icon {\n  width: 64px;\n  height: 64px;\n  margin: auto;\n  background-color: #2563eb;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.widget-2 .ant-statistic-title h6 {\n  font-weight: 600;\n}\n\n.widget-2 .ant-statistic-title p {\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.widget-2 .ant-statistic-content {\n  font-family: open sans, Helvetica, Arial, sans-serif !important;\n  font-weight: 600;\n  font-size: 20px;\n  padding: 12px 16px;\n  border-top: 1px solid #f5f5f5;\n  text-align: center;\n}\n\n.widget-2 .ant-statistic-title {\n  text-align: center;\n  padding: 16px;\n}\n\n.widget-2 .ant-card-body {\n  padding: 0;\n}\n\n.widget-2 .icon img {\n  width: 30px;\n}\n\n.ant-row-flex-middle {\n  align-items: center;\n}\n\n.d-flex {\n  display: flex;\n  align-items: center;\n}\n\n.payment-method-card.ant-card {\n  box-shadow: none;\n  word-spacing: 10px;\n}\n\n.payment-method-card.ant-card img {\n  width: 40px;\n}\n\n.payment-method-card.ant-card .ant-card-body {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.payment-method-card.ant-card .ant-btn {\n  margin-right: -20px;\n}\n\n.ant-btn.ant-btn-link.ant-edit-link {\n  font-weight: 600;\n  font-size: 12px;\n  height: 40px;\n  padding: 0 15px;\n  box-shadow: none;\n}\n\n.ant-btn.ant-btn-link.ant-edit-link img {\n  width: 20px;\n}\n\n.payment-method-card.ant-card .ant-btn {\n  margin-right: -20px;\n}\n\n.fill-gray-7 {\n  fill: #8c8c8c !important;\n}\n\n.payment-method-card.ant-card h6 {\n  font-weight: 600;\n  margin-bottom: 0;\n  color: #141414;\n}\n\n.m-0 {\n  margin: 0px;\n}\n\n.ant-card.ant-card-bordered.payment-method-card .ant-card-body {\n  padding-top: 16px;\n}\n\n.header-solid .ant-card-head {\n  border-bottom: 0;\n}\n\n.invoice-list .ant-list-item,\n.transactions-list .ant-list-item {\n  padding: 11px 0;\n  border-bottom: 0;\n}\n\n.ant-invoice-card .ant-card-body {\n  padding-top: 0px;\n}\n\n.invoice-list .ant-list-item-meta-title,\n.transactions-list .ant-list-item-meta-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #141414;\n}\n\n.invoice-list .ant-list-item-meta-description,\n.transactions-list .ant-list-item-meta-description {\n  font-size: 12px;\n  font-weight: 600;\n  color: #8c8c8c;\n}\n\n.invoice-list .ant-list-item-action .ant-btn,\n.transactions-list .ant-list-item-action .ant-btn {\n  font-weight: 600;\n  color: #141414;\n  box-shadow: none;\n}\n\n.ant-btn>svg,\n.ant-btn>svg+span {\n  vertical-align: middle;\n}\n\n.invoice-list .amount,\n.transactions-list .amount {\n  font-size: 14px;\n  font-weight: 600;\n  color: #8c8c8c;\n}\n\n.card-billing-info.ant-card {\n  box-shadow: none;\n  background-color: #fafafa;\n  border: 1px solid #f5f5f5;\n}\n\n.ant-descriptions .ant-descriptions-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #141414;\n  margin-bottom: 14px;\n}\n\n.fill-danger {\n  fill: #ff4d4f;\n}\n\n.card-billing-info.ant-card .darkbtn {\n  color: #8c8c8c;\n}\n\n.col-action {\n  display: flex;\n}\n\n.card-billing-info .col-action button {\n  height: 34px;\n  font-size: 12px;\n  padding: 0 15px;\n  box-shadow: none;\n}\n\n.ant-descriptions .ant-descriptions-row>td,\n.ant-descriptions .ant-descriptions-row>th {\n  padding-bottom: 6px;\n}\n\n.ant-descriptions .ant-descriptions-item-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #8c8c8c;\n}\n\n.ant-descriptions .ant-descriptions-item-content {\n  font-size: 13px;\n  font-weight: 600;\n  color: #141414;\n}\n\n.ant-descriptions .ant-descriptions-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #141414;\n  margin-bottom: 14px;\n}\n\n.card-billing-info.ant-card .ant-descriptions-header {\n  margin-bottom: 0px;\n}\n\n.card-header-date {\n  margin-bottom: 0;\n  font-weight: 700;\n  color: #8c8c8c;\n}\n\n.card-header-date>* {\n  vertical-align: middle;\n}\n\n.card-header-date svg {\n  margin-right: 5px;\n}\n\n.transactions-list .amount {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.text-light-danger {\n  background: #fde3cf;\n  color: #f56a00;\n}\n\n.text-fill {\n  color: #52c41a;\n  background: #edf9e7;\n}\n\n.text-danger {\n  color: #f5222d;\n}\n\n.text-success {\n  color: #52c41a;\n}\n\n.transactions-list .ant-list-item-meta {\n  align-items: center;\n}\n\n.text-warning {\n  background: rgb(255, 252, 231);\n  color: #fadb14;\n}\n\n.text-warning-b {\n  font-size: 14px;\n  font-weight: 600;\n  color: #fadb14;\n}\n\n.ant-card.ant-list-yes .ant-list-header {\n  border: 0px;\n}\n\n.ant-card.ant-list-yes .ant-list-header h6 {\n  font-size: 12px;\n  font-weight: 600;\n  color: #8c8c8c;\n  margin: 6px 0;\n}\n\n.ant-list.ant-list-split.transactions-list.ant-newest .ant-list-header {\n  padding-top: 0px;\n}\n\n.profile-nav-bg {\n  height: 300px;\n  margin-top: -137.8px;\n  border-radius: 12px;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n  background-size: cover;\n  background-position: 50%;\n}\n\nsection.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile span.ant-page-header-heading-title {\n  color: #fff;\n}\n\nsection.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile span.ant-breadcrumb-separator {\n  color: #e9b248;\n}\n\nsection.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile span.ant-breadcrumb-link {\n  color: #e9b248;\n}\n\nsection.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile .btn-sign-in {\n  color: #fff;\n}\n\n.layout-profile .ant-layout-header {\n  margin: 10px 20px;\n}\n\n.card-profile-head .ant-card-head {\n  border-bottom: 0px;\n  padding: 0px 16px;\n}\n\n.card-profile-head {\n  margin: -53px 0 24px;\n}\n\n.card-profile-head .ant-card-head .ant-avatar {\n  box-shadow: 0 5px 10px rgb(0 0 0 / 12%);\n  border-radius: 8px;\n  margin: 0;\n}\n\n.card-profile-head .ant-card-head .avatar-info {\n  margin-left: 16px;\n}\n\n.ant-card-head-title p {\n  font-weight: 600;\n  color: #8c8c8c;\n  margin-bottom: 0;\n}\n\n.card-profile-head .ant-card-head .avatar-info h4 {\n  font-size: 24px;\n}\n\n.card-profile-head .ant-card-head .avatar-info h4 {\n  font-size: 24px;\n}\n\n.card-profile-head .ant-radio-group .ant-radio-button-wrapper {\n  height: auto;\n  font-weight: 700;\n}\n\n.ant-radio-button-wrapper {\n  color: #595959;\n}\n\n.layout-profile .ant-card-head {\n  padding: 0 16px;\n}\n\n.settings-list {\n  list-style: none;\n  padding: 0;\n}\n\n.settings-list>li:first-child {\n  padding-top: 0;\n}\n\n.settings-list>li {\n  padding: 12px 0;\n}\n\n.settings-list>li h6 {\n  font-size: 12px;\n  color: #8c8c8c;\n  margin: 0;\n  font-weight: 700;\n}\n\n.settings-list>li span {\n  margin-left: 16px;\n  color: #141414;\n}\n\n.ant-btn-link {\n  box-shadow: none;\n}\n\n.card-profile-information hr {\n  opacity: 0.2;\n}\n\n.p-5,\n.pr-5,\n.px-5 {\n  padding-right: 5px !important;\n}\n\n.p-5,\n.pl-5,\n.px-5 {\n  padding-left: 5px !important;\n}\n\n.m-5,\n.mr-5,\n.mx-5 {\n  margin-right: 5px !important;\n}\n\n.m-5,\n.ml-5,\n.mx-5 {\n  margin-left: 5px !important;\n}\n\n.card-profile-information .ant-descriptions .ant-descriptions-row>td,\n.card-profile-information .ant-descriptions .ant-descriptions-row>th {\n  padding-bottom: 16px;\n}\n\n.conversations-list .ant-list-item-meta-description {\n  font-size: 12px;\n  font-weight: 600;\n  color: #8c8c8c;\n}\n\n.conversations-list .ant-avatar {\n  border-radius: 10.5px;\n  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);\n}\n\n.conversations-list .ant-list-item {\n  padding: 14px 0;\n}\n\n.ant-card-head-title p {\n  font-weight: 600;\n  color: #8c8c8c;\n  margin-bottom: 0;\n}\n\n.ant-card-head-title h6 {\n  margin-bottom: 0;\n}\n\n.card-project.ant-card {\n  box-shadow: none;\n  border: none;\n}\n\n.card-project.ant-card .ant-card-cover img {\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);\n}\n\n.card-project.ant-card .card-tag,\n.card-project.ant-card p {\n  font-weight: 600;\n  color: #8c8c8c;\n  margin-bottom: 5px;\n}\n\n.card-project.ant-card h5 {\n  font-weight: 600;\n  font-size: 20px;\n}\n\n.card-project.ant-card .card-tag,\n.card-project.ant-card p {\n  font-weight: 600;\n  color: #8c8c8c;\n  margin-bottom: 5px;\n}\n\n.card-project.ant-card p {\n  margin-bottom: 0;\n}\n\n.card-project.ant-card .ant-card-body {\n  padding: 16px 0 0;\n}\n\n.card-project.ant-card .card-footer {\n  margin-top: 22px;\n}\n\n.avatar-chips .ant-avatar-image {\n  border: 1px solid #fff;\n}\n\n.avatar-chips .ant-avatar-image:hover,\n.avatar-chips .ant-space-item:hover {\n  z-index: 1;\n}\n\n.projects-uploader {\n  height: 100%;\n  border-radius: 8px;\n  border-color: #d9d9d9;\n}\n\n.projects-uploader .ant-upload {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  border-radius: 8px;\n  padding: 8px;\n}\n\n.projects-uploader .ant-upload-list.ant-upload-list-picture-card {\n  height: 100%;\n}\n\n.projects-uploader .ant-upload.ant-upload-select-picture-card {\n  background-color: transparent;\n}\n\n.projects-uploader svg {\n  width: 20px;\n  height: 20px;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.layout-dashboard-rtl {\n  background: transparent;\n  text-align: right;\n  direction: rtl;\n  position: relative;\n  overflow-x: hidden;\n}\n\n.layout-dashboard-rtl .ant-layout-sider.sider-primary .ant-menu-item .icon,\n.layout-dashboard-rtl .ant-layout-sider.sider-primary .ant-menu-submenu .icon {\n  margin-left: 11px;\n  margin-right: 0;\n}\n\n.layout-dashboard-rtl .ant-timeline-item-tail {\n  right: 6.5px;\n  left: auto;\n}\n\n.layout-dashboard-rtl .ant-timeline-item-content {\n  margin: 0 33px 0 0;\n}\n\n.ant-timeline-item-head {\n  width: 15px;\n  height: 15px;\n  border-width: 3px;\n}\n\n.layout-dashboard-rtl .ant-radio-button-wrapper:first-child {\n  border-right-width: 1px;\n  border-radius: 0 4px 4px 0;\n}\n\n.layout-dashboard-rtl .ant-list-box td {\n  text-align: right;\n}\n\n.layout-dashboard-rtl .ant-space-horizontal {\n  direction: ltr;\n}\n\n.layout-dashboard-rtl .ant-btn>.anticon+span,\n.ant-btn>span+.anticon {\n  margin-right: 8px;\n  margin-left: 0px;\n}\n\n.layout-dashboard-rtl .setting-drwer {\n  left: 30px;\n  right: auto;\n}\n\n.layout-dashboard-rtl ul.ant-menu.ant-menu-root.ant-menu-inline.ant-menu-light {\n  text-align: right;\n}\n\n.layout-dashboard-rtl .avatar-group.mt-2 {\n  direction: ltr;\n}\n\n.ant-list-box table tr:hover td {\n  background: #fafafa;\n}\n\n.layout-dashboard-rtl .icon-box {\n  margin-left: 0px;\n  margin-right: auto;\n}\n\n.layout-dashboard-rtl .m-10,\n.layout-dashboard-rtl .mr-10,\n.layout-dashboard-rtl .mx-10 {\n  margin-left: 10px !important;\n}\n\n.layout-dashboard-rtl .ant-progress-show-info .ant-progress-outer {\n  margin-right: 0px;\n  padding-right: 0px;\n}\n\n.layout-dashboard-rtl .ant-badge-count,\n.layout-dashboard-rtl .ant-badge-dot,\n.layout-dashboard-rtl .ant-badge .ant-scroll-number-custom-component {\n  left: 0;\n  right: auto;\n  transform: translate(-50%, -50%);\n}\n\n.layout-dashboard-rtl .header-control .btn-sign-in svg {\n  margin-left: 4px;\n  margin-right: 0px;\n}\n\n.ant-drawer.drawer-sidebar.drawer-sidebar-rtl aside.ant-layout-sider.ant-layout-sider-light.sider-primary.ant-layout-sider-primary {\n  left: auto;\n  right: 0px;\n  direction: rtl;\n}\n\n.layout-dashboard.layout-dashboard-rtl .header-control span.ant-badge {\n  margin: 0px 7px;\n}\n\n.layout-dashboard.layout-dashboard-rtl span.ant-input-prefix {\n  margin-right: 0px;\n  margin-left: 4px;\n}\n\n.layout-dashboard-rtl .ant-drawer-left .ant-drawer-content-wrapper {\n  left: 0;\n  direction: rtl;\n}\n\n.settings-drawer.settings-drawer-rtl {\n  left: 0;\n  direction: rtl;\n}\n\n.settings-drawer.settings-drawer-rtl button.ant-drawer-close {\n  left: 0px;\n  right: auto;\n  margin-right: 0px;\n  margin-left: var(--scroll-bar);\n  padding-left: calc(20px - var(--scroll-bar));\n}\n\n.layout-dashboard-rtl .ant-drawer-left .ant-drawer-content-wrapper {\n  left: 0;\n  direction: rtl;\n}\n\n.settings-drawer.settings-drawer-rtl {\n  left: 0;\n  direction: rtl;\n}\n\n.settings-drawer.settings-drawer-rtl button.ant-drawer-close {\n  left: 0px;\n  right: auto;\n  margin-right: 0px;\n  margin-left: var(--scroll-bar);\n  padding-left: calc(20px - var(--scroll-bar));\n}\n\n.settings-drawer.settings-drawer-rtl .sidebarnav-color button {\n  margin-right: 0px;\n  margin-left: 10px;\n}\n\n.settings-drawer.settings-drawer-rtl .viewstar a:first-child {\n  border-radius: 0em 0.25em 0.25em 0;\n  border-right: 1px solid #ddddde;\n}\n\n.settings-drawer.settings-drawer-rtl .viewstar a {\n  border-radius: 0.25em 0 0 0.25em;\n  border: 1px solid #ddddde;\n  border-right: 0px;\n}\n\n.social svg path {\n  fill: #fff;\n}\n\n.settings-drawer.settings-drawer-rtl .social svg {\n  margin-right: 0px;\n  margin-left: 5px;\n}\n\n.social svg {\n  width: 15px;\n  height: 15px;\n}\n\n.layout-dashboard .ant-affix .ant-layout-header {\n  background: #fff;\n  box-shadow: 0 20px 27px rgb(0 0 0 / 5%);\n  margin: 10px 20px;\n  z-index: 10;\n}\n\naside.ant-layout-sider.ant-layout-sider-light.sider-primary.ant-layout-sider-primary.active-route a.active {\n  background: transparent;\n  box-shadow: none;\n}\n\n.uploadfile.pb-15 {\n  padding-bottom: 16px;\n}\n\n.ant-row.ant-form-item.aligin-center .ant-form-item-control-input-content {\n  display: flex;\n  align-items: center;\n  color: rgba(0, 0, 0, 0.65);\n}\n\n.uploadfile.shadow-none .ant-upload.ant-upload-select.ant-upload-select-text .ant-btn.ant-full-box {\n  box-shadow: none;\n}\n\n.ant-btn-dashed {\n  color: rgba(0, 0, 0, 0.65);\n}\n\nbutton.ant-btn.ant-btn-dashed.ant-full-box svg {\n  width: 16px;\n  height: 16px;\n}\n\n.ant-btn-dashed.active,\n.ant-btn-dashed:active {\n  color: #096dd9;\n  background-color: #fff;\n  border-color: #096dd9;\n}\n\nsection.ant-layout.ant-layout-has-sider.layout-dashboard.layout-profile .header-control span.ant-input-affix-wrapper.header-search .anticon-search svg path {\n  fill: #8c8c8c;\n}\n\n.ant-card-head-wrapper {\n  gap: 16px;\n  align-items: center;\n}\n\n.ant-card-head-wrapper .ant-card-extra {\n  gap: 16px;\n  align-items: center;\n  margin-left: auto;\n  justify-content: end;\n}\n\n.ant-card-head-title {\n  display: block !important;\n  flex: 0 0 auto !important;\n}\n\n.ant-card-extra {\n  display: flex;\n  justify-content: space-between;\n}\n\n.ant-card-head-wrapper {\n  flex-wrap: wrap;\n}\n\n.main-new-header-of-table10 {\n  gap: 15px;\n  flex-wrap: wrap;\n}\n\n.ant-input-wrapper.ant-input-group {\n  max-width: 260px;\n  height: 32px;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.ant-input-wrapper.ant-input-group input.ant-input {\n  border: none;\n}\n\naside {\n  margin: 0 !important;\n  padding: 0 !important;\n  background: #fff !important;\n  /* border-radius: 0px 30px 30px 0px; */\n}\n\n/* width */\naside::-webkit-scrollbar {\n  width: 1px;\n}\n\n/* Handle */\naside::-webkit-scrollbar-thumb {\n  background: #fff;\n}\n\n.ant-tabs-nav-wrap {\n  border-bottom: 1px solid #ddd;\n}\n\n.table-responsive .ant-table::-webkit-scrollbar {\n  height: 6px;\n  touch-action: auto;\n  cursor: pointer;\n}\n\n.brand {\n  padding: 20px;\n}\n\n.ant-breadcrumb+.ant-page-header-heading {\n  margin-top: 0;\n}\n\n.ant-table-pagination.ant-pagination {\n  margin: 8px 15px !important;\n}\n\n.ant-card-head {\n  padding: 0 15px !important;\n}\n\n.ant-card-extra {\n  padding: 10px 0 !important;\n}\n\n.tablespace .ant-card-head-title {\n  padding: 10px 0 !important;\n  width: 100%;\n}\n\n.ant-card-head-wrapper {\n  min-height: unset;\n}\n\nth,\ntd {\n  padding: 8px 15px !important;\n}\n\ntd {\n  width: 150px !important;\n  max-width: 300px !important;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  min-width: 100% !important;\n  background-color: #ffffff24;\n  border-bottom: 1px solid #d9d9d9 !important;\n}\n\n/* The global `td` rule above (150px + min-width:100% !important) was meant\n   for data-list tables, but with no scoping it leaks into every <td> on the\n   page — including antd DatePicker's internal panels. Quarter/year/decade\n   panels lay out their cells in a single row (Q1-Q4, or a decade of years)\n   inside a fixed-width 280px container; forcing each cell to 150px blows\n   that row out to 600px+, and the picker's own overflow:hidden then\n   silently clips whatever falls past the visible edge — Q3/Q4 in the\n   Renewal Rate period picker, for instance, with no visible sign anything\n   is missing. Undo the leak specifically inside any antd picker panel,\n   restoring antd's own default cell sizing there, without touching the\n   global rule the real data tables depend on. */\n.ant-picker-panel td,\n.ant-picker-panel-container td {\n  width: auto !important;\n  max-width: none !important;\n  min-width: 0 !important;\n  background-color: transparent !important;\n  border-bottom: none !important;\n}\n\n.ant-col.ant-form-item-label {\n  width: 100%;\n  display: block;\n  text-align: left;\n}\n\n.ant-col.ant-form-item-control {\n  flex: 0 0 100%;\n}\n\n.ant-space.ant-space-horizontal.ant-space-align-baseline {\n  padding: 0 5px;\n  position: relative;\n  display: block;\n}\n\n.ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space.ant-space-horizontal.ant-space-align-baseline {\n  flex: 0 0 20%;\n  max-width: 20%;\n  display: flex;\n  align-items: center;\n  gap: 0 !important;\n}\n\n.ant-space-item {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  margin: 0 -5px;\n}\n\n/* Card-toolbar `<Space>` rows (Search / filters / action buttons in a Card's\n   `extra`) need each item to size to its own content and flow left-to-right,\n   not stretch to 100% like the dynamic-form-field Space usage above was\n   written for. Scoped override rather than touching the global rule, which\n   other pages may depend on. */\n.gfx-toolbar.ant-space-horizontal {\n  display: flex;\n  flex-wrap: wrap;\n}\n.gfx-toolbar.ant-space-horizontal .ant-space-item {\n  display: inline-flex;\n  width: auto;\n  margin: 0;\n}\n\n/* Toolbars that must never wrap to a second row (e.g. Contract Management's\n   modal toolbar): let the extra area use the card head's full width, and\n   scroll horizontally as a last resort instead of stacking rows. */\n.gfx-toolbar-card .ant-card-head-wrapper {\n  flex-wrap: nowrap;\n}\n.gfx-toolbar-card .ant-card-extra {\n  flex: 1 1 auto;\n  min-width: 0;\n  margin-left: auto;\n}\n.gfx-toolbar-nowrap.ant-space-horizontal {\n  flex-wrap: nowrap;\n  max-width: 100%;\n  overflow-x: auto;\n  padding-bottom: 2px;\n}\n\n/* Payment Records cards: the title is multi-line (contract dates, amount,\n   terms), so undo Ant Design's default single-line ellipsis clipping that was\n   cutting the left edge of the title text. */\n.payment-record-card .ant-card-head-title {\n  overflow: visible;\n  white-space: normal;\n  text-overflow: clip;\n}\n\n/* Contract Management table uses rowSpan to merge contract-level cells across a\n   contract's payment rows. Ant's per-row hover highlight only tints the hovered\n   row, so the un-merged payment cells (Amount / Paid Through) looked like stray\n   white boxes against a tinted row. Kill the hover tint entirely so every cell\n   stays a uniform white and the merged group reads as one block. */\n.gfx-contract-table .ant-table-tbody > tr.ant-table-row:hover > td,\n.gfx-contract-table .ant-table-tbody > tr.ant-table-row-hover > td,\n.gfx-contract-table .ant-table-tbody > tr > td.ant-table-cell-row-hover,\n.gfx-contract-table .ant-table-tbody > tr:hover > td.ant-table-cell {\n  background: #ffffff !important;\n  background-color: #ffffff !important;\n}\n\n.anticon[tabindex] {\n  height: 45px;\n  width: 50px;\n  border-radius: 0px 25px 25px 0px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  margin-top: 0;\n  right: 6px;\n  top: 23px;\n  color: #fff;\n  font-weight: bold;\n  color: black;\n}\n\n.ant-form-item-label>label {\n  height: unset;\n}\n\n.ant-row {\n  width: 100%;\n}\n\n.ant-space-item .ant-space-item {\n  display: block;\n}\n\n.ant-space-item .ant-space-item input {\n  padding-right: 15px;\n}\n\n.ant-space.ant-space-horizontal.ant-space-align-baseline .ant-row.ant-form-item-row {\n  display: block;\n}\n\n.ant-form-item-label>label {\n  display: block;\n  height: unset !important;\n}\n\n.ant-select.ant-select-in-form-item {\n  height: 100%;\n  min-height: 45px !important;\n}\n\nspan.ant-upload-span {\n  justify-content: space-between !important;\n}\n\n.ant-select.ant-select-in-form-item .ant-select-selector {\n  height: 100% !important;\n  border-radius: 8px !important;\n  box-shadow: inset 0 0 20px 20px #f7f8f9 !important;\n  outline: none;\n  border: 1px solid #e8ecf4 !important;\n  width: 100% !important;\n}\n\n.ant-form-item .ant-form-item-control-input-content .ant-select-selection-search {\n  margin: 0px !important;\n}\n\n.nottfy-add span.ant-select-selection-placeholder {\n  line-height: 42px !important;\n}\n\n.ant-form-item.form-add-option {\n  margin-bottom: 0;\n  width: 40px;\n  height: 40px;\n}\n\n.ant-form-item.form-add-option button {\n  margin-top: 6px;\n  width: 40px;\n  height: 40px;\n  background: #2563eb;\n  padding: 0;\n  border: 0;\n}\n\n.ant-form-item.form-add-option button span.anticon.anticon-plus {\n  justify-content: center;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n}\n\n.ant-form-item.form-add-option button span.anticon.anticon-plus svg {\n  margin-right: 0;\n  fill: #000 !important;\n}\n\n.signin-bg {\n  height: 100%;\n}\n\n.signin-bg img {\n  height: 100%;\n  width: 100%;\n}\n\nbutton.ant-btn.ant-btn-text.ant-btn-sm.ant-btn-icon-only.ant-upload-list-item-card-actions-btn {\n  background: none !important;\n  border: none !important;\n}\n\na.ant-upload-list-item-name {\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  max-width: 320px !important;\n  width: 100% !important;\n}\n\n.ant-space.ant-space-horizontal.ant-space-align-baseline .ant-row {\n  margin: 0 -5px;\n}\n\n.ant-space.ant-space-horizontal.ant-space-align-baseline .ant-col {\n  padding: 0 5px;\n}\n\n.signin-box {\n  width: 100%;\n  inset: 0;\n  margin: 0 auto;\n  max-width: 600px;\n  background: #E8F9FF;\n  border: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  justify-content: center;\n  height: 100vh;\n}\n\n.layout-signin-rowsss {\n  height: 100vh;\n}\n\nsection.ant-layout.layout-default.layout-signin {\n  height: 100vh;\n}\n\n.signup-logo {\n  text-align: center;\n  padding: 15px 0px;\n}\n\n.signup-logo img {\n  max-width: 130px;\n}\n\n.signup-logo h4 {\n  font-size: 19px;\n  margin: 0;\n  margin-top: 10px;\n  font-weight: 700;\n  color: #3B6B94;\n}\n\n.signin-box .ant-row {\n  margin: 0 !important;\n}\n\n.ant-menu-submenu-arrow:after,\n.ant-menu-submenu-arrow:before {\n  background-color: rgb(0 0 0 / 70%) !important;\n}\n\nbutton.ant-btn.ant-btn-link.sidebar-toggler.ps-0.d-none.d-lg-block {\n  border: none !important;\n}\n\n.signup-form {\n  padding: 40px;\n}\n\n.ant-input-group-wrapper {\n  width: fit-content !important;\n}\n\nh6.profile-picture.profile-picture-new-picture img {\n  width: 100px;\n  border-radius: 10px;\n  height: 100px;\n}\n\nmain.ant-layout-content.signin {\n  padding: 0px;\n  margin: 0;\n}\n\n.signin-box h1 {\n  font-size: 34px !important;\n  font-weight: 700 !important;\n  margin-bottom: 0 !important;\n  text-align: left;\n  text-transform: uppercase;\n}\n\n.signin-box h5 {\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  margin-top: 5px !important;\n  margin-bottom: 35px !important;\n  text-align: left;\n}\n\n.signin-box .ant-btn-primary {\n  padding: 10px;\n  height: 40px;\n  border-radius: 10px;\n  box-shadow: none !important;\n  background: #3B6B94 !important;\n  border: none !important;\n}\n\n.signin-box .ant-switch-checked {\n  background-color: #3B6B94 !important;\n}\n\n.signin-box .ant-input,\n.username span.ant-input-affix-wrapper.ant-input-password {\n  height: 45px;\n  border-radius: 8px !important;\n  border: 1px solid #e8ecf4 !important;\n  outline: none !important;\n  box-shadow: inset 0 0 20px 20px #f7f8f9 !important;\n  background-color: #3B6B94 !important;\n  width: 100%;\n  background-image: none !important;\n  color: #686868 !important;\n  background: #f7f8f9 !important;\n}\n\ninput#password {\n  box-shadow: inset 0 0 20px 20px #f7f8f9 !important;\n  border: none !important;\n}\n\n.signin-box .ant-input::placeholder {\n  color: #686868 !important;\n}\n\ninput#password {\n  height: 100%;\n}\n\n.sign-rightouter img {\n  max-width: 800px;\n  width: 100%;\n}\n\n/* .signin-bg {\n  background-image: url(../images/bg-light.jpg);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  height: 100vh;\n  width: 100%;\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  padding: 0 40px;\n} */\n.ant-card-body {\n  padding: 15px;\n}\n\nfooter.ant-layout-footer {\n  background: #f4f3ef !important;\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n}\n\nspan.icon img {\n  max-width: 18px;\n  width: 18px;\n  max-height: 18px;\n  filter: brightness(23.5);\n}\n\n.ant-select-single .ant-select-selector .ant-select-selection-item,\n.ant-select-single .ant-select-selector .ant-select-selection-placeholder {\n  padding: 0;\n  line-height: 42px !important;\n}\n\n/* .layout-dashboard .ant-layout-sider.sider-primary.ant-layout-sider-primary .ant-menu-item .active .icon img {\n  filter: none;\n} */\n\nspan.ant-input-group-wrapper.ant-input-search.ant-input-search-large.searchbar-layout {\n  width: fit-content;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item:last-child a {\n  border-bottom: 0;\n}\n\n.ant-btn-primary {\n  background: #3B6B94 !important;\n  border-color: #3B6B94 !important;\n  padding: 10px 24px !important;\n  height: 40px !important;\n  border-radius: 8px !important;\n  line-height: 1;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center;\n  color: #fff !important;\n  font-size: 16px !important;\n  font-weight: 600 !important;\n}\n\n.ant-btn-View {\n  display: inline-flex !important;\n  height: 40px !important;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px !important;\n  background: #3B6B94 !important;\n  color: #fff !important;\n  border-color: #3B6B94 !important;\n}\n.ant-btn-default {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\n.main-all-buttonclassokjh {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.all-check-box-desing {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 10px;\n  column-gap: 15px;\n}\n\n.all-check-box-desing .ant-checkbox-wrapper+.ant-checkbox-wrapper {\n  margin: 0px !important;\n}\n\n.ant-btn-default:hover {\n  background: #fff !important;\n  border-color: #2563eb !important;\n  color: #2563eb !important;\n}\n\n.ant-btn-primary:hover,\n.ant-btn:hover {\n  background: #3B6B94;\n  color: white;\n}\n\n.ant-modal-body {\n  padding: 20px !important;\n}\n\n/* Assistant/Sub-Client management modals (pages/accessModule/AssistantsTab.js) —\n   opts out of the default above for a more breathable Add/Edit Assistant form. */\n.assistant-form-modal .ant-modal-content {\n  padding: 0 !important;\n  border-radius: 16px !important;\n  overflow: hidden;\n}\n.assistant-form-modal .ant-modal-header {\n  padding: 20px 28px !important;\n  margin-bottom: 0 !important;\n  border-bottom: 1px solid var(--border, #E7E9F2) !important;\n}\n.assistant-form-modal .ant-modal-close {\n  top: 14px !important;\n  right: 16px !important;\n}\n.assistant-form-modal .ant-modal-body {\n  padding: 24px 28px !important;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n.assistant-form-modal .ant-form-item {\n  margin-bottom: 20px;\n}\n.assistant-form-modal label {\n  font-weight: 600 !important;\n}\n.assistant-form-modal .ant-modal-footer {\n  padding: 16px 28px !important;\n  margin-top: 0 !important;\n  border-top: 1px solid var(--border, #E7E9F2) !important;\n}\n.assistant-form-modal .ant-modal-footer .ant-btn {\n  height: 40px !important;\n  border-radius: 8px !important;\n  font-weight: 600 !important;\n  padding-left: 20px !important;\n  padding-right: 20px !important;\n}\n\n.ant-modal-footer {\n  padding: 20px;\n}\n\n.ant-modal-body input,\nspan.ant-input-affix-wrapper.ant-input-password,\nspan.ant-input-affix-wrapper.ant-input-password.ant-input-affix-wrapper-has-feedback {\n  height: 45px;\n  border-radius: 10px;\n  border: 1px solid #e8ecf4 !important;\n  background: #f7f8f9 !important;\n  box-shadow: inset 0 0 20px 20px #f7f8f9 !important;\n}\n\ninput#password,\ninput#old_password,\ninput#new_password,\ninput#newPassword,\ninput#confirm_new_password,\ninput#new_password,\ninput#confirm_new_password {\n  box-shadow: inset 0 0 20px 20px #f7f8f9 !important;\n  border: none !important;\n  height: 100%;\n}\n\n.wrapperClassName.rdw-editor-wrapper {\n  border: 1px solid #ddd !important;\n}\n\n.editorClassName.rdw-editor-main {\n  padding: 10px;\n}\n\n.public-DraftStyleDefault-block.public-DraftStyleDefault-ltr {\n  margin: 0;\n}\n\n.main-new-updater-image-okik {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.main-new-graph-class-oki h2 {\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.ant-picker-input input {\n  background: #ffffff !important;\n  background-color: #ffffff !important;\n  border: none !important;\n  box-shadow: unset !important;\n}\n\n.react-tel-input .selected-flag {\n  border-radius: 8px 0 0 8px !important;\n}\n\n.ant-table-cell .ant-btn {\n  height: 30px !important;\n  overflow: hidden !important;\n}\n\n.ant-modal-body .ant-picker {\n  height: 45px;\n  width: 100% !important;\n  border-radius: 8px;\n}\n\n.ant-modal-body .ant-input-affix-wrapper {\n  padding: 0 10px;\n  border-radius: 8px;\n}\n\n.ant-modal-header {\n  padding: 10px 15px;\n}\n\n.ant-input-number.ant-input-number-in-form-item {\n  width: 100% !important;\n  border-radius: 8px;\n}\n\n.ant-modal-header {\n  padding: 20px !important;\n}\n\n.ant-table-tbody>tr>td.ant-table-cell button.ant-btn.ant-btn-default {\n  background: #3B6B94 !important;\n  margin-right: 10px;\n  color: #ffffff !important;\n  border: none !important;\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  font-size: 14px;\n}\nbutton.ant-btn.ant-btn-default.ant-btn-block.add-brand-button {\n    border: 1px solid #3b6b94 !important;\n    background: white !important;\n    color: #3b6b94 !important;\n}\n.ant-table-tbody>tr>td.ant-table-cell button.ant-btn.tb-view {\n  background: #2563eb !important;\n  margin-right: 10px;\n  color: #fff !important;\n  border: none;\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  font-size: 14px;\n}\n\ntd.ant-table-cell .cta_wrap {\n  display: flex;\n  align-items: center;\n}\n\n.ant-pagination-item-active:hover a {\n  color: #2563eb !important;\n}\n\n.ant-pagination-item:hover a {\n  color: #3B6B94 !important;\n  border-color: #3B6B94 !important;\n}\n\n.ant-modal-content .react-tel-input .form-control {\n  height: 42px;\n  width: 100%;\n  border-radius: 8px;\n}\n\n.ant-pagination-item-active:hover a {\n  color: #ffffff !important;\n}\n\n.react-tel-input .flag-dropdown {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  padding: 0;\n  background-color: #f5f5f5;\n  border: 1px solid #cacaca;\n  border-radius: 8px 0 0 8px !important;\n}\n\n.ant-input-wrapper.ant-input-group button {\n  background-color: #3B6B94 !important;\n  border: none !important;\n  color: #ffffff !important;\n  border-radius: 0 8px 8px 0 !important;\n  box-shadow: none !important;\n}\n\n.ant-input-search>.ant-input-group>.ant-input-group-addon:last-child {\n  left: 0px !important;\n}\n\n.signup-form .ant-form-item:last-child {\n  margin-bottom: 0;\n}\n\n.ant-modal-body form .ant-modal-body .ant-row .ant-col.ant-col-12:last-child .ant-form-item {\n  margin-bottom: 0;\n}\n\n.ant-pagination-item-active a {\n  color: #fff !important;\n  background-color: #3B6B94 !important;\n}\n\n.ant-pagination-item-active {\n  border-color: #3B6B94 !important;\n}\n\n.ant-pagination-item {\n  border-radius: 8px !important;\n  overflow: hidden;\n}\n\n.ant-pagination-prev button,\n.ant-pagination-next button {\n  border-radius: 8px !important;\n}\n\n.ant-pagination-prev button,\n.ant-pagination-next button {\n  border-radius: 8px !important;\n  border-color: #3B6B94 !important;\n  color: #3B6B94 !important;\n}\n\n.layout-dashboard .ant-layout-sider.sider-primary .brand a {\n  color: #ffffff !important;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #f5f5f5;\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n  background-color: #3B6B94;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #3B6B94 !important;\n}\n\n.ant-btn .anticon svg {\n  margin-right: 0;\n}\n\n.view-inner-cls {\n  display: flex;\n  align-items: center;\n  border-bottom: solid 1px #f1f1f1;\n  padding: 10px 0px;\n}\n\n.view-inner-cls:last-child {\n  border-bottom: 0;\n  padding-bottom: 0;\n}\n\n.view-inner-cls:first-child {\n  padding-top: 0;\n}\n\n.view-main-list {\n  border-right: solid 1px #d3d3d3;\n  padding-right: 15px;\n}\n\n.view-inner-cls h5 {\n  margin-bottom: 0;\n  font-size: 15px;\n  font-weight: 600;\n  max-width: 600px;\n  width: 100%;\n}\n\n.view-page-header h1 {\n  font-size: 23px;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.view-inner-cls h6 {\n  margin-bottom: 0;\n  font-size: 13px;\n  margin-left: auto;\n  text-align: end;\n  line-height: 21px;\n  font-weight: 600;\n  flex: 0 0 auto;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-word;\n  width: 40%;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Customer View Details page — scoped to .customer-view-page so this\n   doesn't touch .view-inner-cls/.label-quote-card, which other View\n   pages across the app still use as-is.\n   ═══════════════════════════════════════════════════════════════ */\n.customer-view-page .cvp-card {\n  border-radius: 14px;\n  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.06);\n}\n.customer-view-page .cvp-header {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n.customer-view-page .cvp-avatar {\n  width: 72px;\n  height: 72px;\n  flex-shrink: 0;\n  border-radius: 16px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #eaf6f7 0%, #eef4fb 100%);\n  color: #3b6b94;\n  font-size: 28px;\n  box-shadow: 0 0 0 1px #e6ecf4;\n}\n.customer-view-page .cvp-avatar .ant-image,\n.customer-view-page .cvp-avatar .ant-image img {\n  width: 72px;\n  height: 72px;\n  object-fit: cover;\n}\n.customer-view-page .cvp-name {\n  font-size: 22px;\n  font-weight: 700;\n  margin: 0 0 2px;\n  color: #1e293b;\n}\n.customer-view-page .cvp-email {\n  font-size: 14px;\n  color: #64748b;\n  margin-bottom: 10px;\n}\n.customer-view-page .cvp-status-row {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.customer-view-page .cvp-status-row .ant-tag {\n  border-radius: 999px;\n  padding: 2px 12px;\n  font-weight: 600;\n  font-size: 12px;\n  border: none;\n  margin: 0;\n}\n.customer-view-page .cvp-divider {\n  height: 1px;\n  background: #eef1f5;\n  margin: 24px 0 20px;\n}\n.customer-view-page .cvp-section-title {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  color: #94a3b8;\n  margin-bottom: 14px;\n}\n.customer-view-page .cvp-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(200px, 1fr));\n  gap: 20px 32px;\n}\n.customer-view-page .cvp-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.customer-view-page .cvp-field-label {\n  font-size: 12px;\n  color: #94a3b8;\n  font-weight: 600;\n}\n.customer-view-page .cvp-field-value {\n  font-size: 14px;\n  color: #334155;\n  font-weight: 600;\n  word-break: break-word;\n}\n.customer-view-page .cvp-empty {\n  color: #bbb;\n  font-weight: 400;\n}\n@media (max-width: 576px) {\n  .customer-view-page .cvp-grid {\n    grid-template-columns: 1fr;\n  }\n  .customer-view-page .cvp-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\nspan.anticon.anticon-delete.delete-circal {\n  background: #ff4700;\n  border-radius: 7px !important;\n  color: white;\n  font-size: 19px;\n  width: 35px;\n  height: 35px;\n}\n\n.view-main-list.border-right-0 {\n  border-right: 0;\n  padding-right: 0;\n}\n\n.ant-card-head-title {\n  padding: 10px 0 !important;\n}\n\n.profile-nav-inner {\n  display: flex;\n  gap: 10px;\n}\n\n.profile-nav-inner button.ant-btn:last-child {\n  margin-bottom: 0;\n}\n\n.profile-nav-inner button.ant-btn {\n  padding: 0 15px;\n}\nspan.ant-input-group-wrapper.ant-input-search.searchInput input.ant-input {\n    border: none !important;\n}\n.profile-nav {\n  margin-top: 15px !important;\n}\n\n.card-profile-head .ant-card-head-wrapper {\n  display: block;\n  width: 100%;\n}\n\n.card-profile-head .ant-card-head-wrapper .ant-avatar-group {\n  width: 100%;\n}\n\n.card-profile-head .ant-card-head-wrapper .ant-avatar-group .avatar-info {\n  margin-left: auto;\n  text-align: right;\n}\n\n.card-profile-head .ant-card-head {\n  padding: 0 !important;\n  padding-left: 15px !important;\n}\n\n.card-profile-head .ant-card-head-wrapper .ant-avatar-group .avatar-info h4 {\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 0;\n}\n\n.card-profile-head .ant-card-head-wrapper .ant-avatar-group .avatar-info p {\n  font-size: 14px;\n}\n\n.card-profile-head .ant-card-head-wrapper .ant-avatar-group span.ant-avatar.ant-avatar-square.ant-avatar-image {\n  border-radius: 50%;\n}\n\n.ant-upload-list-picture .ant-upload-list-item-thumbnail,\n.ant-upload-list-picture-card .ant-upload-list-item-thumbnail {\n  line-height: 40px !important;\n  height: 40px !important;\n  width: 40px !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ant-upload-list-picture .ant-upload-list-item,\n.ant-upload-list-picture-card .ant-upload-list-item {\n  height: 45px !important;\n  margin-top: 0 !important;\n  position: relative !important;\n  border-radius: 8px !important;\n}\n\nspan.ant-upload-list-item-card-actions.picture {\n  position: unset !important;\n}\n\nspan.ant-upload-list-item-card-actions.picture .ant-upload-list-item-card-actions-btn span.anticon.anticon-delete {\n  position: absolute !important;\n  top: -13px !important;\n  right: -9px !important;\n  border-radius: 0px 8px 8px 0px;\n  height: 45px;\n}\n\nspan.ant-upload-list-item-card-actions.picture .ant-upload-list-item-card-actions-btn span.anticon.anticon-delete svg {\n  fill: #000 !important;\n  font-size: 18px !important;\n}\n\n.ant-upload button.ant-btn.ant-btn-default {\n  width: 100% !important;\n}\n\n.ant-table-content span.ant-avatar.ant-avatar-square {\n  height: 40px !important;\n  width: 40px !important;\n  line-height: 40px !important;\n}\n\n.table-responsive .ant-table {\n  overflow: auto;\n}\n\n.change-pw span.anticon.anticon-eye-invisible.ant-input-password-icon {\n  top: 0px;\n  right: 0px;\n}\n\n/* .change-pw span.anticon.anticon-eye-invisible.ant-input-password-icon svg {\n  filter: brightness(0) invert(1) !important;\n} */\n.forgot-pass {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.forgot-pass .ant-form-item.aligin-center {\n  margin-bottom: 0;\n}\n\n.ant-switch-checked {\n  background: #141414 !important;\n}\n\nspan.anticon.anticon-eye-invisible.ant-input-password-icon {\n  top: 0px !important;\n  right: 0px !important;\n\n  margin: 0 !important;\n}\n\nspan.anticon.anticon-eye-invisible.ant-input-password-icon svg {\n  fill: #000;\n}\n\nspan.anticon.anticon-eye.ant-input-password-icon svg {\n  fill: #000 !important;\n}\n\nspan.anticon.anticon-eye.ant-input-password-icon {\n  top: 0px;\n  right: 0px;\n  margin-right: 0;\n}\n\n.forgate-btn {\n  background-color: transparent !important;\n  color: #020202 !important;\n  border: 0px;\n  font-weight: 600;\n  box-shadow: none !important;\n}\n\n.main-new-class-image-no img {\n  width: 100%;\n  height: 100%;\n  max-width: 50px;\n}\n\ntd.ant-table-cell .ant-select-selector {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 7px !important;\n}\n\n.ant-input-affix-wrapper {\n  padding: 0 !important;\n  border-radius: 8px;\n}\n\n.ant-modal-confirm-body span.anticon.anticon-exclamation- {\n  display: block;\n}\n\nspan.add-services-close-button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.ant-modal-confirm-body-wrapper .ant-modal-confirm-body span.anticon.anticon-exclamation-circle {\n  width: 100%;\n  display: block;\n  margin-right: 0px !important;\n  font-size: 60px;\n  margin-bottom: 15px;\n  color: #3b6b94 !important;\n}\n\n.ant-form-item.add-services-close-button-from label {\n  width: 100%;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.ant-modal-confirm-body-wrapper .ant-modal-confirm-body .ant-modal-confirm-content button.ant-btn.ant-btn-default {\n  width: 100%;\n  background: transparent !important;\n  border: 0 !important;\n  color: #252425 !important;\n  box-shadow: none !important;\n  font-size: 22px;\n  white-space: normal;\n  line-height: 1.2;\n  font-weight: 600;\n  padding: 0 !important;\n  outline: 0 !important;\n  box-shadow: none !important;\n  height: unset;\n}\n\n.ant-input-affix-wrapper>.ant-input:not(textarea) {\n  padding: 0 10px !important;\n  border-radius: 8px;\n}\n\n.ant-upload-list-picture .ant-upload-list-item-thumbnail img,\n.ant-upload-list-picture-card .ant-upload-list-item-thumbnail img {\n  width: 40px !important;\n  height: 40px !important;\n  overflow: hidden;\n  object-fit: cover;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ant-input-number.ant-input-number-in-form-item.ant-input-number-status-success.position-number {\n  width: 206px !important;\n}\n\n.ant-input-number.ant-input-number-in-form-item.ant-input-number-status-error.position-number {\n  width: 206px !important;\n}\n\n.ant-input-number.ant-input-number-in-form-item.position-number {\n  width: 206px !important;\n}\n\n.ant-form-horizontal .ant-form-item-control {\n  min-width: unset !important;\n}\n\n.customRow .ant-form-item-row {\n  display: flex;\n}\n\n.add-question-form .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space-item+.ant-space-item {\n  flex: 0 0 40px;\n  max-width: 40px;\n  margin-left: 5px !important;\n  height: 40px;\n}\n\n.add-question-form .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space-item {\n  width: 100%;\n  flex-basis: calc(100% - 55px);\n  max-width: calc(100% - 55px);\n}\n\n.add-question-form .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space-item .ant-form-item .ant-row.ant-form-item-row {\n  margin: 0 !important;\n}\n\n.add-question-form .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space-item .ant-form-item .ant-col.ant-form-item-control {\n  padding: 0;\n}\n\n.add-question-form .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space.ant-space-horizontal.ant-space-align-baseline .ant-space-item+.ant-space-item span.anticon.anticon-minus-circle {\n  border-radius: 2px;\n  height: 40px;\n  width: 40px;\n  margin-top: -1px;\n  position: unset;\n}\n\n.add-question-form .ant-form-item.form-add-option .ant-row.ant-form-item-row {\n  margin: 0 !important;\n}\n\n.add-question-form .ant-form-item.form-add-option .ant-row.ant-form-item-row .ant-col.ant-form-item-control {\n  margin-top: -1px;\n  padding: 0;\n}\n\n.add-question-form .ant-form-item.form-add-option .ant-row.ant-form-item-row .ant-col.ant-form-item-control button.ant-btn.ant-btn-dashed.ant-btn-icon-only.ant-btn-block {\n  margin-top: 0;\n}\n\n.add-question-form .ant-space-item {\n  align-items: center;\n}\n\n.add-question-form .ant-input-number.ant-input-number-in-form-item.position-number {\n  width: 100% !important;\n}\n\n.add-question-form .ant-input-number.ant-input-number-in-form-item.position-number input {\n  height: 38px !important;\n}\n\n.ant-form-item.add_btn_wrap {\n  width: auto !important;\n  margin-top: 15px;\n}\n\n.ant-form-item.add_btn_wrap .ant-col.ant-form-item-control {\n  width: auto !important;\n  flex: 0 0 100%;\n  padding: 0 5px;\n}\n\n.ant-form-item.add_btn_wrap .ant-row.ant-form-item-row {\n  margin: 0 -5px;\n}\n\n.ant-form-item.add_btn_wrap button.ant-btn.ant-btn-dashed.ant-btn-block {\n  height: 40px;\n}\n\n.ant-form-item.add_btn_wrap button.ant-btn.ant-btn-dashed.ant-btn-block {\n  height: 40px;\n}\n\n.ant-row.question-position-wrap {\n  margin: 0 !important;\n}\n\n.ant-row.question-position-wrap .ant-col {\n  padding: 0 !important;\n}\n\n.add-question-inner-form .ant-space-item {\n  margin: 0 !important;\n}\n\n.add-question-inner-form .ant-space-item .ant-col .ant-row.ant-form-item-row {\n  margin: 0 !important;\n}\n\n.add-question-inner-form .ant-space-item .ant-col .ant-row.ant-form-item-row .ant-col.ant-form-item-label {\n  padding: 0 !important;\n}\n\n.add-question-inner-form .ant-space-item .ant-col .ant-row.ant-form-item-row .ant-col.ant-form-item-control {\n  padding: 0 !important;\n}\n\n.add-question-inner-form .ant-space.ant-space-horizontal.ant-space-align-baseline {\n  padding: 0 !important;\n}\n\n.ant-row.customRow {\n  margin: 0 -5px;\n}\n\n.ant-row.customRow .ant-col {\n  padding: 0 5px;\n}\n\n.ant-row.customRow .ant-col .ant-col {\n  padding: 0 !important;\n}\n\n.ant-form-item.footer-btn-cls .ant-form-item-control-input-content {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  margin: 0 -5px;\n}\n\n.ant-form-item.footer-btn-cls .ant-form-item-control-input-content button.ant-btn.ant-btn-primary {\n  margin-right: 5px;\n  margin-left: 5px;\n}\n\n.add-question-inner-form {\n  margin-bottom: 15px;\n}\n\n.add-question-inner-form span.anticon.anticon-minus-circle {\n  border-radius: 2px;\n  height: 40px;\n  width: 40px;\n  /* margin-top: -1px; */\n}\n\n.ant-picker .ant-picker-input>input {\n  min-width: 100px;\n}\n\n.ant-picker {\n  padding: 8px 16px !important;\n  border-radius: 8px !important;\n  box-shadow: none !important;\n}\n\n.ant-select.ant-select-multiple .ant-select-selector {\n  padding: 8px 11px !important;\n  border-radius: 8px !important;\n}\n\n.successPageOuter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n}\n\n.submit-new-main-buttonh .ant-form-item-control-input-content {\n  display: flex;\n  justify-content: end;\n}\n\n.main-new-location-newh label {\n  width: 100%;\n}\n\n.succesOuter {\n  padding: 50px;\n  max-width: 700px;\n}\n\n.succesOuter .logo-wrap {\n  width: 120px;\n  margin: 0 auto;\n}\n\n.succesOuter .logo-wrap img {\n  width: 100%;\n}\n\n.successCardContent {\n  padding-top: 50px;\n}\n\n.successCardContent .icon {\n  width: 100px;\n  height: 100px;\n  border-radius: 50px;\n  overflow: hidden;\n  margin: 0 auto;\n}\n\n.successCardContent .icon img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: top center;\n}\n\n.successCardContent .thankyou-cont h3 {\n  font-size: 32px;\n  font-weight: bold;\n  text-align: center;\n  color: green;\n  margin: 16px 0 0;\n}\n\n.successCardContent .thankyou-cont .pera {\n  font-size: 16px;\n  font-weight: 400;\n  text-align: center;\n  color: #5c5c5c;\n  margin-top: 8px;\n}\n\n/* .ant-picker:hover, .ant-picker.ant-picker-focused {\n  border-color: #252425 !important;\n  box-shadow: none !important;\n }\n .ant-picker-range .ant-picker-active-bar {\n  background: #252425 !important;\n } */\n\n/* td.ant-table-cell:has(>.cta_wrap) {\n  min-width: 300px !important;\n} */\n.ant-table-thead>tr>th {\n  position: relative;\n  color: rgb(255 255 255 / 100%) !important;\n  font-weight: 600 !important;\n  text-align: left;\n  background: #3B6B94 !important;\n  border-bottom: 1px solid #f0f0f0;\n  font-size: 14px;\n}\n\n.ant-table-filter-dropdown-btns button.ant-btn.ant-btn-primary.ant-btn-sm {\n  padding: 5px !important;\n  width: 50px;\n  height: 30px !important;\n}\n\n.ant-table-filter-dropdown-btns {\n  align-items: center;\n}\n\n.ant-modal-content {\n  position: relative;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n  border-radius: 8px !important;\n  overflow: hidden !important;\n  box-shadow: 0 3px 6px 4px rgba(0, 0, 0, 0.12),\n    0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05) !important;\n  pointer-events: auto;\n}\n\n.ant-modal-title {\n  margin: 0;\n  color: rgba(0, 0, 0, 0.85);\n  font-weight: 600 !important;\n  font-size: 22px !important;\n  line-height: 22px;\n  word-wrap: break-word;\n  text-align: center;\n}\n\n/* .ant-modal {\n  max-width: 600px !important;\n  width: 600px !important;\n} */\nbutton.notification-box.dropdown-toggle.btn.btn-primary {\n  padding: 0;\n  border: 0;\n  background: transparent !important;\n  position: relative;\n  width: 30px;\n}\n\nbutton.notification-box.dropdown-toggle.btn.btn-primary:after {\n  content: \"\";\n  inset: unset !important;\n  position: absolute;\n  height: 8px;\n  width: 8px;\n  background: #ff3b30;\n  border-radius: 50%;\n  top: 0px !important;\n  right: 0px !important;\n  opacity: 1 !important;\n  box-shadow: none !important;\n  outline: 0 !important;\n  border: 0 !important;\n}\n\nbutton.profile-box.dropdown-toggle.btn.btn-primary {\n  background-color: transparent;\n  border: none;\n  padding: 0px !important;\n}\n\n.profileDropdownMain {\n  margin-left: 25px;\n}\n\n.profileDropdownMain {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n}\n\n.profileDropdownMain .ant-btn.ant-btn-default.ant-dropdown-trigger {\n  background-color: initial !important;\n  border: none !important;\n  box-shadow: none !important;\n  color: #000 !important;\n  display: block !important;\n  font-size: 14px;\n  height: auto !important;\n  line-height: normal;\n  padding: 0;\n  text-align: end;\n}\n\n.userImg {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #cbcbcb;\n  border-radius: 50%;\n  display: flex;\n  height: 50px;\n  justify-content: center;\n  overflow: hidden;\n  width: 50px;\n}\n\n.userImg {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #cbcbcb;\n  border-radius: 50%;\n  display: flex;\n  height: 50px;\n  justify-content: center;\n  overflow: hidden;\n  width: 50px;\n}\n\n.profileDropdownMain .ant-image img {\n    height: 100%;\n    object-fit: cover;\n    object-position: top;\n    width: 100%;\n    max-width: 40px;\n}\n\n.profileDropdownMain .ant-btn.ant-btn-default.ant-dropdown-trigger .userName {\n  font-size: 15px;\n  font-weight: 700;\n}\n\nbutton.profile-box.dropdown-toggle.btn.btn-primary img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n\n.ant-tabs-tab.ant-tabs-tab-active {\n  background-color: #3B6B94b3;\n  color: #fff;\n  border-color: #3B6B94b3;\n}\n\n.pageHeadingSearch.pageHeadingSearchnew-add-faqq {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  gap: 10px;\n}\n\n.title-left h4 {\n  margin: 0;\n}\n\nbutton.ant-btn.ant-btn-default.ant-dropdown-trigger.notification-box:hover img {\n  filter: brightness(0);\n}\n\n.button-sec.main-new-add-faq-butons_main {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n\n.primary_btn.btnStyle.main-new-add-faq-butons {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: white !important;\n  background: #3B6B94 !important;\n}\n\n.ant-card-head-title {\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.main-new-lat-10-biiking-header h4 {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 20px;\n}\n\n.primary_btn.btnStyle.main-new-add-faq-butons img {\n  filter: brightness(100);\n}\n\n.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #ffffff;\n  text-shadow: 0 0 0.25px currentcolor;\n  font-size: 14px;\n  font-weight: 600;\n}\n.ant-tabs.client-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  text-shadow: none !important;\n  color: #ffffff !important;\n  background: transparent !important;\n}\n\n.ant-tabs-ink-bar {\n  background: transparent !important;\n}\n\n.ant-tabs:not(.client-tabs) .ant-tabs-tab {\n  padding: 10px !important;\n  font-size: 14px !important;\n  font-weight: 600;\n  max-width: 300px !important;\n  width: 100% !important;\n  min-width: 150px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #f7f8f9 !important;\n  border-radius: 8px;\n  margin: 5px !important;\n  border: 1px solid #e8ecf4 !important;\n  color: #ababab !important;\n}\n\n.notification-box.show.dropdown .dropdown-menu.show {\n  box-shadow: 0px 0px 25px 0px #0000000f;\n  border-radius: 20px;\n  margin: 0 !important;\n  width: fit-content;\n  overflow: hidden;\n}\n\n.ant-input-number-input {\n  width: 100%;\n  height: 40px !important;\n  outline: none !important;\n  box-shadow: none !important;\n  border-radius: 8px;\n}\n\nli.ant-menu-submenu.ant-menu-submenu-inline.car-menagments {\n  padding: 10px 16px;\n  color: #ffffff;\n\n  white-space: nowrap;\n  border-bottom: solid 1px #cccccc29;\n  border-radius: 0 !important;\n}\n\ni.ant-menu-submenu-arrow {\n  color: #fff;\n}\n\nli.ant-menu-submenu.ant-menu-submenu-inline.car-menagments:hover i.ant-menu-submenu-arrow {\n  color: #fff;\n}\n\nli.ant-menu-submenu.ant-menu-submenu-inline.car-menagments ul.ant-menu.ant-menu-sub.ant-menu-inline {\n  background-color: #3e4245;\n}\n\nli.ant-menu-submenu.ant-menu-submenu-inline.car-menagments .ant-menu-submenu-title:hover {\n  color: #fff;\n}\n\n.ant-picker-range .ant-picker-clear {\n  right: 34px !important;\n}\n\n.ant-tag-green {\n  color: #ffffff !important;\n  background: #2ebf57 !important;\n  border-color: #2ebf57 !important;\n  border-radius: 0.375rem !important;\n  cursor: pointer;\n}\n\n.w-100.d-flex.align-items-baseline.text-head_right_cont {\n  align-items: center !important;\n  gap: 10px;\n}\n\n.ant-tag-red {\n  border-radius: 0.375rem !important;\n  color: #fff !important;\n  background: #fa4545 !important;\n  border-color: #fa4545 !important;\n  cursor: pointer;\n}\n\n.main-new-contact-us-form10 {\n  max-width: 400px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.ant-tabs-tab:hover {\n  color: #000000;\n}\n.main-new-contact-us-form10 input.form-control {\n    height: 45px !important;\n    border-radius: 8px !important;\n    border: 1px solid #e8ecf4 !important;\n    background: #f7f8f9 !important;\n    box-shadow: inset 0 0 20px 20px #f7f8f9 !important;\n    overflow: hidden;\n    width: 100%;\n}\n.main-new-contact-us-form10 .ant-form-item-control-input-content input {\n    height: 45px !important;\n}\nspan.main-caricon img {\n  display: inline-flex;\n  flex: 0 0 20px;\n  max-width: 20px;\n  width: 20px;\n  max-height: 20px;\n  box-shadow: 0 4px 6px rgb(0 0 0 / 12%);\n  border-radius: 6px;\n  justify-content: center;\n  align-items: center;\n  margin-right: 11px;\n  vertical-align: middle;\n  filter: brightness(23.5);\n}\n\n.home-cards {\n  position: relative;\n  display: block;\n  margin: 25px 0 30px;\n  background-color: #ffffff;\n  border-radius: 30px;\n}\n\n.home-card-inner {\n  padding: 45px 25px 20px;\n}\n\n.home-cards .icon {\n  position: absolute;\n  top: -20px;\n  left: 20px;\n  z-index: 0;\n  font-size: 50px;\n  height: 50px;\n  width: 50px;\n  background-color: #ff9800;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n}\n\n.home-cards .icon img {\n  width: 30px;\n  color: #ffffff;\n  text-align: center;\n  margin: 0 auto;\n  display: block;\n}\n\n.card-counts h2 {\n  font-size: 30px;\n  color: #303841;\n  font-weight: bold;\n}\n\n.headding-card h4 {\n  font-size: 18px;\n  color: #303841;\n  margin: 0;\n}\n\n.ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination-next .ant-pagination-item-link {\n  display: block;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  font-size: 12px;\n  text-align: center;\n  background-color: #ffffff !important;\n  border: 1px solid #d9d9d9;\n  border-radius: 2px;\n  outline: none;\n  transition: all 0.3s;\n}\n\n.dlx-box h6 {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n/* .dlx-box {\n  display: flex;\n  gap: 15px;\n} */\n.dlx-box p {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.dlx-main-box {\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 50px;\n  row-gap: 15px;\n}\n\n.car-filtter img {\n  max-width: 50px;\n  width: 100%;\n  height: 50px;\n  object-fit: cover;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n}\n\n.ant-card.criclebox.tablespace.mb-24.new-tabls-button-design .ant-card-body {\n  position: relative;\n}\n\n.car-filtter {\n  display: flex;\n  gap: 16px;\n  align-items: baseline;\n}\n\n.driver-details h4 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #ff9800;\n  border-bottom: 1px solid #fecf00;\n  margin-bottom: 18px;\n}\n\n.textarea-inn textarea {\n  border-radius: 15px !important;\n}\n\n.ant-select.ant-select-in-form-item.select-show-inn.ant-select-multiple.ant-select-show-search {\n  height: 100% !important;\n}\n\n.select-show-inn .ant-select-selector {\n  border-radius: 15px !important;\n}\n\n.timeline {\n  max-width: 640px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 34px 30px;\n  background-color: #fff;\n  border-radius: 18px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.timeline__header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 100%;\n  border: 2px solid #f0f0f8;\n  padding: 34px 70px;\n  border-radius: 5px;\n  position: relative;\n}\n\n.timeline__header::after {\n  content: \"\";\n  width: 100%;\n  height: 70px;\n  bottom: 0px;\n  left: 0px;\n  position: absolute;\n  z-index: 2;\n  background-color: #f0f0f8;\n}\n\n.timeline__header span {\n  margin-bottom: 10px;\n  text-align: center;\n  color: gray;\n  font-size: 14px;\n  text-transform: uppercase;\n  font-weight: bold;\n}\n\n.timeline__header h1 {\n  margin-bottom: 100px;\n  font-size: 20px;\n  color: #262245;\n  text-align: center;\n}\n\n.timeline__header .process {\n  height: 8px;\n  background-color: #fff;\n  border-radius: 3px;\n  z-index: 4;\n}\n\n.timeline__header .process .xd {\n  width: 50%;\n  border-radius: 3px;\n  height: 8px;\n  background-color: #2563eb;\n}\n\n.line {\n  padding: 10px 90px;\n  position: relative;\n  /* margin-top: 50px; */\n}\n\n.line::before {\n  position: absolute;\n  width: 2px;\n  height: 100%;\n  left: 90px;\n  background-color: #2563eb;\n  content: \"\";\n}\n\n.line .content {\n  position: relative;\n  padding-left: 30px;\n}\n\n.line .content+.content {\n  margin-top: 40px;\n}\n\n.line .content h1 {\n  font-size: 16px;\n  margin-bottom: 5px;\n  margin-top: 15px;\n}\n\n.line .content p {\n  font-size: 14px;\n}\n\n.line .content::before {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  background-color: #2563eb;\n  content: \"\";\n  left: -9px;\n  border-radius: 50%;\n}\n\n.notification-card {\n  margin-top: 16px;\n}\n\n.view-main-list {\n  padding: 16px;\n  border: 1px solid #e8e8e8;\n  border-radius: 4px;\n  background-color: #fff;\n}\n\n.main-dltall-not-all {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  gap: 10px;\n}\n\n.notification-card .ant-list-item-meta-avatar {\n  margin-right: 16px;\n  width: 60px !important;\n  height: 60px !important;\n}\n\n.notification-card span.ant-avatar.ant-avatar-circle.ant-avatar-image {\n  width: 60px;\n  height: 60px;\n  display: flex;\n  left: inherit;\n  align-items: center;\n  justify-content: center;\n  background: #d19e6569;\n}\n\nh4.main-logo-header-ui98 {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 20px;\n  margin-bottom: 15px;\n}\n\n.view-inner-cls {\n  margin-bottom: 12px;\n}\n\n/* .ant-popover-arrow {\n  display: none;\n}\n.ant-popover-title {\n  text-align: center;\n  font-size: 21px;\n  font-weight: 700;\n  line-height: 30px;\n}\n.ant-popover-content {\n  border-radius: 12px !important;\n  overflow: hidden;\n  border: 1px solid #00000029;\n}\n.ant-popover-inner-content {\n  padding: 0 !important;\n}\n.ant-table-cell {\n  text-align: center !important;\n} */\n.notifivation-teexxt.dropdown-menu.show h4 {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 25px;\n}\n\n.notifivation-teexxt.dropdown-menu.show h4 span {\n  font-weight: 400 !important;\n}\n\n.spin_loader {\n  height: 100vh;\n  width: 100vw;\n  background: #00000052;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1111;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\nspan.ant-avatar.ant-avatar-circle.ant-avatar-image img {\n  width: 30px;\n  height: 30px;\n}\n\n.ant-select-selector {\n    background: #ffffff !important;\n    height: 40px !important;\n    display: flex;\n    align-items: center;\n    border-radius: 8px !important;\n    border: 1px solid #d9d9d9 !important;\n    background-color: #ffffff !important;\n    min-width: 120px !important;\n    width: 100% !important;\n}\n\nspan.ant-input-affix-wrapper {\n  border: none !important;\n}\nspan.ant-input-affix-wrapper.ant-input-password input {\n    border: none !important;\n    background: transparent !important;\n}\n.ant-table-filter-column {\n    justify-content: flex-start !important;\n    gap: 10px !important;\n}\n.main-new-upload-graph-name-insturction {\n  font-size: 13px;\n  font-weight: 600;\n  color: #000000a6;\n  margin: 0;\n  margin-top: 5px;\n}\n\n.ant-btn-primary:hover,\n.ant-btn:hover {\n  background: transparent !important;\n  color: transparent;\n  border: 1px solid #3B6B94 !important;\n  color: #3B6B94 !important;\n}\n\n.ant-modal-footer button.ant-btn.ant-btn-primary,\n.ant-modal-confirm-btns button.ant-btn.ant-btn-primary {\n  background: #3B6B94 !important;\n  color: #fff !important;\n}\n\n.main-new-add-ons-category-ones-ikj-plus {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  margin-top: 5px;\n}\n\n.main-new-add-ons-category-ones-ikj-plus .ant-form-item.add-services-close-button-from {\n  width: 100% !important;\n}\n\n.main-new-add-ons-category-ones-ikj-plus input#price_add_on {\n  width: 100% !important;\n}\n\n.ant-select.main-new-select-absolute.ant-select-single.ant-select-show-arrow {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n}\n\n/* \n.main-new-time-slot-radiobutton-main4545 {\n  background-color: rgb(249, 249, 249);\n  padding: 15px;\n  border-radius: 8px;\n  margin-top: 20px;\n} */\n\n.main-new-time-slot-radiobutton {\n  display: flex !important;\n  align-items: center !important;\n  padding: 10px 15px !important;\n  background: rgb(255, 255, 255);\n  border-radius: 6px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 5px;\n}\n\n.main-new-time-slot-radiobutton-main4545 .ant-radio-inner {\n  top: -3px !important;\n}\n\n.ant-modal-confirm-body span.anticon.anticon-question-circle {\n  font-size: 70px;\n  margin: 0;\n  margin-bottom: 20px;\n  width: 100%;\n  text-align: center;\n  justify-content: center;\n}\n\n.main-new-header-of-table10 {\n  gap: 15px;\n}\n\nspan.ant-select-selection-placeholder {\n  color: rgba(0, 0, 0, 0.85) !important;\n  font-weight: 600;\n}\n\n/* Select placeholders inside the table modals (Add/Edit Content Theme, etc.) use the same\n   light hint gray as the text inputs, instead of reading like entered text. */\n.ant-modal.table_modal span.ant-select-selection-placeholder {\n  color: #b8bfc7 !important;\n}\n\n.ant-form-item span.ant-input-affix-wrapper.ant-input-affix-wrapper-has-feedback {\n  box-shadow: none !important;\n}\n\n.main-new-clildren-class-menuy .ant-menu-submenu-title {\n  padding: 0px !important;\n}\n\n.main-new-clildren-class-menuy span.ant-menu-title-content a {\n  padding: 0px 0px !important;\n}\n\n.main-new-clildren-class-menuy .active::after {\n  background: none !important;\n}\n\n.main-new-clildren-class-menuy .ant-menu-submenu-arrow::before,\n.main-new-clildren-class-menuy .ant-menu-submenu-arrow::after {\n  background-color: #000 !important;\n}\n\n.main-new-clildren-class-menuy .ant-menu-submenu-arrow:hover:before,\n.main-new-clildren-class-menuy .ant-menu-submenu-arrow:hover::after {\n  background-color: #000 !important;\n}\n\nli.ant-menu-submenu.ant-menu-submenu-inline.main-new-clildren-class-menuy102.ant-menu-submenu-active .ant-menu-submenu-arrow::before,\nli.ant-menu-submenu.ant-menu-submenu-inline.main-new-clildren-class-menuy102.ant-menu-submenu-active .ant-menu-submenu-arrow::after {\n  background-color: #000 !important;\n}\n\n.main-new-clildren-class-menuy .ant-menu-submenu-expand-icon,\n.main-new-clildren-class-menuy .ant-menu-submenu-arrow {\n  right: 23px !important;\n}\n\n.main-new-clildren-class-menuy ul.ant-menu.ant-menu-sub.ant-menu-inline {\n  margin-left: 25px;\n  background: none !important;\n}\n\n.ant-menu-submenu-title {\n  padding-left: 0px !important;\n}\n\n.ant-menu-submenu-title {\n  margin: 6px 15px !important;\n  padding: 0px !important;\n  border-radius: 10px;\n  width: unset !important;\n  font-weight: 500 !important;\n  padding: 6px 16px !important;\n  color: #000 !important;\n}\n\n.ant-menu-submenu-title span.ant-menu-title-content {\n  margin: 0px !important;\n}\n\nli.ant-menu-submenu span.ant-menu-title-content a {\n  margin-left: 30px !important;\n}\n\n.ant-modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n\n.ant-card-head-wrapper input.ant-input.ant-input-lg {\n  border: none !important;\n}\n\n.notification-header img {\n  filter: brightness(100) !important;\n}\n\nul.ant-menu.ant-menu-sub.ant-menu-inline li.ant-menu-item.ant-menu-item-only-child a {\n  line-height: 30px;\n}\n\nul.ant-menu.ant-menu-sub.ant-menu-inline li.ant-menu-item.ant-menu-item-only-child a.active {\n  background: none !important;\n  color: #3B6B94;\n}\n\nli.ant-menu-item.ant-menu-item-only-child {\n  background: white !important;\n}\n\n.ant-menu-submenu-selected .ant-menu-submenu-title {\n  background: #3B6B94 !important;\n  color: white;\n}\n\nli.ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-open.ant-menu-submenu-selected .ant-menu-submenu-title span.ant-menu-title-content {\n\n  color: white;\n}\nli.ant-menu-submenu.ant-menu-submenu-inline.ant-menu-submenu-open.ant-menu-submenu-selected .ant-menu-submenu-title span.ant-menu-title-content img{\n    filter: invert(1);\n}\n.layout-dashboard .ant-layout-sider.sider-primary .ant-menu-item .active .icon img {\n    filter: invert(1);\n}\n.ant-modal-confirm-btns {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  border-top: 1px solid #f0f0f0;\n  padding-top: 10px;\n}\n.button-group.button-group-new-mian {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n}\nbutton.ant-btn.ant-btn-primary.active-button-maink {\n    background: #1d9cc9 !important;\n    border-color: #1d9cc9 !important;\n}\n.notification-group .ant-list-item-meta {\n    align-items: center !important;\n}\n.ant-modal-confirm-body p {\n    text-align: center;\n    font-size: 16px;\n    font-weight: 600;\n}\nbutton.ant-btn.ant-btn-default.table-light-fill-btn {\n  background: #EDF3FF;\n}\n.client-profile-img-outer {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n.client-profile-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n}\n.client-profile-view-page {\n  background: var(--bg-app);\n  padding: 20px;\n  border-radius: var(--r-lg);\n}\n.view-client-text p {\n  color: var(--text-secondary);\n  font-weight: var(--fw-medium);\n  font-size: var(--fs-base);\n  line-height: var(--lh-normal);\n  letter-spacing: 0;\n  margin: 0;\n}\n.view-client-text h6 {\n  font-weight: var(--fw-bold);\n  font-size: var(--fs-2xl);\n  line-height: var(--lh-tight);\n  letter-spacing: 0;\n  color: var(--text-primary);\n  margin: 0;\n}\n.view-client-img  img {\n    width: 100%;\n}\n.view-client-img {\n    width: 80px;\n    height: 80px;\n    border-radius: 10px;\n    flex: 0 0 auto;\n}\n.acc-card-main {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: space-between;\n  background: var(--bg-surface);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border);\n  border-radius: var(--r-lg);\n  padding: 14px 20px;\n  max-width: none;\n  width: 100%;\n  flex: 1 1 calc(25% - 15px);\n  min-width: 220px;\n  transition: box-shadow var(--dur-base) var(--ease-out);\n}\n.acc-card-main:hover {\n  box-shadow: var(--shadow-md);\n  transform: translateY(-3px);\n}\n.acc-client-outer-list {\n    display: flex;\n    flex-wrap: nowrap;\n    width: 100%;\n    gap: 15px;\n}\n.acc-client-outer-list > .acc-card-main {\n  animation: ime-fade-in-up var(--dur-slow) var(--ease-out) both;\n}\n.acc-client-outer-list > .acc-card-main:nth-child(1) { animation-delay: 0ms; }\n.acc-client-outer-list > .acc-card-main:nth-child(2) { animation-delay: 60ms; }\n.acc-client-outer-list > .acc-card-main:nth-child(3) { animation-delay: 120ms; }\n.acc-client-outer-list > .acc-card-main:nth-child(4) { animation-delay: 180ms; }\n\n.acc-card-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  min-width: 52px;\n  border-radius: var(--r-md);\n  background: var(--brand-gradient-soft);\n  box-shadow: inset 0 0 0 1px var(--brand-100);\n  font-size: 22px;\n  flex-shrink: 0;\n  transition: background var(--dur-base) var(--ease-out);\n}\n.acc-card-main:hover .acc-card-icon {\n  background: linear-gradient(135deg, var(--brand-100) 0%, #d9f2f3 100%);\n}\n\n/* ── Stats wrapper: cards row + account manager bar ────────────────────── */\n.acc-stats-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n/* ── Account Manager bar ───────────────────────────────────────────────── */\n.acc-manager-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #f8faff;\n  border: 1px solid #e4eaf5;\n  border-radius: 12px;\n  padding: 10px 18px;\n  gap: 16px;\n}\n.acc-manager-bar-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.acc-manager-icon-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: #e8eeff;\n  color: #4361ee;\n  font-size: 15px;\n  flex-shrink: 0;\n}\n.acc-manager-info {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n.acc-manager-label {\n  font-size: 11px;\n  font-weight: 500;\n  color: #8896ab;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  line-height: 1;\n}\n.acc-manager-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1e293b;\n  line-height: 1.3;\n}\n.acc-manager-bar-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n.acc-manager-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: #ffffff;\n  border: 1px solid #dde3f0;\n  border-radius: 20px;\n  padding: 4px 12px;\n  font-size: 12.5px;\n  color: #475569;\n  font-weight: 400;\n  white-space: nowrap;\n}\n.acc-manager-chip .anticon {\n  color: var(--brand-600);\n  font-size: 12px;\n}\n.acc-card-breakdown {\n    color: #64748b;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.35;\n    margin-top: 6px;\n    white-space: nowrap;\n}\n.acc-card-breakdown span[role=\"button\"] {\n    cursor: pointer;\n}\n.acc-card-breakdown span[role=\"button\"]:hover {\n    color: var(--brand-600);\n    text-decoration: underline;\n}\n.acc-card-breakdown .acc-card-breakdown-disabled {\n    color: #9ca3af;\n    cursor: default;\n    pointer-events: none;\n    text-decoration: none;\n}\n.acc-card-text h4 {\n  font-weight: var(--fw-bold);\n  font-size: var(--fs-xl);\n  line-height: 100%;\n  letter-spacing: 0;\n  color: var(--text-primary);\n  margin: 0;\n}\n.acc-card-text h6 {\n  color: var(--text-muted);\n  font-weight: var(--fw-medium);\n  font-size: var(--fs-sm);\n  line-height: 100%;\n  letter-spacing: 0.02em;\n  vertical-align: middle;\n  margin-bottom: 8px;\n}\nbutton.ant-btn.edit-icon-btn {\n    width: 50px;\n    height: 50px !important;\n    border-radius: 50% !important;\n    background: #FFFFFF !important;\n    border-color  : #FFFFFF !important;\n    padding: 5px !important;\n}\n.preferences-card-header h6 {\n  color: var(--text-primary);\n  font-weight: var(--fw-bold);\n  font-size: var(--fs-lg);\n  line-height: var(--lh-tight);\n  letter-spacing: 0;\n  margin: 0;\n}\n.preferences-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 15px;\n}.preferences-card-list-menubar h6 {\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 150%;\n    letter-spacing: 0;\n    margin-bottom: 5px;\n}\n.preferences-card-list-menubar {\n    max-width: 318px;\n    width: 100%;\n}\n.preferences-card-list-menubar ul {\n    padding-left: 18px;\n    margin: 0;\n}\n.preferences-card-list-menubar ul li {\n    color: #1e293b;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 1.6;\n}\n.preferences-card-list {\n    display: flex;\n    gap: 15px;\n    width: 100%;\n}\n.acces-client-calender {\n  margin-top: 24px;\n  background: var(--bg-surface);\n  padding: 16px;\n  border-radius: var(--r-lg);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n}\n/* ── Client Tabs — pill nav bar, full-width ── */\n.ant-tabs.client-tabs .ant-tabs-nav {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 8px 10px;\n  box-shadow: 0 1px 4px rgba(15,23,42,0.06), 0 4px 16px rgba(15,23,42,0.04);\n  margin-bottom: 24px !important;\n}\n.ant-tabs.client-tabs .ant-tabs-nav::before {\n  border-bottom: none !important;\n}\n.ant-tabs.client-tabs .ant-tabs-nav-wrap {\n  overflow-x: auto !important;\n  flex: 1 !important;\n}\n.ant-tabs.client-tabs .ant-tabs-nav-list {\n  width: 100% !important;\n  flex-wrap: nowrap !important;\n  gap: 2px;\n}\n.ant-tabs.client-tabs .ant-tabs-ink-bar {\n  display: none !important;\n}\n.ant-tabs.client-tabs .ant-tabs-tab {\n  flex: 1 1 0 !important;\n  min-width: fit-content !important;\n  justify-content: center !important;\n  background: transparent !important;\n  border: none !important;\n  padding: 11px 10px !important;\n  border-radius: 10px !important;\n  width: auto !important;\n  max-width: none !important;\n  margin: 0 !important;\n  color: inherit !important;\n  white-space: nowrap !important;\n  transition: background 0.18s ease !important;\n}\n.ant-tabs.client-tabs .ant-tabs-tab:hover {\n  background: rgba(59,107,148,0.07) !important;\n}\n.ant-tabs.client-tabs .ant-tabs-tab.ant-tabs-tab-active {\n  background: linear-gradient(135deg, #3B6B94 0%, #071E31 100%) !important;\n  box-shadow: 0 3px 10px rgba(59,107,148,0.35) !important;\n  color: #ffffff !important;\n}\n.ant-tabs.client-tabs .ant-tabs-tab.ant-tabs-tab-active span.tab-label {\n  color: #ffffff !important;\n  font-weight: 700 !important;\n}\n.ant-tabs.client-tabs span.tab-label {\n  font-size: 13.5px;\n  font-weight: 500;\n  line-height: 1;\n  letter-spacing: 0;\n  color: #5a7080 !important;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n.ant-tabs.client-tabs .ant-tabs-tab + .ant-tabs-tab {\n  margin: 0 2px !important;\n}\n.calendar-controls .ant-btn-default {\n    display: inline-flex !important;\n    height: unset !important;\n    align-items: center;\n    justify-content: center;\n    border-radius: 7px !important;\n    color: #92929D !important;\n    border-color: #42424229 !important;\n    background: transparent !important;\n    box-shadow: unset !important;\n}\n.client-profile-header-02 p {\n    font-size: 14px;\n    color: black;\n}\n.action-footer-buttons {\n    display: flex;\n    justify-content: end;\n    gap: 20px;\n}\nbutton.ant-btn.submitted-btn {\n  background: var(--brand-gradient) !important;\n  padding: 0 24px;\n  color: #fff !important;\n  border-radius: var(--r-md) !important;\n  font-weight: var(--fw-semibold);\n  font-size: var(--fs-base);\n  height: 40px !important;\n  border: none !important;\n}\nbutton.ant-btn.schedule-btn {\n  background: var(--brand-500) !important;\n  padding: 0 24px;\n  color: #fff !important;\n  border-radius: var(--r-md) !important;\n  font-weight: var(--fw-semibold);\n  font-size: var(--fs-base);\n  height: 40px !important;\n  border: none !important;\n}\n.action-footer-buttons button.ant-btn.ant-btn-default.submitted-btn {\n    max-width: 250px !important;\n    width: 100%;\n}\n.profile-followers {\n  color: var(--text-secondary);\n  font-weight: var(--fw-regular);\n  font-size: var(--fs-base);\n  line-height: 100%;\n  letter-spacing: 0;\n  margin: 8px 0;\n}\n.profile-date {\n  font-weight: var(--fw-semibold);\n  font-size: var(--fs-base);\n  line-height: 100%;\n  letter-spacing: 0;\n  color: var(--text-secondary);\n}\n.profile-post-images {\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    overflow: hidden;\n}\n.profile-header {\n    display: flex;\n    gap: 10px;\n    align-items: flex-start;\n}\n.drawer--up-body {\n    padding: 70px 30px !important;\n}\n.action-icons {\n    display: flex;\n    align-items: center;\n}\n.ant-table-tbody>tr>td.ant-table-cell .action-icons .ant-btn.ant-btn-default {\n  align-items: center;\n  padding: 0px  !important;\n  width: 36px !important;\n  height: 36px !important;\n  margin-right: 10px;\n  display: inline-flex !important;\n  gap: 7px;\n  background: #EDF3FF !important;\n  border-radius: 45px !important;\n  font-weight: 400 !important;\n  text-transform: capitalize !important;\n  letter-spacing: 0px !important;\n}\n.ant-table-tbody>tr>td.ant-table-cell .action-icons button.ant-btn.ant-btn-default.table-light-fill-btn {\n  background: #EDF3FF;\n}\n.ant-table-tbody>tr>td.ant-table-cell .action-icons button.ant-btn.ant-btn-default.table-primary-fill-btn {\n  background: #3B6B94 !important;\n}\n.ant-table-tbody>tr>td.ant-table-cell .action-icons button.ant-btn.ant-btn-default.table-danger-fill-btn {\n  background: #FF3030 !important;\n}\n.ant-table-tbody>tr>td.ant-table-cell .action-icons button.ant-btn.ant-btn-default.table-danger-fill-btn img {\n  filter: brightness(18.5);\n}\nbutton.ant-btn.delete-fill-btn {\n    max-width: 250px;\n    width: 100%;\n    background-color: #071E31 !important;\n    margin: 0 auto;\n    height: 50px !important;\n    color: #fff !important;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 100%;\n    letter-spacing: 0px;\n}\n.delete-modal-body p {\n    font-weight: 400;\n    font-size: 22px;\n    line-height: 1.5;\n    letter-spacing: -0.27px;\n    text-align: center;\n    color: #686868;\n    margin: 0;\n}\n.delete-modal-body h3 {\n    color: #414454;\n    font-weight: 600;\n    font-size: 32px;\n    line-height: 150%;\n    letter-spacing: 0;\n    text-align: center;\n    margin: 0;\n}\n.delete-modal-body img {\n    max-width: 150px;\n    height: 150px;\n    margin: 0 auto;\n    width: 100%;\n}\n.delete-modal-body {\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n    text-align: center;\n    max-width: 400px;\n    margin: 0 auto;\n}\n.ant-modal-mask {\n    -webkit-backdrop-filter: blur(4px);\n    backdrop-filter: blur(4px);\n    background: #00000040 !important;\n}\n.ant-modal.table_modal.delete-modal .ant-modal-body {\n    padding: 35px 36px !important;\n}\n.ant-modal.table_modal .ant-modal-content {\n    box-shadow: 0px 4px 30px 4px #00000021;\n    border-radius: 25px !important;\n    overflow: hidden;\n}\n.repport-headding-sec {\n    display: flex;\n    gap: 50px;\n    align-items: end;\n    justify-content: space-between;\n}\n.report-count-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 12px;\n  margin-top: 20px;\n}\n\n/* ─── KPI card styles — matches user panel exactly ─── */\n.report-count-grid .content-card.kpi-card {\n  background: #ffffff;\n  border: 1px solid #E5E7EB;\n  border-radius: 10px;\n  padding: 14px 14px 14px 18px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n.report-count-grid .content-card.kpi-card:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);\n}\n.report-count-grid .content-card.kpi-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0; left: 0; bottom: 0;\n  width: 3px;\n  background: #0A66C2;\n}\n.report-count-grid .content-card.kpi-card .content-idea-card { display: block; }\n.report-count-grid .content-card.kpi-card .content-idea-card h6 {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #6B7280;\n  margin: 0;\n}\n.report-count-grid .content-card.kpi-card .report-count-detail-bar { margin-top: 0; }\n.report-count-grid .content-card.kpi-card .report-count-detail-bar h4 {\n  font-weight: 700;\n  font-size: 30px;\n  line-height: 1.1;\n  letter-spacing: -0.5px;\n  text-align: left;\n  color: #0F172A;\n  margin: 0;\n}\n.report-count-grid .content-card.kpi-card .report-count-detail-bar h6 {\n  font-weight: 400;\n  font-size: 11.5px;\n  line-height: 1.3;\n  color: #64748B;\n  text-align: left;\n  margin: 6px 0 0;\n}\n.report-count-grid .kpi-followers::before   { background: #0A66C2; }\n.report-count-grid .kpi-posts::before       { background: #6366F1; }\n.report-count-grid .kpi-likes::before       { background: #F59E0B; }\n.report-count-grid .kpi-comments::before    { background: #10B981; }\n.report-count-grid .kpi-shares::before      { background: #06B6D4; }\n.report-count-grid .kpi-impressions::before { background: #8B5CF6; }\n.report-count-grid .kpi-reach::before       { background: #EC4899; }\n@media (min-width: 1600px) {\n  .report-count-grid .content-card.kpi-card .report-count-detail-bar h4 { font-size: 36px; }\n  .report-count-grid .content-card.kpi-card .content-idea-card h6       { font-size: 12px; }\n}\n@media (max-width: 1100px) {\n  .report-count-grid { grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); }\n}\n.card-top-icon img {\n    width: 25px;\n}\n.card-top-icon {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n}\n.content-idea-card h6 {\n    color: #1D1E24;\n    font-size: 15px;\n    line-height: 100%;\n    letter-spacing: 0px;\n    margin: 0;\n    margin-bottom: 10px;\n    font-weight: 500;\n}\n.content-card {\n    background: #fff;\n    border-radius: 15px;\n    padding: 15px;\n    position: relative;\n    border: 1px solid #CBD5E1;\n    display: grid;\n    gap: 15px;\n}\n.inner-day-report {\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 100%;\n    letter-spacing: 0px;\n    text-align: center;\n    color: #3F4753;\n    margin-top: 50px;\n}\n/* Skeleton shimmer used while report data is (re)loading after a period change */\n.report-count-grid .content-card.kpi-card.kpi-card--loading .report-count-detail-bar h4,\n.report-count-grid .content-card.kpi-card.kpi-card--loading .report-count-detail-bar h6 {\n  color: transparent;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #eceff3 25%, #f6f7f9 37%, #eceff3 63%);\n  background-size: 400% 100%;\n  animation: report-shimmer 1.4s ease infinite;\n}\n.report-count-grid .content-card.kpi-card.kpi-card--loading .report-count-detail-bar h4 {\n  display: inline-block;\n  width: 60%;\n  min-height: 30px;\n}\n.report-count-grid .content-card.kpi-card.kpi-card--loading .report-count-detail-bar h6 {\n  display: inline-block;\n  width: 80%;\n  min-height: 14px;\n}\n@keyframes report-shimmer {\n  0% { background-position: 100% 50%; }\n  100% { background-position: 0 50%; }\n}\n.report-period-dropdown {\n  min-width: 260px;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n  padding: 8px 0;\n}\n.report-period-dropdown .ant-radio-wrapper {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 10px 16px;\n  margin: 0;\n}\n.report-period-dropdown .ant-radio-wrapper:hover {\n  background: #f5f7fa;\n}\n.report-period-dropdown .report-period-custom-range {\n  padding: 8px 16px 4px;\n}\n.report-period-dropdown .report-period-footer {\n  padding: 12px 16px 4px;\n  border-top: 1px solid #eef1f4;\n  margin-top: 4px;\n}\n\n.incam-price-count {\n    color: #00B468;\n    font-weight: 500;\n    font-size: 22px;\n    line-height: 100%;\n    letter-spacing: 0px;\n    text-align: center;\n}\n.report-count-detail-bar h6 {\n    font-weight: 500;\n    line-height: 100%;\n    letter-spacing: 0px;\n    color: #3F4753;\n    text-align: center;\n    margin: 12px 0px;\n}\n.report-count-detail-bar h4 {\n    font-weight: 600;\n    font-size: 50px;\n    line-height: 100%;\n    letter-spacing: 0px;\n    text-align: center;\n    color: #1D1E24;\n    margin: 0;\n}\n.report-count-detail-bar {\n    margin-top: 40px;\n}\n.report-section-01 {\n    margin-bottom: 20px;\n}\n.headding-titals h4 {\n    color: #110B2A;\n    font-weight: 700;\n    font-size: 32px;\n    line-height: 150%;\n    letter-spacing: 0;\n    margin: 0;\n}\n.repport-headding-sec {\n    display: flex;\n    gap: 50px;\n    align-items: end;\n    justify-content: space-between;\n}\n.chart-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n.report-weekly-card {\n    margin-top: 20px;\n    border: 0.71px solid #CBD5E1;\n    border-radius: 10px;\n    padding: 10px;\n}\n.headding-titals h4 {\n    color: #110B2A;\n    font-weight: 700;\n    font-size: 32px;\n    line-height: 150%;\n    letter-spacing: 0;\n    margin: 0;\n}\nbutton.ant-btn.report-btn {\n    border: 0.71px solid #CBD5E1 !important;\n    font-weight: 700;\n    font-size: 10px;\n    line-height: 14.1px;\n    letter-spacing: 0;\n    color: #475569 !important;\n    gap: 5px;\n    border-radius: 50px !important;\n    padding: 7px 10px !important;\n    background: transparent !important;\n    height: 31px !important;\n}\nspan.highlight-tag {\n    color: #475569;\n    font-weight: 600;\n    font-size: 10px;\n    line-height: 11.28px;\n    letter-spacing: 0;\n    text-align: center;\n}\n.chart-left-outer {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n.headline-actions {\n    flex: 0 0 auto;\n    display: flex;\n    gap: 24px;\n}\n.headline-text {\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 1.4;\n    letter-spacing: 0px;\n    color: #1D1E24;\n}\n.searching-listbar {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    align-items: center;\n    gap: 10px;\n}\n\n.headline-actions button.ant-btn.ant-btn-default {\n    background: transparent !important;\n    border: none !important;\n    padding: 0px !important;\n    box-shadow: unset !important;\n}\n.headlines-section, .topics-section, .trends-section {\n    margin-top: 30px;\n}\n.headline-toll-headding {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n}\n.headline-toll-headding h6 {\n    color: #1D1E24;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 100%;\n    letter-spacing: 0px;\n    margin: 0;\n}\n.headline-actions {\n    flex: 0 0 auto;\n    display: flex;\n    gap: 24px;\n}\n.tag-topics {\n    background: #fff;\n    padding: 8px 16px;\n    border-radius: 10px;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 100%;\n    letter-spacing: 0px;\n    color: #1D1E24;\n    border: 1px solid #3B6B9433;\n}\n.tags-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-top: 20px;\n}\nsection.headlines-section h6 {\n    color: #000000;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 100%;\n    letter-spacing: 0px;\n    margin-bottom: 20px;\n}\n.ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-content {\n    height: 100% !important;\n    width: 100% !important;\n}\n.content-area {\n    flex: 1 1;\n    padding: 15px;\n    background: #F2F5FF;\n    border-radius: 10px;\n}\n.header-02-writing {\n    flex-wrap: wrap;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    margin: 20px 0px;\n}\n.writing-header-bar h6 {\n    font-weight: 600;\n    font-size: 25px;\n    line-height: 100%;\n    letter-spacing: 0px;\n    margin: 0;\n}\n.sidebar-left-research {\n    width: 100%;\n    background: #F2F5FF;\n    padding: 30px;\n    border-radius: 10px;\n    max-width: 600px;\n}\n.sidebar-left-research.writing-ass {\n    max-width: 100%;\n    padding: 20px;\n}\n.writing-ass-footer {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    flex-wrap: wrap;\n    margin-top: 15px;\n}\n.writing-ass-footer.writing-button-group {\n    justify-content: space-between;\n    align-items: center;\n}\n.writing-button-comp {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    flex-wrap: wrap;\n    width: 50%;\n}\n.footer-writing-btn {\n    position: relative;\n    display: flex;\n    justify-content: end;\n    gap: 10px;\n    align-items: center;\n    margin-top: 150px;\n    flex-wrap: wrap;\n}\n.writing-ass-footer button.ant-btn.fill-btn {\n    height: 35px !important;\n    max-width: 150px;\n    width: 100%;\n}\n.writing-ass-footer button.ant-btn.borderd-btn {\n    border: 1px solid #D7D7D7 !important;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 100%;\n    letter-spacing: 0px;\n    height: 35px !important;\n    color: #071E31 !important;\n    max-width: 150px;\n    width: 100%;\n    background: white !important;\n}\n.writing-ass-footer.writing-button-group button.ant-btn.submitted-btn {\n    background: #071E31;\n    padding: 10px 20px;\n    color: #fff !important;\n    border-radius: 6px !important;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 100%;\n    letter-spacing: 0px;\n    height: 35px !important;\n}\n.writing-ass-footer.writing-button-group button.ant-btn.schedule-btn {\n    background: #3B6B94;\n    padding: 10px 20px;\n    color: #fff !important;\n    border-radius: 6px !important;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 100%;\n    letter-spacing: 0px;\n    height: 35px !important;\n}\n.writing-list-bar ul li.active {\n    background-color: #3B6B94;\n    border-color: #3B6B94;\n    box-shadow: 0 4px 12px rgba(59, 107, 148, 0.2);\n    font-weight: 500;\n    color: #fff;\n    border-radius: 6px !important;\n}\n.writing-list-bar ul li {\n    padding: 10px;\n    margin-bottom: 8px;\n    border: 1px solid #D9E2EF;\n    border-radius: 6px;\n    background-color: #fff;\n    transition: all 0.3s ease;\n}\n.writing-list-bar ul {\n    padding: 0px;\n    margin: 0px;\n    list-style: none;\n}\n.writing-list-bar {\n    padding: 15px;\n    background: #F2F5FF;\n    border-radius: 10px;\n}\n.writing-list-bar ul li a {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 1.4;\n    letter-spacing: 0px;\n    color: #3F4753 !important;\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.writing-list-bar ul li.active a {\n    color: #fff !important;\n    white-space: normal;\n}\nbutton.ant-btn.run-button {\n    font-weight: 500 !important;\n    font-size: 20px !important;\n    line-height: 100% !important;\n    letter-spacing: 0px !important;\n    margin-top: 25px;\n    height: 50px !important;\n}\n\n.writing-assistant-chat-container {\n  \n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  max-height: 60vh;\n  margin: 0 auto;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scroll-behavior: smooth;\n}\nbutton.ant-btn.ant-btn-default.table-primary-fill-btn {\n  background: #3B6B94 !important;\n  color: #fff !important;\n}\n.chat-bubble.left {\n  align-self: flex-start;\n  background-color: #F2F5FF;\n  border-top-left-radius: 4px;\n}\n.chat-content {\n  line-height: 1.4;\n}\n.chat-bubble.right {\n  align-self: flex-end;\n  background-color: #3B6B94;\n  color: white;\n  border-top-right-radius: 4px;\n}\n.chat-bubble {\n  max-width: 70%;\n  padding: 10px 14px;\n  border-radius: 18px;\n  position: relative;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  white-space: pre-wrap;\n}\n.chat-bubble {\n  animation: fadeIn 0.3s ease-in-out;\n}\n.post-image {\n    width: 100%;\n    border-radius: 8px;\n}\n.post-detail-page {\n    display: flex;\n    justify-content: end;\n    align-items: center;\n    gap: 13px;\n    margin-bottom: 0px;\n}\nbutton.ant-btn.post-edit-btn {\n    padding: 0px;\n    outline: none;\n    border: 0px !important;\n    box-shadow: none !important;\n    background: transparent !important;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-info {\n    width: 100% !important;\n}\n.custom-upload-item-video-thumb {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 5px;\n  cursor: pointer;\n  display: block;\n}\n\n.custom-upload-item-delete {\n    position: absolute;\n    right: 0;\n    top: 0;\n    background: #ff0000a6 !important;\n    border-radius: 50px;\n    width: 18px !important;\n    height: 18px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: black;\n    z-index: 1024;\n    font-size: 10px;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-info .ant-upload-list-item-thumbnail {\n    height: 100% !important;\n    width: 100% !important;\n}\n.ant-upload-list-picture-card .ant-upload-list-item {\n    height: 100% !important;\n    margin: 0;\n}\n.ant-upload-list-picture-card .ant-upload-list-item-info .ant-upload-list-item-thumbnail .ant-upload-list-item-image {\n    height: 100% !important;\n    width: 100% !important;\n    object-fit: cover;\n}\n.ant-upload-list-picture-card span.anticon.anticon-delete {\n    height: fit-content !important;\n}\n.ant-row.ant-form-item-row .rdw-editor-wrapper {\n    border: solid 1px #D7D7D7 !important;\n    border-radius: 10px;\n    overflow: hidden;\n}\n.post-comment-toggle {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    margin-top: 10px;\n}\n.post-comment-toggle p {\n    color: #071E31;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 100%;\n    letter-spacing: 0px;\n    margin: 0;\n}\n.upload-post-description {\n    margin: 24px 0px;\n}\n.ant-drawer.post-upload-drawer .ant-drawer-header-title {\n    justify-content: end;\n    position: absolute;\n    right: 0px;\n    top: 30px;\n}\n.ant-drawer.post-upload-drawer .ant-drawer-header-title .ant-drawer-close {\n    color: rgb(0 0 0) !important;\n    font-size: 22px;\n}\nbutton.ant-btn.ant-btn-default.ant-drawer-close.main-new-drawer-claose {\n    background: transparent !important;\n    box-shadow: unset !important;\n    border: none !important;\n}\nbutton.ant-btn.ant-btn-default.fill-btn {\n    background: var(--brand-gradient) !important;\n    color: #fff !important;\n    font-weight: var(--fw-semibold);\n    font-size: var(--fs-base);\n    line-height: 100%;\n    letter-spacing: 0;\n    height: 36px !important;\n    border-radius: var(--r-md) !important;\n    border: none !important;\n    box-shadow: var(--shadow-brand);\n}\n.post-editor-title {\n    font-weight: var(--fw-semibold);\n    font-size: var(--fs-lg);\n    line-height: 100%;\n    letter-spacing: 0;\n    color: var(--text-primary);\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    margin-bottom: 18px;\n}\n.ant-modal-confirm-body {\n    display: grid;\n    place-content: center;\n    text-align: center;\n}\n.ant-modal-confirm-body .ant-modal-confirm-content {\nmargin: 0px !important;\n}\nspan.ant-modal-confirm-title {\n    font-size: 22px !important;\n    font-weight: 500 !important;\n}\n\n/* Delete Account confirm (User.js) — the account name + optional\n   active-contract warning, added to that modal's `content`. Sized/spaced\n   to match the shared .ant-modal-confirm look (centered icon+title above,\n   14px muted-gray body text) rather than reading as a bolted-on afterthought. */\n.delete-account-confirm-content p {\n  margin: 0;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.65);\n  line-height: 1.6;\n}\n.delete-account-confirm-warning {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 16px;\n  padding: 10px 14px;\n  background: #fffbe6;\n  border: 1px solid #ffe58f;\n  border-radius: 8px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 500;\n  color: #874d00;\n}\n.delete-account-confirm-warning .anticon {\n  margin-top: 2px;\n  flex-shrink: 0;\n  color: #d48806;\n  font-size: 15px;\n}\n\n/* Bulk-delete confirm (BrandManager.js's \"Delete Selected\" — Customer\n   Management/User.js has no bulk delete) — the list of selected accounts'\n   names, between the two <p>s. Left-aligned like the warning box, capped\n   height with its own scroll so selecting 20 rows doesn't blow the modal\n   off-screen. */\n.delete-account-confirm-list + p {\n  margin-top: 12px !important;\n}\n.delete-account-confirm-list {\n  margin: 8px 0 0;\n  padding: 8px 14px;\n  max-height: 140px;\n  overflow-y: auto;\n  text-align: left;\n  list-style: disc;\n  background: #fafafa;\n  border: 1px solid #f0f0f0;\n  border-radius: 8px;\n  font-size: 13px;\n  color: rgba(0, 0, 0, 0.75);\n}\n.delete-account-confirm-list li {\n  padding: 2px 0;\n}\n\n.research-mode-select {\n  position: absolute;\n  bottom: 6px;\n  right: 8px;\n  width: auto;\n  min-width: 68px;\n  max-width: 90px;\n  height: 20px;\n  font-size: 11px;\n  background: #f5f5f5;\n  border-radius: 12px;\n  box-shadow: inset 0 0 0 1px #d9d9d9;\n}\n\n.best-model-strip {\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.rag-scrollable-content {\n  max-height: 300px;\n  overflow-y: auto;\n  padding: 12px;\n  background: #fafafa;\n  border-radius: 6px;\n  border: 1px solid #eaeaea;\n}\n\n.rag-analysis {\n  margin-top: 16px;\n  padding: 12px;\n  background: #fffbe6;\n  border-radius: 6px;\n  border: 1px solid #ffe58f;\n}\n\n.rag-analysis pre {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.rag-result-card {\n  border-radius: 12px;\n  padding: 16px;\n}\n\n.rag-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.rag-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.rag-subtitle {\n  font-size: 13px;\n  color: #888;\n}\n\n.rag-content {\n  max-height: 420px;\n  overflow-y: auto;\n  padding: 14px;\n  background: #fafafa;\n  border-radius: 8px;\n  font-size: 14px;\n  line-height: 1.7;\n}\n\n.rag-content h1,\n.rag-content h2,\n.rag-content h3 {\n  margin-top: 16px;\n}\n\n.rag-analysis {\n  margin-top: 16px;\n  display: grid;\n  gap: 12px;\n}\n\n.analysis-card {\n  border-radius: 10px;\n  background: #fafafa;\n}\n\n.analysis-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.analysis-card-header h6 {\n  margin: 0;\n  font-size: 14px;\n}\n\n.analysis-card-body {\n  max-height: 260px;\n  overflow-y: auto;\n  padding: 10px;\n  background: #fff;\n  border-radius: 6px;\n  font-size: 13px;\n  line-height: 1.6;\n}\n\n.model-answer-card {\n  border-radius: 10px;\n  background: #ffffff;\n}\n\n.model-answer-card .analysis-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.error-text {\n  color: #d4380d;\n  background: #fff2f0;\n  padding: 10px;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n.score-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 6px 0;\n  font-size: 13px;\n}\n\n\n\n/* actual select box */\n.research-mode-select .ant-select-selector {\n  height: 20px !important;\n  padding: 0 6px !important;\n  line-height: 20px !important;\n}\n\n/* selected text */\n.research-mode-select .ant-select-selection-item {\n  line-height: 20px !important;\n  font-size: 11px;\n  padding: 0 !important;\n}\n\n/* remove extra spacing */\n.research-mode-select .ant-select-selection-search {\n  display: none;\n}\n\n/* Brand assignee picker (Manual Onboarding — Content Strategy Deck card).\n   Two global rules fight a size=\"small\" select here: .ant-select-selector\n   forces height:40px !important, and .ant-select-single .ant-select-selector\n   .ant-select-selection-placeholder forces line-height:42px !important. Class\n   selectors here previously lost that specificity fight (or won it after a\n   fix but still rendered wrong in testing) — using the wrapper's #id below\n   guarantees this wins over any class-only rule, no specificity math needed. */\n#content-strategy-assignee-wrap .ant-select-selector {\n  height: 24px !important;\n  padding: 0 7px !important;\n  line-height: 22px !important;\n}\n#content-strategy-assignee-wrap .ant-select-selection-placeholder,\n#content-strategy-assignee-wrap .ant-select-selection-item {\n  line-height: 22px !important;\n  padding: 0 !important;\n}\n#content-strategy-assignee-wrap .ant-select-selection-search {\n  inset-inline-start: 7px !important;\n  inset-inline-end: 7px !important;\n}\n#content-strategy-assignee-wrap .ant-select-selection-search-input {\n  height: 22px !important;\n}\n.create-post-container {\n  background:\n    radial-gradient(circle at top left, rgba(10, 102, 194, 0.1), transparent 34%),\n    linear-gradient(135deg, #f8fafd 0%, #eef3f8 52%, #f6f8fb 100%);\n  border: 1px solid rgba(120, 143, 175, 0.16);\n  border-radius: 24px;\n  min-height: calc(100vh - 120px);\n  padding: 26px;\n}\n\n.post-up-header {\n  display: flex;\n  gap: 14px;\n  align-items: center;\n  margin-bottom: 18px;\n  color: #071e31;\n}\n\n.post-up-header-avatar {\n  border: 3px solid #fff;\n  box-shadow: 0 14px 30px rgba(30, 54, 86, 0.16);\n}\n\n.post-up-header h6 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.drawer--up-body {\n  padding: 24px 0 0;\n}\n\n.post-preview-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  height: 100%;\n}\n\n.post-preview-label {\n  color: #446584;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.linkedin-preview-shell {\n  background:\n    linear-gradient(#ffffff, #ffffff) padding-box,\n    linear-gradient(135deg, rgba(10, 102, 194, 0.26), rgba(116, 139, 166, 0.1)) border-box;\n  border: 1px solid transparent;\n  border-radius: 22px;\n  box-shadow: 0 22px 48px rgba(31, 54, 84, 0.1);\n  padding: 22px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.linkedin-preview-shell:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 28px 60px rgba(31, 54, 84, 0.14);\n}\n\n.linkedin-preview-shell .profile-header {\n  gap: 14px;\n  align-items: center;\n}\n\n.linkedin-preview-shell .profile-post-images {\n  width: 58px;\n  height: 58px;\n  min-width: 58px;\n}\n\n.linkedin-preview-shell .profile-post-images img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 50%;\n  border: 2px solid #eef4fb;\n}\n\n.linkedin-preview-shell .profile-name {\n  color: #111827;\n  font-size: 17px;\n  font-weight: 800;\n}\n\n.linkedin-preview-shell .profile-followers {\n  color: #65748b;\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 3px 0;\n}\n\n.linkedin-preview-shell .profile-date {\n  color: #25364f;\n  font-size: 14px;\n  font-weight: 600;\n  /* The date text and calendar icon are two inline siblings inside a plain\n     block div — on a narrow preview card there's just barely not enough\n     width for both, so the browser wraps mid-content (\"Aug 2\" / \"1\" +\n     icon on the next line) instead of keeping the date intact. Laying them\n     out as a non-wrapping flex row keeps \"Aug 21 📅\" together as one unit. */\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.linkedin-preview-title {\n  margin-top: 18px;\n  color: #102033;\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.linkedin-preview-text,\n.linkedin-preview-placeholder {\n  margin-top: 14px;\n  color: #1f2937;\n  font-size: 15px;\n  /* Real LinkedIn post copy renders at a much tighter line-height than\n     1.8 — that value inflated every single line break (not just the\n     genuinely blank ones the post text contains via \"\\n\\n\"), making\n     even adjacent, non-blank lines look double-spaced in this preview. */\n  line-height: 1.5;\n  white-space: pre-wrap;\n}\n\n.linkedin-preview-text p,\n.linkedin-preview-text ul,\n.linkedin-preview-text ol {\n  margin-bottom: 12px;\n}\n\n/* Hanging indent for list-marker lines (\"- \" / \"1. \") in the plain-text\n   preview — negative text-indent pulls the marker itself back out to the\n   margin, padding-left pushes everything (including a wrapped second line)\n   in by the same amount, so a wrapped bullet/numbered line lines up under\n   its own text instead of falling back to the left margin. Matches how the\n   real published post wraps on LinkedIn. */\n.linkedin-preview-list-line {\n  padding-left: 1.4em;\n  text-indent: -1.4em;\n}\n\n.linkedin-preview-placeholder {\n  color: #73839a;\n  background: linear-gradient(135deg, #f8fbff, #f2f6fb);\n  border: 1px dashed #c8d6e7;\n  border-radius: 14px;\n  padding: 18px;\n}\n\n.linkedin-preview-shell .upload-post-description {\n  margin: 18px 0 8px;\n}\n\n.linkedin-preview-shell .post-image,\n.linkedin-preview-shell .post-video {\n  border-radius: 20px;\n  overflow: hidden;\n}\n\n.post-contant-outerpanel {\n  background: rgba(255, 255, 255, 0.96);\n  border: 1px solid #dfe7f1;\n  border-radius: 22px;\n  box-shadow: 0 22px 52px rgba(31, 54, 84, 0.09);\n  padding: 22px;\n}\n\n.post-contant-outerpanel .ant-form-item {\n  margin-bottom: 18px;\n}\n\n.post-contant-outerpanel .ant-form-item-label > label {\n  color: #102033;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.post-contant-outerpanel .ant-input,\n.post-contant-outerpanel .ant-select-selector,\n.post-contant-outerpanel .rdw-editor-wrapper {\n  border-radius: 12px !important;\n}\n\n.post-contant-outerpanel .rdw-editor-wrapper {\n  border: 1px solid #d7e0eb;\n  overflow: visible;\n  background: #fff;\n}\n\n.post-contant-outerpanel .ant-input,\n.post-contant-outerpanel .ant-select-selector {\n  min-height: 38px;\n  border-color: #d7e0eb !important;\n  box-shadow: none !important;\n}\n\n.post-contant-outerpanel .ant-input:focus,\n.post-contant-outerpanel .ant-select-focused .ant-select-selector,\n.post-contant-outerpanel .rdw-editor-wrapper:focus-within {\n  border-color: #3b6b94 !important;\n  box-shadow: 0 0 0 3px rgba(59, 107, 148, 0.12) !important;\n}\n\n.post-contant-outerpanel .rdw-editor-toolbar {\n  border: 0;\n  border-bottom: 1px solid #e6ebf3;\n  margin-bottom: 0;\n  padding: 9px 12px;\n  background: #f7f9fc;\n  border-radius: 12px 12px 0 0;\n}\n\n.post-contant-outerpanel .rdw-editor-main {\n  min-height: 220px;\n  padding: 14px 16px;\n  font-size: 16px;\n  /* Matches the LinkedIn Preview panel's line-height (1.5) — this cascades\n     to every block equally (tight or blank), so a value looser than the\n     preview made even single, non-blank line breaks look pre-spaced in the\n     editor, and made a genuinely-added blank line hard to tell apart from\n     the existing baseline gap. */\n  line-height: 1.5;\n  color: #16233f;\n  border-radius: 0 0 12px 12px;\n}\n\n/* react-draft-wysiwyg's OWN shipped CSS (react-draft-wysiwyg.css) ships an\n   UNSCOPED \".public-DraftStyleDefault-block { margin: 1em 0; }\" rule that\n   applies to every block in every Editor instance on the page, regardless\n   of preset — that's what actually made a single Enter look like a full\n   paragraph gap instead of a tight line break (a previous attempt to\n   override this was scoped to \".editorClassName\", which is not a real\n   class — the actual editorClassName prop value is \"custom-editor\" — so it\n   silently never matched anything). This scoped selector has higher\n   specificity than the library's bare one and reliably wins regardless of\n   CSS load order. */\n.post-contant-outerpanel .rdw-editor-main .public-DraftStyleDefault-block {\n  margin: 0;\n  /* Per-paragraph direction: Arabic paragraphs read right-to-left, English stay left-to-right. */\n  unicode-bidi: plaintext;\n  text-align: start;\n}\n\n/* A blank line the user types (an empty paragraph, just a <br> with no\n   text) has no content to size a line-height box against, so its rendered\n   height isn't guaranteed the way a text-containing block's is — the\n   editor's own live view could under-represent consecutive blank lines\n   (visually reading as fewer than were actually typed) even though the\n   underlying data and the plain-text LinkedIn Preview (which renders\n   literal \"\\n\" characters, not box-model height) both have the correct\n   count. Pinning each block to exactly one line-height (matching the 1.5\n   set on .rdw-editor-main, not a taller value) keeps the editor's own view\n   honest with however many blank lines are really there, while making a\n   pressed-twice blank line take up exactly the same vertical space as a\n   single line of text. Scoped to .post-empty-block (set via blockStyleFn)\n   only — applying this to every block, blank or not, inflated ordinary\n   paragraphs too and produced visibly oversized gaps between adjacent,\n   non-blank lines. */\n.post-contant-outerpanel .rdw-editor-main .public-DraftStyleDefault-block.post-empty-block {\n  min-height: 1.5em;\n}\n\n/* Same fix, same reasoning, for the Blog Write outline builder's \"outline\"\n   preset (.normal-editor-shell-outline) — it was missing this scoped\n   override entirely, so react-draft-wysiwyg's unscoped 1em block margin was\n   still winning there and stacking up into the \"too much space between\n   lines\" look reported on that editor specifically. */\n.normal-editor-shell-outline .rdw-editor-main {\n  font-size: 15px;\n  line-height: 1.5;\n}\n.normal-editor-shell-outline .rdw-editor-main .public-DraftStyleDefault-block {\n  margin: 0;\n}\n.normal-editor-shell-outline .rdw-editor-main .public-DraftStyleDefault-block.post-empty-block {\n  min-height: 1.5em;\n}\n\n.normal-editor-shell-linkedin .rdw-option-wrapper {\n  width: 34px;\n  height: 34px;\n  border: 0;\n  border-radius: 10px;\n  box-shadow: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n}\n\n.normal-editor-shell-linkedin .rdw-option-wrapper:hover,\n.normal-editor-shell-linkedin .rdw-option-wrapper.rdw-option-active {\n  background: #e8f1fb;\n  color: #0a66c2;\n}\n\n.normal-editor-shell-linkedin .rdw-dropdown-wrapper,\n.normal-editor-shell-linkedin .rdw-link-dropdown,\n.normal-editor-shell-linkedin .rdw-emoji-dropdown {\n  border: 0;\n  border-radius: 12px;\n  box-shadow: none;\n  background: transparent;\n}\n\n.normal-editor-shell-linkedin .rdw-editor-toolbar,\n.normal-editor-shell-linkedin .rdw-emoji-wrapper,\n.normal-editor-shell-linkedin .rdw-emoji-dropdown {\n  position: relative;\n  overflow: visible;\n}\n\n.normal-editor-shell-linkedin .rdw-editor-toolbar {\n  flex-wrap: nowrap;\n  align-items: center;\n  z-index: 5;\n}\n\n.normal-editor-shell-linkedin .rdw-editor-toolbar > div {\n  flex-shrink: 0;\n  flex-grow: 0;\n  margin-right: 8px;\n}\n\n.normal-editor-shell-linkedin .rdw-link-modal,\n.normal-editor-shell-linkedin .rdw-emoji-modal {\n  border-radius: 16px;\n  border: 1px solid #dfe7f2;\n  box-shadow: 0 18px 48px rgba(22, 35, 63, 0.14);\n  z-index: 1200;\n}\n\n.normal-editor-shell-linkedin .custom-emoji-toolbar {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  margin-right: 8px;\n}\n\n.normal-editor-shell-linkedin .custom-emoji-trigger {\n  font-size: 18px;\n  line-height: 1;\n}\n\n.normal-editor-shell-linkedin .custom-emoji-modal {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  width: 244px;\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 6px;\n  padding: 10px;\n  border-radius: 16px;\n  border: 1px solid #dfe7f2;\n  background: #ffffff;\n  box-shadow: 0 18px 48px rgba(22, 35, 63, 0.14);\n  z-index: 1201;\n}\n\n.normal-editor-shell-linkedin .custom-emoji-item {\n  border: 0;\n  background: transparent;\n  border-radius: 10px;\n  font-size: 20px;\n  line-height: 1;\n  padding: 8px 0;\n  cursor: pointer;\n}\n\n.normal-editor-shell-linkedin .custom-emoji-item:hover {\n  background: #eef4ff;\n}\n\n/* Calendar/post composer polish */\n.ant-drawer.post-upload-drawer .ant-drawer-body {\n  padding: 0 !important;\n  overflow: hidden !important;\n  background: #eef4fa;\n  display: flex !important;\n  flex-direction: column !important;\n  height: 100% !important;\n}\n\n.ant-drawer.post-upload-drawer .ant-drawer-content {\n  background: #eef4fa;\n}\n\n.post-upload-drawer .create-post-container {\n  flex: 1 1 auto;\n  min-height: 0;\n  border-radius: 0;\n  border: 0;\n  padding: 22px 28px 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.post-upload-drawer .post-up-header {\n  flex: 0 0 auto;\n  min-height: 52px;\n  margin-bottom: 24px;\n}\n\n.post-upload-drawer .post-up-header h6,\n.post-upload-drawer .post-editor-title,\n.post-upload-drawer .post-preview-label,\n.post-upload-drawer .post-contant-outerpanel .ant-form-item-label > label,\n.post-upload-drawer .post-comment-toggle p {\n  color: #071e31 !important;\n}\n\n/* Visibility selector (Anyone / Connections only) — mirrors LinkedIn's own\n   native post-composer visibility picker. .post-comment-toggle's default\n   layout is a single-row label+switch pair; this block instead holds a\n   label plus a full-width, multi-row radio list, so it needs its own\n   flex-direction rather than the row layout the base class expects. */\n.post-visibility-block {\n  flex-direction: column !important;\n  align-items: stretch !important;\n  gap: 10px !important;\n}\n\n.post-visibility-group.ant-radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.post-visibility-group .ant-radio-wrapper.post-visibility-option {\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin: 0;\n  padding: 10px 14px;\n  border: 1px solid #e3eaf2;\n  border-radius: 12px;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.post-visibility-group .ant-radio-wrapper.post-visibility-option:hover {\n  border-color: #b9cee5;\n}\n\n.post-visibility-group .ant-radio-wrapper-checked.post-visibility-option {\n  border-color: #0a66c2;\n  background: #f0f6ff;\n}\n\n.post-visibility-group .ant-radio-wrapper.post-visibility-option > span:last-child {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  padding: 0;\n}\n\n.post-visibility-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #f1f5f9;\n  color: #334155;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.post-visibility-text {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.post-visibility-text strong {\n  color: #071e31;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.post-visibility-text small {\n  color: #65748b;\n  font-size: 12px;\n}\n\n.post-upload-drawer .drawer--up-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 0 0 24px;\n}\n\n.post-upload-drawer .drawer--up-body > .ant-row {\n  align-items: flex-start;\n}\n\n.post-upload-drawer .post-preview-panel {\n  position: sticky;\n  top: 0;\n  min-height: auto;\n}\n\n.post-upload-drawer .linkedin-preview-shell,\n.post-upload-drawer .post-contant-outerpanel {\n  border-radius: 16px;\n}\n\n.post-upload-drawer .post-contant-outerpanel {\n  padding: 0;\n  overflow: visible !important;\n}\n\n.post-upload-drawer .post-editor-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 54px;\n  padding: 0 18px;\n  margin: 0;\n  border-bottom: 1px solid #e3eaf2;\n  font-size: 16px;\n  font-weight: 800;\n  flex-wrap: nowrap;\n}\n\n.post-upload-drawer .post-editor-icon-box {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #3b6b94 0%, #0a66c2 100%);\n  box-shadow: 0 6px 16px rgba(10, 102, 194, 0.28);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 16px;\n}\n\n.post-upload-drawer .post-editor-title-text {\n  flex: 1;\n  /* Without this, a flex item with nowrap text ignores flex:1 shrinking and\n     instead forces the whole row to its full content width — pushing the\n     link/delete icons and \"Edit Post\" button on narrow screens past the\n     drawer's edge instead of leaving them room. */\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #071e31;\n  font-size: 16px;\n  font-weight: 800;\n  white-space: nowrap;\n}\n\n.post-upload-drawer .post-editor-title > img {\n  display: none;\n}\n\n.post-upload-drawer .post-editor-title .post-detail-page {\n  margin-bottom: 0;\n  flex-shrink: 0;\n}\n\n.post-upload-drawer .post-editor-title .post-edit-btn {\n  width: 34px;\n  height: 34px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px !important;\n  border: 1px solid #e3eaf2 !important;\n  background: #f6f9fc !important;\n  padding: 0 !important;\n  transition: background 0.18s, border-color 0.18s;\n}\n\n.post-upload-drawer .post-editor-title .post-edit-btn:hover {\n  background: #e8f0f7 !important;\n  border-color: #c7d9ec !important;\n}\n\n.post-upload-drawer .post-editor-title .post-edit-btn img {\n  width: 16px;\n  height: 16px;\n  object-fit: contain;\n}\n\n.post-upload-drawer .post-editor-title .fill-btn {\n  height: 34px !important;\n  padding: 0 16px !important;\n  font-size: 13px !important;\n  font-weight: 700;\n  border-radius: 8px !important;\n  white-space: nowrap;\n}\n\n.post-upload-drawer .post-contant-outerpanel > .ant-form-item,\n.post-upload-drawer .post-contant-outerpanel > .post-comment-toggle,\n.post-upload-drawer .post-contant-outerpanel > div:not(.post-editor-title):not(.action-footer-buttons) {\n  margin-left: 18px;\n  margin-right: 18px;\n}\n\n.post-upload-drawer .post-contant-outerpanel .ant-form-item {\n  margin-bottom: 14px;\n}\n\n.post-upload-drawer .post-contant-outerpanel .rdw-editor-main {\n  min-height: 210px;\n  max-height: 34vh;\n  overflow-y: auto;\n}\n\n/* Footer sits naturally at the bottom of the form content — no sticky, no float */\n.post-upload-drawer .action-footer-buttons,\n.post-upload-drawer .post-contant-outerpanel .action-footer-buttons {\n  position: static !important;\n  bottom: auto !important;\n  z-index: auto !important;\n  display: flex;\n  /* `wrap` (not `nowrap`) is what actually makes this responsive: with\n     several long labels (\"Send for Review\", \"Publish\", \"Save as Draft\",\n     etc.), any container narrower than roughly 700-750px can't fit them\n     all on one row. `wrap` is a no-op on wide screens (buttons only wrap\n     once they'd genuinely overflow) but lets them drop to a second row\n     instead of the old forced-nowrap approach, which — combined with\n     `min-width: 0` below — let the browser cram every button into one row\n     by shrinking each below its own readable text width, producing\n     overlapping/clipped labels instead of ever actually wrapping. */\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px;\n  padding: 14px 18px !important;\n  margin: 16px 0 0 !important;\n  border-top: 1px solid #e3eaf2;\n  background: #fff !important;\n  backdrop-filter: none;\n  border-radius: 0 0 16px 16px;\n}\n\n.post-upload-drawer .action-footer-buttons .ant-btn {\n  /* !important + box-sizing/line-height pinned explicitly on every one of\n     these — antd's own per-variant rules (default vs primary vs\n     dangerous/\"danger\") carry their own padding/line-height/border, and\n     without pinning all of them here those variants (e.g. \"Override & Send\n     to Client\", a plain `danger type=\"primary\"` button with no extra class)\n     render visibly shorter/thinner than the rest, exactly the reported\n     \"buttons aren't uniform\" bug. */\n  flex: 1 1 auto;\n  /* A real min-width (not 0) is what lets `flex-wrap: wrap` above actually\n     trigger — with min-width:0 the browser could always cram every button\n     into one row by shrinking each below its own label's width, so wrap\n     never kicked in and text just overlapped instead. */\n  min-width: 150px;\n  box-sizing: border-box !important;\n  height: 46px !important;\n  min-height: 46px !important;\n  line-height: 1 !important;\n  padding: 0 16px !important;\n  border-radius: 10px !important;\n  font-size: 15px !important;\n  font-weight: 700 !important;\n  white-space: nowrap;\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.post-upload-drawer .action-footer-buttons button.ant-btn.ant-btn-default.submitted-btn {\n  max-width: none !important;\n  width: auto;\n}\n\n.post-upload-drawer .post-action-btn {\n  min-width: 86px;\n}\n\n/* LinkedIn preview — all 4 action buttons on ONE row */\n.linkedin-preview-shell .action-buttons {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 8px;\n  margin-top: 14px;\n  width: 100%;\n}\n\n.linkedin-preview-shell .post-action-btn {\n  flex: 1;\n  min-width: 0;\n  height: 40px;\n  border: 1px solid #eef2f7;\n  border-radius: 10px;\n  color: #334155;\n  font-weight: 700;\n  box-shadow: 0 8px 18px rgba(31, 54, 84, 0.05);\n  white-space: nowrap;\n  padding: 0 8px !important;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n@media (max-width: 991px) {\n  .post-upload-drawer .create-post-container {\n    padding: 18px 16px 0;\n  }\n\n  .post-upload-drawer .post-preview-panel {\n    position: static;\n  }\n\n  .post-upload-drawer .action-footer-buttons {\n    gap: 8px;\n  }\n\n  .post-upload-drawer .action-footer-buttons .ant-btn {\n    font-size: 13px !important;\n    padding: 0 10px !important;\n  }\n}\n\n@media (max-width: 1200px) {\n  .post-upload-drawer .create-post-container { padding: 18px 20px 0 !important; }\n  .post-upload-drawer .drawer--up-body { padding: 0 !important; }\n  .post-upload-drawer .post-contant-outerpanel { padding: 0 !important; }\n  .post-upload-drawer .linkedin-preview-shell { padding: 18px !important; }\n}\n\n@media (max-width: 992px) {\n  .post-upload-drawer .drawer--up-body .ant-row { flex-direction: column !important; }\n  .post-upload-drawer .drawer--up-body .ant-col { max-width: 100% !important; flex: 0 0 100% !important; }\n  .post-upload-drawer .create-post-container { padding: 16px 16px 0 !important; }\n  .post-upload-drawer .post-contant-outerpanel { padding: 0 !important; }\n  .post-upload-drawer .linkedin-preview-shell { padding: 16px !important; }\n  button.ant-btn.submitted-btn, button.ant-btn.schedule-btn { font-size: 14px !important; height: 42px !important; padding: 0 16px !important; min-width: 110px; }\n}\n\n@media (max-width: 768px) {\n  .ant-drawer.post-upload-drawer { width: 100% !important; }\n  .post-upload-drawer .create-post-container { padding: 12px 12px 0 !important; }\n  .post-upload-drawer .post-up-header h6 { font-size: 14px !important; }\n  /* post-contant-outerpanel is correctly 0 — its children carry their own\n     left/right margins. The preview card has no such per-child spacing, so\n     zeroing it out too (as this used to) left every element inside it —\n     name, date, title, caption, like/comment counts, action buttons —\n     flush against the card's edges with no breathing room at all. */\n  .post-upload-drawer .post-contant-outerpanel { padding: 0 !important; border-radius: 14px !important; }\n  .post-upload-drawer .linkedin-preview-shell { padding: 16px !important; border-radius: 14px !important; }\n  /* No forced nowrap here — the base rule's `flex-wrap: wrap` (with a real\n     min-width on each button) already lets footer buttons drop to a second\n     row the moment they don't fit, instead of overlapping/clipping like\n     they did when this used to force nowrap at every width down to 600px. */\n  .post-upload-drawer .action-footer-buttons { gap: 8px !important; }\n  button.ant-btn.submitted-btn, button.ant-btn.schedule-btn { font-size: 13px !important; height: 42px !important; padding: 0 10px !important; max-width: none !important; }\n}\n\n/* Multiple footer buttons genuinely don't fit side-by-side on a phone-width\n   screen without truncating their labels. Stack them full-width instead of\n   forcing them into one nowrap row. */\n@media (max-width: 600px) {\n  .post-upload-drawer .action-footer-buttons,\n  .post-upload-drawer .post-contant-outerpanel .action-footer-buttons {\n    flex-wrap: wrap !important;\n    flex-direction: column !important;\n    gap: 10px !important;\n    padding: 12px 14px !important;\n  }\n\n  .post-upload-drawer .action-footer-buttons .ant-btn {\n    flex: 1 1 100% !important;\n    width: 100% !important;\n    min-width: 0 !important;\n    max-width: none !important;\n    white-space: normal !important;\n    text-align: center;\n    line-height: 1.25;\n  }\n\n  button.ant-btn.submitted-btn,\n  button.ant-btn.schedule-btn {\n    white-space: normal !important;\n    min-width: 0 !important;\n  }\n\n  /* The toolbar (B / I / S, undo/redo, list options) is forced\n     `flex-wrap: nowrap` with every group `flex-shrink: 0` (see the base\n     .normal-editor-shell-linkedin .rdw-editor-toolbar rule) so it never\n     drops icons — great on desktop, but on a phone-width editor there just\n     isn't room for every group on one row, so the icons overlap/squeeze\n     into each other instead of the toolbar simply growing taller. Letting\n     it wrap fixes that without touching the 34px icon sizing. */\n  .normal-editor-shell-linkedin .rdw-editor-toolbar {\n    flex-wrap: wrap !important;\n    row-gap: 4px;\n  }\n\n  .normal-editor-shell-linkedin .rdw-editor-toolbar > div {\n    margin-right: 4px !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .post-upload-drawer .create-post-container { padding: 10px 10px 0 !important; }\n  .post-upload-drawer .post-contant-outerpanel { padding: 0 !important; border-radius: 12px !important; }\n  .post-upload-drawer .linkedin-preview-shell { padding: 14px !important; border-radius: 12px !important; }\n  .post-upload-drawer .post-editor-title { font-size: 15px !important; gap: 8px !important; padding: 0 12px !important; }\n  .post-upload-drawer .post-editor-title-text { font-size: 14px !important; }\n  .post-upload-drawer .post-editor-title .post-edit-btn { width: 30px !important; height: 30px !important; }\n  .post-upload-drawer .post-editor-title .fill-btn { padding: 0 10px !important; font-size: 12px !important; }\n  button.ant-btn.submitted-btn, button.ant-btn.schedule-btn { font-size: 13px !important; height: 40px !important; }\n}\n\n/* Below ~400px, \"Like / Comment / Repost / Send\" (4 full-label buttons) no\n   longer fit on one row without the last one (Send) getting pushed past the\n   card edge — tighten padding/gap/font so all 4 stay fully visible. */\n@media (max-width: 400px) {\n  .linkedin-preview-shell .action-buttons {\n    gap: 4px;\n  }\n\n  .linkedin-preview-shell .post-action-btn {\n    padding: 0 4px !important;\n    font-size: 12px !important;\n    gap: 4px;\n  }\n}\n\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .ant-drawer.post-upload-drawer .ant-drawer-body,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .ant-drawer.post-upload-drawer .ant-drawer-content {\n  background: #0f172a;\n}\n\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .create-post-container {\n  background:\n    radial-gradient(circle at top left, rgba(46, 141, 218, 0.18), transparent 36%),\n    linear-gradient(135deg, #111827 0%, #0f172a 58%, #111827 100%);\n}\n\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .post-up-header h6,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .post-editor-title,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .post-preview-label,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .post-contant-outerpanel .ant-form-item-label > label,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .post-comment-toggle p,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .linkedin-preview-title,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .linkedin-preview-text,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .profile-name,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .profile-date {\n  color: #f8fafc !important;\n}\n\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .linkedin-preview-shell,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .post-contant-outerpanel {\n  background: #111827;\n  border-color: #26364d;\n  box-shadow: 0 22px 52px rgba(0, 0, 0, 0.28);\n}\n\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .profile-followers,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .linkedin-preview-placeholder {\n  color: #cbd5e1;\n}\n\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .linkedin-preview-placeholder,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .rdw-editor-toolbar {\n  background: #172033;\n  border-color: #2b3b52;\n}\n\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .ant-input,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .ant-select-selector,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .rdw-editor-wrapper,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .rdw-editor-main {\n  background: #0f172a !important;\n  border-color: #2b3b52 !important;\n  color: #f8fafc !important;\n}\n\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .ant-input::placeholder,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .public-DraftEditorPlaceholder-root {\n  color: #94a3b8 !important;\n}\n\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .post-upload-drawer .action-footer-buttons {\n  background: rgba(17, 24, 39, 0.96);\n  border-color: #26364d;\n}\n\n/* drawer--up-body is the scroll container; body stays hidden */\n.post-upload-drawer .post-contant-outerpanel {\n  overflow: visible !important;\n}\n\n.post-upload-drawer .post-contant-outerpanel .rdw-editor-main {\n  max-height: none;\n  overflow-y: visible;\n}\n\n/* LinkedIn-style emoji picker */\n.normal-editor-shell-linkedin .linkedin-emoji-picker.custom-emoji-modal {\n  width: 360px;\n  max-width: calc(100vw - 32px);\n  max-height: 390px;\n  padding: 0;\n  overflow: hidden;\n  border-radius: 8px;\n  background: #ffffff;\n}\n\n.linkedin-emoji-search-row {\n  display: grid;\n  grid-template-columns: 24px 1fr 34px;\n  align-items: center;\n  gap: 6px;\n  padding: 12px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.linkedin-emoji-search-icon {\n  color: #38434f;\n  font-size: 24px;\n  line-height: 1;\n  transform: rotate(-20deg);\n}\n\n.linkedin-emoji-search {\n  width: 100%;\n  height: 38px;\n  padding: 0 12px;\n  border: 1px solid #56687a;\n  border-radius: 4px;\n  background: #eef3f8;\n  color: #111827;\n  font-size: 15px;\n  outline: none;\n}\n\n.linkedin-emoji-search:focus {\n  border-color: #0a66c2;\n  box-shadow: 0 0 0 2px rgba(10, 102, 194, 0.16);\n}\n\n.linkedin-emoji-close {\n  width: 32px;\n  height: 32px;\n  border: 0;\n  background: transparent;\n  color: #38434f;\n  cursor: pointer;\n  font-size: 30px;\n  line-height: 1;\n}\n\n.linkedin-emoji-tabs {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  background: #ebe6de;\n  border-bottom: 1px solid #d8d2c8;\n}\n\n.linkedin-emoji-tab {\n  height: 54px;\n  border: 0;\n  border-bottom: 3px solid transparent;\n  background: transparent;\n  color: #3f3f3f;\n  cursor: pointer;\n  font-size: 25px;\n}\n\n.linkedin-emoji-tab.active {\n  border-bottom-color: #0a66c2;\n}\n\n.linkedin-emoji-sections {\n  max-height: 245px;\n  overflow-y: auto;\n  padding: 12px 12px 18px;\n}\n\n.linkedin-emoji-section + .linkedin-emoji-section {\n  margin-top: 16px;\n}\n\n.linkedin-emoji-section-title {\n  color: #666666;\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 10px;\n}\n\n.linkedin-emoji-grid {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 8px;\n}\n\n.normal-editor-shell-linkedin .linkedin-emoji-picker .custom-emoji-item {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border-radius: 6px;\n  font-size: 24px;\n}\n\n.linkedin-emoji-empty {\n  color: #6b7280;\n  font-size: 14px;\n  padding: 10px 0 16px;\n}\n\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .normal-editor-shell-linkedin .linkedin-emoji-picker.custom-emoji-modal {\n  background: #111827;\n  border-color: #334155;\n}\n\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-emoji-search-row,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-emoji-tabs {\n  border-color: #334155;\n}\n\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-emoji-tabs {\n  background: #1f2937;\n}\n\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-emoji-search {\n  background: #0f172a;\n  border-color: #475569;\n  color: #f8fafc;\n}\n\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-emoji-search-icon,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-emoji-close,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-emoji-section-title,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-emoji-empty {\n  color: #cbd5e1;\n}\n\n/* Emoji picker clipping fix */\n.post-upload-drawer .normal-editor-shell-linkedin .rdw-editor-wrapper,\n.post-upload-drawer .normal-editor-shell-linkedin .custom-wrapper,\n.post-upload-drawer .normal-editor-shell-linkedin .rdw-editor-toolbar,\n.post-upload-drawer .normal-editor-shell-linkedin .rdw-editor-toolbar > div,\n.normal-editor-shell-linkedin .rdw-editor-wrapper,\n.normal-editor-shell-linkedin .custom-wrapper,\n.normal-editor-shell-linkedin .rdw-editor-toolbar,\n.normal-editor-shell-linkedin .rdw-editor-toolbar > div,\n.normal-editor-shell-linkedin .custom-emoji-toolbar {\n  overflow: visible !important;\n}\n\n.normal-editor-shell-linkedin .custom-emoji-toolbar {\n  position: static;\n}\n\n.normal-editor-shell-linkedin .linkedin-emoji-picker.custom-emoji-modal {\n  position: absolute;\n  left: 8px;\n  top: calc(100% + 8px);\n  width: 440px;\n  max-width: min(440px, calc(100vw - 48px));\n  max-height: 390px;\n  z-index: 5000;\n  border: 1px solid #d0d7de;\n  border-radius: 8px;\n  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.22);\n}\n\n.normal-editor-shell-linkedin .linkedin-emoji-search-row {\n  grid-template-columns: 28px 1fr 32px;\n  padding: 10px 12px;\n}\n\n.normal-editor-shell-linkedin .linkedin-emoji-tabs {\n  grid-template-columns: repeat(8, 1fr);\n}\n\n.normal-editor-shell-linkedin .linkedin-emoji-tab {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.normal-editor-shell-linkedin .linkedin-emoji-sections {\n  max-height: 250px;\n}\n\n.normal-editor-shell-linkedin .linkedin-emoji-grid {\n  grid-template-columns: repeat(8, 36px);\n  justify-content: start;\n}\n\n/* Final LinkedIn emoji picker layout override */\n.normal-editor-shell-linkedin .custom-emoji-modal.linkedin-emoji-picker {\n  display: block !important;\n  grid-template-columns: none !important;\n  gap: 0 !important;\n  width: 440px !important;\n  min-width: 440px;\n  padding: 0 !important;\n}\n\n.normal-editor-shell-linkedin .linkedin-emoji-picker .linkedin-emoji-search-row {\n  display: grid !important;\n  grid-template-columns: 30px minmax(0, 1fr) 34px !important;\n}\n\n.normal-editor-shell-linkedin .linkedin-emoji-picker .linkedin-emoji-tabs {\n  display: grid !important;\n  grid-template-columns: repeat(8, minmax(0, 1fr)) !important;\n}\n\n.normal-editor-shell-linkedin .linkedin-emoji-picker .linkedin-emoji-sections {\n  display: block !important;\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n  max-height: 250px !important;\n  height: 250px;\n  padding-bottom: 42px !important;\n  overscroll-behavior: contain;\n  scrollbar-width: thin;\n  touch-action: pan-y;\n  scroll-behavior: auto;\n}\n\n.normal-editor-shell-linkedin .linkedin-emoji-picker .linkedin-emoji-section:last-child {\n  padding-bottom: 28px;\n}\n\n.normal-editor-shell-linkedin .linkedin-emoji-picker .custom-emoji-item {\n  scroll-margin-bottom: 36px;\n}\n\n.normal-editor-shell-linkedin .linkedin-emoji-picker .linkedin-emoji-grid {\n  display: grid !important;\n  grid-template-columns: repeat(8, 36px) !important;\n}\n\n.normal-editor-shell-linkedin .linkedin-emoji-picker .linkedin-emoji-search {\n  min-width: 0;\n}\n\n/* SYNCED ARTICLE EDITOR UI START */\n\n.linkedin-article-composer {\n  width: 100%;\n  padding: 0;\n  background: linear-gradient(180deg, #ffffff 0%, #fbfbfa 100%);\n}\n\n.linkedin-article-author-row {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  min-width: 260px;\n  padding: 0 22px;\n}\n\n.linkedin-article-author-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border: 1px solid #ffffff;\n  background: linear-gradient(135deg, #dce8f5, #c8d9ed);\n  color: #0f2f4a;\n  font-size: 20px;\n  font-weight: 800;\n  box-shadow: 0 8px 22px rgba(10, 102, 194, 0.14);\n  overflow: hidden;\n}\n\n.linkedin-article-author-avatar img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.linkedin-article-author-name {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  color: #111827;\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.linkedin-article-author-caret {\n  color: #4b5563;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.linkedin-article-author-type {\n  color: #4b5563;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.linkedin-article-toolbar-shell {\n  position: sticky;\n  top: 0;\n  z-index: 6;\n  display: grid;\n  grid-template-columns: minmax(230px, 1fr) auto minmax(230px, 1fr);\n  align-items: center;\n  width: 100%;\n  min-height: 82px;\n  margin: 0 0 36px;\n  padding: 10px 28px;\n  border-top: 1px solid #f8fafc;\n  border-bottom: 1px solid #e5e7eb;\n  background: rgba(255, 255, 255, 0.96);\n  backdrop-filter: blur(16px);\n  box-shadow: 0 12px 34px rgba(15, 23, 42, 0.07);\n}\n\n.linkedin-article-toolbar-start {\n  justify-self: start;\n}\n\n.linkedin-article-toolbar-center {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 50px;\n  padding: 7px 14px;\n  border: 1px solid #d8d3ca;\n  border-radius: 999px;\n  background: linear-gradient(180deg, #f8f6f1 0%, #f0ede8 100%);\n  box-shadow:\n    0 16px 38px rgba(15, 23, 42, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.86);\n}\n\n.linkedin-article-toolbar-end {\n  min-width: 230px;\n  justify-self: end;\n}\n\n.linkedin-article-toolbar-spacer {\n  width: 230px;\n}\n\n.linkedin-article-toolbar-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.linkedin-article-toolbar-group + .linkedin-article-toolbar-group {\n  margin-left: 4px;\n  padding-left: 10px;\n  border-left: 1px solid #d6d1c8;\n}\n\n.linkedin-article-style-select {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  min-width: 132px;\n  padding: 0;\n  border-radius: 999px;\n}\n\n.linkedin-article-style-select select {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  color: #0f172a;\n  font-size: 15px;\n  font-weight: 800;\n  appearance: none;\n  outline: none;\n  padding: 5px 28px 5px 12px;\n  cursor: pointer;\n}\n\n.linkedin-article-style-caret {\n  position: absolute;\n  right: 10px;\n  color: #334a6b;\n  pointer-events: none;\n  font-size: 12px;\n  line-height: 1;\n}\n\n.linkedin-article-toolbar-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: #333333;\n  font-size: 17px;\n  font-weight: 800;\n  cursor: pointer;\n  transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.linkedin-article-toolbar-button:hover,\n.linkedin-article-toolbar-button.active {\n  background: #e8f3ff;\n  color: #0a66c2;\n  box-shadow: inset 0 0 0 1px rgba(10, 102, 194, 0.1);\n}\n\n.linkedin-article-toolbar-button:hover {\n  transform: translateY(-1px) scale(1.02);\n}\n\n.linkedin-article-toolbar-text {\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.linkedin-article-toolbar-quote {\n  position: relative;\n  display: inline-block;\n  width: 22px;\n  height: 18px;\n}\n\n.linkedin-article-toolbar-quote::before,\n.linkedin-article-toolbar-quote::after {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  width: 7px;\n  height: 11px;\n  border-radius: 2px 2px 6px 6px;\n  background: currentColor;\n  transform: skew(-8deg);\n}\n\n.linkedin-article-toolbar-quote::before {\n  left: 3px;\n}\n\n.linkedin-article-toolbar-quote::after {\n  right: 3px;\n}\n\n.linkedin-article-toolbar-code {\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n}\n\n.linkedin-article-toolbar-divider {\n  width: 18px;\n  height: 2px;\n  border-radius: 999px;\n  background: currentColor;\n}\n\n.normal-editor-shell-article .custom-wrapper,\n.normal-editor-shell-article .rdw-editor-wrapper {\n  border: 0 !important;\n  border-radius: 0 !important;\n  overflow: visible !important;\n}\n\n.linkedin-article-cover-shell {\n  max-width: 900px;\n  margin: 0 auto 34px;\n}\n\n.linkedin-article-title-shell {\n  max-width: 900px;\n  margin: 0 auto 18px;\n}\n\n.linkedin-article-title-input {\n  display: block;\n  width: 100%;\n  min-height: 64px;\n  overflow: hidden;\n  resize: none;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: #191919;\n  font-family: inherit;\n  font-size: 44px;\n  font-weight: 600;\n  line-height: 1.16;\n  letter-spacing: 0;\n  padding: 0;\n}\n\n.linkedin-article-title-input::placeholder {\n  color: #777777;\n}\n\n.linkedin-article-title-input:disabled {\n  color: #191919;\n  opacity: 1;\n  cursor: default;\n}\n\n.linkedin-article-cover-stage {\n  position: relative;\n  overflow: hidden;\n  min-height: 380px;\n  border: 1px solid #d8d8d8;\n  background: #f3f0eb;\n}\n\n.linkedin-article-cover-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 380px;\n  padding: 40px 24px 86px;\n  text-align: center;\n}\n\n.linkedin-article-cover-placeholder p {\n  margin: 0;\n  color: #111827;\n  font-size: 18px;\n  line-height: 1.55;\n}\n\n.linkedin-article-cover-placeholder-icon {\n  position: relative;\n  width: 92px;\n  height: 72px;\n  margin-bottom: 28px;\n  border: 4px solid #dbe5f0;\n  background: #eef3f8;\n}\n\n.linkedin-article-cover-mountain,\n.linkedin-article-cover-sun {\n  position: absolute;\n  display: block;\n}\n\n.linkedin-article-cover-mountain {\n  left: 14px;\n  bottom: 14px;\n  width: 44px;\n  height: 28px;\n  background: linear-gradient(135deg, #6d88a8, #95abc2);\n  clip-path: polygon(0 100%, 35% 38%, 62% 73%, 100% 12%, 100% 100%);\n}\n\n.linkedin-article-cover-sun {\n  right: 12px;\n  top: 12px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #f3b45d;\n}\n\n.linkedin-article-cover-media {\n  display: block;\n  width: 100%;\n  min-height: 380px;\n  max-height: 460px;\n  object-fit: cover;\n}\n\n.linkedin-article-cover-trigger {\n  position: absolute;\n  left: 50%;\n  bottom: 28px;\n  transform: translateX(-50%);\n  min-width: 236px;\n  min-height: 42px;\n  border: 1.5px solid #3f3f3f;\n  border-radius: 999px;\n  background: #ffffff;\n  color: #1f2937;\n  font-size: 16px;\n  font-weight: 700;\n  padding: 0 24px;\n}\n\n.linkedin-article-cover-trigger:hover {\n  background: #ffffff;\n}\n\n.linkedin-article-hidden-upload,\n.linkedin-article-inline-upload {\n  position: absolute;\n  width: 0;\n  height: 0;\n  overflow: hidden;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.normal-editor-shell-article .custom-editor {\n  min-height: 420px;\n  padding: 0;\n  border: 0;\n}\n\n.normal-editor-shell-article .rdw-editor-wrapper,\n.normal-editor-shell-article .custom-wrapper,\n.normal-editor-shell-article .custom-editor {\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.normal-editor-shell-article .rdw-editor-main {\n  max-width: 900px;\n  min-height: 420px;\n  margin: 0 auto;\n  padding: 0 0 36px;\n  color: #191919;\n  font-size: 21px;\n  line-height: 1.65;\n  background: transparent;\n}\n\n.normal-editor-shell-article .rdw-editor-main h1,\n.normal-editor-shell-article .rdw-editor-main h2,\n.normal-editor-shell-article .rdw-editor-main h3 {\n  color: #191919;\n  margin: 2px 0 4px;\n  font-weight: 800;\n}\n\n.normal-editor-shell-article .rdw-editor-main h1 {\n  font-size: 40px;\n  line-height: 1.08;\n}\n\n.normal-editor-shell-article .rdw-editor-main h2 {\n  font-size: 30px;\n  line-height: 1.16;\n}\n\n.normal-editor-shell-article .rdw-editor-main h3 {\n  font-size: 24px;\n  line-height: 1.22;\n}\n\n.normal-editor-shell-article .rdw-editor-main p {\n  margin: 0 0 12px;\n}\n\n.normal-editor-shell-article .public-DraftStyleDefault-block {\n  /* The \".rdw-editor-main p\" rule above was meant to give every article\n     paragraph a 12px bottom gap (blog-style spacing) — but it never\n     applied: blocks render as <div>, not <p>, in the live editing view, so\n     that selector silently matched nothing. Meanwhile react-draft-wysiwyg's\n     own unscoped \".public-DraftStyleDefault-block\" rule (margin: 1em 0,\n     ~16px both sides) WAS applying, giving every paragraph an oversized,\n     uneven gap instead of the intended 12px bottom-only gap. This restates\n     that same 12px intent directly on the block that's actually rendered,\n     with higher specificity than the library's rule. */\n  margin: 0 0 12px;\n  min-height: 1.65em;\n}\n\n.normal-editor-shell-article .public-DraftEditor-content {\n  min-height: 520px;\n  cursor: text;\n}\n\n.normal-editor-shell-article .public-DraftEditor-content::after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n\n.normal-editor-shell-article .linkedin-article-writing-prompt {\n  color: #8b98a9;\n  font-weight: 400;\n}\n\n.normal-editor-shell-article .linkedin-article-empty-body-block {\n  position: relative;\n  min-height: 260px !important;\n}\n\n.normal-editor-shell-article .linkedin-article-empty-body-block::before {\n  content: \"Write your article...\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  color: #8b98a9;\n  font-size: 22px;\n  font-weight: 400;\n  line-height: 1.65;\n  pointer-events: none;\n}\n\n.normal-editor-shell-article .public-DraftEditor-content > div > div:last-child\n  .public-DraftStyleDefault-block {\n  min-height: 260px;\n}\n\n.normal-editor-shell-article .rdw-editor-main ul,\n.normal-editor-shell-article .rdw-editor-main ol {\n  margin: 8px 0 20px 28px;\n  padding-left: 18px;\n}\n\n.normal-editor-shell-article .rdw-editor-main li {\n  margin: 4px 0;\n  padding-left: 6px;\n  line-height: 1.55;\n}\n\n.normal-editor-shell-article .rdw-editor-main li > div,\n.normal-editor-shell-article .rdw-editor-main li > p {\n  display: inline;\n  margin: 0 !important;\n}\n\n.normal-editor-shell-article .rdw-editor-main li > div:empty,\n.normal-editor-shell-article .rdw-editor-main li > p:empty {\n  display: none;\n}\n\n.normal-editor-shell-article .public-DraftStyleDefault-ul,\n.normal-editor-shell-article .public-DraftStyleDefault-ol {\n  margin: 10px 0 20px !important;\n  padding: 0 !important;\n}\n\n.normal-editor-shell-article .public-DraftStyleDefault-unorderedListItem,\n.normal-editor-shell-article .public-DraftStyleDefault-orderedListItem {\n  margin-top: 5px !important;\n  margin-bottom: 5px !important;\n  line-height: 1.55 !important;\n}\n\n.normal-editor-shell-article\n  .public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR {\n  margin-left: 1.9em !important;\n}\n\n.normal-editor-shell-article\n  .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR::before {\n  left: -40px !important;\n  width: 32px !important;\n  top: 0;\n}\n\n.normal-editor-shell-article .rdw-editor-main blockquote {\n  margin: 22px 0;\n  padding-left: 18px;\n  border-left: 4px solid #c9d7e6;\n  color: #4a5f7e;\n  font-size: 22px;\n  line-height: 1.55;\n}\n\n.linkedin-article-divider-block {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin: 30px 0;\n  min-height: 42px;\n}\n\n.linkedin-article-divider-line {\n  display: block;\n  width: 100%;\n  height: 1px;\n  background: #d8d8d8;\n}\n\n.linkedin-article-divider-delete {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  z-index: 3;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  border: 0;\n  border-radius: 50%;\n  background: #666666;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 18px;\n  opacity: 0;\n  transform: translateY(-50%) scale(0.96);\n  pointer-events: none;\n  transition: opacity 0.18s ease, transform 0.18s ease, background 0.18s ease;\n}\n\n.linkedin-article-divider-block:hover .linkedin-article-divider-delete,\n.linkedin-article-divider-delete:focus-visible {\n  opacity: 1;\n  pointer-events: auto;\n  transform: translateY(-50%) scale(1);\n}\n\n.linkedin-article-divider-delete:hover {\n  background: #4f4f4f;\n}\n\n.normal-editor-shell-article .rdw-editor-main pre {\n  margin: 20px 0;\n  padding: 16px 18px;\n  border-radius: 18px;\n  background: #f6f8fb;\n  color: #18314f;\n  font-size: 15px;\n  line-height: 1.7;\n}\n\n.normal-editor-shell-article .rdw-editor-main img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  margin: 24px auto;\n}\n\n.normal-editor-shell-article .linkedin-article-image-block {\n  width: min(520px, 100%);\n  margin: 30px auto;\n  text-align: center;\n  cursor: grab;\n  transition: opacity 0.18s ease, transform 0.18s ease, width 0.2s ease;\n}\n\n.normal-editor-shell-article .linkedin-article-image-dragging {\n  opacity: 0.52;\n  transform: scale(0.985);\n}\n\n.normal-editor-shell-article .linkedin-article-image-block-wide {\n  width: min(880px, 100%);\n}\n\n.normal-editor-shell-article .linkedin-article-image-align-left {\n  float: left;\n  width: min(360px, 46%);\n  margin: 8px 30px 20px 0;\n}\n\n.normal-editor-shell-article .linkedin-article-image-align-right {\n  float: right;\n  width: min(360px, 46%);\n  margin: 8px 0 20px 30px;\n}\n\n.normal-editor-shell-article .linkedin-article-image-align-center,\n.normal-editor-shell-article .linkedin-article-image-block-wide {\n  clear: both;\n}\n\n.normal-editor-shell-article\n  .linkedin-article-image-block-wide.linkedin-article-image-align-left,\n.normal-editor-shell-article\n  .linkedin-article-image-block-wide.linkedin-article-image-align-right {\n  float: none;\n  margin: 30px auto;\n}\n\n.normal-editor-shell-article .linkedin-article-image-frame {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  overflow: hidden;\n  background: #f3f0eb;\n}\n\n.normal-editor-shell-article .linkedin-article-image-frame::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  background: rgba(0, 0, 0, 0.38);\n  transition: opacity 0.18s ease;\n  pointer-events: none;\n}\n\n.normal-editor-shell-article .linkedin-article-image-frame:hover::after {\n  opacity: 1;\n}\n\n.normal-editor-shell-article .linkedin-article-image-frame img {\n  display: block;\n  width: 100%;\n  max-width: none;\n  height: auto;\n  margin: 0;\n  filter: brightness(var(--article-image-brightness, 100%))\n    contrast(var(--article-image-contrast, 100%))\n    saturate(var(--article-image-saturation, 100%))\n    grayscale(var(--article-image-grayscale, 0%))\n    sepia(var(--article-image-sepia, 0%));\n  object-fit: cover;\n  transform: scale(var(--article-image-zoom, 1)) rotate(var(--article-image-rotate, 0deg));\n  transform-origin: center;\n}\n\n.normal-editor-shell-article .linkedin-article-image-ratio-square .linkedin-article-image-frame {\n  aspect-ratio: 1 / 1;\n}\n\n.normal-editor-shell-article .linkedin-article-image-ratio-4-1 .linkedin-article-image-frame {\n  aspect-ratio: 4 / 1;\n}\n\n.normal-editor-shell-article .linkedin-article-image-ratio-3-4 .linkedin-article-image-frame {\n  aspect-ratio: 3 / 4;\n}\n\n.normal-editor-shell-article .linkedin-article-image-ratio-16-9 .linkedin-article-image-frame {\n  aspect-ratio: 16 / 9;\n}\n\n.normal-editor-shell-article .linkedin-article-image-ratio-square .linkedin-article-image-frame img,\n.normal-editor-shell-article .linkedin-article-image-ratio-4-1 .linkedin-article-image-frame img,\n.normal-editor-shell-article .linkedin-article-image-ratio-3-4 .linkedin-article-image-frame img,\n.normal-editor-shell-article .linkedin-article-image-ratio-16-9 .linkedin-article-image-frame img {\n  height: 100%;\n}\n\n.normal-editor-shell-article .linkedin-article-image-actions {\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 10px;\n  max-width: calc(100% - 36px);\n  opacity: 0;\n  transition: opacity 0.18s ease;\n}\n\n.normal-editor-shell-article .linkedin-article-image-frame:hover .linkedin-article-image-actions,\n.normal-editor-shell-article .linkedin-article-image-actions:focus-within {\n  opacity: 1;\n}\n\n.normal-editor-shell-article .linkedin-article-image-actions button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: 1px solid rgba(255, 255, 255, 0.86);\n  border-radius: 50%;\n  background: rgba(36, 36, 36, 0.72);\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 16px;\n  transition: background 0.18s ease, transform 0.18s ease;\n}\n\n.normal-editor-shell-article .linkedin-article-image-actions button:hover {\n  background: rgba(17, 17, 17, 0.9);\n  transform: translateY(-1px);\n}\n\n.normal-editor-shell-article .linkedin-article-image-drag {\n  cursor: grab;\n}\n\n@media (max-width: 720px) {\n  .normal-editor-shell-article .linkedin-article-image-align-left,\n  .normal-editor-shell-article .linkedin-article-image-align-right,\n  .normal-editor-shell-outline .linkedin-article-image-align-left,\n  .normal-editor-shell-outline .linkedin-article-image-align-right,\n  .linkedin-article-preview-content .linkedin-article-image-align-left,\n  .linkedin-article-preview-content .linkedin-article-image-align-right,\n  .public-article-content .linkedin-article-image-align-left,\n  .public-article-content .linkedin-article-image-align-right {\n    float: none;\n    width: 100%;\n    margin: 24px auto;\n  }\n}\n\n.normal-editor-shell-article .linkedin-article-empty-atomic {\n  display: none;\n}\n\n/* Same hover-icon image toolbar (drag/resize/edit/delete) as the article\n   editor above, now also for the Blog Write outline builder's images —\n   outline's own image button already inserts via the exact same\n   insertImage()/ArticleImageBlock renderer the article preset uses (see\n   NormalEditor.js's customBlockRenderFunc/mousedown-capture handlers,\n   extended to toolbarPreset===\"outline\" too), so the underlying image\n   entity was always compatible; it just had no matching CSS here to make\n   it look and behave the same way — react-draft-wysiwyg's own default\n   plain \"L C R\" alignment buttons were showing instead, since without this\n   scoped CSS the custom hover toolbar renders with no positioning/opacity\n   rules at all. Duplicated rather than just adding \".normal-editor-shell-\n   outline\" to every selector above, so article's own image sizing (520px/\n   880px wide) can be tuned independently later without touching this. */\n.normal-editor-shell-outline .rdw-editor-main img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  margin: 12px auto;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-block {\n  width: min(520px, 100%);\n  margin: 16px auto;\n  text-align: center;\n  cursor: grab;\n  transition: opacity 0.18s ease, transform 0.18s ease, width 0.2s ease;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-dragging {\n  opacity: 0.52;\n  transform: scale(0.985);\n}\n\n.normal-editor-shell-outline .linkedin-article-image-block-wide {\n  width: min(720px, 100%);\n}\n\n.normal-editor-shell-outline .linkedin-article-image-align-left {\n  float: left;\n  width: min(300px, 46%);\n  margin: 8px 24px 16px 0;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-align-right {\n  float: right;\n  width: min(300px, 46%);\n  margin: 8px 0 16px 24px;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-align-center,\n.normal-editor-shell-outline .linkedin-article-image-block-wide {\n  clear: both;\n}\n\n.normal-editor-shell-outline\n  .linkedin-article-image-block-wide.linkedin-article-image-align-left,\n.normal-editor-shell-outline\n  .linkedin-article-image-block-wide.linkedin-article-image-align-right {\n  float: none;\n  margin: 16px auto;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-frame {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  overflow: hidden;\n  background: #f3f0eb;\n  border-radius: 10px;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-frame::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  background: rgba(0, 0, 0, 0.38);\n  transition: opacity 0.18s ease;\n  pointer-events: none;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-frame:hover::after {\n  opacity: 1;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-frame img {\n  display: block;\n  width: 100%;\n  max-width: none;\n  height: auto;\n  margin: 0;\n  filter: brightness(var(--article-image-brightness, 100%))\n    contrast(var(--article-image-contrast, 100%))\n    saturate(var(--article-image-saturation, 100%))\n    grayscale(var(--article-image-grayscale, 0%))\n    sepia(var(--article-image-sepia, 0%));\n  object-fit: cover;\n  transform: scale(var(--article-image-zoom, 1)) rotate(var(--article-image-rotate, 0deg));\n  transform-origin: center;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-ratio-square .linkedin-article-image-frame {\n  aspect-ratio: 1 / 1;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-ratio-4-1 .linkedin-article-image-frame {\n  aspect-ratio: 4 / 1;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-ratio-3-4 .linkedin-article-image-frame {\n  aspect-ratio: 3 / 4;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-ratio-16-9 .linkedin-article-image-frame {\n  aspect-ratio: 16 / 9;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-ratio-square .linkedin-article-image-frame img,\n.normal-editor-shell-outline .linkedin-article-image-ratio-4-1 .linkedin-article-image-frame img,\n.normal-editor-shell-outline .linkedin-article-image-ratio-3-4 .linkedin-article-image-frame img,\n.normal-editor-shell-outline .linkedin-article-image-ratio-16-9 .linkedin-article-image-frame img {\n  height: 100%;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-actions {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 8px;\n  max-width: calc(100% - 24px);\n  opacity: 0;\n  transition: opacity 0.18s ease;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-frame:hover .linkedin-article-image-actions,\n.normal-editor-shell-outline .linkedin-article-image-actions:focus-within {\n  opacity: 1;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-actions button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: 1px solid rgba(255, 255, 255, 0.86);\n  border-radius: 50%;\n  background: rgba(36, 36, 36, 0.72);\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.18s ease, transform 0.18s ease;\n}\n\n.normal-editor-shell-outline .linkedin-article-image-actions button:hover {\n  background: rgba(17, 17, 17, 0.9);\n  transform: translateY(-1px);\n}\n\n.normal-editor-shell-outline .linkedin-article-image-drag {\n  cursor: grab;\n}\n\n.normal-editor-shell-outline .linkedin-article-empty-atomic {\n  display: none;\n}\n\n.linkedin-image-edit-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 5000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.56);\n}\n\n.linkedin-image-edit-modal {\n  width: min(1130px, calc(100vw - 58px));\n  max-height: min(760px, calc(100vh - 42px));\n  overflow: hidden;\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.32);\n}\n\n.linkedin-image-edit-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 48px;\n  padding: 0 20px 0 24px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.linkedin-image-edit-header strong {\n  color: #1f2937;\n  font-size: 20px;\n  font-weight: 800;\n}\n\n.linkedin-image-edit-header button,\n.linkedin-image-edit-panel-head button,\n.linkedin-image-edit-tools button {\n  border: 0;\n  background: transparent;\n  color: #404040;\n  cursor: pointer;\n}\n\n.linkedin-image-edit-header button {\n  font-size: 22px;\n}\n\n.linkedin-image-edit-body {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 378px;\n  min-height: 590px;\n  background: #f5f7fa;\n}\n\n.linkedin-image-edit-preview {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 590px;\n  overflow: hidden;\n  background: #f1f3f5;\n}\n\n.linkedin-image-edit-preview img {\n  display: block;\n  width: 100%;\n  max-height: 590px;\n  filter: brightness(var(--article-image-brightness, 100%))\n    contrast(var(--article-image-contrast, 100%))\n    saturate(var(--article-image-saturation, 100%))\n    grayscale(var(--article-image-grayscale, 0%))\n    sepia(var(--article-image-sepia, 0%));\n  object-fit: contain;\n  transform: scale(var(--article-image-zoom, 1)) rotate(var(--article-image-rotate, 0deg));\n  transform-origin: center;\n}\n\n.linkedin-image-edit-preview-square img,\n.linkedin-image-edit-preview-4-1 img,\n.linkedin-image-edit-preview-3-4 img,\n.linkedin-image-edit-preview-16-9 img {\n  width: auto;\n  max-width: 82%;\n  object-fit: cover;\n}\n\n.linkedin-image-edit-preview-square img {\n  aspect-ratio: 1 / 1;\n}\n\n.linkedin-image-edit-preview-4-1 img {\n  aspect-ratio: 4 / 1;\n}\n\n.linkedin-image-edit-preview-3-4 img {\n  aspect-ratio: 3 / 4;\n}\n\n.linkedin-image-edit-preview-16-9 img {\n  aspect-ratio: 16 / 9;\n}\n\n.linkedin-image-edit-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 22px;\n  padding: 22px 24px 24px;\n  background: #ffffff;\n}\n\n.linkedin-image-edit-panel-head {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  color: #4b5563;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.linkedin-image-edit-panel-head button {\n  font-size: 22px;\n}\n\n.linkedin-image-edit-tabs {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.linkedin-image-edit-tabs button {\n  height: 46px;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: #4a4a4a;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.linkedin-image-edit-tabs button.active {\n  border-bottom-color: #057642;\n  color: #057642;\n}\n\n.linkedin-image-edit-tools {\n  display: flex;\n  gap: 22px;\n  color: #3f3f3f;\n}\n\n.linkedin-image-edit-tools button {\n  font-size: 22px;\n}\n\n.linkedin-image-edit-section p,\n.linkedin-image-edit-range span {\n  display: block;\n  margin: 0 0 12px;\n  color: #666666;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.linkedin-image-ratio-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.linkedin-image-ratio-options button {\n  height: 34px;\n  border: 1px solid #b6b6b6;\n  border-radius: 999px;\n  background: #ffffff;\n  color: #444444;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0 14px;\n}\n\n.linkedin-image-ratio-options button.active {\n  border-color: #057642;\n  background: #057642;\n  color: #ffffff;\n}\n\n.linkedin-image-edit-range input {\n  width: 100%;\n  accent-color: #057642;\n}\n\n.linkedin-image-edit-range span {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.linkedin-image-edit-range span em {\n  color: #6b7280;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n}\n\n.linkedin-image-filter-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.linkedin-image-filter-grid button {\n  border: 1px solid #d7dce2;\n  border-radius: 10px;\n  background: #ffffff;\n  color: #303030;\n  cursor: pointer;\n  overflow: hidden;\n  padding: 0 0 10px;\n  text-align: left;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.linkedin-image-filter-grid button.active {\n  border-color: #057642;\n  box-shadow: 0 0 0 2px rgba(5, 118, 66, 0.12);\n}\n\n.linkedin-image-filter-grid button > span:last-child {\n  display: block;\n  padding: 9px 10px 0;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.linkedin-image-filter-thumb {\n  display: block;\n  height: 76px;\n  overflow: hidden;\n  background: #eef2f6;\n}\n\n.linkedin-image-filter-thumb img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  filter: brightness(var(--article-image-brightness, 100%))\n    contrast(var(--article-image-contrast, 100%))\n    saturate(var(--article-image-saturation, 100%))\n    grayscale(var(--article-image-grayscale, 0%))\n    sepia(var(--article-image-sepia, 0%));\n  object-fit: cover;\n}\n\n.linkedin-image-edit-apply {\n  height: 40px;\n  margin-top: auto;\n  border: 0;\n  border-radius: 999px;\n  background: #0a66c2;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.normal-editor-shell-article .rdw-editor-placeholder {\n  top: 4px;\n  left: calc((100% - 900px) / 2);\n  color: #6f6f6f;\n  font-size: 20px;\n  line-height: 1.6;\n}\n\n.normal-editor-shell-article,\n.normal-editor-shell-article .custom-wrapper,\n.normal-editor-shell-article .rdw-editor-wrapper,\n.normal-editor-shell-article .rdw-editor-toolbar,\n.normal-editor-shell-article .custom-emoji-toolbar {\n  overflow: visible !important;\n}\n\n.normal-editor-shell-article .custom-emoji-toolbar {\n  position: relative;\n  display: inline-flex;\n}\n\n.normal-editor-shell-article .custom-emoji-trigger.rdw-option-wrapper {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  min-width: 34px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: #2f2f2f;\n  box-shadow: none;\n  font-size: 17px;\n}\n\n.normal-editor-shell-article .custom-emoji-trigger.rdw-option-wrapper:hover {\n  background: #e0e8f3;\n  color: #0a66c2;\n}\n\n.normal-editor-shell-article .linkedin-emoji-picker.custom-emoji-modal {\n  position: absolute;\n  top: calc(100% + 10px);\n  left: 50%;\n  z-index: 5000;\n  display: block !important;\n  grid-template-columns: none !important;\n  gap: 0 !important;\n  width: 440px !important;\n  min-width: 440px;\n  max-width: min(440px, calc(100vw - 48px));\n  max-height: 390px;\n  padding: 0 !important;\n  overflow: hidden;\n  transform: translateX(-50%);\n  border: 1px solid #d0d7de;\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow: 0 18px 42px rgba(16, 24, 40, 0.24);\n}\n\n.normal-editor-shell-article .linkedin-emoji-picker .linkedin-emoji-search-row {\n  display: grid !important;\n  grid-template-columns: 30px minmax(0, 1fr) 34px !important;\n  padding: 10px 12px;\n}\n\n.normal-editor-shell-article .linkedin-emoji-picker .linkedin-emoji-tabs {\n  display: grid !important;\n  grid-template-columns: repeat(8, minmax(0, 1fr)) !important;\n}\n\n.normal-editor-shell-article .linkedin-emoji-picker .linkedin-emoji-sections {\n  display: block !important;\n  height: 250px;\n  max-height: 250px !important;\n  overflow-x: hidden !important;\n  overflow-y: auto !important;\n  padding-bottom: 42px !important;\n  overscroll-behavior: contain;\n  scrollbar-width: thin;\n  touch-action: pan-y;\n}\n\n.normal-editor-shell-article .linkedin-emoji-picker .linkedin-emoji-section:last-child {\n  padding-bottom: 28px;\n}\n\n.normal-editor-shell-article .linkedin-emoji-picker .linkedin-emoji-grid {\n  display: grid !important;\n  grid-template-columns: repeat(8, 36px) !important;\n  justify-content: start;\n}\n\n.normal-editor-shell-article .linkedin-emoji-picker .custom-emoji-item {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border-radius: 6px;\n  font-size: 24px;\n  scroll-margin-bottom: 36px;\n}\n\n.normal-editor-shell-article .linkedin-emoji-picker .linkedin-emoji-search {\n  min-width: 0;\n}\n\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-article-composer,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-article-toolbar-shell {\n  background: #ffffff;\n}\n\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-article-title-input,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .normal-editor-shell-article .rdw-editor-main,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .normal-editor-shell-article .rdw-editor-main h1,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .normal-editor-shell-article .rdw-editor-main h2,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .normal-editor-shell-article .rdw-editor-main h3,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-article-author-name,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-article-author-type,\n:is([data-theme=\"dark\"], .dark-mode, .theme-dark, .layout-dashboard-dark) .linkedin-article-cover-placeholder p {\n  color: #191919;\n}\n\n.ant-form-item-has-error .normal-editor-shell-article .rdw-editor-wrapper,\n.ant-form-item-has-error .normal-editor-shell-article .custom-wrapper,\n.ant-form-item-has-error .normal-editor-shell-article .custom-editor {\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n\n.linkedin-article-import-button.ant-btn {\n  display: block;\n  min-width: 150px;\n  height: 38px !important;\n  margin: 14px auto 0 !important;\n  border: 1px solid #d0d5dd !important;\n  border-radius: 999px !important;\n  background: #ffffff !important;\n  color: #334155 !important;\n  font-size: 13px;\n  font-weight: 700;\n  box-shadow: none !important;\n}\n\n.linkedin-article-composer-readonly .linkedin-article-toolbar-shell {\n  display: none;\n}\n\n.post-contant-outerpanel .post-editor-title {\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid #edf1f6;\n  color: #071e31;\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.post-contant-outerpanel .post-editor-title > img {\n  width: 42px;\n  height: 42px;\n  margin-right: 10px;\n  padding: 10px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #3b6b94, #0a66c2);\n  box-shadow: 0 12px 22px rgba(59, 107, 148, 0.24);\n}\n\n.post-contant-outerpanel .post-comment-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: -4px 0 10px;\n  padding: 10px 12px;\n  border: 1px solid #e4ebf4;\n}\n\n.linkedin-article-preview-modal .ant-modal-content {\n  overflow: hidden;\n  border-radius: 18px;\n  background: #eef3f8;\n  box-shadow: 0 28px 80px rgba(15, 23, 42, 0.22);\n}\n\n.linkedin-article-preview-modal .ant-modal-close {\n  top: 16px;\n  right: 16px;\n}\n\n.linkedin-article-preview-modal .ant-modal-body {\n  padding: 0;\n}\n\n.linkedin-article-preview-shell {\n  max-height: calc(100vh - 96px);\n  overflow-y: auto;\n  background: #eef3f8;\n}\n\n.linkedin-article-share-panel {\n  width: min(720px, calc(100% - 40px));\n  margin: 28px auto 18px;\n  overflow: hidden;\n  border: 1px solid #d8e1ec;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 16px 44px rgba(15, 23, 42, 0.09);\n}\n\n.linkedin-article-share-panel .linkedin-article-preview-author {\n  padding: 18px 22px 8px;\n}\n\n.linkedin-article-share-textarea.ant-input {\n  display: block;\n  width: calc(100% - 44px);\n  margin: 0 22px 18px;\n  padding: 10px 0;\n  border: 0;\n  box-shadow: none;\n  color: #111827;\n  font-size: 18px;\n  line-height: 1.5;\n  resize: none;\n}\n\n.linkedin-article-share-textarea.ant-input:focus {\n  border: 0;\n  box-shadow: none;\n}\n\n.linkedin-article-share-card {\n  display: grid;\n  grid-template-columns: 150px 1fr;\n  margin: 0 22px 22px;\n  overflow: hidden;\n  border: 1px solid #d9dde3;\n  border-radius: 10px;\n  background: #f8fafc;\n}\n\n.linkedin-article-share-thumb {\n  display: grid;\n  min-height: 112px;\n  place-items: center;\n  overflow: hidden;\n  background: #f3f0eb;\n}\n\n.linkedin-article-share-thumb img,\n.linkedin-article-share-thumb video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.linkedin-article-share-card-body {\n  padding: 16px 18px;\n}\n\n.linkedin-article-share-card-body h3 {\n  margin: 0 0 8px;\n  color: #111827;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.25;\n}\n\n.linkedin-article-share-card-body p {\n  display: -webkit-box;\n  margin: 0 0 10px;\n  overflow: hidden;\n  color: #475569;\n  font-size: 14px;\n  line-height: 1.45;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.linkedin-article-share-card-body span {\n  color: #64748b;\n  font-size: 13px;\n}\n\n.linkedin-article-preview-page {\n  width: min(900px, calc(100% - 40px));\n  min-height: 720px;\n  margin: 28px auto 0;\n  background: #ffffff;\n  border: 1px solid #dde3ea;\n  box-shadow: 0 18px 60px rgba(15, 23, 42, 0.1);\n}\n\n.linkedin-article-preview-author {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 24px 40px 18px;\n}\n\n.linkedin-article-preview-avatar {\n  display: grid;\n  width: 52px;\n  height: 52px;\n  place-items: center;\n  overflow: hidden;\n  border-radius: 50%;\n  background: #dbeafe;\n  color: #0a66c2;\n  font-size: 20px;\n  font-weight: 800;\n}\n\n.linkedin-article-preview-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.linkedin-article-preview-name {\n  color: #111827;\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.linkedin-article-preview-subtitle {\n  margin-top: 2px;\n  color: #475569;\n  font-size: 13px;\n}\n\n.linkedin-article-preview-cover {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 360px;\n  margin: 0 40px;\n  overflow: hidden;\n  border: 1px solid #d7d2ca;\n  background: #f3f0eb;\n}\n\n.linkedin-article-preview-cover img,\n.linkedin-article-preview-cover video {\n  display: block;\n  width: 100%;\n  max-height: 520px;\n  object-fit: cover;\n}\n\n.linkedin-article-preview-cover-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  color: #475569;\n  text-align: center;\n}\n\n.linkedin-article-preview-body {\n  max-width: 760px;\n  margin: 0 auto;\n  padding: 36px 12px 86px;\n}\n\n.linkedin-article-preview-body h1 {\n  margin: 0 0 10px;\n  color: #1f2937;\n  font-size: 44px;\n  font-weight: 600;\n  line-height: 1.15;\n  letter-spacing: 0;\n}\n\n.linkedin-article-preview-content h1,\n.linkedin-article-preview-content h2,\n.linkedin-article-preview-content h3,\n.public-article-content h1,\n.public-article-content h2,\n.public-article-content h3 {\n  margin: 4px 0 4px;\n}\n\n.linkedin-article-preview-content {\n  color: #111827;\n  font-size: 18px;\n  line-height: 1.75;\n}\n\n.linkedin-article-preview-content::after,\n.public-article-content::after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n\n.linkedin-article-preview-content p {\n  margin: 0 0 12px;\n}\n\n.linkedin-article-preview-content ul,\n.linkedin-article-preview-content ol {\n  margin: 0 0 18px 24px;\n  padding: 0;\n}\n\n.linkedin-article-preview-content li {\n  margin-bottom: 8px;\n}\n\n.linkedin-article-preview-content blockquote {\n  margin: 26px 0;\n  padding-left: 20px;\n  border-left: 4px solid #0a66c2;\n  color: #334155;\n  font-size: 22px;\n  line-height: 1.55;\n}\n\n.linkedin-article-preview-content hr {\n  height: 1px;\n  margin: 34px 0;\n  border: 0;\n  background: #d4d4d4;\n}\n\n.linkedin-article-preview-content img {\n  max-width: 100%;\n  border-radius: 4px;\n}\n\n.linkedin-article-preview-content .linkedin-article-image,\n.public-article-content .linkedin-article-image {\n  width: min(620px, 100%);\n  margin: 30px auto;\n  text-align: center;\n}\n\n.linkedin-article-preview-content .linkedin-article-image-size-wide,\n.public-article-content .linkedin-article-image-size-wide {\n  width: min(760px, 100%);\n}\n\n.linkedin-article-preview-content .linkedin-article-image-align-left,\n.public-article-content .linkedin-article-image-align-left {\n  float: left;\n  width: min(340px, 46%);\n  margin: 8px 28px 18px 0;\n}\n\n.linkedin-article-preview-content .linkedin-article-image-align-right,\n.public-article-content .linkedin-article-image-align-right {\n  float: right;\n  width: min(340px, 46%);\n  margin: 8px 0 18px 28px;\n}\n\n.linkedin-article-preview-content .linkedin-article-image-align-center,\n.linkedin-article-preview-content .linkedin-article-image-size-wide,\n.public-article-content .linkedin-article-image-align-center,\n.public-article-content .linkedin-article-image-size-wide {\n  clear: both;\n}\n\n.linkedin-article-preview-content\n  .linkedin-article-image-size-wide.linkedin-article-image-align-left,\n.linkedin-article-preview-content\n  .linkedin-article-image-size-wide.linkedin-article-image-align-right,\n.public-article-content\n  .linkedin-article-image-size-wide.linkedin-article-image-align-left,\n.public-article-content\n  .linkedin-article-image-size-wide.linkedin-article-image-align-right {\n  float: none;\n  margin: 30px auto;\n}\n\n.linkedin-article-preview-content .linkedin-article-image img,\n.public-article-content .linkedin-article-image img {\n  display: block;\n  width: 100%;\n  max-width: none;\n  height: auto;\n  margin: 0;\n  border-radius: 0;\n  filter: brightness(var(--article-image-brightness, 100%))\n    contrast(var(--article-image-contrast, 100%))\n    saturate(var(--article-image-saturation, 100%))\n    grayscale(var(--article-image-grayscale, 0%))\n    sepia(var(--article-image-sepia, 0%));\n  object-fit: cover;\n  transform: scale(var(--article-image-zoom, 1)) rotate(var(--article-image-rotate, 0deg));\n  transform-origin: center;\n}\n\n.linkedin-article-preview-content .linkedin-article-image-ratio-square,\n.public-article-content .linkedin-article-image-ratio-square {\n  aspect-ratio: 1 / 1;\n  overflow: hidden;\n}\n\n.linkedin-article-preview-content .linkedin-article-image-ratio-4-1,\n.public-article-content .linkedin-article-image-ratio-4-1 {\n  aspect-ratio: 4 / 1;\n  overflow: hidden;\n}\n\n.linkedin-article-preview-content .linkedin-article-image-ratio-3-4,\n.public-article-content .linkedin-article-image-ratio-3-4 {\n  aspect-ratio: 3 / 4;\n  overflow: hidden;\n}\n\n.linkedin-article-preview-content .linkedin-article-image-ratio-16-9,\n.public-article-content .linkedin-article-image-ratio-16-9 {\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n}\n\n.linkedin-article-preview-content .linkedin-article-image-ratio-square img,\n.linkedin-article-preview-content .linkedin-article-image-ratio-4-1 img,\n.linkedin-article-preview-content .linkedin-article-image-ratio-3-4 img,\n.linkedin-article-preview-content .linkedin-article-image-ratio-16-9 img,\n.public-article-content .linkedin-article-image-ratio-square img,\n.public-article-content .linkedin-article-image-ratio-4-1 img,\n.public-article-content .linkedin-article-image-ratio-3-4 img,\n.public-article-content .linkedin-article-image-ratio-16-9 img {\n  height: 100%;\n}\n\n.linkedin-article-preview-footer {\n  position: sticky;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 14px;\n  padding: 18px 28px;\n  border-top: 1px solid #dbe3ec;\n  background: rgba(248, 250, 252, 0.94);\n  backdrop-filter: blur(12px);\n}\n\n.linkedin-article-preview-footer .ant-btn {\n  height: 46px;\n  min-width: 150px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.linkedin-article-preview-publish {\n  min-width: 118px !important;\n  border-color: #001f35 !important;\n  background: #001f35 !important;\n}\n\n/* .blog-mark-published-btn removed — the \"Mark as Published\" button now\n   reuses .submitted-btn (same class \"Send for Review\" uses), which already\n   has the correct height/padding/radius/font AND this same brand gradient,\n   instead of this one-off class that only set background/color and left\n   height/padding/radius to antd's defaults. */\n\n.linkedin-article-native-button.ant-btn {\n  min-width: 220px !important;\n  border: 1px solid #0a66c2 !important;\n  background: #ffffff !important;\n  color: #0a66c2 !important;\n}\n\n.linkedin-article-native-button.ant-btn:hover {\n  border-color: #004182 !important;\n  background: #eef6ff !important;\n  color: #004182 !important;\n}\n\n.linkedin-native-help p {\n  margin: 0 0 14px;\n  color: #334155;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.linkedin-native-help textarea.ant-input {\n  border-radius: 10px;\n  color: #111827;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.article-editor-count {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: -14px;\n  margin-bottom: 16px;\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.4;\n}\n\n.article-editor-count strong {\n  color: #d93025;\n  font-weight: 600;\n}\n\n.article-editor-count-error {\n  color: #d93025;\n}\n\n.ant-row.ant-form-item-row .normal-editor-shell-article .rdw-editor-wrapper,\n.ant-row.ant-form-item-row .normal-editor-shell-article .custom-wrapper,\n.ant-row.ant-form-item-row .normal-editor-shell-article .custom-editor,\n.linkedin-article-composer .normal-editor-shell-article .rdw-editor-wrapper,\n.linkedin-article-composer .normal-editor-shell-article .custom-wrapper,\n.linkedin-article-composer .normal-editor-shell-article .custom-editor {\n  border: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n}\n\n.linkedin-article-composer .normal-editor-shell-article .rdw-editor-main {\n  border-top: 0 !important;\n}\n\n@media (max-width: 767px) {\n  .linkedin-article-preview-page {\n    width: calc(100% - 20px);\n    min-height: 560px;\n    margin-top: 18px;\n  }\n\n  .linkedin-article-preview-author {\n    padding: 20px 20px 16px;\n  }\n\n  .linkedin-article-preview-cover {\n    min-height: 240px;\n    margin: 0 20px;\n  }\n\n  .linkedin-article-preview-body {\n    padding: 28px 20px 84px;\n  }\n\n  .linkedin-article-preview-body h1 {\n    font-size: 34px;\n  }\n\n  .linkedin-article-preview-footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .linkedin-article-preview-footer .ant-btn {\n    width: 100%;\n  }\n}\n\n.linkedin-article-composer .linkedin-article-author-row {\n  min-width: 250px !important;\n  gap: 12px;\n  padding: 0 !important;\n}\n\n.linkedin-article-composer .linkedin-article-author-avatar {\n  width: 50px !important;\n  height: 50px !important;\n  border: 0 !important;\n  background: #d8e5f3 !important;\n  color: #0b4778 !important;\n  box-shadow: none !important;\n}\n\n.linkedin-article-composer .linkedin-article-author-name {\n  color: #111827 !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  line-height: 1.05;\n}\n\n.linkedin-article-composer .linkedin-article-author-caret {\n  color: #4b5563;\n  font-size: 13px;\n}\n\n.linkedin-article-composer .linkedin-article-author-type {\n  margin-top: 2px !important;\n  color: #111827 !important;\n  font-size: 15px !important;\n  line-height: 1.15;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-center {\n  min-height: 50px !important;\n  gap: 8px !important;\n  padding: 6px 18px !important;\n  border: 0 !important;\n  border-radius: 999px !important;\n  background: #f3f1ed !important;\n  box-shadow: none !important;\n}\n\n.linkedin-article-composer .linkedin-article-style-select {\n  min-width: 118px;\n}\n\n.linkedin-article-composer .linkedin-article-style-select select {\n  color: #1f2937 !important;\n  font-size: 17px !important;\n  font-weight: 700 !important;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-group {\n  gap: 5px;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-group + .linkedin-article-toolbar-group {\n  margin-left: 7px !important;\n  padding-left: 12px !important;\n  border-left: 1px solid #ded8cf !important;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-button,\n.linkedin-article-composer .custom-emoji-trigger.rdw-option-wrapper {\n  width: 36px !important;\n  height: 36px !important;\n  min-width: 36px !important;\n  border-radius: 50% !important;\n  color: #333333 !important;\n  font-size: 19px !important;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-button:hover,\n.linkedin-article-composer .linkedin-article-toolbar-button.active,\n.linkedin-article-composer .custom-emoji-trigger.rdw-option-wrapper:hover {\n  background: #dcecff !important;\n  color: #0a66c2 !important;\n  transform: none !important;\n}\n\n.linkedin-article-actions {\n  min-width: 180px !important;\n}\n\n/* Was a bordered \"Next\" text button — now an icon-only circular CTA (an\n   arrow, not text) so it reads as the one standout primary action among\n   the otherwise-plain icon buttons in this row, rather than another\n   same-weight rectangle. Uses --brand-gradient (steel blue -> dark navy),\n   the same gradient this app already uses for its other primary CTAs (see\n   e.g. \"+ Create Blog Write Request\" on the Blog Write Requests page) —\n   two earlier versions of this (a steel-blue->turquoise gradient, then a\n   flat solid #3B6B94) both missed that reference; fixed to match it\n   exactly this time. */\n.linkedin-article-preview-button {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  width: 42px !important;\n  min-width: 42px !important;\n  height: 42px !important;\n  padding: 0 !important;\n  border: none !important;\n  border-radius: 50% !important;\n  background: var(--brand-gradient, linear-gradient(135deg, #3B6B94 0%, #071E31 100%)) !important;\n  color: #ffffff !important;\n  font-size: 17px;\n  box-shadow: 0 6px 16px rgba(7, 30, 49, 0.35) !important;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;\n}\n\n.linkedin-article-preview-button:hover {\n  filter: brightness(1.15);\n  transform: translateY(-2px) scale(1.04);\n  box-shadow: 0 10px 22px rgba(7, 30, 49, 0.45) !important;\n}\n\n.linkedin-article-preview-button:disabled {\n  background: #cbd5e1 !important;\n  color: #f1f5f9 !important;\n  box-shadow: none !important;\n  transform: none;\n  filter: none;\n  cursor: not-allowed;\n}\n\n/* \"Send Request to Blog Writer\" — CreateBlogManually.js's Create Blog page\n   header. Same --brand-gradient as every other primary CTA in this app —\n   same fix/reasoning as .linkedin-article-preview-button above. */\n.blog-send-writer-request-btn.ant-btn {\n  border: none !important;\n  background: var(--brand-gradient, linear-gradient(135deg, #3B6B94 0%, #071E31 100%)) !important;\n  color: #ffffff !important;\n  font-weight: 600;\n  box-shadow: 0 6px 16px rgba(7, 30, 49, 0.3) !important;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, filter 0.18s ease;\n}\n.blog-send-writer-request-btn.ant-btn:hover,\n.blog-send-writer-request-btn.ant-btn:focus {\n  color: #ffffff !important;\n  filter: brightness(1.15);\n  transform: translateY(-1px);\n  box-shadow: 0 10px 22px rgba(7, 30, 49, 0.4) !important;\n}\n.blog-send-writer-request-btn.ant-btn .anticon {\n  color: #ffffff !important;\n}\n\n.linkedin-article-composer {\n  background:\n    linear-gradient(180deg, #f8fbff 0%, #ffffff 210px) !important;\n}\n\n.linkedin-article-composer .normal-editor-before,\n.linkedin-article-composer .normal-editor-shell-article .rdw-editor-main {\n  position: relative;\n  z-index: 1;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-shell {\n  position: sticky !important;\n  top: 0;\n  z-index: 20 !important;\n  margin-bottom: 30px !important;\n  background:\n    linear-gradient(90deg, #ffffff 0%, #fbfdff 46%, #ffffff 100%) !important;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.055) !important;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-center {\n  border: 1px solid #e5ded2 !important;\n  background: linear-gradient(180deg, #fbfaf7 0%, #efebe5 100%) !important;\n  box-shadow:\n    0 16px 36px rgba(15, 23, 42, 0.12),\n    inset 0 1px 0 rgba(255, 255, 255, 0.94) !important;\n}\n\n.linkedin-article-cover-shell,\n.linkedin-article-title-shell,\n.normal-editor-shell-article .rdw-editor-main {\n  max-width: 880px !important;\n}\n\n.linkedin-article-cover-stage {\n  border-color: #e3dfd7 !important;\n  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.08);\n}\n\n.linkedin-article-cover-media {\n  max-height: 480px !important;\n}\n\n.linkedin-article-title-shell {\n  margin-top: 28px !important;\n}\n\n.linkedin-article-title-input {\n  color: #0f172a !important;\n  font-weight: 600 !important;\n}\n\n/* LinkedIn article header strength */\n.linkedin-article-composer .linkedin-article-toolbar-shell {\n  grid-template-columns: minmax(280px, 1fr) auto minmax(180px, 1fr) !important;\n  min-height: 74px !important;\n  margin-bottom: 30px !important;\n  padding: 10px 56px !important;\n  border-top: 0 !important;\n  border-bottom: 1px solid #d8dadd !important;\n  background: #ffffff !important;\n  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04) !important;\n}\n\n.linkedin-article-composer .linkedin-article-author-row {\n  gap: 12px !important;\n  min-width: 280px !important;\n}\n\n.linkedin-article-composer .linkedin-article-author-avatar {\n  width: 48px !important;\n  height: 48px !important;\n  border: 0 !important;\n  background: #d9e5f2 !important;\n  color: #0a4778 !important;\n  font-size: 21px !important;\n  font-weight: 800 !important;\n  box-shadow: none !important;\n}\n\n.linkedin-article-composer .linkedin-article-author-name {\n  color: #111111 !important;\n  font-size: 18px !important;\n  font-weight: 800 !important;\n  line-height: 1.08 !important;\n}\n\n.linkedin-article-composer .linkedin-article-author-caret {\n  color: #3d3d3d !important;\n  font-size: 14px !important;\n  font-weight: 800 !important;\n}\n\n.linkedin-article-composer .linkedin-article-author-type {\n  margin-top: 1px !important;\n  color: #111111 !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 1.15 !important;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-center {\n  min-height: 48px !important;\n  gap: 7px !important;\n  padding: 5px 18px !important;\n  border: 0 !important;\n  border-radius: 999px !important;\n  background: #f3f1ed !important;\n  box-shadow: none !important;\n}\n\n.linkedin-article-composer .linkedin-article-style-select {\n  min-width: 78px !important;\n}\n\n.linkedin-article-composer .linkedin-article-style-select select {\n  color: #111111 !important;\n  font-size: 17px !important;\n  font-weight: 800 !important;\n  padding: 5px 18px 5px 10px !important;\n}\n\n.linkedin-article-composer .linkedin-article-style-caret {\n  right: 4px !important;\n  color: #111111 !important;\n  font-size: 11px !important;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-group + .linkedin-article-toolbar-group {\n  margin-left: 8px !important;\n  padding-left: 14px !important;\n  border-left: 1px solid #d8d2c9 !important;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-button,\n.linkedin-article-composer .custom-emoji-trigger.rdw-option-wrapper {\n  width: 38px !important;\n  height: 38px !important;\n  min-width: 38px !important;\n  color: #303030 !important;\n  font-size: 22px !important;\n  font-weight: 900 !important;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-button .anticon svg,\n.linkedin-article-composer .custom-emoji-trigger.rdw-option-wrapper .anticon svg {\n  width: 22px !important;\n  height: 22px !important;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-text {\n  font-size: 24px !important;\n  font-weight: 900 !important;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-quote {\n  width: 24px !important;\n  height: 20px !important;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-quote::before,\n.linkedin-article-composer .linkedin-article-toolbar-quote::after {\n  width: 8px !important;\n  height: 13px !important;\n  border-radius: 2px 2px 7px 7px !important;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-code {\n  font-size: 16px !important;\n  font-weight: 900 !important;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-divider {\n  width: 22px !important;\n  height: 2px !important;\n}\n\n.linkedin-article-actions {\n  gap: 10px !important;\n}\n\n.linkedin-article-action-button.ant-btn,\n.linkedin-article-action-icon {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  height: 38px !important;\n  border: 1px solid #d8e2ef !important;\n  border-radius: 999px !important;\n  background: #ffffff !important;\n  color: #314761 !important;\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.06) !important;\n  font-size: 14px;\n  font-weight: 700;\n  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease, transform 0.18s ease;\n}\n\n.linkedin-article-action-button.ant-btn {\n  min-width: 152px;\n  padding: 0 16px !important;\n}\n\n.linkedin-article-action-icon {\n  width: 38px;\n  min-width: 38px;\n  padding: 0;\n  cursor: pointer;\n}\n\n.linkedin-article-action-button.ant-btn:hover,\n.linkedin-article-action-icon:hover {\n  border-color: #9ec5f1 !important;\n  background: #eef6ff !important;\n  color: #0a66c2 !important;\n  transform: translateY(-1px);\n}\n\n.linkedin-article-delete-button:hover {\n  border-color: #fecaca !important;\n  background: #fff1f2 !important;\n  color: #dc2626 !important;\n}\n\n.linkedin-article-action-icon:disabled {\n  cursor: not-allowed;\n  opacity: 0.48;\n  transform: none;\n}\n\n.linkedin-article-cover-trigger {\n  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.2);\n}\n\n.public-article-page {\n  min-height: 100vh;\n  padding: 42px 18px 72px;\n  background: #f3f2ef;\n  color: #111827;\n}\n\n.public-article-card {\n  width: min(920px, 100%);\n  min-height: calc(100vh - 114px);\n  margin: 0 auto;\n  padding: 40px 56px 72px;\n  background: #ffffff;\n  box-shadow: 0 18px 54px rgba(15, 23, 42, 0.08);\n}\n\n.public-article-header {\n  margin-bottom: 28px;\n}\n\n.public-article-author {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n}\n\n.public-article-avatar {\n  display: grid;\n  width: 52px;\n  height: 52px;\n  place-items: center;\n  overflow: hidden;\n  border-radius: 50%;\n  background: #dbeafe;\n  color: #0a66c2;\n  font-size: 20px;\n  font-weight: 800;\n}\n\n.public-article-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.public-article-author-name {\n  color: #111827;\n  font-size: 18px;\n  font-weight: 800;\n  line-height: 1.2;\n}\n\n.public-article-author-meta {\n  margin-top: 2px;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.public-article-cover {\n  display: block;\n  width: 100%;\n  max-height: 520px;\n  margin-bottom: 36px;\n  object-fit: cover;\n  background: #f3f0eb;\n}\n\n.public-article-card h1 {\n  margin: 0 0 30px;\n  color: #191919;\n  font-size: 46px;\n  font-weight: 700;\n  line-height: 1.15;\n}\n\n.public-article-content {\n  color: #191919;\n  font-size: 19px;\n  line-height: 1.76;\n}\n\n.public-article-content p {\n  margin: 0 0 18px;\n}\n\n.public-article-content ul,\n.public-article-content ol {\n  margin: 0 0 18px 24px;\n  padding: 0;\n}\n\n.public-article-content hr {\n  height: 1px;\n  margin: 34px 0;\n  border: 0;\n  background: #d4d4d4;\n}\n\n.public-article-content blockquote {\n  margin: 26px 0;\n  padding-left: 20px;\n  border-left: 4px solid #0a66c2;\n  color: #334155;\n  font-size: 22px;\n}\n\n.public-article-content img {\n  max-width: 100%;\n}\n\n.public-article-state {\n  width: min(680px, 100%);\n  margin: 20vh auto 0;\n  padding: 32px;\n  border-radius: 12px;\n  background: #ffffff;\n  color: #334155;\n  text-align: center;\n  font-size: 18px;\n  box-shadow: 0 18px 54px rgba(15, 23, 42, 0.08);\n}\n\n@media (max-width: 767px) {\n  .public-article-page {\n    padding: 0;\n  }\n\n  .public-article-card {\n    min-height: 100vh;\n    padding: 28px 22px 56px;\n    box-shadow: none;\n  }\n\n  .public-article-card h1 {\n    font-size: 34px;\n  }\n}\n\n@media (max-width: 1100px) {\n  .linkedin-article-composer .linkedin-article-toolbar-shell {\n    grid-template-columns: 1fr !important;\n    gap: 14px;\n  }\n\n  .linkedin-article-composer .linkedin-article-toolbar-start,\n  .linkedin-article-composer .linkedin-article-toolbar-center,\n  .linkedin-article-composer .linkedin-article-toolbar-end {\n    justify-self: center;\n  }\n\n  .linkedin-article-actions {\n    min-width: 0 !important;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 767px) {\n  .linkedin-article-action-button.ant-btn {\n    min-width: 142px;\n  }\n\n  .linkedin-article-composer .linkedin-article-toolbar-center {\n    max-width: 100%;\n    overflow-x: auto;\n  }\n}\n\n/* SYNCED ARTICLE EDITOR UI END */\n/* Blog list rows */\n.blr-list-container {\n  background: #ffffff;\n  border-radius: 0 0 8px 8px;\n  overflow: hidden;\n}\n\n.blr-wrapper {\n  border-bottom: 1px solid #f0f0f0;\n  background: #ffffff;\n}\n\n.blr-wrapper:last-child {\n  border-bottom: 0;\n}\n\n.blr-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 0;\n  padding: 14px 18px 14px 0;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  user-select: none;\n  min-height: 64px;\n}\n\n.blr-row:hover {\n  background: #f9fafb;\n}\n\n.blr-bar {\n  flex: 0 0 4px;\n  align-self: stretch;\n  min-height: 52px;\n  border-radius: 0 3px 3px 0;\n  margin-right: 14px;\n}\n\n.blr-content {\n  flex: 1 1 0;\n  min-width: 0;\n  padding-right: 10px;\n}\n\n.blr-top {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin-bottom: 5px;\n  flex-wrap: wrap;\n}\n\n.blr-type-badge {\n  display: inline-flex;\n  align-items: center;\n  height: 19px;\n  padding: 0 7px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n}\n\n.blr-type-ai {\n  background: #ede9fe;\n  color: #6d28d9;\n}\n\n.blr-type-manual {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.blr-status-dot {\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.blr-status-label {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.blr-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n  line-height: 1.35;\n  margin-bottom: 3px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.blr-outline {\n  font-size: 12.5px;\n  font-weight: 500;\n  color: #374151;\n  line-height: 1.45;\n  margin-bottom: 3px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.blr-preview {\n  font-size: 12px;\n  color: #6b7280;\n  line-height: 1.45;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 5px;\n}\n\n.blr-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 11.5px;\n  color: #9ca3af;\n  flex-wrap: wrap;\n}\n\n.blr-meta-sep {\n  color: #d1d5db;\n}\n\n.blr-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  padding-top: 1px;\n}\n\n.blr-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid #e5e7eb;\n  border-radius: 50%;\n  background: #ffffff;\n  color: #4b5563;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.14s, border-color 0.14s, color 0.14s;\n  flex-shrink: 0;\n}\n\n.blr-action-btn:hover {\n  background: #eff6ff;\n  border-color: #93c5fd;\n  color: #0a66c2;\n}\n\n.blr-action-btn-download:hover {\n  background: #f0fdf4;\n  border-color: #86efac;\n  color: #16a34a;\n}\n\n.blr-action-btn-delete:hover {\n  background: #fff1f2;\n  border-color: #fca5a5;\n  color: #dc2626;\n}\n\n.blr-chevron {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border: 0;\n  background: transparent;\n  color: #9ca3af;\n  font-size: 11px;\n  cursor: pointer;\n  transition: transform 0.2s ease, color 0.15s ease;\n  flex-shrink: 0;\n  margin-left: 2px;\n}\n\n.blr-chevron.blr-chevron-open {\n  transform: rotate(180deg);\n  color: #0a66c2;\n}\n\n.blr-expanded {\n  padding: 14px 20px 16px 18px;\n  background: #f8fafc;\n  border-top: 1px solid #f0f0f0;\n  animation: blr-slide-down 0.18s ease;\n}\n\n@keyframes blr-slide-down {\n  from { opacity: 0; transform: translateY(-6px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.blr-expanded-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px 20px;\n}\n\n@media (max-width: 640px) {\n  .blr-expanded-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.blr-expanded-section {\n  min-width: 0;\n}\n\n.blr-expanded-label {\n  font-size: 10.5px;\n  font-weight: 700;\n  color: #9ca3af;\n  letter-spacing: 0.7px;\n  text-transform: uppercase;\n  margin-bottom: 5px;\n}\n\n.blr-expanded-text {\n  font-size: 13px;\n  color: #374151;\n  line-height: 1.6;\n}\n\n.blr-empty {\n  padding: 40px;\n  text-align: center;\n  color: #9ca3af;\n  font-size: 14px;\n}\n/* Monthly report account highlights */\n.monthly-report-highlights-title {\n  font-size: 40px !important;\n  font-weight: 500 !important;\n  line-height: 1.1 !important;\n  margin-bottom: 24px !important;\n}\n\n.monthly-report-highlights .ant-card {\n  border-radius: 18px !important;\n}\n\n.monthly-report-highlights .ant-card-head {\n  border-bottom: 0 !important;\n  padding: 22px 28px 0 !important;\n  min-height: auto !important;\n}\n\n.monthly-report-highlights .ant-card-head-title {\n  font-size: 24px !important;\n  line-height: 1.25 !important;\n  font-weight: 800 !important;\n  color: #111827 !important;\n}\n\n.monthly-report-highlights .ant-card-body {\n  padding: 34px 28px 28px !important;\n  min-height: 154px;\n}\n\n.monthly-report-highlights .ant-card-body > div[style*=\"font-style: italic\"] {\n  font-size: 18px !important;\n  margin-bottom: 20px !important;\n}\n\n.monthly-report-highlights .ant-card-body span[style*=\"font-size: 22px\"] {\n  font-size: 32px !important;\n  line-height: 1.1 !important;\n}\n\n.monthly-report-highlights .ant-card-body span[style*=\"font-size: 14px\"] {\n  font-size: 20px !important;\n}\n\n.monthly-report-highlights .ant-input-number {\n  height: 62px !important;\n  font-size: 22px !important;\n}\n\n.monthly-report-highlights .ant-input-number-input {\n  height: 60px !important;\n  font-size: 22px !important;\n}\n\n.monthly-report-highlights .ant-col > div[style*=\"font-size: 12px\"] {\n  font-size: 16px !important;\n  margin-bottom: 8px !important;\n}\n\n/* Monthly report post performance section */\n.monthly-report-post-section .ant-card {\n  border-radius: 18px !important;\n}\n\n.monthly-report-post-section .ant-card-head {\n  border-bottom: 0 !important;\n  min-height: auto !important;\n  padding: 22px 28px 0 !important;\n}\n\n.monthly-report-post-section .ant-card-head-title {\n  color: #111827 !important;\n  font-size: 24px !important;\n  font-weight: 800 !important;\n  line-height: 1.25 !important;\n}\n\n.monthly-report-post-section .ant-card-body {\n  padding: 28px !important;\n}\n\n.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table {\n  font-size: 18px !important;\n  table-layout: fixed !important;\n  width: 100% !important;\n}\n\n.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table-thead > tr > th {\n  background: #f4f6fb !important;\n  color: #0f172a !important;\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  padding: 18px 10px !important;\n  white-space: nowrap !important;\n}\n\n.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table-tbody > tr > td {\n  color: #374151 !important;\n  font-size: 18px !important;\n  padding: 18px 10px !important;\n  vertical-align: middle !important;\n}\n\n.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table-cell {\n  white-space: nowrap !important;\n}\n\n.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table-cell a,\n.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table-cell:nth-child(2) {\n  display: block !important;\n  max-width: 100% !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n\n.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table-content {\n  overflow-x: hidden !important;\n}\n\n.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .monthly-report-date-cell {\n  overflow: visible !important;\n  text-overflow: clip !important;\n}\n\n.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .monthly-report-date-text {\n  display: inline-block !important;\n  font-size: 17px !important;\n  letter-spacing: 0 !important;\n  line-height: 1.25 !important;\n  min-width: 96px !important;\n  overflow: visible !important;\n  white-space: nowrap !important;\n}\n\n.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table-body {\n  scrollbar-color: #151033 #d4d4d8;\n  scrollbar-width: auto;\n}\n\n/* \"Status of Blogs\" card (2nd card in the same column) — same header/cell\n   treatment as the Engagement Tracking table above it, so the two editable\n   tables in this section read as one consistent design instead of the\n   Engagement table looking finished and this one looking like a bare\n   default antd table. Blog Title has no fixed width (unlike the Engagement\n   table's Date/Likes/Comments), so table-layout stays auto here rather than\n   fixed — that's what was making its input cramped. */\n.monthly-report-post-section > .ant-col:first-child > .ant-card:nth-child(2) .ant-table-thead > tr > th {\n  background: #f4f6fb !important;\n  color: #0f172a !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  padding: 14px 10px !important;\n  white-space: nowrap !important;\n}\n\n/* Kills the default antd column-divider (a dark ::before bar between header\n   cells) on both editable tables in this section — same treatment the\n   brand-manager panel's site-wide table styling already applies, scoped\n   here instead of going global so it can't affect any other admin table. */\n.monthly-report-post-section > .ant-col:first-child > .ant-card:first-child .ant-table-thead > tr > th::before,\n.monthly-report-post-section > .ant-col:first-child > .ant-card:nth-child(2) .ant-table-thead > tr > th::before {\n  background-color: transparent !important;\n}\n\n.monthly-report-post-section > .ant-col:first-child > .ant-card:nth-child(2) .ant-table-tbody > tr > td {\n  color: #374151 !important;\n  font-size: 15px !important;\n  padding: 12px 10px !important;\n  vertical-align: middle !important;\n}\n\n.monthly-report-post-section > .ant-col:first-child > .ant-card:nth-child(2) .ant-input {\n  border-radius: 8px !important;\n}\n\n.monthly-report-post-section > .ant-col:last-child > .ant-card:first-child .ant-card-body {\n  font-size: 18px !important;\n  line-height: 1.6 !important;\n}\n\n.monthly-report-post-section > .ant-col:last-child > .ant-card:first-child .ant-input {\n  border-radius: 10px !important;\n  font-size: 20px !important;\n  height: 60px !important;\n  padding: 0 18px !important;\n}\n\n.monthly-report-post-section > .ant-col:last-child > .ant-card:first-child .ant-upload .ant-btn {\n  border-radius: 10px !important;\n  font-size: 22px !important;\n  height: 78px !important;\n  padding: 0 30px !important;\n}\n\n.monthly-report-post-section > .ant-col:last-child > .ant-card:first-child img {\n  max-height: 280px !important;\n}\n.writing-pro-card {\n  background: #fff;\n}\n\n.writing-pro-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 18px;\n}\n\n.writing-pro-header h4 {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  color: #06163a;\n}\n\n.writing-pro-header p {\n  margin: 4px 0 0;\n  color: #697184;\n  font-size: 14px;\n}\n\n.writing-pro-layout {\n  display: grid;\n  grid-template-columns: minmax(250px, 300px) minmax(0, 1fr) minmax(260px, 320px);\n  gap: 18px;\n  align-items: start;\n}\n\n.writing-pro-panel,\n.writing-pro-main {\n  border: 1px solid #edf0f6;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0 10px 28px rgba(13, 38, 76, 0.06);\n}\n\n.writing-pro-panel {\n  padding: 16px;\n}\n\n.writing-pro-actions,\n.writing-pro-submit,\n.writing-pro-toolbar-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.writing-pro-actions {\n  flex-direction: column;\n}\n\n.writing-pro-history {\n  margin-top: 18px;\n  padding-top: 16px;\n  border-top: 1px solid #edf0f6;\n}\n\n.writing-pro-history h5,\n.writing-pro-list h5 {\n  margin: 0 0 10px;\n  font-size: 15px;\n  font-weight: 700;\n  color: #06163a;\n}\n\n.writing-pro-history button {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  text-align: left;\n  border: 1px solid #edf0f6;\n  background: #f8fafd;\n  color: #1f2937;\n  border-radius: 8px;\n  padding: 10px 12px;\n  margin-bottom: 8px;\n  cursor: pointer;\n}\n\n.writing-pro-history button.active {\n  border-color: #0b7bea;\n  background: #eef7ff;\n}\n\n.writing-pro-history button span {\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.writing-pro-history button small {\n  color: #7b8495;\n}\n\n.writing-pro-main {\n  min-width: 0;\n  overflow: hidden;\n}\n\n.writing-pro-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 14px 16px;\n  border-bottom: 1px solid #edf0f6;\n}\n\n.writing-pro-toolbar strong {\n  display: block;\n  font-size: 18px;\n  color: #06163a;\n}\n\n.writing-pro-toolbar span {\n  color: #697184;\n  font-size: 13px;\n}\n\n.writing-pro-main .contant-editer iframe {\n  border: 0 !important;\n  min-height: 520px;\n}\n\n.writing-pro-main .contant-editer .description-editor-local {\n  background: #fff;\n  border: 0;\n  color: #1f2937;\n  font-size: 16px;\n  line-height: 1.7;\n  min-height: 520px;\n  outline: none;\n  overflow-y: auto;\n  padding: 16px;\n  width: 100%;\n}\n\n.writing-pro-main .contant-editer .description-editor-local:empty::before {\n  color: #9ca3af;\n  content: attr(data-placeholder);\n  pointer-events: none;\n}\n\n.writing-pro-submit {\n  justify-content: flex-end;\n  padding: 14px 16px;\n  border-top: 1px solid #edf0f6;\n}\n\n.writing-pro-metric,\n.writing-pro-list {\n  margin-top: 14px;\n  padding: 14px;\n  border: 1px solid #edf0f6;\n  border-radius: 8px;\n  background: #f9fbff;\n}\n\n.writing-pro-metric span {\n  display: block;\n  color: #697184;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.writing-pro-metric strong {\n  display: block;\n  margin-top: 6px;\n  color: #082b63;\n  font-size: 24px;\n}\n\n.writing-pro-metric p,\n.writing-pro-list p {\n  margin: 8px 0 0;\n  color: #4c5668;\n  line-height: 1.5;\n}\n\n@media (max-width: 1200px) {\n  .writing-pro-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .writing-pro-toolbar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n\n/* Keep the staff article workflow visible: edit, Next, then review actions in preview. */\n.linkedin-article-composer .linkedin-article-toolbar-shell {\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) !important;\n}\n\n.linkedin-article-composer .linkedin-article-toolbar-end {\n  display: flex !important;\n  min-width: 0 !important;\n  justify-self: end !important;\n}\n\n.linkedin-article-composer .linkedin-article-actions {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: flex-end !important;\n  gap: 8px !important;\n  min-width: 0 !important;\n}\n\n.linkedin-article-preview-avatar {\n  flex: 0 0 52px;\n  width: 52px !important;\n  height: 52px !important;\n}\n\n.linkedin-article-preview-avatar img {\n  display: block;\n  width: 52px !important;\n  height: 52px !important;\n  max-width: 52px !important;\n  object-fit: cover !important;\n}\n\n\n/* =========================================================\n   Header responsive overrides — sidebar-aware\n   ========================================================= */\n\n@media (max-width: 1600px) {\n  .section-headding h6 {\n    font-size: 26px !important;\n    line-height: 1.2 !important;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  .layout-dashboard .ant-layout-header {\n    padding: 12px 24px 12px 16px !important;\n  }\n  .layout-dashboard .header-control {\n    gap: 12px !important;\n  }\n}\n\n@media (max-width: 1400px) {\n  .section-headding h6 {\n    font-size: 22px !important;\n    line-height: 1.2 !important;\n  }\n  .layout-dashboard .ant-layout-header {\n    padding: 10px 20px 10px 14px !important;\n  }\n  .layout-dashboard .header-control {\n    gap: 8px !important;\n  }\n}\n\n@media (max-width: 1200px) {\n  .section-headding h6 {\n    font-size: 20px !important;\n  }\n  .layout-dashboard .ant-layout-header {\n    padding: 8px 16px 8px 12px !important;\n  }\n}\n\n/* ── LinkedIn post preview — interactions row ── */\n.post-interactions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.like-counts {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.like-counts img {\n  width: 30px;\n  height: 30px;\n  flex: 0 0 auto;\n}\n\n.like-counts span {\n  color: #585757;\n  font-weight: 400;\n  font-size: 16px;\n}\n\n.cm-reort-text {\n  display: flex;\n  gap: 10px;\n}\n\n.cm-reort-text span {\n  color: #585757;\n  font-weight: 500;\n  font-size: 15px;\n  letter-spacing: -0.14px;\n}\n\n/* =========================================================\n   Writing Assistant — new UI (wa-* classes)\n   ========================================================= */\n\n.wa-root {\n  padding: 4px 0 24px;\n}\n\n.wa-page-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  gap: 16px;\n}\n\n.wa-page-header-left {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.wa-page-header-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%);\n  color: #fff;\n  font-size: 20px;\n  flex-shrink: 0;\n  box-shadow: 0 4px 14px rgba(11, 123, 234, 0.3);\n}\n\n.wa-page-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n  line-height: 1.3;\n}\n\n.wa-page-subtitle {\n  font-size: 13px;\n  color: #64748b;\n  margin: 2px 0 0;\n}\n\n.wa-history-btn {\n  flex-shrink: 0;\n  background: #ffffff !important;\n  color: #334155 !important;\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 8px !important;\n  font-weight: 600 !important;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, color 0.18s ease;\n}\n.wa-history-btn:hover {\n  background: #f0f8ff !important;\n  border-color: #0b7bea !important;\n  color: #0b7bea !important;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(11, 123, 234, 0.18);\n}\n\n.wa-layout {\n  display: grid;\n  grid-template-columns: 280px minmax(0, 1fr);\n  gap: 16px;\n  align-items: stretch;\n  height: calc(100vh - 210px);\n  min-height: 560px;\n}\n\n.wa-sidebar {\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 1px 4px rgba(15,23,42,.06), 0 4px 20px rgba(15,23,42,.04);\n  overflow: hidden;\n}\n\n.wa-sidebar-tabs.ant-tabs { height: 100%; }\n.wa-sidebar-tabs .ant-tabs-nav { margin: 0; padding: 0 8px; background: #f8fafd; border-bottom: 1px solid #e2e8f0 !important; }\n.wa-sidebar-tabs .ant-tabs-tab { padding: 12px 10px !important; font-size: 13px !important; }\n.wa-sidebar-tabs .ant-tabs-tab-active .ant-tabs-tab-btn { color: #0b7bea !important; font-weight: 600 !important; }\n.wa-sidebar-tabs .ant-tabs-ink-bar { background: #0b7bea !important; }\n.wa-sidebar-tabs .ant-tabs-content-holder { padding: 16px; }\n\n.wa-tab-label { display: flex; align-items: center; gap: 5px; }\n.wa-tab-badge { display: inline-flex; align-items: center; justify-content: center; min-width: 18px; height: 18px; padding: 0 5px; border-radius: 10px; background: #0b7bea; color: #fff; font-size: 10px; font-weight: 700; line-height: 1; margin-left: 2px; }\n\n.wa-form-actions { display: flex; flex-direction: column; gap: 10px; margin-top: 8px; }\n.wa-generate-row { display: flex; align-items: center; gap: 8px; }\n.wa-generate-row .wa-btn-generate.ant-btn-block { width: auto; flex: 1 1 auto; min-width: 0; }\n\n.wa-btn-generate { background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%) !important; border: none !important; box-shadow: 0 3px 10px rgba(11,123,234,.28) !important; font-weight: 600 !important; }\n.wa-btn-generate:hover { opacity: 0.9; box-shadow: 0 4px 14px rgba(11,123,234,.38) !important; }\n.wa-btn-search { border-color: #e2e8f0 !important; color: #475569 !important; }\n.wa-textarea { resize: none !important; font-size: 13px !important; }\n\n.wa-content-bank { display: flex; flex-direction: column; gap: 0; }\n.wa-bank-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; font-size: 12px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; color: #94a3b8; }\n.wa-bank-item { width: 100%; display: flex; flex-direction: column; gap: 2px; text-align: left; border: 1px solid #f1f5f9; background: #fafbfd; border-radius: 8px; padding: 10px 12px; margin-bottom: 6px; cursor: pointer; transition: border-color .15s ease, background .15s ease, box-shadow .15s ease; }\n.wa-bank-item:hover { border-color: #bfdbfe; background: #eff6ff; box-shadow: 0 2px 8px rgba(11,123,234,.08); }\n.wa-bank-item.active { border-color: #0b7bea; background: #eff6ff; box-shadow: 0 2px 10px rgba(11,123,234,.14); }\n.wa-bank-item-title { font-size: 13px; font-weight: 600; color: #1e293b; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.wa-bank-item-meta { font-size: 11px; color: #94a3b8; }\n.wa-bank-item-words { margin-left: 4px; color: #cbd5e1; }\n.wa-bank-empty { display: flex; flex-direction: column; align-items: center; padding: 28px 16px; text-align: center; }\n.wa-bank-empty p { margin: 0; font-size: 13px; color: #94a3b8; }\n.wa-bank-empty small { font-size: 11px; color: #cbd5e1; margin-top: 4px; }\n\n/* ── Chat sidebar (chat history + drafts) ─────────────────────────────────── */\n.wa-chat-sidebar { display: flex; flex-direction: column; border: 1px solid #e2e8f0; border-radius: 14px; background: #fff; box-shadow: 0 1px 4px rgba(15,23,42,.06), 0 4px 20px rgba(15,23,42,.04); overflow: hidden; height: 100%; min-height: 0; }\n.wa-chat-sidebar-top { padding: 14px 14px 8px; }\n.wa-new-chat-btn.ant-btn { background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%) !important; border: none !important; font-weight: 600 !important; box-shadow: 0 3px 10px rgba(11,123,234,.28) !important; }\n.wa-chat-sidebar-search { padding: 0 14px 10px; }\n.wa-chat-sidebar-toggle { padding: 0 14px 10px; }\n.wa-chat-sidebar-list { flex: 1; min-height: 0; overflow-y: auto; padding: 4px 10px 10px; }\n.wa-chat-sidebar-group { margin-bottom: 6px; }\n.wa-chat-sidebar-group-label { font-size: 11px; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; color: #94a3b8; padding: 10px 8px 4px; }\n.wa-chat-sidebar-item { display: flex; align-items: center; gap: 8px; padding: 8px; border-radius: 8px; cursor: pointer; transition: background .15s ease; }\n.wa-chat-sidebar-item:hover { background: #f1f5f9; }\n.wa-chat-sidebar-item.active { background: #eff6ff; }\n.wa-chat-sidebar-item-icon { color: #94a3b8; font-size: 13px; flex-shrink: 0; }\n.wa-chat-sidebar-item.active .wa-chat-sidebar-item-icon { color: #0b7bea; }\n.wa-chat-sidebar-item-title { flex: 1; min-width: 0; font-size: 13px; color: #334155; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.wa-chat-sidebar-item.active .wa-chat-sidebar-item-title { color: #0b7bea; font-weight: 600; }\n.wa-chat-sidebar-item-body { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }\n.wa-chat-sidebar-item-body .wa-chat-sidebar-item-title { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.wa-chat-sidebar-item-meta { font-size: 11px; color: #94a3b8; }\n.wa-chat-sidebar-item-delete { opacity: 0; border: none; background: transparent; color: #94a3b8; cursor: pointer; padding: 4px; border-radius: 6px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; transition: opacity .15s ease, background .15s ease, color .15s ease; }\n.wa-chat-sidebar-item:hover .wa-chat-sidebar-item-delete { opacity: 1; }\n.wa-chat-sidebar-item-delete:hover { background: #fee2e2; color: #dc2626; }\n.wa-chat-sidebar-empty { padding: 24px 12px; text-align: center; font-size: 13px; color: #94a3b8; }\n.wa-chat-sidebar-footer { padding: 8px 10px; border-top: 1px solid #f1f5f9; flex-shrink: 0; }\n\n/* ── Chat column (conversation thread + composer) ─────────────────────────── */\n.wa-chat-column { display: flex; flex-direction: column; border: 1px solid #e2e8f0; border-radius: 14px; background: #fff; box-shadow: 0 1px 4px rgba(15,23,42,.06), 0 4px 20px rgba(15,23,42,.04); overflow: hidden; min-width: 0; height: 100%; min-height: 0; }\n.wa-chat-thread { flex: 1; min-height: 0; overflow-y: auto; padding: 20px; display: flex; flex-direction: column; gap: 16px; background: #fbfcfe; }\n\n.wa-chat-empty { margin: auto; text-align: center; max-width: 420px; padding: 24px; }\n.wa-chat-empty-icon { width: 56px; height: 56px; border-radius: 16px; background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%); color: #fff; display: flex; align-items: center; justify-content: center; font-size: 24px; margin: 0 auto 14px; box-shadow: 0 4px 14px rgba(11,123,234,.3); }\n.wa-chat-empty h3 { font-size: 17px; font-weight: 700; color: #0f172a; margin: 0 0 6px; }\n.wa-chat-empty p { font-size: 13px; color: #64748b; margin: 0 0 18px; }\n.wa-chat-starters { display: flex; flex-wrap: wrap; gap: 8px; justify-content: center; }\n.wa-chat-starter-chip { border: 1px solid #e2e8f0; background: #fff; color: #334155; font-size: 12.5px; padding: 8px 14px; border-radius: 20px; cursor: pointer; transition: border-color .15s ease, background .15s ease, color .15s ease; }\n.wa-chat-starter-chip:hover { border-color: #93c5fd; background: #eff6ff; color: #0b7bea; }\n\n.wa-msg { display: flex; }\n.wa-msg-user { justify-content: flex-end; }\n.wa-msg-assistant { justify-content: flex-start; }\n.wa-msg-bubble { border-radius: 16px; font-size: 14px; line-height: 1.55; }\n.wa-msg-user .wa-msg-bubble { max-width: 78%; background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%); color: #fff; padding: 10px 16px; border-bottom-right-radius: 4px; white-space: pre-wrap; word-wrap: break-word; }\n.wa-msg-assistant .wa-msg-bubble { max-width: 92%; width: 100%; }\n.wa-msg-card { background: #fff; border: 1px solid #e2e8f0; border-bottom-left-radius: 4px; box-shadow: 0 1px 3px rgba(15,23,42,.04); }\n.wa-msg-static { padding: 14px 16px; font-size: 14px; color: #1e293b; line-height: 1.65; }\n.wa-msg-static p { margin: 0 0 10px; }\n.wa-msg-static p:last-child { margin-bottom: 0; }\n.wa-msg-typing { display: flex; align-items: center; gap: 8px; padding: 12px 16px; color: #64748b; font-size: 13px; }\n.wa-msg-card.wa-editor-surface { flex: none; min-height: 0; }\n.wa-msg-card.wa-editor-surface .contant-editer .description-editor-local { min-height: 200px; border-radius: 12px; }\n\n/* ── Current draft actions bar ─────────────────────────────────────────────── */\n.wa-draft-actions { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 16px; border-top: 1px solid #e8edf5; background: #f8fafd; flex-shrink: 0; flex-wrap: wrap; }\n\n/* ── Composer ──────────────────────────────────────────────────────────────── */\n.wa-composer { border-top: 1px solid #e2e8f0; background: #fff; flex-shrink: 0; padding: 12px 16px 14px; }\n.wa-composer-input-row { display: flex; align-items: flex-end; gap: 8px; }\n.wa-composer-settings-toggle { flex-shrink: 0; width: 36px; height: 36px; border-radius: 10px; border: 1px solid #e2e8f0; background: #fff; color: #64748b; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 15px; transition: background .15s ease, color .15s ease, border-color .15s ease; }\n.wa-composer-settings-toggle:hover { background: #f1f5f9; }\n.wa-composer-settings-toggle.active { background: #eff6ff; border-color: #bfdbfe; color: #0b7bea; }\n\n.wa-settings-anchor { position: relative; flex-shrink: 0; }\n.wa-settings-panel { position: absolute; bottom: calc(100% + 10px); left: 0; width: 240px; background: #fff; border: 1px solid #eef2f7; border-radius: 16px; box-shadow: 0 16px 40px rgba(15,23,42,.16), 0 4px 12px rgba(15,23,42,.08); padding: 16px; z-index: 20; }\n.wa-settings-panel .ant-form-item { margin-bottom: 16px; }\n.wa-settings-panel .ant-form-item:last-child { margin-bottom: 0; }\n.wa-settings-panel .ant-form-item-label > label { font-size: 13px; font-weight: 700; color: #0f172a; height: auto; }\n.wa-settings-panel .ant-select-selector, .wa-settings-panel .ant-input { border-radius: 10px !important; }\n.wa-settings-panel .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) { background: linear-gradient(135deg, #3B6B94 0%, #071E31 100%) !important; border-color: #3B6B94 !important; color: #fff !important; box-shadow: -1px 0 0 0 #3B6B94 !important; }\n.wa-settings-panel .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before { background-color: #3B6B94 !important; }\n.wa-settings-panel .ant-radio-button-wrapper:hover { color: #3B6B94 !important; }\n.wa-settings-panel .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover { background: linear-gradient(135deg, #4a7ba8 0%, #0d2a42 100%) !important; border-color: #4a7ba8 !important; color: #fff !important; }\n\n.wa-composer-textarea { flex: 1; min-width: 0; }\n.wa-composer-textarea textarea.ant-input, .wa-composer-textarea.ant-input { border-radius: 18px !important; padding: 8px 16px !important; resize: none !important; font-size: 14px !important; border-color: #e2e8f0 !important; }\n.wa-composer-textarea textarea.ant-input:focus, .wa-composer-textarea.ant-input:focus { border-color: #0b7bea !important; box-shadow: 0 0 0 2px rgba(11,123,234,.12) !important; }\n.wa-composer-send.ant-btn { flex-shrink: 0; width: 36px; height: 36px; min-width: 36px; padding: 0; background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%) !important; border: none !important; box-shadow: 0 3px 10px rgba(11,123,234,.28) !important; }\n.wa-composer-send.ant-btn[disabled] { background: #e2e8f0 !important; box-shadow: none !important; color: #94a3b8 !important; }\n\n.wa-editor-panel { display: flex; flex-direction: column; border: 1px solid #e2e8f0; border-radius: 14px; background: #fff; box-shadow: 0 1px 4px rgba(15,23,42,.06), 0 4px 20px rgba(15,23,42,.04); overflow: hidden; min-width: 0; }\n\n.wa-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 16px; background: #f8fafd; border-bottom: 1px solid #e8edf5; flex-shrink: 0; }\n.wa-toolbar-left { display: flex; align-items: center; gap: 10px; flex-shrink: 0; }\n.wa-editor-label { font-size: 13px; font-weight: 700; color: #1e293b; white-space: nowrap; }\n.wa-generating-badge { display: inline-flex; align-items: center; gap: 5px; padding: 2px 10px; border-radius: 20px; background: #eff6ff; border: 1px solid #bfdbfe; font-size: 11px; color: #0b7bea; font-weight: 600; animation: wa-pulse 1.5s ease-in-out infinite; }\n@keyframes wa-pulse { 0%,100%{opacity:1} 50%{opacity:.6} }\n\n/* Stop control — spinning ring + morphing core */\n:root { --wa-stop-color: #ef4444; }\n@keyframes wa-stop-spin { to { transform: rotate(360deg); } }\n.wa-stop-icon, .wa-stop-pill { position: relative; display: inline-flex; align-items: center; justify-content: center; border: none; cursor: pointer; background: #fff; box-shadow: 0 0 0 1px rgba(239,68,68,.35); transition: box-shadow .2s ease, transform .12s ease; }\n.wa-stop-icon:hover, .wa-stop-pill:hover { box-shadow: 0 0 0 1px rgba(239,68,68,.6); transform: translateY(-1px); }\n.wa-stop-icon:active, .wa-stop-pill:active { transform: translateY(0) scale(.94); }\n.wa-stop-icon { width: 32px; height: 32px; border-radius: 50%; flex-shrink: 0; align-self: center; }\n.wa-stop-ring { position: absolute; inset: 0; width: 100%; height: 100%; animation: wa-stop-spin 2.2s linear infinite; }\n.wa-stop-ring circle { fill: none; stroke: var(--wa-stop-color); stroke-width: 2; stroke-dasharray: 18 76; stroke-linecap: round; }\n.wa-stop-core { position: relative; z-index: 1; width: 11px; height: 11px; background: var(--wa-stop-color); border-radius: 2px; transition: border-radius .18s ease, transform .18s ease; }\n.wa-stop-icon:hover .wa-stop-core, .wa-stop-pill:hover .wa-stop-core { border-radius: 50%; transform: scale(.85); }\n.wa-stop-pill { width: 100%; height: 40px; gap: 10px; border-radius: 999px; margin-top: 8px; font-size: 13px; font-weight: 600; color: var(--wa-stop-color); }\n.wa-stop-ring-wrap { position: relative; display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px; flex-shrink: 0; }\n.wa-stop-ring-wrap .wa-stop-ring circle { stroke-width: 2.4; stroke-dasharray: 12 51; }\n.wa-stop-ring-wrap .wa-stop-core { width: 7px; height: 7px; }\n\n.wa-toolbar-actions { display: flex; align-items: center; gap: 6px; flex-wrap: nowrap; flex-shrink: 0; }\n.wa-tool-btn.ant-btn, .wa-tool-btn .ant-btn { font-size: 12px !important; height: 28px !important; padding: 0 10px !important; border-radius: 7px !important; white-space: nowrap !important; border-color: #e2e8f0 !important; color: #475569 !important; background: #fff !important; transition: all .15s ease !important; }\n.wa-tool-btn.ant-btn:hover, .wa-tool-btn .ant-btn:hover { border-color: #0b7bea !important; color: #0b7bea !important; background: #eff6ff !important; }\n.wa-tool-btn-ghost.ant-btn { border-color: transparent !important; background: transparent !important; color: #94a3b8 !important; padding: 0 7px !important; }\n.wa-tool-btn-ghost.ant-btn:hover { color: #0b7bea !important; border-color: transparent !important; background: #eff6ff !important; }\n.wa-tool-btn-hashtag.ant-btn { color: #7c3aed !important; border-color: #ddd6fe !important; background: #f5f3ff !important; }\n.wa-tool-btn-hashtag.ant-btn:hover { background: #ede9fe !important; border-color: #c4b5fd !important; }\n.wa-toolbar-divider { width: 1px; height: 18px; background: #e2e8f0; flex-shrink: 0; margin: 0 2px; }\n.wa-hashtag-panel { background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; padding: 12px 14px; margin-bottom: 10px; box-shadow: 0 2px 10px rgba(0,0,0,0.06); }\n.wa-hashtag-panel-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; }\n.wa-hashtag-panel-title { font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.06em; }\n.wa-hashtag-panel-actions { display: flex; align-items: center; gap: 8px; }\n.wa-hashtag-add-all { font-size: 11.5px; font-weight: 600; color: #7c3aed; background: #f5f3ff; border: 1px solid #ddd6fe; border-radius: 6px; padding: 3px 10px; cursor: pointer; transition: background 0.15s; line-height: 1.5; }\n.wa-hashtag-add-all:hover { background: #ede9fe; }\n.wa-hashtag-close { font-size: 13px; color: #94a3b8; background: none; border: none; cursor: pointer; padding: 2px 5px; line-height: 1; border-radius: 4px; }\n.wa-hashtag-close:hover { color: #475569; background: #f1f5f9; }\n.wa-hashtag-chips { display: flex; flex-wrap: wrap; gap: 6px; }\n.wa-hashtag-chip { font-size: 12.5px; font-weight: 500; color: #6d28d9; background: #f5f3ff; border: 1px solid #ddd6fe; border-radius: 20px; padding: 4px 13px; cursor: pointer; transition: all 0.15s; line-height: 1.4; }\n.wa-hashtag-chip:hover { background: #ede9fe; border-color: #c4b5fd; }\n.wa-hashtag-chip-added { color: #15803d; background: #f0fdf4; border-color: #86efac; opacity: 0.65; cursor: default; }\n\n.wa-editor-hint { display: flex; align-items: center; gap: 7px; padding: 5px 16px; font-size: 11.5px; color: #94a3b8; background: #fafbfd; border-bottom: 1px solid #f1f5f9; flex-shrink: 0; }\n.wa-hint-dot { display: inline-block; width: 6px; height: 6px; border-radius: 50%; background: #0b7bea; flex-shrink: 0; }\n\n.wa-editor-surface { flex: 1; min-height: 0; }\n.wa-editor-surface .contant-editer { height: 100%; }\n.wa-editor-surface .contant-editer .description-editor-local { background: #fff; border: 0; color: #1e293b; font-size: 15px; line-height: 1.85; min-height: 440px; outline: none; overflow-y: auto; padding: 22px 24px; width: 100%; }\n.wa-editor-surface .contant-editer .description-editor-local:empty::before { content: attr(data-placeholder); color: #c4cdd8; pointer-events: none; font-style: italic; }\n\n.wa-editor-footer { display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 10px 16px; border-top: 1px solid #e8edf5; background: #f8fafd; flex-shrink: 0; flex-wrap: wrap; }\n.wa-footer-stats { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #64748b; }\n.wa-stat { font-weight: 600; color: #475569; }\n.wa-stat small { font-weight: 400; color: #94a3b8; margin-left: 1px; }\n.wa-stat-sep { color: #cbd5e1; }\n.wa-char-count { font-weight: 700 !important; cursor: default; }\n.wa-footer-actions { display: flex; align-items: center; gap: 8px; flex-wrap: nowrap; }\n.wa-action-ghost.ant-btn { border-color: transparent !important; color: #94a3b8 !important; background: transparent !important; }\n.wa-action-ghost.ant-btn:hover { border-color: #e2e8f0 !important; color: #475569 !important; background: #f8fafd !important; }\n.wa-btn-send-post.ant-btn { background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%) !important; border: none !important; box-shadow: 0 2px 8px rgba(11,123,234,.25) !important; font-weight: 600 !important; }\n.wa-btn-send-post.ant-btn:hover { opacity: .9 !important; }\n\n.wa-analysis { margin-top: 16px; padding: 20px 20px 24px; border: 1px solid #e2e8f0; border-radius: 14px; background: #fff; box-shadow: 0 1px 4px rgba(15,23,42,.06), 0 4px 20px rgba(15,23,42,.04); }\n.wa-analysis-header { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin-bottom: 18px; }\n.wa-analysis-title { font-size: 16px; font-weight: 700; color: #0f172a; margin: 0; }\n.wa-analysis-subtitle { font-size: 13px; color: #64748b; margin: 3px 0 0; }\n.wa-analyze-btn.ant-btn { background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%) !important; border: none !important; box-shadow: 0 3px 10px rgba(11,123,234,.28) !important; font-weight: 600 !important; flex-shrink: 0; }\n\n.wa-metric-card { padding: 22px; border: 1px solid #e8edf5; border-radius: 14px; background: #fff; height: 100%; transition: box-shadow .18s ease, transform .18s ease, border-color .18s ease; display: flex; flex-direction: column; gap: 0; }\n.wa-metric-card:hover { box-shadow: 0 6px 24px rgba(11,123,234,.09); transform: translateY(-2px); border-color: #c7dcfc; }\n.wa-metric-card-top { display: flex; align-items: center; gap: 10px; margin-bottom: 16px; }\n.wa-metric-card-top .wa-metric-icon { margin-bottom: 0; flex-shrink: 0; }\n.wa-metric-card-top .wa-metric-label { margin-bottom: 0; }\n.wa-metric-icon { display: inline-flex; align-items: center; justify-content: center; width: 38px; height: 38px; border-radius: 10px; font-size: 16px; margin-bottom: 14px; flex-shrink: 0; }\n.wa-metric-label { font-size: 11px; font-weight: 700; letter-spacing: .07em; text-transform: uppercase; color: #94a3b8; margin-bottom: 8px; }\n.wa-metric-value { font-size: 38px; font-weight: 800; line-height: 1; margin-bottom: 10px; letter-spacing: -1px; }\n.wa-metric-badge { display: inline-block; font-size: 11px; font-weight: 700; letter-spacing: .05em; text-transform: uppercase; padding: 3px 10px; border-radius: 20px; margin-bottom: 10px; }\n.wa-metric-note { font-size: 12.5px; color: #64748b; line-height: 1.6; margin: 0; padding-top: 6px; }\n.wa-metric-card-fill { margin-top: auto; }\n.wa-metric-card-list { padding: 20px 22px; }\n.wa-metric-list-header { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; padding-bottom: 12px; border-bottom: 1px solid #f1f5f9; }\n.wa-metric-icon-sm { width: 30px; height: 30px; border-radius: 8px; font-size: 13px; }\n.wa-suggestion-list { list-style: none; margin: 0; padding: 0; }\n.wa-suggestion-list li { font-size: 12.5px; color: #475569; padding: 7px 0 7px 14px; position: relative; line-height: 1.55; border-bottom: 1px solid #f8fafc; display: flex; align-items: flex-start; justify-content: space-between; gap: 8px; }\n.wa-suggestion-list li:last-child { border-bottom: none; }\n.wa-suggestion-list li::before { content: \"›\"; position: absolute; left: 0; color: #0b7bea; font-weight: 700; font-size: 14px; }\n.wa-suggestion-text { flex: 1; }\n.wa-suggestion-apply-btn { flex-shrink: 0; font-size: 11px; font-weight: 600; color: #2563eb; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 6px; padding: 3px 10px; cursor: pointer; white-space: nowrap; transition: background 0.15s; margin-top: 1px; line-height: 1.5; }\n.wa-suggestion-apply-btn:hover { background: #dbeafe; }\n.wa-suggestion-apply-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n.wa-fact-checks { display: flex; flex-direction: column; }\n.wa-fact-item { padding: 11px 0; border-bottom: 1px solid #f1f5f9; }\n.wa-fact-item:last-child { border-bottom: none; padding-bottom: 0; }\n.wa-fact-claim { font-size: 12.5px; font-weight: 500; line-height: 1.5; padding: 7px 10px; border-radius: 6px; margin-bottom: 7px; }\n.wa-fact-claim-false { background: #fef2f2; color: #7f1d1d; }\n.wa-fact-claim-partial { background: #fffbeb; color: #78350f; }\n.wa-fact-claim-true { background: #f0fdf4; color: #14532d; }\n.wa-fact-claim-unverified { background: #f8fafc; color: #334155; }\n.wa-fact-badge { display: inline-flex; align-items: center; font-size: 11px; font-weight: 700; padding: 3px 10px; border-radius: 20px; margin-bottom: 7px; letter-spacing: 0.01em; }\n.wa-fact-explanation { font-size: 12px; color: #475569; line-height: 1.5; margin-bottom: 6px; }\n.wa-fact-explanation strong { display: block; font-size: 10px; text-transform: uppercase; letter-spacing: 0.06em; color: #94a3b8; margin-bottom: 3px; font-weight: 700; }\n.wa-fact-explanation p { margin: 0; }\n.wa-fact-sources { display: flex; flex-direction: column; gap: 3px; margin-top: 4px; }\n.wa-fact-source-link { font-size: 11.5px; color: #0b7bea; text-decoration: none; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block; max-width: 100%; }\n.wa-fact-source-link:hover { text-decoration: underline; }\n.wa-fact-no-source { font-size: 11.5px; color: #94a3b8; font-style: italic; }\n.wa-fact-retry-btn { margin-top: 7px; display: inline-flex; align-items: center; gap: 4px; font-size: 11.5px; font-weight: 600; color: #6b7280; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px; padding: 3px 10px; cursor: pointer; transition: all 0.15s; }\n.wa-fact-retry-btn:hover { color: #0b7bea; border-color: #bfdbfe; background: #eff6ff; }\n.wa-fact-actions-row { display: flex; gap: 6px; margin-top: 7px; flex-wrap: wrap; }\n.wa-fact-actions-row .wa-fact-retry-btn { margin-top: 0; }\n.wa-fact-fix-btn { display: inline-flex; align-items: center; gap: 4px; font-size: 11.5px; font-weight: 600; color: #fff; background: #1d4ed8; border: none; border-radius: 6px; padding: 3px 10px; cursor: pointer; transition: background 0.15s; }\n.wa-fact-fix-btn:hover:not(:disabled) { background: #1e40af; }\n.wa-fact-fix-btn:disabled { opacity: 0.6; cursor: not-allowed; }\n.wa-fact-edit { margin-top: 8px; }\n.wa-fact-edit-input { width: 100%; font-size: 12px; padding: 6px 10px; border: 1px solid #bfdbfe; border-radius: 7px; outline: none; color: #1e293b; background: #f8faff; line-height: 1.5; box-sizing: border-box; }\n.wa-fact-edit-input:focus { border-color: #0b7bea; background: #fff; }\n.wa-fact-edit-actions { display: flex; gap: 6px; margin-top: 6px; }\n.wa-fact-verify-btn { font-size: 11.5px; font-weight: 600; color: #fff; background: #0b7bea; border: none; border-radius: 6px; padding: 4px 14px; cursor: pointer; }\n.wa-fact-verify-btn:hover { background: #0369a1; }\n.wa-fact-cancel-btn { font-size: 11.5px; font-weight: 500; color: #64748b; background: #f1f5f9; border: 1px solid #e2e8f0; border-radius: 6px; padding: 4px 12px; cursor: pointer; }\n.wa-fact-cancel-btn:hover { background: #e2e8f0; }\n.wa-accuracy-banner { display: flex; align-items: center; justify-content: space-between; gap: 8px; padding: 8px 12px; border-radius: 8px; border: 1px solid; margin-bottom: 12px; font-size: 13px; }\n.wa-accuracy-pct { flex: 1; font-size: 13px; }\n.wa-fix-content-btn { flex-shrink: 0; padding: 4px 12px; border-radius: 6px; border: none; font-size: 12px; font-weight: 600; cursor: pointer; background: #1d4ed8; color: #fff; transition: background 0.15s; }\n.wa-fix-content-btn:hover:not(:disabled) { background: #1e40af; }\n.wa-fix-content-btn:disabled { opacity: 0.6; cursor: not-allowed; }\n.wa-linkedin-checks { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 16px; }\n.wa-check-chip { display: inline-flex; align-items: center; gap: 5px; padding: 5px 13px; border-radius: 20px; font-size: 12.5px; font-weight: 500; line-height: 1.4; border: 1px solid transparent; white-space: nowrap; }\n.wa-check-pass { background: #f0fdf4; border-color: #86efac; color: #15803d; }\n.wa-check-fail { background: #fef2f2; border-color: #fca5a5; color: #b91c1c; }\n.wa-check-dot { font-size: 13px; font-weight: 700; line-height: 1; }\n.wa-check-label { font-weight: 600; }\n.wa-check-value { opacity: 0.8; }\n.wa-metric-empty { font-size: 12.5px; color: #c8d2e0; margin: 8px 0 0; font-style: italic; line-height: 1.6; }\n\n.wa-modal-title { display: flex; align-items: center; gap: 8px; font-size: 16px; font-weight: 700; color: #0f172a; }\n.wa-humanize-modal .ant-modal-content { border-radius: 14px !important; }\n\n/* ── Paste-your-own-content modal ────────────────────────────────────────── */\n\n.wa-paste-modal .ant-modal-content {\n  border-radius: 14px !important;\n  padding: 24px 24px 20px;\n}\n\n.wa-paste-modal .ant-modal-header {\n  margin-bottom: 4px;\n  padding: 0;\n  border-bottom: none;\n}\n\n.wa-paste-modal-desc {\n  margin: 4px 0 14px;\n  color: #64748b;\n  font-size: 13px;\n  line-height: 1.6;\n}\n\n.wa-paste-modal-textarea.ant-input {\n  border-radius: 10px;\n  border-color: #e2e8f0;\n  font-size: 13.5px;\n  line-height: 1.6;\n  padding: 12px 14px;\n  resize: vertical;\n}\n\n.wa-paste-modal-textarea.ant-input:hover {\n  border-color: #93c5fd;\n}\n\n.wa-paste-modal-textarea.ant-input:focus {\n  border-color: #0b7bea;\n  box-shadow: 0 0 0 3px rgba(11, 123, 234, 0.1);\n}\n\n.wa-paste-modal .ant-modal-footer {\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid #f1f5f9;\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.wa-paste-modal .ant-modal-footer .ant-btn {\n  border-radius: 8px;\n  height: 36px;\n  padding: 0 18px;\n  font-weight: 600;\n}\n\n.wa-paste-modal .ant-modal-footer .ant-btn-primary {\n  background: #0b7bea;\n  border-color: #0b7bea;\n}\n\n.wa-paste-modal .ant-modal-footer .ant-btn-primary:hover {\n  background: #0968c9;\n  border-color: #0968c9;\n}\n.wa-diff-panel { border-radius: 10px; padding: 16px; min-height: 240px; display: flex; flex-direction: column; gap: 10px; }\n.wa-diff-original { background: #f8fafd; border: 1px solid #e2e8f0; }\n.wa-diff-humanized { background: #f0fdf4; border: 1px solid #bbf7d0; }\n.wa-diff-label { font-size: 10.5px; font-weight: 700; letter-spacing: .07em; text-transform: uppercase; color: #94a3b8; }\n.wa-diff-content { font-size: 13.5px; color: #334155; line-height: 1.7; white-space: pre-wrap; flex: 1; }\n.wa-diff-loading { display: flex; align-items: center; gap: 8px; color: #64748b; font-size: 13px; font-style: italic; padding: 12px 0; }\n\n@media (max-width: 1100px) {\n  .wa-layout { grid-template-columns: 1fr; height: auto; min-height: 0; }\n  .wa-sidebar { max-width: 100%; }\n  .wa-chat-sidebar { height: 260px; }\n  .wa-chat-column { height: calc(100vh - 420px); min-height: 420px; }\n}\n@media (max-width: 768px) {\n  .wa-page-header { flex-direction: column; align-items: flex-start; gap: 12px; }\n  .wa-toolbar { flex-wrap: wrap; }\n  .wa-toolbar-actions { flex-wrap: wrap; width: 100%; }\n  .wa-editor-footer, .wa-draft-actions { flex-direction: column; align-items: flex-start; }\n  .wa-footer-actions { flex-wrap: wrap; width: 100%; }\n  .wa-analysis-header { flex-direction: column; align-items: flex-start; }\n  .wa-analyze-btn.ant-btn { width: 100%; }\n}\n@media (max-width: 575.98px) {\n  .wa-root { padding: 4px 0 16px; }\n  .wa-page-header-icon {\n    width: 40px;\n    height: 40px;\n    font-size: 18px;\n  }\n  .wa-page-title { font-size: 18px; }\n  .wa-page-subtitle { font-size: 12px; }\n  .wa-history-btn.ant-btn { width: 100%; }\n  .wa-root .ant-radio-group {\n    flex-wrap: wrap !important;\n    gap: 6px;\n  }\n  .wa-root .ant-radio-group .ant-radio-button-wrapper {\n    flex: 1 0 30% !important;\n    border-radius: 6px !important;\n  }\n  .wa-editor-surface .contant-editer .description-editor-local {\n    min-height: 280px;\n    padding: 16px;\n    font-size: 14px;\n  }\n  .wa-msg-card.wa-editor-surface .contant-editer .description-editor-local {\n    min-height: 220px;\n  }\n  .wa-editor-surface .contant-editer .description-editor-local,\n  .wa-diff-content {\n    overflow-wrap: break-word;\n    word-break: break-word;\n  }\n  .wa-footer-actions .ant-btn,\n  .wa-toolbar-actions .ant-btn {\n    flex: 1 1 auto;\n  }\n}\n\n/* Research Assistant modern parity with user panel */\n.research-assistant-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n}\n\n.research-assistant-heading h4 {\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.3;\n  letter-spacing: 0;\n  color: #0f172a;\n  margin: 0;\n}\n\n.research-assistant-heading p {\n  font-size: 13px;\n  line-height: 1.5;\n  color: #64748b;\n  margin: 2px 0 0;\n}\n\n.research-assistant-heading .chat-history-toggle-btn {\n  border-radius: 8px !important;\n  border: 1px solid #e2e8f0 !important;\n  background: #ffffff !important;\n  color: #334155 !important;\n  font-weight: 600 !important;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, color 0.18s ease;\n}\n\n.research-assistant-heading .chat-history-toggle-btn:hover {\n  transform: translateY(-1px);\n  border-color: #0b7bea !important;\n  color: #0b7bea !important;\n  background: #f0f8ff !important;\n  box-shadow: 0 4px 12px rgba(11, 123, 234, 0.18);\n}\n\n.research-assistant-heading + .research-container {\n  display: grid;\n  grid-template-columns: minmax(260px, 300px) minmax(0, 1fr);\n  gap: 16px;\n  align-items: stretch;\n}\n\n.research-assistant-heading + .research-container > .sidebar-left-research {\n  width: 100%;\n  max-width: none;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 18px;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06), 0 4px 20px rgba(15, 23, 42, 0.04);\n}\n\n.research-assistant-heading + .research-container > .sidebar-left-research h6,\n.research-assistant-heading + .research-container .ant-form-item-label > label,\n.research-assistant-heading + .research-container .ant-form-item-label > label > div {\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: #334155;\n  margin: 0;\n}\n\n.research-assistant-heading + .research-container .textarea-with-mode {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.research-assistant-heading + .research-container .topic-textarea,\n.research-assistant-heading + .research-container .dropdown-research-select .ant-select-selector {\n  border-radius: 8px !important;\n  border: 1px solid #e2e8f0 !important;\n  background: #ffffff !important;\n  font-size: 13px !important;\n  box-shadow: none !important;\n}\n\n.research-assistant-heading + .research-container .dropdown-research-select .ant-select-selector {\n  height: 40px !important;\n  padding: 4px 11px !important;\n}\n\n.research-assistant-heading + .research-container .mode-select {\n  align-self: flex-end;\n  width: 100%;\n}\n\n.research-assistant-heading + .research-container .mode-select .ant-select-selector {\n  border-radius: 6px !important;\n  border-color: #e2e8f0 !important;\n  background: #f8fafd !important;\n  font-size: 12px !important;\n  min-height: 24px !important;\n}\n\n.research-assistant-heading + .research-container button.ant-btn.run-button {\n  height: 44px !important;\n  margin-top: 18px;\n  border: none !important;\n  border-radius: 10px !important;\n  background: linear-gradient(135deg, #3B6B94 0%, #071E31 100%) !important;\n  color: #ffffff !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  line-height: 1 !important;\n  letter-spacing: 0;\n  box-shadow: 0 3px 10px rgba(7, 30, 49, 0.35) !important;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;\n}\n\n.research-assistant-heading + .research-container button.ant-btn.run-button:hover {\n  opacity: 0.92;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(7, 30, 49, 0.45) !important;\n}\n\n.research-assistant-heading + .research-container > .content-area {\n  min-width: 0;\n  padding: 0;\n  background: transparent;\n  border-radius: 0;\n  animation: research-assistant-content-in 0.35s ease both;\n}\n\n@keyframes research-assistant-content-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.research-assistant-heading + .research-container .headlines-section,\n.research-assistant-heading + .research-container .topics-section,\n.research-assistant-heading + .research-container .trends-section {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 18px;\n  margin-top: 16px;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);\n}\n\n.research-assistant-heading + .research-container .headlines-section.mt-0,\n.research-assistant-heading + .research-container .headlines-section:first-child {\n  margin-top: 0 !important;\n}\n\n.research-assistant-heading + .research-container .headline-toll-headding {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.research-assistant-heading + .research-container section.headlines-section h6,\n.research-assistant-heading + .research-container .headline-toll-headding h6 {\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  margin: 0;\n}\n\n.research-assistant-heading + .research-container .headlines-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.research-assistant-heading + .research-container .headline-card,\n.research-assistant-heading + .research-container .ant-card.ant-card-bordered.headline-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 14px;\n  background: #f8fafd;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  box-shadow: none;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.research-assistant-heading + .research-container .headline-card:hover {\n  transform: translateY(-2px);\n  border-color: rgba(11, 123, 234, 0.65);\n  box-shadow: 0 6px 16px rgba(11, 123, 234, 0.12);\n}\n\n.research-assistant-heading + .research-container .headline-card .ant-card-body {\n  width: 100%;\n  padding: 0 !important;\n}\n\n.research-assistant-heading + .research-container .searching-listbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n}\n\n.research-assistant-heading + .research-container .headline-text {\n  min-width: 0;\n  color: #1e293b;\n  font-size: 13.5px;\n  font-weight: 500;\n  line-height: 1.5;\n  letter-spacing: 0;\n}\n\n.research-assistant-heading + .research-container .headline-actions {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.research-assistant-heading + .research-container .headline-actions button.ant-btn,\n.research-assistant-heading + .research-container .tag-topics button.ant-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 28px;\n  width: auto;\n  height: 28px !important;\n  padding: 0 8px !important;\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 7px !important;\n  background: #f8fafd !important;\n  color: #0f172a !important;\n  box-shadow: none !important;\n  font-size: 12px;\n  font-weight: 600;\n  transition: transform 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;\n}\n\n.research-assistant-heading + .research-container .headline-actions button.ant-btn-primary,\n.research-assistant-heading + .research-container .tag-topics button.ant-btn-primary,\n.research-assistant-heading + .research-container button.table-primary-fill-btn {\n  border-color: transparent !important;\n  background: #0b7bea !important;\n  color: #ffffff !important;\n}\n\n.research-assistant-heading + .research-container .headline-actions button.ant-btn:hover,\n.research-assistant-heading + .research-container .tag-topics button.ant-btn:hover {\n  border-color: #0b7bea !important;\n  transform: translateY(-1px) scale(1.04);\n  opacity: 0.92;\n}\n\n.research-assistant-heading + .research-container .tags-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.research-assistant-heading + .research-container .tag-topics {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 100%;\n  background: #f8fafd;\n  padding: 8px 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 9px;\n  color: #1e293b;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.35;\n  letter-spacing: 0;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, background 0.18s ease;\n}\n\n.research-assistant-heading + .research-container .tag-topics:hover {\n  transform: translateY(-2px);\n  border-color: #0b7bea;\n  background: #ffffff;\n  box-shadow: 0 4px 12px rgba(11, 123, 234, 0.15);\n}\n\n.research-assistant-heading + .research-container .tag-topics span {\n  color: #0ea5e9;\n}\n\n.research-assistant-heading + .research-container .no-headlines,\n.research-assistant-heading + .research-container .no-data-message,\n.research-assistant-heading + .research-container .no-research-done {\n  width: 100%;\n  min-height: 360px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 14px;\n  padding: 40px 24px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.06), 0 4px 20px rgba(15, 23, 42, 0.04);\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n.research-assistant-heading + .research-container .no-headlines img {\n  max-width: 240px;\n  width: 100%;\n  margin: 0 auto 12px;\n}\n\n@media (max-width: 991.98px) {\n  .research-assistant-heading + .research-container {\n    grid-template-columns: 1fr;\n  }\n\n  .research-assistant-heading + .research-container > .sidebar-left-research,\n  .research-assistant-heading + .research-container > .content-area {\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .research-assistant-heading + .research-container .searching-listbar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .research-assistant-heading {\n    align-items: flex-start;\n  }\n\n  .research-assistant-heading .chat-history-toggle-btn {\n    width: 100%;\n  }\n\n  .research-assistant-heading + .research-container .headline-toll-headding {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n\n/* Vault module parity with user panel */\n.vault-layout {\n  background: transparent;\n}\n\n.vault-layout .vault-sider {\n  border-radius: 14px 0 0 14px;\n  overflow: hidden;\n}\n\n.vault-layout .vault-sider .ant-menu {\n  background: #fff;\n}\n\n.vault-layout .valult-tabs-listing {\n  font-weight: 600;\n}\n\n.vault-category-bar {\n  background: #fff;\n  border-bottom: 1px solid #f0f0f0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  padding: 4px 8px;\n}\n\n.vault-category-bar .ant-menu.ant-menu-horizontal {\n  display: flex;\n  flex-wrap: nowrap;\n  min-width: max-content;\n  line-height: 1.2;\n  border-bottom: 0;\n  background: transparent;\n}\n\n.vault-category-bar .ant-menu.ant-menu-horizontal > li.ant-menu-item.valult-tabs-listing {\n  flex: 0 0 auto;\n  margin: 4px;\n  padding: 0 14px;\n  height: 38px;\n  line-height: 38px;\n  top: 0;\n  border-radius: 6px;\n  border-bottom: 0 !important;\n}\n\n.vault-category-bar .ant-menu.ant-menu-horizontal > li.ant-menu-item.valult-tabs-listing::after {\n  border-bottom: 0 !important;\n}\n\n.vault-category-bar .ant-menu.ant-menu-horizontal > li.ant-menu-item.valult-tabs-listing span {\n  font-size: 14px;\n}\n\n@media (max-width: 991.98px) {\n  .vault-layout .ant-card-head-wrapper {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .vault-layout .ant-card-head-wrapper .ant-card-extra {\n    width: 100%;\n    margin-left: 0;\n  }\n\n  .vault-layout .ant-card-extra > .d-flex {\n    width: 100%;\n    gap: 12px !important;\n  }\n\n  .vault-layout .ant-card-extra .pageHeadingSearch,\n  .vault-layout .ant-card-extra .role-wrap {\n    width: 100%;\n    flex: 1 1 100%;\n  }\n\n  .vault-layout .ant-card-extra .pageHeadingSearch .ant-input-search,\n  .vault-layout .ant-card-extra .pageHeadingSearch .searchInput,\n  .vault-layout .ant-card-extra .role-wrap .ant-picker.ant-picker-range,\n  .vault-layout .ant-card-extra .role-wrap .ant-select.ant-select-single {\n    width: 100% !important;\n  }\n\n  .vault-layout .ant-card-extra .role-wrap .ant-picker-range .ant-picker-input {\n    flex: 1 1 0;\n    min-width: 0;\n  }\n\n  .vault-layout .ant-card-extra .role-wrap .ant-picker-range .ant-picker-input > input {\n    width: 100% !important;\n    text-align: left;\n  }\n\n  .vault-layout .ant-card-extra .role-wrap .ant-select .ant-select-selection-placeholder {\n    color: rgba(0, 0, 0, 0.45);\n    opacity: 1;\n  }\n\n  .vault-layout .ant-card-extra .ant-space,\n  .vault-layout .ant-card-extra [style*=\"display: flex\"] {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .vault-layout .ant-card-extra .ant-space .ant-space-item,\n  .vault-layout .ant-card-extra [style*=\"display: flex\"] > .ant-btn {\n    flex: 1 1 auto;\n  }\n\n  .vault-layout .ant-card-extra .ant-space .ant-space-item .ant-btn,\n  .vault-layout .ant-card-extra [style*=\"display: flex\"] > .ant-btn {\n    width: 100%;\n  }\n}\n\n\n/* ===== NOTIFICATIONS PAGE ===== */\n.notif-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 32px 24px 60px;\n}\n.notif-body { display: flex; gap: 24px; align-items: flex-start; }\n.notif-feed { flex: 1; min-width: 0; }\n.notif-filters { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 20px; }\n.notif-filter-pill { display: inline-flex; align-items: center; gap: 6px; padding: 6px 14px; border-radius: 99px; border: 1px solid rgba(7,30,49,0.1); background: #fff; font-size: 13px; font-weight: 500; color: #5a7080; cursor: pointer; transition: all 0.18s; }\n.notif-filter-pill:hover { border-color: #3B6B94; color: #3B6B94; }\n.notif-filter-pill--active { background: linear-gradient(135deg,#3B6B94 0%,#071E31 100%); border-color: transparent; color: #fff !important; }\n.notif-filter-count { display: inline-flex; align-items: center; justify-content: center; min-width: 18px; height: 18px; padding: 0 5px; border-radius: 99px; background: rgba(255,255,255,0.22); font-size: 11px; font-weight: 700; }\n.notif-filter-pill:not(.notif-filter-pill--active) .notif-filter-count { background: rgba(7,30,49,0.08); color: #071E31; }\n.notif-sidebar { width: 280px; flex: 0 0 280px; display: flex; flex-direction: column; gap: 16px; position: sticky; top: 24px; }\n.notif-sidebar__card { background: #fff; border: 1px solid rgba(7,30,49,0.07); border-radius: 16px; padding: 20px; }\n.notif-sidebar__card-label { font-size: 11px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #9aaab8; margin: 0 0 16px; }\n.notif-ring-wrap { position: relative; width: 100px; height: 100px; margin: 0 auto 14px; }\n.notif-ring { width: 100px; height: 100px; border-radius: 50%; background: conic-gradient(#3B6B94 0% var(--pct), rgba(7,30,49,0.08) var(--pct) 100%); }\n.notif-ring-inner { position: absolute; inset: 12px; border-radius: 50%; background: #fff; display: flex; flex-direction: column; align-items: center; justify-content: center; }\n.notif-ring-pct { font-size: 20px; font-weight: 700; color: #071E31; line-height: 1; }\n.notif-ring-sub { font-size: 10px; color: #9aaab8; margin-top: 2px; }\n.notif-ring-legend { display: flex; align-items: center; justify-content: center; gap: 8px; font-size: 12px; color: #5a7080; }\n.notif-legend-dot { width: 8px; height: 8px; border-radius: 50%; display: inline-block; }\n.notif-legend-dot--read { background: #3B6B94; }\n.notif-legend-dot--unread { background: rgba(7,30,49,0.12); }\n.notif-cat-list { display: flex; flex-direction: column; gap: 4px; }\n.notif-cat-row { display: flex; align-items: center; gap: 10px; padding: 8px 10px; border-radius: 8px; cursor: pointer; transition: background 0.15s; }\n.notif-cat-row:hover { background: rgba(7,30,49,0.04); }\n.notif-cat-row--active { background: rgba(59,107,148,0.08); }\n.notif-cat-dot { width: 8px; height: 8px; border-radius: 50%; flex: 0 0 auto; }\n.notif-cat-dot--green   { background: #16a34a; }\n.notif-cat-dot--blue    { background: #3B6B94; }\n.notif-cat-dot--purple  { background: #7c3aed; }\n.notif-cat-dot--amber   { background: #d97706; }\n.notif-cat-dot--teal    { background: #0e7490; }\n.notif-cat-dot--indigo  { background: #4338ca; }\n.notif-cat-dot--default { background: #3B6B94; }\n.notif-cat-name { flex: 1; font-size: 13px; font-weight: 500; color: #071E31; }\n.notif-cat-count { font-size: 12px; font-weight: 700; color: #9aaab8; background: rgba(7,30,49,0.06); border-radius: 99px; padding: 1px 8px; }\n.notif-sidebar__actions { display: flex; flex-direction: column; gap: 8px; }\n.notif-qa-btn { display: flex; align-items: center; gap: 8px; width: 100%; padding: 9px 14px; border-radius: 8px; border: 1px solid rgba(7,30,49,0.1); background: transparent; font-size: 13px; font-weight: 500; color: #3B6B94; cursor: pointer; transition: all 0.18s; }\n.notif-qa-btn:hover { background: rgba(59,107,148,0.08); border-color: #3B6B94; }\n.notif-qa-btn--danger { color: #ef4444; }\n.notif-qa-btn--danger:hover { background: rgba(239,68,68,0.06); border-color: rgba(239,68,68,0.3); }\n.notif-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 32px; padding-bottom: 24px; border-bottom: 1px solid rgba(7,30,49,0.08); }\n.notif-header__left { display: flex; align-items: center; gap: 16px; }\n.notif-header__icon-wrap { width: 52px; height: 52px; border-radius: 14px; background: linear-gradient(135deg,#3B6B94 0%,#071E31 100%); display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 16px rgba(59,107,148,0.35); }\n.notif-header__bell { font-size: 22px !important; color: #fff !important; }\n.notif-header__title { font-size: 26px; font-weight: 700; color: #071E31; margin: 0 0 2px; font-family: 'Greycliff CF', sans-serif; }\n.notif-header__sub { font-size: 14px; color: #7a8fa0; margin: 0; display: flex; align-items: center; gap: 8px; }\n.notif-count-chip { display: inline-flex; align-items: center; justify-content: center; min-width: 22px; height: 22px; padding: 0 7px; border-radius: 99px; background: linear-gradient(135deg,#3B6B94 0%,#071E31 100%); color: #fff; font-size: 12px; font-weight: 700; }\n.notif-menu-btn { width: 40px; height: 40px; border-radius: 10px; border: 1px solid rgba(7,30,49,0.12); background: #fff; color: #3B6B94; font-size: 20px; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all 0.18s; }\n.notif-menu-btn:hover { background: linear-gradient(135deg,#3B6B94 0%,#071E31 100%); color: #fff; border-color: transparent; }\n.notif-timeline { display: flex; flex-direction: column; gap: 10px; }\n.notif-card { display: flex; align-items: center; gap: 16px; padding: 16px 20px; border-radius: 14px; background: #fff; border: 1px solid rgba(7,30,49,0.07); cursor: pointer; position: relative; transition: transform 0.18s, box-shadow 0.18s, border-color 0.18s; }\n.notif-card:hover { transform: translateY(-2px); box-shadow: 0 6px 24px rgba(7,30,49,0.1); }\n.notif-card--unread { border-left: 3px solid #3B6B94; background: linear-gradient(90deg,rgba(59,107,148,0.04) 0%,#fff 50%); }\n.notif-card--read { border-left: 3px solid transparent; opacity: 0.82; }\n.notif-card__icon { width: 44px; height: 44px; border-radius: 12px; display: flex; align-items: center; justify-content: center; flex: 0 0 auto; font-size: 18px !important; }\n.notif-icon--green   { background: rgba(34,197,94,0.12);  color: #16a34a !important; }\n.notif-icon--blue    { background: rgba(59,107,148,0.12); color: #3B6B94 !important; }\n.notif-icon--purple  { background: rgba(139,92,246,0.12); color: #7c3aed !important; }\n.notif-icon--amber   { background: rgba(245,158,11,0.12); color: #d97706 !important; }\n.notif-icon--teal    { background: rgba(108,229,232,0.18);color: #0e7490 !important; }\n.notif-icon--indigo  { background: rgba(99,102,241,0.12); color: #4338ca !important; }\n.notif-icon--default { background: rgba(7,30,49,0.08);   color: #3B6B94 !important; }\n.notif-card__body { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }\n.notif-type-badge { display: inline-flex; align-items: center; font-size: 10px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; padding: 2px 8px; border-radius: 99px; width: fit-content; }\n.notif-badge--green   { background: rgba(34,197,94,0.12);  color: #16a34a; }\n.notif-badge--blue    { background: rgba(59,107,148,0.12); color: #3B6B94; }\n.notif-badge--purple  { background: rgba(139,92,246,0.12); color: #7c3aed; }\n.notif-badge--amber   { background: rgba(245,158,11,0.12); color: #d97706; }\n.notif-badge--teal    { background: rgba(108,229,232,0.22);color: #0e7490; }\n.notif-badge--indigo  { background: rgba(99,102,241,0.12); color: #4338ca; }\n.notif-badge--default { background: rgba(7,30,49,0.07);   color: #3B6B94; }\n.notif-card__sub-title { font-size: 12px; font-weight: 600; color: #3B6B94; }\n.notif-card__desc { font-size: 14px; font-weight: 500; color: #071E31; margin: 0; line-height: 1.45; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.notif-card__time { font-size: 12px; color: #9aaab8; }\n.notif-card__actions { display: flex; align-items: center; gap: 10px; flex: 0 0 auto; }\n.notif-pulse-dot { width: 10px; height: 10px; border-radius: 50%; background: #6CE5E8; box-shadow: 0 0 0 0 rgba(108,229,232,0.6); animation: notif-pulse 1.8s ease-in-out infinite; display: block; }\n@keyframes notif-pulse { 0%{box-shadow:0 0 0 0 rgba(108,229,232,0.6)} 70%{box-shadow:0 0 0 8px rgba(108,229,232,0)} 100%{box-shadow:0 0 0 0 rgba(108,229,232,0)} }\n.notif-delete-btn { width: 32px; height: 32px; border-radius: 8px; border: 1px solid transparent; background: transparent; color: #bcc8d4; font-size: 14px; display: flex; align-items: center; justify-content: center; cursor: pointer; opacity: 0; transition: opacity 0.18s, background 0.18s, color 0.18s; }\n.notif-card:hover .notif-delete-btn { opacity: 1; }\n.notif-delete-btn:hover { background: rgba(239,68,68,0.08); border-color: rgba(239,68,68,0.2); color: #ef4444; }\n.notif-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 80px 24px; text-align: center; }\n.notif-empty__graphic { width: 80px; height: 80px; border-radius: 24px; background: linear-gradient(135deg,#3B6B94 0%,#071E31 100%); display: flex; align-items: center; justify-content: center; margin-bottom: 20px; box-shadow: 0 8px 24px rgba(59,107,148,0.3); }\n.notif-empty__bell { font-size: 36px !important; color: #fff !important; }\n.notif-empty__title { font-size: 22px; font-weight: 700; color: #071E31; margin: 0 0 8px; }\n.notif-empty__sub { font-size: 14px; color: #9aaab8; margin: 0; max-width: 320px; }\n.notif-pagination { display: flex; justify-content: center; padding: 32px 0 0; }\n.notif-pagination .ant-pagination-item-active { background: linear-gradient(135deg,#3B6B94 0%,#071E31 100%); border-color: transparent; }\n.notif-pagination .ant-pagination-item-active a { color: #fff; }\n@media (max-width: 768px) {\n  .notif-body { flex-direction: column; }\n  .notif-sidebar { width: 100%; flex: none; position: static; }\n  .notif-page { padding: 20px 16px 40px; }\n}\n\n\n/* ═══════════════════════════════════════════════════════════════\n   Table Row Actions — soft icon buttons + kebab menu\n   ═══════════════════════════════════════════════════════════════ */\n.row-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n.row-action-btn {\n  width: 34px;\n  height: 34px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  border: 1px solid transparent;\n  background: #f1f5f9;\n  color: #475569;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.16s ease;\n  padding: 0;\n  line-height: 1;\n}\n.row-action-btn i { font-size: 13px; }\n.row-action-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 3px 8px rgba(15, 23, 42, 0.12);\n}\n.row-action-view {\n  background: rgba(59, 107, 148, 0.10);\n  color: #3b6b94;\n}\n.row-action-view:hover {\n  background: #3b6b94;\n  color: #ffffff;\n}\n.row-action-edit {\n  background: rgba(16, 185, 129, 0.10);\n  color: #059669;\n}\n.row-action-edit:hover {\n  background: #059669;\n  color: #ffffff;\n}\n.row-action-contract {\n  background: rgba(245, 158, 11, 0.12);\n  color: #d97706;\n}\n.row-action-contract:hover {\n  background: #d97706;\n  color: #ffffff;\n}\n.row-action-delete {\n  background: rgba(239, 68, 68, 0.10);\n  color: #dc2626;\n}\n.row-action-delete:hover {\n  background: #dc2626;\n  color: #ffffff;\n}\n.row-action-more {\n  background: #f1f5f9;\n  color: #64748b;\n}\n.row-action-more:hover {\n  background: #071e31;\n  color: #ffffff;\n}\n\n/* dropdown menu */\n.row-actions-menu {\n  border-radius: 12px !important;\n  padding: 6px !important;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.14) !important;\n  min-width: 200px;\n}\n.row-actions-menu .ant-dropdown-menu-item,\n.row-actions-menu .ant-menu-item {\n  border-radius: 8px !important;\n  padding: 9px 12px !important;\n  font-size: 13px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.row-actions-menu .ant-dropdown-menu-item i,\n.row-actions-menu .ant-menu-item i {\n  width: 18px;\n  text-align: center;\n  font-size: 12.5px;\n  color: #64748b;\n}\n.row-actions-menu .ant-dropdown-menu-item:hover,\n.row-actions-menu .ant-menu-item:hover {\n  background: rgba(59, 107, 148, 0.08) !important;\n}\n.row-actions-menu .ant-dropdown-menu-item-danger i,\n.row-actions-menu .ant-menu-item-danger i {\n  color: #ef4444;\n}\n\n/* ── Graphics Oversight: header filters in one row ── */\n.gfx-oversight-filters {\n  flex-wrap: nowrap !important;\n}\n.gfx-oversight-card .ant-card-head-wrapper {\n  flex-wrap: nowrap !important;\n}\n.gfx-oversight-card .ant-card-head-title {\n  width: auto !important;\n  flex: 0 0 auto !important;\n  white-space: nowrap;\n}\n.gfx-oversight-card .ant-card-extra {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n@media (max-width: 900px) {\n  .gfx-oversight-filters {\n    flex-wrap: wrap !important;\n  }\n  .gfx-oversight-card .ant-card-head-wrapper {\n    flex-wrap: wrap !important;\n  }\n  .gfx-oversight-card .ant-card-head-title {\n    width: 100% !important;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Graphics Oversight (Admin) — hero, toolbar, pills\n   ═══════════════════════════════════════════════════════════════ */\n\n/* ── Hero header ── */\n.gfx-req-hero {\n  border-radius: 20px;\n  padding: 22px 26px;\n  margin-bottom: 20px;\n  background: var(--brand-gradient, linear-gradient(135deg, #3B6B94 0%, #071E31 100%));\n  box-shadow: 0 10px 24px -6px rgba(7, 30, 49, 0.45);\n}\n.gfx-req-hero-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n.gfx-req-hero-eyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(255,255,255,0.65);\n  margin-bottom: 4px;\n}\n.gfx-req-hero-title {\n  margin: 0;\n  color: #ffffff;\n  font-size: 21px;\n  font-weight: 700;\n  letter-spacing: -0.2px;\n}\n\n/* ── Hero right-side stat ── */\n.gfx-hero-done {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 18px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(108, 229, 232, 0.28);\n  flex-shrink: 0;\n}\n.gfx-hero-done-ring {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(108, 229, 232, 0.16);\n  border: 1.5px solid rgba(108, 229, 232, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  color: #6CE5E8;\n}\n.gfx-hero-done-value {\n  font-size: 22px;\n  font-weight: 700;\n  color: #ffffff;\n  line-height: 1.1;\n}\n.gfx-hero-done-label {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.60);\n}\n@media (max-width: 640px) {\n  .gfx-hero-done { display: none; }\n}\n\n/* ── Toolbar card ── */\n.gfx-oversight-toolbar-card .ant-card-body {\n  padding: 16px 20px !important;\n}\n.gfx-oversight-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n}\n.gfx-oversight-search {\n  flex: 1 1 240px;\n  min-width: 200px;\n  max-width: 320px;\n  border-radius: 10px !important;\n}\n.gfx-oversight-select {\n  width: 190px !important;\n}\n.gfx-oversight-select .ant-select-selector {\n  border-radius: 10px !important;\n}\n.gfx-oversight-select--sm {\n  width: 140px !important;\n}\n@media (max-width: 700px) {\n  .gfx-oversight-search,\n  .gfx-oversight-select,\n  .gfx-oversight-select--sm {\n    width: 100% !important;\n    max-width: none;\n  }\n}\n\n/* ── Priority dot + pill (table cell) ── */\n.gfx-priority-dot {\n  border-radius: 50%;\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n}\n.gfx-priority-dot.priority-urgent { background: #F5222D; }\n.gfx-priority-dot.priority-high   { background: #FA8C16; }\n.gfx-priority-dot.priority-medium { background: #3B6B94; }\n.gfx-priority-dot.priority-low    { background: #94A3B8; }\n.gfx-priority-pill-sm {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--text-secondary, #475569);\n}\n\n/* ── Status pill (table cell) ── */\n.gfx-status-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 12px;\n  border-radius: 9999px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.gfx-status--neutral { background: #F1F5F9; color: #64748B; }\n.gfx-status--info    { background: #EFF6FF; color: #1D4ED8; }\n.gfx-status--warn     { background: #FFFBEB; color: #B45309; }\n.gfx-status--success { background: #ECFDF5; color: #047857; }\n.gfx-status--danger  { background: #FEF2F2; color: #B91C1C; }\n\n/* ── Row action buttons: disabled state ── */\n.row-action-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Admin Home Dashboard — overview strip + card header nowrap fix\n   ═══════════════════════════════════════════════════════════════ */\n\n.home-overview-strip {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 18px;\n}\n.home-overview-eyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  color: var(--brand-500, #3B6B94);\n  margin-bottom: 3px;\n}\n.home-overview-date {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text-primary, #0F172A);\n  letter-spacing: -0.2px;\n}\n\n/* Fix title + search overlapping/wrapping in the renewals/expired cards —\n   same root cause as the Dashboard/Oversight toolbars: a global\n   `.tablespace .ant-card-head-title { width: 100% }` rule forces the title\n   onto its own full-width line, pushing the search input down. */\n.home-header-nowrap .ant-card-head-wrapper {\n  flex-wrap: nowrap !important;\n}\n.home-header-nowrap .ant-card-head-title {\n  width: auto !important;\n  flex: 0 0 auto !important;\n  white-space: nowrap;\n}\n.home-header-nowrap .ant-card-extra {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  justify-content: flex-end;\n}\n@media (max-width: 700px) {\n  .home-header-nowrap .ant-card-head-wrapper {\n    flex-wrap: wrap !important;\n  }\n  .home-header-nowrap .ant-card-head-title {\n    width: 100% !important;\n  }\n  .home-header-nowrap .ant-card-extra .ant-input-search {\n    width: 100% !important;\n  }\n}\n\n/* Avatar + name rows inside the \"Latest\" tables */\n.color-badge-table {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.color-badge-table img {\n  border-radius: 50%;\n  object-fit: cover;\n  width: 30px;\n  height: 30px;\n  flex-shrink: 0;\n}\n.color-badge-table p {\n  margin: 0;\n  font-size: 13.5px;\n  color: var(--text-secondary, #475569);\n}\n.tag-name-text p {\n  font-weight: 600;\n  color: var(--text-primary, #0F172A) !important;\n}\n\n/* ── Hero CTA button (solid pill on gradient hero) ── */\n.gfx-hero-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 20px;\n  border-radius: 9999px;\n  background: #ffffff;\n  color: var(--brand-700, #1D3C56);\n  border: none;\n  font-size: 13.5px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);\n  transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;\n  flex-shrink: 0;\n}\n.gfx-hero-cta:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.22);\n  opacity: 0.95;\n}\n\n/* ═══════════════════════════════════════════════════════════════\n   Edit Preferences Panel — multi-select tag chips\n   (tagRender in ClientPreferenceEditModal.js had zero matching CSS,\n   so each selected value rendered as a bare block-level <p> with\n   a close icon stacked underneath instead of an inline chip.)\n   ═══════════════════════════════════════════════════════════════ */\n.ant-select.multi-select .ant-select-selector {\n  min-height: 44px !important;\n  border-radius: 10px !important;\n  padding: 6px 8px !important;\n  display: flex !important;\n  flex-wrap: wrap !important;\n  align-items: center !important;\n  gap: 6px !important;\n}\n.ant-select.multi-select .ant-select-selection-overflow {\n  gap: 6px;\n  row-gap: 6px;\n}\n.ant-select.multi-select .ant-select-selection-search {\n  margin: 0 !important;\n}\n.ant-select.multi-select .ant-select-selection-placeholder {\n  padding-left: 4px;\n}\n\n.multiselect-card-box.edit-preferences-selected {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--brand-50, #EAF1F6);\n  border: 1px solid var(--brand-100, #D2E2EC);\n  border-radius: 9999px;\n  padding: 4px 8px 4px 12px;\n  margin: 0;\n  max-width: 100%;\n}\n.multiselect-card-box.edit-preferences-selected p {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--brand-700, #1D3C56);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.multiselect-card-box.edit-preferences-selected .remove-tag {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--brand-400, #5A8AAB);\n  font-size: 13px;\n  line-height: 1;\n  transition: color 0.15s ease;\n}\n.multiselect-card-box.edit-preferences-selected .remove-tag:hover {\n  color: var(--error, #EF4444);\n}\n\n/* ===== Research Assistant: Graphical Insights, Content Ideas & Mindmap (ported from user panel) ===== */\n/* ── Tabs ── */\n.ant-tabs.tabs-main-research .ant-tabs-nav {\n  margin-bottom: 20px;\n}\n\n.ant-tabs.tabs-main-research .ant-tabs-tab {\n  color: #475569;\n  font-size: 13.5px;\n  line-height: 1;\n  font-weight: 600;\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  padding: 9px 18px;\n  border-radius: 10px;\n  margin-right: 10px !important;\n  transition: background-color 0.2s ease, transform 0.18s ease, box-shadow 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n}\n\n.ant-tabs.tabs-main-research .ant-tabs-tab:hover {\n  border-color: #0b7bea;\n  color: #0b7bea;\n}\n\n.ant-tabs.tabs-main-research .ant-tabs-tab.ant-tabs-tab-active {\n  background: #0b7bea !important;\n  border-color: transparent !important;\n  box-shadow: 0 2px 6px rgba(11, 123, 234, 0.25);\n}\n\n.ant-tabs.tabs-main-research .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #fff;\n  text-shadow: none;\n}\n\n.ant-tabs.tabs-main-research .ant-tabs-nav::before {\n  display: none;\n}\n\n.ant-tabs-ink-bar.ant-tabs-ink-bar-animated {\n  display: none;\n}\n\n/* ── Section cards (Headlines / Topics / Trends) ── */\nsection.headlines-section h6,\n.headline-toll-headding h6 {\n  color: #0f172a;\n  font-weight: 700;\n  font-size: 13px;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  margin: 0;\n}\n\n.ant-card.ant-card-bordered.headline-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 14px;\n  background: #f8fafd;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n  animation: research-content-in 0.4s ease both;\n}\n.ant-card.ant-card-bordered.headline-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(11, 123, 234, 0.12);\n  border-color: #0b7beaaa;\n}\n\n.searching-listbar {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n  gap: 10px;\n}\n\n.headline-text {\n  font-weight: 500;\n  font-size: 13.5px;\n  line-height: 1.5;\n  color: #1e293b;\n}\n\n.headlines-section,\n.topics-section,\n.trends-section {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 18px;\n  margin-top: 16px;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);\n}\n.headlines-section {\n  margin-top: 0;\n}\n\n.headline-actions {\n  flex: 0 0 auto;\n  display: flex;\n  gap: 8px;\n}\n\n.headline-actions button {\n  padding: 0 !important;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 7px !important;\n  border: 1px solid #e2e8f0 !important;\n  background: #f8fafd !important;\n  transition: transform 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;\n}\n.headline-actions button:hover {\n  border-color: #0b7bea !important;\n  transform: translateY(-1px) scale(1.06);\n  opacity: 0.92;\n}\n.headline-actions button:active {\n  transform: scale(0.96);\n}\n\n.headline-toll-headding {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.headlines-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.headline-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 14px;\n  background: #f8fafd;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n  cursor: default;\n  animation: research-content-in 0.4s ease both;\n}\n.headline-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(11, 123, 234, 0.12);\n  border-color: #0b7beaaa;\n}\n.headlines-list .headline-card:nth-child(1) { animation-delay: 0.02s; }\n.headlines-list .headline-card:nth-child(2) { animation-delay: 0.06s; }\n.headlines-list .headline-card:nth-child(3) { animation-delay: 0.10s; }\n.headlines-list .headline-card:nth-child(4) { animation-delay: 0.14s; }\n.headlines-list .headline-card:nth-child(5) { animation-delay: 0.18s; }\n.headlines-list .headline-card:nth-child(n + 6) { animation-delay: 0.22s; }\n\n.tags-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.tag-topics {\n  background: #f8fafd;\n  padding: 8px 14px;\n  border-radius: 9px;\n  font-weight: 500;\n  font-size: 13px;\n  color: #1e293b;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease, background 0.18s ease;\n}\n.tag-topics:hover {\n  transform: translateY(-2px);\n  border-color: #0b7bea;\n  background: #ffffff;\n  box-shadow: 0 4px 12px rgba(11, 123, 234, 0.15);\n}\n.tag-topics button.ant-btn {\n  transition: transform 0.15s ease, opacity 0.15s ease;\n}\n.tag-topics button.ant-btn:hover {\n  transform: scale(1.15);\n  opacity: 0.85;\n}\n.tag-topics button.ant-btn:active {\n  transform: scale(0.96);\n}\n\n/* ── Prompt History button ── */\n.chat-history-toggle-btn {\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n.chat-history-toggle-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(11, 123, 234, 0.18);\n}\n\n/* Respect users who prefer no motion */\n@media (prefers-reduced-motion: reduce) {\n  .content-area,\n  .headlines-list .headline-card {\n    animation: none;\n  }\n  button.ant-btn.run-button,\n  .headline-card,\n  .tag-topics,\n  .ant-tabs.tabs-main-research .ant-tabs-tab {\n    transition: none;\n  }\n}\n\n/* --- \"Get more ideas\" button in the Select-a-Content-Idea modal --- */\nbutton.ant-btn.load-more-ideas-btn {\n  height: 40px;\n  padding: 0 22px;\n  border-radius: 8px;\n  font-weight: 600;\n  color: #0b7bea;\n  background: #eff8ff;\n  border: 1px solid #0b7bea55;\n  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;\n}\nbutton.ant-btn.load-more-ideas-btn:hover {\n  color: #ffffff;\n  background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%);\n  border-color: transparent;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(11, 123, 234, 0.28);\n}\n\n/* --- Dynamic SVG mind map (Content Ideas) --- */\n.mindmap-canvas {\n  position: relative;\n  width: 100%;\n}\n.dynamic-mindmap-svg {\n  width: 100%;\n  height: auto;\n  display: block;\n  max-width: 560px;\n  margin: 0 auto;\n  overflow: visible;\n}\n\n/* Clickable nodes — pop in on load, lift/glow on hover */\n.dynamic-mindmap-svg .mm-node {\n  cursor: pointer;\n  transform-box: fill-box;\n  transform-origin: center;\n  animation: mm-pop 0.45s cubic-bezier(0.34, 1.56, 0.64, 1) both;\n}\n.dynamic-mindmap-svg .mm-node circle {\n  transition: filter 0.18s ease;\n}\n.dynamic-mindmap-svg .mm-node:hover circle {\n  filter: drop-shadow(0 4px 8px rgba(11, 123, 234, 0.4));\n}\n.dynamic-mindmap-svg .mm-node.mm-selected circle {\n  filter: drop-shadow(0 4px 10px rgba(11, 123, 234, 0.45));\n}\n/* Gentle pulse on the selected node's halo ring */\n.dynamic-mindmap-svg .mm-selected > circle:first-of-type {\n  animation: mm-halo 1.6s ease-in-out infinite;\n}\n\n@keyframes mm-pop {\n  0% {\n    opacity: 0;\n    transform: scale(0.2);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes mm-halo {\n  0%,\n  100% {\n    opacity: 0.25;\n  }\n  50% {\n    opacity: 0.6;\n  }\n}\n\n/* Floating detail panel shown when a node is clicked */\n.mindmap-detail {\n  position: absolute;\n  left: 12px;\n  right: 12px;\n  bottom: 8px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 10px 12px;\n  box-shadow: 0 8px 22px rgba(11, 123, 234, 0.18);\n  animation: research-content-in 0.25s ease both;\n  z-index: 2;\n}\n.mm-detail-dot {\n  flex: 0 0 auto;\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n}\n.mm-detail-label {\n  flex: 1 1 auto;\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #0f172a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.mm-detail-actions {\n  flex: 0 0 auto;\n  display: flex;\n  gap: 6px;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .dynamic-mindmap-svg .mm-node,\n  .dynamic-mindmap-svg .mm-node circle,\n  .dynamic-mindmap-svg .mm-selected > circle:first-of-type,\n  .mindmap-detail {\n    animation: none;\n    transition: none;\n  }\n}\n\n/* ── Graphical Insights tab ── */\n.graphical-insights-container {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 18px;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);\n}\n\n.graphical-chart-headding {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin: 0 0 16px;\n}\n\n.graphical-chart-headding h6 {\n  color: #0f172a;\n  font-weight: 700;\n  font-size: 13px;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  margin: 0;\n}\n\n.score-box {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.graphical-chart-headding h6.score-label {\n  color: #64748b;\n  font-weight: 600;\n  font-size: 12.69px;\n  line-height: 16.93px;\n  letter-spacing: 0;\n}\n\n.graphical-chart-headding .score-value {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 26.8px;\n  letter-spacing: 0;\n  text-align: center;\n  color: #0f172a;\n}\n\n.chart-card {\n  border: 1px solid #e2e8f0;\n  padding: 16px;\n  border-radius: 12px;\n  background-color: #fff;\n  max-width: 670px;\n  width: 100%;\n}\n\n.interest-main-section {\n  display: flex;\n  gap: 16px;\n}\n\n.score-area {\n  border: 1px solid #e2e8f0;\n  padding: 10px;\n  border-radius: 12px;\n  background-color: #fff;\n  max-width: 225px;\n  width: 100%;\n  flex: 0 0 auto;\n}\n\nbutton.ant-btn.report-btn {\n  border: 1px solid #e2e8f0 !important;\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 14.1px;\n  letter-spacing: 0;\n  color: #64748b !important;\n  gap: 5px;\n  border-radius: 50px !important;\n  padding: 7px 10px !important;\n}\n\n.chart-footer .ant-tag {\n  border-color: #F0FDF4;\n  background: #F0FDF4;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 11.28px;\n  text-align: center;\n  color: #22C55E;\n  padding: 5px 10px;\n  border-radius: 50px;\n}\n\nspan.highlight-tag {\n  color: #64748b;\n  font-weight: 600;\n  font-size: 10px;\n  line-height: 11.28px;\n  letter-spacing: 0;\n  text-align: center;\n}\n\n.chart-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 12px;\n}\n\nspan.month-text {\n  color: #64748b;\n  font-weight: 500;\n  font-size: 11.28px;\n  line-height: 15.52px;\n  text-align: center;\n}\n\nspan.growth-text {\n  color: #0f172a;\n  font-weight: 700;\n  font-size: 21.16px;\n  line-height: 26.8px;\n  letter-spacing: 0;\n  text-align: center;\n}\n\n.link-box {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.metric-name {\n  color: #64748b;\n  font-weight: 600;\n  font-size: 12.69px;\n  line-height: 16.93px;\n  letter-spacing: 0;\n  margin-bottom: 5px;\n}\n\n.link-metric a.link-url {\n  font-weight: 500;\n  font-size: 10px;\n  line-height: 18.28px;\n  letter-spacing: 0;\n  color: #22C55E;\n}\n\n.metric-value {\n  color: #0f172a;\n  font-weight: 700;\n  font-size: 21.16px;\n  line-height: 26.8px;\n  letter-spacing: 0;\n  padding-right: 20px;\n  position: relative;\n}\n\nspan.negative {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 15.28px;\n  color: #F43F5E;\n}\n\nspan.positive {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 15.28px;\n  color: #22C55E;\n}\n\n.metric-right-icon {\n  width: 28px;\n  height: 28px;\n  position: absolute;\n  right: 0;\n  background: #eff8ff;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  bottom: 0;\n}\n\nspan.ant-tag.status-tag {\n  border: 1px solid #22C55E;\n  background: #22C55E33;\n  font-weight: 500;\n  font-size: 13px;\n  text-align: center;\n  color: #0f172a;\n  border-radius: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px 10px !important;\n}\n\n/* ── Content Ideas tab ── */\n.topbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.view-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.tab-btn {\n  background: white;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  padding: 6px 16px;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.tab-btn.active {\n  background: #0b7bea;\n  color: white;\n  border-color: #0b7bea;\n}\n\n.top-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.content-idea-card h6 {\n  color: #0f172a;\n  font-size: 13px;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  margin: 0 0 10px;\n  font-weight: 700;\n}\n\n.content-idea-card p {\n  font-weight: 600;\n  font-size: 16px;\n  letter-spacing: 0px;\n  color: #1e293b;\n  margin: 0;\n}\n\n.cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));\n  gap: 16px;\n}\n\n.content-card {\n  background: #fff;\n  border-radius: 14px;\n  padding: 16px;\n  position: relative;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);\n  display: grid;\n  gap: 14px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n.content-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(11, 123, 234, 0.12);\n  border-color: #0b7beaaa;\n}\n\n.card-top-icon {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n}\n\n.card-top-icon img {\n  width: 22px;\n}\n\n/* Each cell inside a keyword card (Keyword / Search volume / Subtopic\n   bullets / Trending) — had no styling of its own before, so it fell back to\n   raw browser defaults (h6/p margins, inline-flow button) and looked cramped\n   next to the absolutely-positioned bird icon. */\n.content-idea-card {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.content-idea-card h6 {\n  margin: 0;\n  padding-right: 28px; /* clears the top-right bird icon */\n  font-size: 15px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.content-idea-card .card-sub {\n  margin: 0;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.write-idea-btn.ant-btn {\n  align-self: flex-start;\n  margin-top: 4px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  /* .ant-btn-primary globally forces height/padding via !important (fighting\n     size=\"small\") — match !important here so this stays compact regardless. */\n  height: 28px !important;\n  line-height: 1;\n  padding: 0 10px !important;\n}\n\n/* Angle-variety badge on each content idea (Contrarian / Data-Driven /\n   Story-Led / How-To / Trend-Spotting / Personal Take) — so the 10 ideas\n   read as genuinely different angles, not ten variations of one flavor. */\n.angle-tag {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 8px;\n  padding: 1px 8px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  white-space: nowrap;\n  background: #eff6ff;\n  color: #0b7bea;\n}\n.angle-tag-contrarian { background: #fef2f2; color: #dc2626; }\n.angle-tag-data-driven { background: #eff6ff; color: #0b7bea; }\n.angle-tag-story-led { background: #fdf4ff; color: #a21caf; }\n.angle-tag-how-to { background: #f0fdf4; color: #16a34a; }\n.angle-tag-trend-spotting { background: #fff7ed; color: #ea580c; }\n.angle-tag-personal-take { background: #fefce8; color: #ca8a04; }\n\n/* Source-confidence badge on each headline — see user-panel main.css for\n   the full explanation. */\n.confidence-badge {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 8px;\n  padding: 1px 8px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.confidence-badge-none { background: #f1f5f9; color: #64748b; }\n\n/* Favicon strip: shows the actual corroborating sites, up to 3, with a\n   \"+N\" overflow. Hovering reveals the full list (domain + link) via\n   antd Tooltip — see .confidence-tooltip below. */\n.confidence-sources {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 8px;\n  vertical-align: middle;\n  cursor: default;\n}\n.confidence-favicon {\n  width: 15px;\n  height: 15px;\n  border-radius: 3px;\n  margin-left: -4px;\n  border: 1.5px solid #fff;\n  background: #fff;\n  object-fit: cover;\n}\n.confidence-favicon:first-child { margin-left: 0; }\n.confidence-more {\n  font-size: 10px;\n  font-weight: 700;\n  color: #64748b;\n  margin-left: 4px;\n}\n.confidence-tooltip {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-width: 260px;\n}\n.confidence-tooltip-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 4px;\n  border-radius: 6px;\n  /* App's global .ant-tooltip-inner override makes tooltips WHITE, not\n     antd's default dark — so this needs a dark, legible color, not\n     white-on-white. */\n  color: #334155;\n  text-decoration: none;\n  font-size: 12px;\n  font-weight: 500;\n}\n.confidence-tooltip-row:hover {\n  color: #0b7bea;\n  text-decoration: underline;\n  background: #f1f5f9;\n}\n.confidence-tooltip-domain {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\nul.bullets li {\n  color: #475569;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.bullets {\n  padding-left: 16px;\n  margin-bottom: 0px;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.fire-headding {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n}\n\n.fire-headding .trend-label {\n  margin: 0px;\n}\n\n.fire-headding img {\n  width: 20px;\n}\n\nbutton.ant-btn.show-more-btn {\n  font-weight: 600;\n  font-size: 13px;\n  letter-spacing: 0px;\n  text-align: center;\n  color: #0b7bea !important;\n  box-shadow: none !important;\n}\n\nbutton.ant-btn::after {\n  display: none;\n}\n\n.content-ideas-container {\n  margin-top: 0;\n}\n\nbutton.ant-btn.tab-btn-content {\n  border: 1px solid #e2e8f0 !important;\n  padding: 8px 16px;\n  color: #475569 !important;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 1;\n  letter-spacing: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border-radius: 9px;\n  background: #fff !important;\n  transition: border-color 0.18s ease, color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;\n}\n\nbutton.ant-btn.tab-btn-content .tab-icon {\n  font-size: 14px;\n  color: inherit;\n}\n\nbutton.ant-btn.tab-btn-content:hover {\n  border-color: #0b7bea !important;\n  color: #0b7bea !important;\n}\n\nbutton.ant-btn.tab-btn-content.active {\n  border: 1px solid transparent !important;\n  background: #0b7bea !important;\n  color: #fff !important;\n  box-shadow: 0 2px 6px rgba(11, 123, 234, 0.25);\n}\n\nbutton.ant-btn.export-btn {\n  border: 1px solid #e2e8f0 !important;\n  background: #f8fafd;\n  color: #334155 !important;\n  font-weight: 600;\n  gap: 5px;\n  font-size: 12px;\n  line-height: 100%;\n  letter-spacing: 0px;\n  height: 32px !important;\n  border-radius: 8px;\n}\n\nbutton.ant-btn.create-contant-btn {\n  background: linear-gradient(135deg, #0b7bea 0%, #0ea5e9 100%) !important;\n  border: none !important;\n  color: #fff !important;\n  font-weight: 600;\n  gap: 6px;\n  font-size: 13px;\n  line-height: 100%;\n  height: 38px !important;\n  border-radius: 9px;\n  letter-spacing: 0px;\n  box-shadow: 0 3px 10px rgba(11, 123, 234, 0.28);\n  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;\n}\n\nbutton.ant-btn.create-contant-btn:hover {\n  opacity: 0.92;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(11, 123, 234, 0.35);\n}\n\nbutton.ant-btn.create-contant-btn img {\n  filter: brightness(8.5);\n}\n\n.ant-select.contant-select .ant-select-selector {\n  height: 32px !important;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n}\n\n.ant-select.contant-select {\n  max-width: 100px;\n  width: 100%;\n}\n\n.ant-select.contant-select span.ant-select-selection-item {\n  color: #334155 !important;\n  font-weight: 500 !important;\n  font-size: 12px !important;\n  letter-spacing: 0px;\n}\n\n.owerview-cards {\n  background-color: #fff;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);\n  padding: 18px;\n  border-radius: 14px;\n}\n\nh6.ow-headding {\n  color: #0f172a;\n  font-weight: 700;\n  font-size: 13px;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  margin-bottom: 14px;\n}\n\nh3.ow-headding {\n  color: #0f172a;\n  font-weight: 700;\n  font-size: 16px;\n  margin-bottom: 14px;\n}\n\nul.owerview-listing {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\nul.owerview-listing li {\n  border: 1px solid #e2e8f0;\n  background: #f8fafd;\n  padding: 12px 14px;\n  border-radius: 10px;\n  color: #1e293b;\n  font-weight: 500;\n  font-size: 13.5px;\n  line-height: 1.5;\n  transition: transform 0.18s ease, border-color 0.18s ease;\n}\n\nul.owerview-listing li:hover {\n  transform: translateY(-1px);\n  border-color: #0b7bea55;\n}\n\nul.questions-listing li span {\n  border: 1px solid #e2e8f0;\n  padding: 15px 10px;\n  border-radius: 10px;\n  color: #1e293b;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 100%;\n  letter-spacing: 0px;\n  max-width: 80px;\n  width: 100%;\n  cursor: pointer;\n}\n\nul.questions-listing li {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\nul.questions-listing {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.mind-map-grid {\n  background-color: #fff;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);\n  padding: 20px;\n  border-radius: 14px;\n}\n\n.listing-mindmap {\n  margin: 18px 0px 12px;\n}\n\n.age-box-outer {\n  border-radius: 8px !important;\n  padding: 10px;\n  min-height: 45px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  background: #fff;\n}\n\nbutton.ant-btn.age-change-btn {\n  width: 30px;\n  height: 30px !important;\n  padding: 0px !important;\n  margin: 0px !important;\n  color: #000000 !important;\n  font-size: 25px !important;\n}\n\nbutton.ant-btn.age-change-btn span {\n  font-size: 25px !important;\n}\n\n.age-number-count {\n  color: #3F4753;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 100%;\n  letter-spacing: 0;\n}\n\n.header-02-writing {\n  flex-wrap: wrap;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  margin: 20px 0px;\n}\n\n.writing-header-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.writing-header-bar h6 {\n  font-weight: 600;\n  font-size: 25px;\n  line-height: 100%;\n  letter-spacing: 0px;\n  margin: 0;\n}\n\n.header-02-writing h6 {\n  color: #071E31;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0px;\n  margin: 0;\n}\n\n.header-02-writing .post-detail-page {\n  margin: 0px;\n}\n\n.writing-ass-footer {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-top: 15px;\n}\n\nbutton.ant-btn.borderd-btn {\n  border: 1px solid #D7D7D7 !important;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 100%;\n  letter-spacing: 0px;\n  height: 35px !important;\n  color: #071E31 !important;\n  max-width: 150px;\n  width: 100%;\n}\n\n.writing-ass-footer button.ant-btn.fill-btn {\n  height: 35px !important;\n  max-width: 150px;\n  width: 100%;\n}\n\n.footer-writing-btn {\n  position: relative;\n  display: flex;\n  justify-content: end;\n  gap: 10px;\n  align-items: center;\n  margin-top: 150px;\n  flex-wrap: wrap;\n}\n\n.repport-headding-sec {\n  display: flex;\n  gap: 50px;\n  align-items: end;\n  justify-content: space-between;\n}\n\n.report-headding-action {\n  flex: 0 0 auto;\n}\n\n.report-headding-action .top-actions button.ant-btn {\n  height: 42px !important;\n}\n\n.report-count-grid {\n  display: grid;\n  /* 7 KPI cards (Followers, Posts, Likes, Comments, Shares, Impressions, Reach)\n     fit on one row at ~1100px+. Cards stretch via auto-fit when there's room. */\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 12px;\n  margin-top: 20px;\n}\n\n/* ===== Research Assistant tabs nested inside client-tabs =====\n   Full-width, evenly-spaced blue pills — identical across admin & staff.\n   High specificity + !important so these beat both the outer `.client-tabs`\n   distribution/active-gradient rules and any older `.tabs-main-research` rules. */\n.ant-tabs.client-tabs .ant-tabs.tabs-main-research .ant-tabs-nav {\n  margin-bottom: 20px !important;\n}\n.ant-tabs.client-tabs .ant-tabs.tabs-main-research .ant-tabs-nav-list {\n  width: 100% !important;\n  flex: 1 1 auto !important;\n  gap: 12px !important;\n  justify-content: space-between !important;\n}\n.ant-tabs.client-tabs .ant-tabs.tabs-main-research .ant-tabs-tab {\n  flex: 1 1 0 !important;\n  min-width: 0 !important;\n  margin: 0 !important;\n  justify-content: center !important;\n  background: #ffffff !important;\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 8px !important;\n  padding: 7px 14px !important;\n  box-shadow: none !important;\n}\n.ant-tabs.client-tabs .ant-tabs.tabs-main-research .ant-tabs-tab .ant-tabs-tab-btn {\n  color: #475569 !important;\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  text-shadow: none !important;\n}\n.ant-tabs.client-tabs .ant-tabs.tabs-main-research .ant-tabs-tab:hover {\n  border-color: #0b7bea !important;\n}\n.ant-tabs.client-tabs .ant-tabs.tabs-main-research .ant-tabs-tab:hover .ant-tabs-tab-btn {\n  color: #0b7bea !important;\n}\n.ant-tabs.client-tabs .ant-tabs.tabs-main-research .ant-tabs-tab.ant-tabs-tab-active {\n  background: #0b7bea !important;\n  border-color: transparent !important;\n  box-shadow: 0 2px 6px rgba(11, 123, 234, 0.25) !important;\n}\n.ant-tabs.client-tabs .ant-tabs.tabs-main-research .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n  color: #ffffff !important;\n}\n\n/* ── Reschedule Post modal ── */\n.reschedule-modal .ant-modal-header {\n  padding: 22px 24px !important;\n  margin-bottom: 0 !important;\n  border-bottom: 1px solid var(--border, #E7E9F2) !important;\n}\n.reschedule-modal .ant-modal-title {\n  text-align: center !important;\n  font-size: 19px !important;\n}\n.reschedule-modal .ant-modal-body {\n  padding: 24px !important;\n}\n.reschedule-modal .ant-modal-close {\n  top: 18px !important;\n  right: 18px !important;\n}\n.reschedule-modal .ant-modal-content {\n  padding: 0 !important;\n  border-radius: 16px !important;\n  overflow: hidden;\n}\n.reschedule-modal label {\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  color: var(--text-secondary, #475569) !important;\n}\n.reschedule-modal .ant-picker,\n.reschedule-modal input {\n  border-radius: 10px !important;\n  height: 44px !important;\n}\n.reschedule-modal .ant-btn.submitted-btn,\n.reschedule-modal .ant-btn {\n  border-radius: 10px !important;\n  height: 46px !important;\n  font-weight: 700 !important;\n  background: var(--brand-gradient, linear-gradient(135deg, #3B6B94 0%, #071E31 100%)) !important;\n  border: none !important;\n  color: #fff !important;\n}\n\n/* Pulse animation reused by the results-panel shimmer title */\n@keyframes research-loading-pulse {\n  0%,\n  100% {\n    opacity: 0.5;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n/* Shimmer skeleton shown in the results panel while research runs */\n.research-shimmer {\n  width: 100%;\n}\n\n.research-shimmer-header {\n  margin-bottom: 22px;\n}\n\n.research-shimmer-title {\n  font-size: 22px;\n  font-weight: 800;\n  margin: 0 0 6px;\n  background: linear-gradient(\n    90deg,\n    #0b7bea,\n    #0ea5e9,\n    #38bdf8,\n    #0b7bea\n  );\n  background-size: 300% 100%;\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  color: transparent;\n  animation: research-title-gradient 3s linear infinite;\n}\n\n@keyframes research-title-gradient {\n  0% {\n    background-position: 0% 50%;\n  }\n  100% {\n    background-position: 300% 50%;\n  }\n}\n\n.research-shimmer-subtitle {\n  font-size: 12px;\n  color: #8c8c8c;\n  margin: 0;\n}\n\n.shimmer-block {\n  position: relative;\n  overflow: hidden;\n  border-radius: 8px;\n  background: linear-gradient(\n    90deg,\n    #e2e8f0,\n    #dbeafe,\n    #e0f2fe,\n    #e2e8f0\n  );\n  background-size: 300% 100%;\n  animation: shimmer-flow 2.4s ease-in-out infinite;\n}\n\n@keyframes shimmer-flow {\n  0% {\n    background-position: 0% 50%;\n  }\n  100% {\n    background-position: 300% 50%;\n  }\n}\n\n.shimmer-block::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    100deg,\n    rgba(255, 255, 255, 0) 0,\n    rgba(255, 255, 255, 0.9) 45%,\n    rgba(255, 255, 255, 0.9) 55%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  transform: translateX(-100%);\n  animation: shimmer-sweep 1.3s ease-in-out infinite;\n}\n\n@keyframes shimmer-sweep {\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n.shimmer-heading {\n  width: 180px;\n  height: 18px;\n  margin: 18px 0 14px;\n}\n\n.shimmer-card-list {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.shimmer-card {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 18px 20px;\n  box-shadow: 0 4px 14px rgba(11, 123, 234, 0.06);\n  animation: shimmer-card-float 2.6s ease-in-out infinite;\n}\n\n.shimmer-card:nth-child(2) {\n  animation-delay: 0.2s;\n}\n.shimmer-card:nth-child(3) {\n  animation-delay: 0.4s;\n}\n.shimmer-card:nth-child(4) {\n  animation-delay: 0.6s;\n}\n\n@keyframes shimmer-card-float {\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-3px);\n  }\n}\n\n.shimmer-line {\n  height: 14px;\n}\n\n.shimmer-line-lg {\n  width: 85%;\n  margin-bottom: 10px;\n}\n\n.shimmer-line-sm {\n  width: 55%;\n}\n\n.shimmer-tag-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.shimmer-tag {\n  width: 110px;\n  height: 34px;\n  border-radius: 8px;\n}\n\n/* Stagger the tag shimmer so they flow out of sync */\n.shimmer-tag:nth-child(2n) {\n  animation-delay: 0.3s;\n}\n.shimmer-tag:nth-child(3n) {\n  animation-delay: 0.6s;\n  width: 90px;\n}\n/* ── LinkedIn live-post delete warning ─────────────────────────────────── */\n/* Ported from user-panel-Imergey's main.css to match its delete-post modal,\n   which this file's delete modals (FullCalender.js, accessModule/PostTabs.js)\n   now mirror. */\n.delete-linkedin-warning {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  background: #fff8e6;\n  border: 1.5px solid #f5a623;\n  border-radius: 10px;\n  padding: 12px 16px;\n  margin-bottom: 18px;\n}\n\n.delete-linkedin-warning-icon {\n  font-size: 20px;\n  line-height: 1.4;\n  flex-shrink: 0;\n}\n\n.delete-linkedin-warning-text {\n  font-size: 13.5px;\n  color: #7a4f00;\n  line-height: 1.55;\n}\n\n.delete-linkedin-warning-text strong {\n  display: block;\n  font-size: 14px;\n  color: #5c3700;\n  margin-bottom: 2px;\n}\n\n/* Delete confirm button — red to signal destructive action */\n.delete-confirm-btn {\n  background: #e53935 !important;\n  border-color: #e53935 !important;\n  color: #fff !important;\n}\n\n.delete-confirm-btn:hover {\n  background: #c62828 !important;\n  border-color: #c62828 !important;\n}\n\n/* Cancel button in delete modal */\n.action-footer-buttons .cancel-btn,\n.cancel-btn {\n  background: #f5f5f5 !important;\n  border-color: #d9d9d9 !important;\n  color: #555 !important;\n  min-width: 110px;\n}\n\n.action-footer-buttons .cancel-btn:hover,\n.cancel-btn:hover {\n  background: #ebebeb !important;\n  border-color: #bbb !important;\n  color: #333 !important;\n}\n\n.shimmer-tag:nth-child(4n) {\n  width: 130px;\n}\n\n/* Analytics Graph legend (Reports tab) */\n.analytics-chart-legend {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  flex-wrap: wrap;\n  margin-bottom: 14px;\n  padding: 8px 14px;\n  background: #f8f9fc;\n  border: 1px solid #eef1f6;\n  border-radius: 8px;\n}\n.analytics-chart-legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #5b6477;\n  font-weight: 500;\n}\n.analytics-chart-legend-dot {\n  display: inline-block;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n}\n.analytics-chart-legend-dot-tracked { background: #6c63f5; }\n.analytics-chart-legend-dot-untracked { background: #bfc5d2; }\n.analytics-chart-legend-hint {\n  color: #8a94a6;\n  font-style: italic;\n}\n.analytics-chart-legend-hint .anticon {\n  color: #94a3b8;\n}\n\n/* --- Customizable dashboard: drag handle + dragging state --- */\n.dashboard-section-drag-handle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: grab;\n  user-select: none;\n}\n.dashboard-section-drag-handle:active {\n  cursor: grabbing;\n}\n.dashboard-section-drag-handle .anticon {\n  color: #b0b7c3;\n  font-size: 14px;\n}\n.dashboard-section-dragging {\n  opacity: 0.45;\n}\n\n/* ═══════════════════════════════════════════════════════════════════════\n   Customer Management — professional table refresh (scoped to .customer-table)\n   Brand: Midnight #071D31 · Steel Blue #3B6B94 · Turquoise #6CE5E8\n   Goal: tighter rows (kill the dead vertical whitespace), branded header,\n   zebra striping, refined hover, polished toolbar + pagination. Everything\n   here is scoped so no other table in the app is touched.\n   ═══════════════════════════════════════════════════════════════════════ */\n\n/* — Card shell — */\n.ant-card.criclebox.customer-table {\n  border-radius: 16px;\n  border: 1px solid #eef1f6;\n  box-shadow: 0 12px 34px rgba(7, 29, 49, 0.06);\n  overflow: hidden;\n}\n.ant-card.criclebox.customer-table .ant-card-body {\n  padding: 0;\n}\n\n/* — Card head: tighter, branded, with an accent bar before the title — */\n.ant-card.criclebox.customer-table .ant-card-head {\n  padding: 18px 24px;\n  background: linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%);\n  border-bottom: 1px solid #eef1f6;\n  min-height: auto;\n}\n.ant-card.criclebox.customer-table .ant-card-head-title {\n  padding: 0;\n  overflow: visible;\n  white-space: normal;\n}\n/* Creative title block: gradient icon chip + title + subtitle */\n.cm-title {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n.cm-title-icon {\n  flex: 0 0 auto;\n  width: 44px;\n  height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 13px;\n  background: linear-gradient(135deg, #3b6b94 0%, #071d31 100%);\n  color: #6ce5e8;\n  font-size: 18px;\n  box-shadow: 0 8px 18px rgba(7, 29, 49, 0.22);\n  position: relative;\n}\n.cm-title-icon::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: 13px;\n  border: 1px solid rgba(108, 229, 232, 0.35);\n}\n.cm-title-text {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2;\n}\n.cm-title-main {\n  font-size: 19px;\n  font-weight: 700;\n  color: #071d31;\n  letter-spacing: 0.2px;\n}\n.cm-title-sub {\n  font-size: 12.5px;\n  font-weight: 500;\n  color: #8a97a8;\n  letter-spacing: 0.1px;\n}\n\n/* — Toolbar: give every control the same height + soft rounding — */\n.customer-table .gfx-toolbar .ant-input-affix-wrapper,\n.customer-table .gfx-toolbar .ant-input-search .ant-input,\n.customer-table .gfx-toolbar .ant-picker,\n.customer-table .gfx-toolbar .ant-btn {\n  height: 40px;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n}\n.customer-table .gfx-toolbar .ant-input-search .ant-input-search-button {\n  height: 40px;\n  border-radius: 0 10px 10px 0;\n}\n.customer-table .gfx-toolbar .ant-btn:not(.ant-btn-primary) {\n  border-color: #dbe2ec;\n  color: #334f68;\n  font-weight: 600;\n}\n.customer-table .gfx-toolbar .ant-btn:not(.ant-btn-primary):hover {\n  border-color: #3b6b94;\n  color: #3b6b94;\n}\n.customer-table .gfx-toolbar .ant-btn-primary {\n  font-weight: 600;\n  box-shadow: 0 6px 16px rgba(59, 107, 148, 0.24);\n}\n\n/* — Table header: soft slate band, steel-blue uppercase labels — */\n.ant-card.criclebox.customer-table .ant-table-thead > tr > th {\n  background: #f4f7fb !important;\n  color: #3b6b94 !important;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  padding: 14px 20px !important;\n  border-bottom: 1px solid #e6ecf4 !important;\n}\n/* kill AntD's default column divider bars in the header */\n.ant-card.criclebox.customer-table .ant-table-thead > tr > th::before {\n  display: none !important;\n}\n.ant-card.criclebox.customer-table .ant-table-thead th.ant-table-column-has-sorters:hover {\n  background: #eaf1f8 !important;\n}\n/* align first/last columns with the card head's 24px edge */\n.ant-card.criclebox.customer-table .ant-table-thead > tr > th:first-child,\n.ant-card.criclebox.customer-table .ant-table-tbody > tr > td:first-child {\n  padding-left: 24px !important;\n}\n/* ...EXCEPT on #bm-staff-table-card (BrandManager.js), whose first column\n   is a row-selection checkbox, not a real data column — see the\n   #bm-staff-table-card override up near the base \".ant-card.criclebox\n   table th\" rule; an #id selector always beats this rule's class chain\n   regardless of source order. */\n.ant-card.criclebox.customer-table .ant-table-thead > tr > th:last-child,\n.ant-card.criclebox.customer-table .ant-table-tbody > tr > td:last-child {\n  padding-right: 24px !important;\n}\n\n/* — Table body: tighter rows (the whitespace fix) + zebra + clean borders — */\n.ant-card.criclebox.customer-table .ant-table-tbody > tr > td {\n  padding: 9px 20px !important;\n  border-bottom: 1px solid #f1f4f9 !important;\n  color: #33475b;\n  font-size: 14px;\n  line-height: 1.3;\n  vertical-align: middle;\n}\n.ant-card.criclebox.customer-table .ant-table-tbody > tr:nth-child(even) > td {\n  background: #fafbfd;\n}\n.ant-card.criclebox.customer-table .ant-table-tbody > tr:hover > td,\n.ant-card.criclebox.customer-table .ant-table-tbody > tr.ant-table-row-hover > td {\n  background: #eef5fb !important;\n}\n/* left accent that appears on row hover */\n.ant-card.criclebox.customer-table .ant-table-tbody > tr > td:first-child {\n  box-shadow: inset 3px 0 0 transparent;\n  transition: box-shadow 0.15s ease;\n}\n.ant-card.criclebox.customer-table .ant-table-tbody > tr:hover > td:first-child {\n  box-shadow: inset 3px 0 0 #6ce5e8;\n}\n\n/* — Profile image: compact, rounded, subtle ring (trims row height) —\n   Was 38px — the \"no image\" placeholder icon in particular read as louder/\n   more prominent than an actual photo at that size, next to the now-bolder\n   name text in the merged Client column. */\n.ant-card.criclebox.customer-table .ant-table-tbody .ant-image img,\n.ant-card.criclebox.customer-table .ant-table-tbody .main-new-class-image-no img {\n  width: 28px !important;\n  height: 28px !important;\n  border-radius: 8px !important;\n  object-fit: cover;\n  box-shadow: 0 0 0 1px #e6ecf4;\n}\n.ant-card.criclebox.customer-table .ant-table-tbody .main-new-class-image-no {\n  width: 28px;\n  height: 28px;\n}\n.ant-card.criclebox.customer-table .main-new-class-image-no {\n  display: inline-flex;\n}\n\n/* — Status pills: consistent, rounded, quiet borders — */\n.ant-card.criclebox.customer-table .ant-table-tbody .ant-tag {\n  border-radius: 999px;\n  padding: 2px 12px;\n  font-weight: 600;\n  font-size: 12px;\n  border: none;\n  margin: 0;\n}\n\n/* — Pagination: brand the active page — */\n.ant-card.criclebox.customer-table .ant-pagination {\n  padding: 16px 24px;\n  margin: 0;\n}\n.ant-card.criclebox.customer-table .ant-pagination .ant-pagination-item-active {\n  background: #071d31;\n  border-color: #071d31;\n  border-radius: 8px;\n}\n.ant-card.criclebox.customer-table .ant-pagination .ant-pagination-item-active a {\n  color: #ffffff;\n}\n.ant-card.criclebox.customer-table .ant-pagination .ant-pagination-item,\n.ant-card.criclebox.customer-table .ant-pagination .ant-pagination-prev .ant-pagination-item-link,\n.ant-card.criclebox.customer-table .ant-pagination .ant-pagination-next .ant-pagination-item-link {\n  border-radius: 8px;\n}\n\n/* ═══════════════════════════════════════════════════════════════════════\n   Session Expiry — \"session expired, please log in again\" modal\n   ═══════════════════════════════════════════════════════════════════════ */\n.session-expired-modal .ant-modal-content {\n  border-radius: 18px;\n  overflow: hidden;\n  padding: 0;\n  box-shadow: 0 24px 60px rgba(7, 29, 49, 0.28);\n}\n.session-expired-modal .ant-modal-body {\n  padding: 0;\n}\n.session-expired-body {\n  text-align: center;\n  padding: 34px 30px 30px;\n}\n.session-expired-icon {\n  width: 74px;\n  height: 74px;\n  margin: 0 auto 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 32px;\n  color: #ffffff;\n  background: linear-gradient(135deg, #3b6b94 0%, #071d31 100%);\n  box-shadow: 0 10px 24px rgba(7, 29, 49, 0.26);\n  position: relative;\n}\n.session-expired-icon::after {\n  content: \"\";\n  position: absolute;\n  inset: -6px;\n  border-radius: 50%;\n  border: 2px solid rgba(108, 229, 232, 0.35);\n}\n.session-expired-title {\n  font-size: 21px;\n  font-weight: 700;\n  color: #071d31;\n  margin: 0 0 8px;\n}\n.session-expired-text {\n  font-size: 14px;\n  line-height: 1.55;\n  color: #6b7889;\n  margin: 0 auto 24px;\n  max-width: 320px;\n}\n.session-expired-btn.ant-btn {\n  height: 46px;\n  border-radius: 11px;\n  font-weight: 600;\n  font-size: 15px;\n  background: #071d31;\n  border-color: #071d31;\n  box-shadow: 0 8px 18px rgba(7, 29, 49, 0.24);\n}\n.session-expired-btn.ant-btn:hover,\n.session-expired-btn.ant-btn:focus {\n  background: #3b6b94;\n  border-color: #3b6b94;\n}\n\n/* Demo-account \"Login Password\" field (User.js Add Customer form). AntD\n   renders Input.Password + addonAfter as:\n     span.ant-input-group-wrapper.demo-password-input   <- our className lands HERE\n       span.ant-input-wrapper.ant-input-group           <- display:table, width:100% by default\n         span.ant-input-affix-wrapper (input + eye icon) <- table-cell, width:100% by default\n         span.ant-input-group-addon (\"Generate\")         <- table-cell, width:1px (auto-sized)\n   A global rule elsewhere in this file\n   (\".ant-input-group-wrapper { width: fit-content !important; }\") forces\n   that OUTERMOST span to shrink-wrap its content — collapsing the whole\n   input+button assembly to a sliver — and every rule below it (the table's\n   own width:100%, the affix wrapper's width:100%) is powerless against that\n   because the table itself has no definite width to distribute in the first\n   place. Overriding just the outer wrapper, with matching !important and\n   higher specificity (two classes on the same element beats the global\n   rule's one), is enough: once it has a real width, antd's own default CSS\n   correctly stretches everything inside it. */\n.demo-password-input.ant-input-group-wrapper {\n  width: 100% !important;\n}\n/* A second global rule (\".ant-input-wrapper.ant-input-group { max-width:\n   260px; ... }\", a few hundred lines above in this file) caps the actual\n   input+addon table at 260px regardless of the wrapper's own width — found\n   by testing this fix in a real browser rather than trusting the wrapper\n   fix alone. It has no !important, so out-specificing it (three classes\n   here vs its two) is enough; no !important needed to match it, per the\n   project's own rule against adding !important where the original didn't\n   have it (see feedback_css_important_overrides memory). */\n.demo-password-input .ant-input-wrapper.ant-input-group {\n  max-width: none;\n  width: 100%;\n}\n.demo-password-input .ant-input-group-addon {\n  background: #f7f9f8;\n  padding: 0 16px;\n  white-space: nowrap;\n}\n.demo-password-input input.ant-input {\n  height: 32px;\n}\n.demo-password-input .ant-input::placeholder {\n  /* Matches the modal-wide placeholder color (.ant-modal-body input::placeholder\n     above) so every field in this form reads consistently. */\n  color: #b8bfc7;\n  font-weight: 400;\n}\n\n/* ── Notes Detail popup ───────────────────────────────────────────── */\n.note-detail { display: flex; flex-direction: column; gap: 20px; padding-top: 8px; }\n.note-detail-meta { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }\n.note-detail-item { background: #f6f8fc; border: 1px solid #e5eaf2; border-radius: 14px; padding: 14px 16px; min-width: 0; }\n.note-detail-label { display: block; font-size: 11px; font-weight: 700; letter-spacing: 0.6px; text-transform: uppercase; color: #64748b; margin-bottom: 6px; }\n.note-detail-value { display: block; font-size: 16px; font-weight: 600; color: #0f172a; line-height: 1.4; word-break: break-word; }\n.note-detail-pill { display: inline-flex; align-items: center; gap: 6px; padding: 3px 12px; border-radius: 999px; font-size: 13px; font-weight: 700; }\n.note-detail-pill.is-public { background: #dcfce7; color: #166534; }\n.note-detail-pill.is-private { background: #fef3c7; color: #92400e; }\n.note-detail-content { background: #ffffff; border: 1px solid #e5eaf2; border-radius: 14px; padding: 16px 18px; }\n.note-detail-body { font-size: 16px; line-height: 1.65; color: #1e293b; white-space: pre-wrap; word-break: break-word; max-height: 340px; overflow-y: auto; }\n@media (max-width: 640px) { .note-detail-meta { grid-template-columns: 1fr; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
